import _defineProperty from "/Users/alex/crypto/ethamsterdam/primetime/client/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/alex/crypto/ethamsterdam/primetime/client/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _awaitAsyncGenerator from "/Users/alex/crypto/ethamsterdam/primetime/client/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/Users/alex/crypto/ethamsterdam/primetime/client/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _asyncIterator from "/Users/alex/crypto/ethamsterdam/primetime/client/node_modules/@babel/runtime/helpers/esm/asyncIterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { GrpcAuthentication } from "@textile/grpc-authentication";
import { Client } from "@textile/hub-threads-client";
import { ThreadID } from "@textile/threads-id";
import "@textile/context";

const _ref2 = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0,
      AbortController$1 = _ref2.AbortController,
      AbortSignal = _ref2.AbortSignal;

var browser = AbortController$1,
    AbortSignal_1 = AbortSignal,
    _default = AbortController$1;
let impl;
browser.AbortSignal = AbortSignal_1, browser.default = _default, impl = globalThis.AbortController && globalThis.AbortSignal ? globalThis : browser;
var src = {
  AbortController: impl.AbortController,
  AbortSignal: impl.AbortSignal
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(e, t, o, r) {
  return new (o || (o = Promise))(function (s, n) {
    function i(e) {
      try {
        u(r.next(e));
      } catch (e) {
        n(e);
      }
    }

    function a(e) {
      try {
        u(r.throw(e));
      } catch (e) {
        n(e);
      }
    }

    function u(e) {
      var t;
      e.done ? s(e.value) : (t = e.value, t instanceof o ? t : new o(function (e) {
        e(t);
      })).then(i, a);
    }

    u((r = r.apply(e, t || [])).next());
  });
}

function __values(e) {
  var t = "function" == typeof Symbol && Symbol.iterator,
      o = t && e[t],
      r = 0;
  if (o) return o.call(e);
  if (e && "number" == typeof e.length) return {
    next: function next() {
      return e && r >= e.length && (e = void 0), {
        value: e && e[r++],
        done: !e
      };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __await(e) {
  return this instanceof __await ? (this.v = e, this) : new __await(e);
}

function __asyncGenerator(e, t, o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r,
      s = o.apply(e, t || []),
      n = [];
  return r = {}, i("next"), i("throw"), i("return"), r[Symbol.asyncIterator] = function () {
    return this;
  }, r;

  function i(e) {
    s[e] && (r[e] = function (t) {
      return new Promise(function (o, r) {
        n.push([e, t, o, r]) > 1 || a(e, t);
      });
    });
  }

  function a(e, t) {
    try {
      !function (e) {
        e.value instanceof __await ? Promise.resolve(e.value.v).then(u, g) : p(n[0][2], e);
      }(s[e](t));
    } catch (e) {
      p(n[0][3], e);
    }
  }

  function u(e) {
    a("next", e);
  }

  function g(e) {
    a("throw", e);
  }

  function p(e, t) {
    e(t), n.shift(), n.length && a(n[0][0], n[0][1]);
  }
}

function __asyncDelegator(e) {
  var t, o;
  return t = {}, r("next"), r("throw", function (e) {
    throw e;
  }), r("return"), t[Symbol.iterator] = function () {
    return this;
  }, t;

  function r(r, s) {
    t[r] = e[r] ? function (t) {
      return (o = !o) ? {
        value: __await(e[r](t)),
        done: "return" === r
      } : s ? s(t) : t;
    } : s;
  }
}

function __asyncValues(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t,
      o = e[Symbol.asyncIterator];
  return o ? o.call(e) : (e = "function" == typeof __values ? __values(e) : e[Symbol.iterator](), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
    return this;
  }, t);

  function r(o) {
    t[o] = e[o] && function (t) {
      return new Promise(function (r, s) {
        (function (e, t, o, r) {
          Promise.resolve(r).then(function (t) {
            e({
              value: t,
              done: o
            });
          }, t);
        })(r, s, (t = e[o](t)).done, t.value);
      });
    };
  }
}

var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function createCommonjsModule(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}

var loglevel = createCommonjsModule(function (e) {
  var t, o;
  t = commonjsGlobal, o = function o() {
    var e = function e() {},
        t = "undefined",
        o = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent),
        r = ["trace", "debug", "info", "warn", "error"];

    function s(e, t) {
      var o = e[t];
      if ("function" == typeof o.bind) return o.bind(e);

      try {
        return Function.prototype.bind.call(o, e);
      } catch (t) {
        return function () {
          return Function.prototype.apply.apply(o, [e, arguments]);
        };
      }
    }

    function n() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }

    function i(r) {
      return "debug" === r && (r = "log"), typeof console !== t && ("trace" === r && o ? n : void 0 !== console[r] ? s(console, r) : void 0 !== console.log ? s(console, "log") : e);
    }

    function a(t, o) {
      for (var s = 0; s < r.length; s++) {
        var n = r[s];
        this[n] = s < t ? e : this.methodFactory(n, t, o);
      }

      this.log = this.debug;
    }

    function u(e, o, r) {
      return function () {
        typeof console !== t && (a.call(this, o, r), this[e].apply(this, arguments));
      };
    }

    function g(e, t, o) {
      return i(e) || u.apply(this, arguments);
    }

    function p(e, o, s) {
      var n,
          i = this,
          u = "loglevel";

      function p() {
        var e;

        if (typeof window !== t) {
          try {
            e = window.localStorage[u];
          } catch (e) {}

          if (typeof e === t) try {
            var o = window.document.cookie,
                r = o.indexOf(encodeURIComponent(u) + "=");
            -1 !== r && (e = /^([^;]+)/.exec(o.slice(r))[1]);
          } catch (e) {}
          return void 0 === i.levels[e] && (e = void 0), e;
        }
      }

      e && (u += ":" + e), i.name = e, i.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, i.methodFactory = s || g, i.getLevel = function () {
        return n;
      }, i.setLevel = function (o, s) {
        if ("string" == typeof o && void 0 !== i.levels[o.toUpperCase()] && (o = i.levels[o.toUpperCase()]), !("number" == typeof o && o >= 0 && o <= i.levels.SILENT)) throw "log.setLevel() called with invalid level: " + o;
        if (n = o, !1 !== s && function (e) {
          var o = (r[e] || "silent").toUpperCase();

          if (typeof window !== t) {
            try {
              return void (window.localStorage[u] = o);
            } catch (e) {}

            try {
              window.document.cookie = encodeURIComponent(u) + "=" + o + ";";
            } catch (e) {}
          }
        }(o), a.call(i, o, e), typeof console === t && o < i.levels.SILENT) return "No console available for logging";
      }, i.setDefaultLevel = function (e) {
        p() || i.setLevel(e, !1);
      }, i.enableAll = function (e) {
        i.setLevel(i.levels.TRACE, e);
      }, i.disableAll = function (e) {
        i.setLevel(i.levels.SILENT, e);
      };
      var l = p();
      null == l && (l = null == o ? "WARN" : o), i.setLevel(l, !1);
    }

    var l = new p(),
        c = {};

    l.getLogger = function (e) {
      if ("string" != typeof e || "" === e) throw new TypeError("You must supply a name when creating a logger.");
      var t = c[e];
      return t || (t = c[e] = new p(e, l.getLevel(), l.methodFactory)), t;
    };

    var d = typeof window !== t ? window.log : void 0;
    return l.noConflict = function () {
      return typeof window !== t && window.log === l && (window.log = d), l;
    }, l.getLoggers = function () {
      return c;
    }, l;
  }, e.exports ? e.exports = o() : t.log = o();
}),
    grpcWebClient_umd = createCommonjsModule(function (e, t) {
  e.exports = function (e) {
    var t = {};

    function o(r) {
      if (t[r]) return t[r].exports;
      var s = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(s.exports, s, s.exports, o), s.l = !0, s.exports;
    }

    return o.m = e, o.c = t, o.d = function (e, t, r) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (o.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var s in e) o.d(r, s, function (t) {
        return e[t];
      }.bind(null, s));
      return r;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o(o.s = 10);
  }([function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(3);
    t.Metadata = r.BrowserHeaders;
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.debug = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];

      console.debug ? console.debug.apply(null, e) : console.log.apply(null, e);
    };
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(0),
        s = o(8),
        n = o(9),
        i = o(1),
        a = o(4),
        u = o(14);

    t.client = function (e, t) {
      return new g(e, t);
    };

    var g = function () {
      function e(e, t) {
        this.started = !1, this.sentFirstMessage = !1, this.completed = !1, this.closed = !1, this.finishedSending = !1, this.onHeadersCallbacks = [], this.onMessageCallbacks = [], this.onEndCallbacks = [], this.parser = new s.ChunkParser(), this.methodDefinition = e, this.props = t, this.createTransport();
      }

      return e.prototype.createTransport = function () {
        var e = this.props.host + "/" + this.methodDefinition.service.serviceName + "/" + this.methodDefinition.methodName,
            t = {
          methodDefinition: this.methodDefinition,
          debug: this.props.debug || !1,
          url: e,
          onHeaders: this.onTransportHeaders.bind(this),
          onChunk: this.onTransportChunk.bind(this),
          onEnd: this.onTransportEnd.bind(this)
        };
        this.props.transport ? this.transport = this.props.transport(t) : this.transport = a.makeDefaultTransport(t);
      }, e.prototype.onTransportHeaders = function (e, t) {
        if (this.props.debug && i.debug("onHeaders", e, t), this.closed) this.props.debug && i.debug("grpc.onHeaders received after request was closed - ignoring");else if (0 === t) ;else {
          this.responseHeaders = e, this.props.debug && i.debug("onHeaders.responseHeaders", JSON.stringify(this.responseHeaders, null, 2));
          var o = p(e);
          this.props.debug && i.debug("onHeaders.gRPCStatus", o);
          var r = o && o >= 0 ? o : n.httpStatusToCode(t);
          this.props.debug && i.debug("onHeaders.code", r);
          var s = e.get("grpc-message") || [];

          if (this.props.debug && i.debug("onHeaders.gRPCMessage", s), this.rawOnHeaders(e), r !== n.Code.OK) {
            var a = this.decodeGRPCStatus(s[0]);
            this.rawOnError(r, a, e);
          }
        }
      }, e.prototype.onTransportChunk = function (e) {
        var t = this;
        if (this.closed) this.props.debug && i.debug("grpc.onChunk received after request was closed - ignoring");else {
          var o = [];

          try {
            o = this.parser.parse(e);
          } catch (e) {
            return this.props.debug && i.debug("onChunk.parsing error", e, e.message), void this.rawOnError(n.Code.Internal, "parsing error: " + e.message);
          }

          o.forEach(function (e) {
            if (e.chunkType === s.ChunkType.MESSAGE) {
              var o = t.methodDefinition.responseType.deserializeBinary(e.data);
              t.rawOnMessage(o);
            } else e.chunkType === s.ChunkType.TRAILERS && (t.responseHeaders ? (t.responseTrailers = new r.Metadata(e.trailers), t.props.debug && i.debug("onChunk.trailers", t.responseTrailers)) : (t.responseHeaders = new r.Metadata(e.trailers), t.rawOnHeaders(t.responseHeaders)));
          });
        }
      }, e.prototype.onTransportEnd = function () {
        if (this.props.debug && i.debug("grpc.onEnd"), this.closed) this.props.debug && i.debug("grpc.onEnd received after request was closed - ignoring");else if (void 0 !== this.responseTrailers) {
          var e = p(this.responseTrailers);

          if (null !== e) {
            var t = this.responseTrailers.get("grpc-message"),
                o = this.decodeGRPCStatus(t[0]);
            this.rawOnEnd(e, o, this.responseTrailers);
          } else this.rawOnError(n.Code.Internal, "Response closed without grpc-status (Trailers provided)");
        } else {
          if (void 0 === this.responseHeaders) return void this.rawOnError(n.Code.Unknown, "Response closed without headers");
          var r = p(this.responseHeaders),
              s = this.responseHeaders.get("grpc-message");
          if (this.props.debug && i.debug("grpc.headers only response ", r, s), null === r) return void this.rawOnEnd(n.Code.Unknown, "Response closed without grpc-status (Headers only)", this.responseHeaders);
          var a = this.decodeGRPCStatus(s[0]);
          this.rawOnEnd(r, a, this.responseHeaders);
        }
      }, e.prototype.decodeGRPCStatus = function (e) {
        if (!e) return "";

        try {
          return decodeURIComponent(e);
        } catch (t) {
          return e;
        }
      }, e.prototype.rawOnEnd = function (e, t, o) {
        var r = this;
        this.props.debug && i.debug("rawOnEnd", e, t, o), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (s) {
          if (!r.closed) try {
            s(e, t, o);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }));
      }, e.prototype.rawOnHeaders = function (e) {
        this.props.debug && i.debug("rawOnHeaders", e), this.completed || this.onHeadersCallbacks.forEach(function (t) {
          try {
            t(e);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        });
      }, e.prototype.rawOnError = function (e, t, o) {
        var s = this;
        void 0 === o && (o = new r.Metadata()), this.props.debug && i.debug("rawOnError", e, t), this.completed || (this.completed = !0, this.onEndCallbacks.forEach(function (r) {
          if (!s.closed) try {
            r(e, t, o);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }));
      }, e.prototype.rawOnMessage = function (e) {
        var t = this;
        this.props.debug && i.debug("rawOnMessage", e.toObject()), this.completed || this.closed || this.onMessageCallbacks.forEach(function (o) {
          if (!t.closed) try {
            o(e);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        });
      }, e.prototype.onHeaders = function (e) {
        this.onHeadersCallbacks.push(e);
      }, e.prototype.onMessage = function (e) {
        this.onMessageCallbacks.push(e);
      }, e.prototype.onEnd = function (e) {
        this.onEndCallbacks.push(e);
      }, e.prototype.start = function (e) {
        if (this.started) throw new Error("Client already started - cannot .start()");
        this.started = !0;
        var t = new r.Metadata(e || {});
        t.set("content-type", "application/grpc-web+proto"), t.set("x-grpc-web", "1"), this.transport.start(t);
      }, e.prototype.send = function (e) {
        if (!this.started) throw new Error("Client not started - .start() must be called before .send()");
        if (this.closed) throw new Error("Client already closed - cannot .send()");
        if (this.finishedSending) throw new Error("Client already finished sending - cannot .send()");
        if (!this.methodDefinition.requestStream && this.sentFirstMessage) throw new Error("Message already sent for non-client-streaming method - cannot .send()");
        this.sentFirstMessage = !0;
        var t = u.frameRequest(e);
        this.transport.sendMessage(t);
      }, e.prototype.finishSend = function () {
        if (!this.started) throw new Error("Client not started - .finishSend() must be called before .close()");
        if (this.closed) throw new Error("Client already closed - cannot .send()");
        if (this.finishedSending) throw new Error("Client already finished sending - cannot .finishSend()");
        this.finishedSending = !0, this.transport.finishSend();
      }, e.prototype.close = function () {
        if (!this.started) throw new Error("Client not started - .start() must be called before .close()");
        if (this.closed) throw new Error("Client already closed - cannot .close()");
        this.closed = !0, this.props.debug && i.debug("request.abort aborting request"), this.transport.cancel();
      }, e;
    }();

    function p(e) {
      var t = e.get("grpc-status") || [];
      if (t.length > 0) try {
        var o = t[0];
        return parseInt(o, 10);
      } catch (e) {
        return null;
      }
      return null;
    }
  }, function (e, t, o) {
    var r;
    r = function r() {
      return function (e) {
        var t = {};

        function o(r) {
          if (t[r]) return t[r].exports;
          var s = t[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(s.exports, s, s.exports, o), s.l = !0, s.exports;
        }

        return o.m = e, o.c = t, o.i = function (e) {
          return e;
        }, o.d = function (e, t, r) {
          o.o(e, t) || Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: r
          });
        }, o.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return o.d(t, "a", t), t;
        }, o.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, o.p = "", o(o.s = 1);
      }([function (e, t, o) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = o(3),
            s = function () {
          function e(e, t) {
            void 0 === e && (e = {}), void 0 === t && (t = {
              splitValues: !1
            });
            var o,
                s = this;
            this.headersMap = {}, e && ("undefined" != typeof Headers && e instanceof Headers ? r.getHeaderKeys(e).forEach(function (o) {
              r.getHeaderValues(e, o).forEach(function (e) {
                t.splitValues ? s.append(o, r.splitHeaderValue(e)) : s.append(o, e);
              });
            }) : "object" == typeof (o = e) && "object" == typeof o.headersMap && "function" == typeof o.forEach ? e.forEach(function (e, t) {
              s.append(e, t);
            }) : "undefined" != typeof Map && e instanceof Map ? e.forEach(function (e, t) {
              s.append(t, e);
            }) : "string" == typeof e ? this.appendFromString(e) : "object" == typeof e && Object.getOwnPropertyNames(e).forEach(function (t) {
              var o = e[t];
              Array.isArray(o) ? o.forEach(function (e) {
                s.append(t, e);
              }) : s.append(t, o);
            }));
          }

          return e.prototype.appendFromString = function (e) {
            for (var t = e.split("\r\n"), o = 0; o < t.length; o++) {
              var r = t[o],
                  s = r.indexOf(":");

              if (s > 0) {
                var n = r.substring(0, s).trim(),
                    i = r.substring(s + 1).trim();
                this.append(n, i);
              }
            }
          }, e.prototype.delete = function (e, t) {
            var o = r.normalizeName(e);
            if (void 0 === t) delete this.headersMap[o];else {
              var s = this.headersMap[o];

              if (s) {
                var n = s.indexOf(t);
                n >= 0 && s.splice(n, 1), 0 === s.length && delete this.headersMap[o];
              }
            }
          }, e.prototype.append = function (e, t) {
            var o = this,
                s = r.normalizeName(e);
            Array.isArray(this.headersMap[s]) || (this.headersMap[s] = []), Array.isArray(t) ? t.forEach(function (e) {
              o.headersMap[s].push(r.normalizeValue(e));
            }) : this.headersMap[s].push(r.normalizeValue(t));
          }, e.prototype.set = function (e, t) {
            var o = r.normalizeName(e);

            if (Array.isArray(t)) {
              var s = [];
              t.forEach(function (e) {
                s.push(r.normalizeValue(e));
              }), this.headersMap[o] = s;
            } else this.headersMap[o] = [r.normalizeValue(t)];
          }, e.prototype.has = function (e, t) {
            var o = this.headersMap[r.normalizeName(e)];
            if (!Array.isArray(o)) return !1;

            if (void 0 !== t) {
              var s = r.normalizeValue(t);
              return o.indexOf(s) >= 0;
            }

            return !0;
          }, e.prototype.get = function (e) {
            var t = this.headersMap[r.normalizeName(e)];
            return void 0 !== t ? t.concat() : [];
          }, e.prototype.forEach = function (e) {
            var t = this;
            Object.getOwnPropertyNames(this.headersMap).forEach(function (o) {
              e(o, t.headersMap[o]);
            }, this);
          }, e.prototype.toHeaders = function () {
            if ("undefined" != typeof Headers) {
              var e = new Headers();
              return this.forEach(function (t, o) {
                o.forEach(function (o) {
                  e.append(t, o);
                });
              }), e;
            }

            throw new Error("Headers class is not defined");
          }, e;
        }();

        t.BrowserHeaders = s;
      }, function (e, t, o) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = o(0);
        t.BrowserHeaders = r.BrowserHeaders;
      }, function (e, t, o) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.iterateHeaders = function (e, t) {
          for (var o = e[Symbol.iterator](), r = o.next(); !r.done;) t(r.value[0]), r = o.next();
        }, t.iterateHeadersKeys = function (e, t) {
          for (var o = e.keys(), r = o.next(); !r.done;) t(r.value), r = o.next();
        };
      }, function (e, t, o) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = o(2);

        function s(e) {
          return e;
        }

        t.normalizeName = function (e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }, t.normalizeValue = function (e) {
          return "string" != typeof e && (e = String(e)), e;
        }, t.getHeaderValues = function (e, t) {
          var o = s(e);
          if (o instanceof Headers && o.getAll) return o.getAll(t);
          var r = o.get(t);
          return r && "string" == typeof r ? [r] : r;
        }, t.getHeaderKeys = function (e) {
          var t = s(e),
              o = {},
              n = [];
          return t.keys ? r.iterateHeadersKeys(t, function (e) {
            o[e] || (o[e] = !0, n.push(e));
          }) : t.forEach ? t.forEach(function (e, t) {
            o[t] || (o[t] = !0, n.push(t));
          }) : r.iterateHeaders(t, function (e) {
            var t = e[0];
            o[t] || (o[t] = !0, n.push(t));
          }), n;
        }, t.splitHeaderValue = function (e) {
          var t = [];
          return e.split(", ").forEach(function (e) {
            e.split(",").forEach(function (e) {
              t.push(e);
            });
          }), t;
        };
      }]);
    }, e.exports = r();
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = o(5),
        s = function s(e) {
      return r.CrossBrowserHttpTransport({
        withCredentials: !1
      })(e);
    };

    t.setDefaultTransportFactory = function (e) {
      s = e;
    }, t.makeDefaultTransport = function (e) {
      return s(e);
    };
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(6),
        s = o(7);

    t.CrossBrowserHttpTransport = function (e) {
      if (r.detectFetchSupport()) {
        var t = {
          credentials: e.withCredentials ? "include" : "same-origin"
        };
        return r.FetchReadableStreamTransport(t);
      }

      return s.XhrTransport({
        withCredentials: e.withCredentials
      });
    };
  }, function (e, t, o) {
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, o = 1, r = arguments.length; o < r; o++) for (var s in t = arguments[o]) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);

        return e;
      }).apply(this, arguments);
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = o(0),
        n = o(1);

    t.FetchReadableStreamTransport = function (e) {
      return function (t) {
        return function (e, t) {
          return e.debug && n.debug("fetchRequest", e), new i(e, t);
        }(t, e);
      };
    };

    var i = function () {
      function e(e, t) {
        this.cancelled = !1, this.controller = self.AbortController && new AbortController(), this.options = e, this.init = t;
      }

      return e.prototype.pump = function (e, t) {
        var o = this;
        if (this.reader = e, this.cancelled) return this.options.debug && n.debug("Fetch.pump.cancel at first pump"), void this.reader.cancel();
        this.reader.read().then(function (e) {
          if (e.done) return o.options.onEnd(), t;
          o.options.onChunk(e.value), o.pump(o.reader, t);
        }).catch(function (e) {
          o.cancelled ? o.options.debug && n.debug("Fetch.catch - request cancelled") : (o.cancelled = !0, o.options.debug && n.debug("Fetch.catch", e.message), o.options.onEnd(e));
        });
      }, e.prototype.send = function (e) {
        var t = this;
        fetch(this.options.url, r({}, this.init, {
          headers: this.metadata.toHeaders(),
          method: "POST",
          body: e,
          signal: this.controller && this.controller.signal
        })).then(function (e) {
          if (t.options.debug && n.debug("Fetch.response", e), t.options.onHeaders(new s.Metadata(e.headers), e.status), !e.body) return e;
          t.pump(e.body.getReader(), e);
        }).catch(function (e) {
          t.cancelled ? t.options.debug && n.debug("Fetch.catch - request cancelled") : (t.cancelled = !0, t.options.debug && n.debug("Fetch.catch", e.message), t.options.onEnd(e));
        });
      }, e.prototype.sendMessage = function (e) {
        this.send(e);
      }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
        this.metadata = e;
      }, e.prototype.cancel = function () {
        this.cancelled ? this.options.debug && n.debug("Fetch.abort.cancel already cancelled") : (this.cancelled = !0, this.reader ? (this.options.debug && n.debug("Fetch.abort.cancel"), this.reader.cancel()) : this.options.debug && n.debug("Fetch.abort.cancel before reader"), this.controller && this.controller.abort());
      }, e;
    }();

    t.detectFetchSupport = function () {
      return "undefined" != typeof Response && Response.prototype.hasOwnProperty("body") && "function" == typeof Headers;
    };
  }, function (e, t, o) {
    var _r,
        s = this && this.__extends || (_r = function r(e, t) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) t.hasOwnProperty(o) && (e[o] = t[o]);
      })(e, t);
    }, function (e, t) {
      function o() {
        this.constructor = e;
      }

      _r(e, t), e.prototype = null === t ? Object.create(t) : (o.prototype = t.prototype, new o());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = o(0),
        i = o(1),
        a = o(11);

    t.XhrTransport = function (e) {
      return function (t) {
        if (a.detectMozXHRSupport()) return new g(t, e);
        if (a.detectXHROverrideMimeTypeSupport()) return new u(t, e);
        throw new Error("This environment's XHR implementation cannot support binary transfer.");
      };
    };

    var u = function () {
      function e(e, t) {
        this.options = e, this.init = t;
      }

      return e.prototype.onProgressEvent = function () {
        this.options.debug && i.debug("XHR.onProgressEvent.length: ", this.xhr.response.length);
        var e = this.xhr.response.substr(this.index);
        this.index = this.xhr.response.length;
        var t = l(e);
        this.options.onChunk(t);
      }, e.prototype.onLoadEvent = function () {
        this.options.debug && i.debug("XHR.onLoadEvent"), this.options.onEnd();
      }, e.prototype.onStateChange = function () {
        this.options.debug && i.debug("XHR.onStateChange", this.xhr.readyState), this.xhr.readyState === XMLHttpRequest.HEADERS_RECEIVED && this.options.onHeaders(new n.Metadata(this.xhr.getAllResponseHeaders()), this.xhr.status);
      }, e.prototype.sendMessage = function (e) {
        this.xhr.send(e);
      }, e.prototype.finishSend = function () {}, e.prototype.start = function (e) {
        var t = this;
        this.metadata = e;
        var o = new XMLHttpRequest();
        this.xhr = o, o.open("POST", this.options.url), this.configureXhr(), this.metadata.forEach(function (e, t) {
          o.setRequestHeader(e, t.join(", "));
        }), o.withCredentials = Boolean(this.init.withCredentials), o.addEventListener("readystatechange", this.onStateChange.bind(this)), o.addEventListener("progress", this.onProgressEvent.bind(this)), o.addEventListener("loadend", this.onLoadEvent.bind(this)), o.addEventListener("error", function (e) {
          t.options.debug && i.debug("XHR.error", e), t.options.onEnd(e.error);
        });
      }, e.prototype.configureXhr = function () {
        this.xhr.responseType = "text", this.xhr.overrideMimeType("text/plain; charset=x-user-defined");
      }, e.prototype.cancel = function () {
        this.options.debug && i.debug("XHR.abort"), this.xhr.abort();
      }, e;
    }();

    t.XHR = u;

    var g = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return s(t, e), t.prototype.configureXhr = function () {
        this.options.debug && i.debug("MozXHR.configureXhr: setting responseType to 'moz-chunked-arraybuffer'"), this.xhr.responseType = "moz-chunked-arraybuffer";
      }, t.prototype.onProgressEvent = function () {
        var e = this.xhr.response;
        this.options.debug && i.debug("MozXHR.onProgressEvent: ", new Uint8Array(e)), this.options.onChunk(new Uint8Array(e));
      }, t;
    }(u);

    function p(e, t) {
      var o = e.charCodeAt(t);

      if (o >= 55296 && o <= 56319) {
        var r = e.charCodeAt(t + 1);
        r >= 56320 && r <= 57343 && (o = 65536 + (o - 55296 << 10) + (r - 56320));
      }

      return o;
    }

    function l(e) {
      for (var t = new Uint8Array(e.length), o = 0, r = 0; r < e.length; r++) {
        var s = String.prototype.codePointAt ? e.codePointAt(r) : p(e, r);
        t[o++] = 255 & s;
      }

      return t;
    }

    t.MozChunkedArrayBufferXHR = g, t.stringToArrayBuffer = l;
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r,
        s = o(0),
        n = function n(e) {
      return 9 === e || 10 === e || 13 === e;
    };

    function i(e) {
      return n(e) || e >= 32 && e <= 126;
    }

    function a(e) {
      for (var t = 0; t !== e.length; ++t) if (!i(e[t])) throw new Error("Metadata is not valid (printable) ASCII");

      return String.fromCharCode.apply(String, Array.prototype.slice.call(e));
    }

    function u(e) {
      return 128 == (128 & e.getUint8(0));
    }

    function g(e) {
      return e.getUint32(1, !1);
    }

    function p(e, t, o) {
      return e.byteLength - t >= o;
    }

    function l(e, t, o) {
      if (e.slice) return e.slice(t, o);
      var r = e.length;
      void 0 !== o && (r = o);

      for (var s = new Uint8Array(r - t), n = 0, i = t; i < r; i++) s[n++] = e[i];

      return s;
    }

    t.decodeASCII = a, t.encodeASCII = function (e) {
      for (var t = new Uint8Array(e.length), o = 0; o !== e.length; ++o) {
        var r = e.charCodeAt(o);
        if (!i(r)) throw new Error("Metadata contains invalid ASCII");
        t[o] = r;
      }

      return t;
    }, function (e) {
      e[e.MESSAGE = 1] = "MESSAGE", e[e.TRAILERS = 2] = "TRAILERS";
    }(r = t.ChunkType || (t.ChunkType = {}));

    var c = function () {
      function e() {
        this.buffer = null, this.position = 0;
      }

      return e.prototype.parse = function (e, t) {
        if (0 === e.length && t) return [];
        var o,
            n = [];
        if (null == this.buffer) this.buffer = e, this.position = 0;else if (this.position === this.buffer.byteLength) this.buffer = e, this.position = 0;else {
          var i = this.buffer.byteLength - this.position,
              c = new Uint8Array(i + e.byteLength),
              d = l(this.buffer, this.position);
          c.set(d, 0);
          var f = new Uint8Array(e);
          c.set(f, i), this.buffer = c, this.position = 0;
        }

        for (;;) {
          if (!p(this.buffer, this.position, 5)) return n;
          var b = l(this.buffer, this.position, this.position + 5),
              h = new DataView(b.buffer, b.byteOffset, b.byteLength),
              y = g(h);
          if (!p(this.buffer, this.position, 5 + y)) return n;
          var m = l(this.buffer, this.position + 5, this.position + 5 + y);
          if (this.position += 5 + y, u(h)) return n.push({
            chunkType: r.TRAILERS,
            trailers: (o = m, new s.Metadata(a(o)))
          }), n;
          n.push({
            chunkType: r.MESSAGE,
            data: m
          });
        }
      }, e;
    }();

    t.ChunkParser = c;
  }, function (e, t, o) {
    var r;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.OK = 0] = "OK", e[e.Canceled = 1] = "Canceled", e[e.Unknown = 2] = "Unknown", e[e.InvalidArgument = 3] = "InvalidArgument", e[e.DeadlineExceeded = 4] = "DeadlineExceeded", e[e.NotFound = 5] = "NotFound", e[e.AlreadyExists = 6] = "AlreadyExists", e[e.PermissionDenied = 7] = "PermissionDenied", e[e.ResourceExhausted = 8] = "ResourceExhausted", e[e.FailedPrecondition = 9] = "FailedPrecondition", e[e.Aborted = 10] = "Aborted", e[e.OutOfRange = 11] = "OutOfRange", e[e.Unimplemented = 12] = "Unimplemented", e[e.Internal = 13] = "Internal", e[e.Unavailable = 14] = "Unavailable", e[e.DataLoss = 15] = "DataLoss", e[e.Unauthenticated = 16] = "Unauthenticated";
    }(r = t.Code || (t.Code = {})), t.httpStatusToCode = function (e) {
      switch (e) {
        case 0:
          return r.Internal;

        case 200:
          return r.OK;

        case 400:
          return r.InvalidArgument;

        case 401:
          return r.Unauthenticated;

        case 403:
          return r.PermissionDenied;

        case 404:
          return r.NotFound;

        case 409:
          return r.Aborted;

        case 412:
          return r.FailedPrecondition;

        case 429:
          return r.ResourceExhausted;

        case 499:
          return r.Canceled;

        case 500:
          return r.Unknown;

        case 501:
          return r.Unimplemented;

        case 503:
          return r.Unavailable;

        case 504:
          return r.DeadlineExceeded;

        default:
          return r.Unknown;
      }
    };
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(3),
        s = o(4),
        n = o(6),
        i = o(12),
        a = o(7),
        u = o(5),
        g = o(9),
        p = o(13),
        l = o(15),
        c = o(2);
    !function (e) {
      e.setDefaultTransport = s.setDefaultTransportFactory, e.CrossBrowserHttpTransport = u.CrossBrowserHttpTransport, e.FetchReadableStreamTransport = n.FetchReadableStreamTransport, e.XhrTransport = a.XhrTransport, e.WebsocketTransport = i.WebsocketTransport, e.Code = g.Code, e.Metadata = r.BrowserHeaders, e.client = function (e, t) {
        return c.client(e, t);
      }, e.invoke = p.invoke, e.unary = l.unary;
    }(t.grpc || (t.grpc = {}));
  }, function (e, t, o) {
    var r;

    function s() {
      if (void 0 !== r) return r;

      if (XMLHttpRequest) {
        r = new XMLHttpRequest();

        try {
          r.open("GET", "https://localhost");
        } catch (e) {}
      }

      return r;
    }

    function n(e) {
      var t = s();
      if (!t) return !1;

      try {
        return t.responseType = e, t.responseType === e;
      } catch (e) {}

      return !1;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.xhrSupportsResponseType = n, t.detectMozXHRSupport = function () {
      return "undefined" != typeof XMLHttpRequest && n("moz-chunked-arraybuffer");
    }, t.detectXHROverrideMimeTypeSupport = function () {
      return "undefined" != typeof XMLHttpRequest && XMLHttpRequest.prototype.hasOwnProperty("overrideMimeType");
    };
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        s = o(1),
        n = o(8);
    !function (e) {
      e[e.FINISH_SEND = 1] = "FINISH_SEND";
    }(r || (r = {}));
    var i = new Uint8Array([1]);

    t.WebsocketTransport = function () {
      return function (e) {
        return function (e) {
          e.debug && s.debug("websocketRequest", e);

          var t,
              o = function (e) {
            if ("https://" === e.substr(0, 8)) return "wss://" + e.substr(8);
            if ("http://" === e.substr(0, 7)) return "ws://" + e.substr(7);
            throw new Error("Websocket transport constructed with non-https:// or http:// host.");
          }(e.url),
              a = [];

          function u(e) {
            if (e === r.FINISH_SEND) t.send(i);else {
              var o = e,
                  s = new Int8Array(o.byteLength + 1);
              s.set(new Uint8Array([0])), s.set(o, 1), t.send(s);
            }
          }

          return {
            sendMessage: function sendMessage(e) {
              t && t.readyState !== t.CONNECTING ? u(e) : a.push(e);
            },
            finishSend: function finishSend() {
              t && t.readyState !== t.CONNECTING ? u(r.FINISH_SEND) : a.push(r.FINISH_SEND);
            },
            start: function start(r) {
              (t = new WebSocket(o, ["grpc-websockets"])).binaryType = "arraybuffer", t.onopen = function () {
                var o;
                e.debug && s.debug("websocketRequest.onopen"), t.send((o = "", r.forEach(function (e, t) {
                  o += e + ": " + t.join(", ") + "\r\n";
                }), n.encodeASCII(o))), a.forEach(function (e) {
                  u(e);
                });
              }, t.onclose = function (t) {
                e.debug && s.debug("websocketRequest.onclose", t), e.onEnd();
              }, t.onerror = function (t) {
                e.debug && s.debug("websocketRequest.onerror", t);
              }, t.onmessage = function (t) {
                e.onChunk(new Uint8Array(t.data));
              };
            },
            cancel: function cancel() {
              e.debug && s.debug("websocket.abort"), t.close();
            }
          };
        }(e);
      };
    };
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(2);

    t.invoke = function (e, t) {
      if (e.requestStream) throw new Error(".invoke cannot be used with client-streaming methods. Use .client instead.");
      var o = r.client(e, {
        host: t.host,
        transport: t.transport,
        debug: t.debug
      });
      return t.onHeaders && o.onHeaders(t.onHeaders), t.onMessage && o.onMessage(t.onMessage), t.onEnd && o.onEnd(t.onEnd), o.start(t.metadata), o.send(t.request), o.finishSend(), {
        close: function close() {
          o.close();
        }
      };
    };
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.frameRequest = function (e) {
      var t = e.serializeBinary(),
          o = new ArrayBuffer(t.byteLength + 5);
      return new DataView(o, 1, 4).setUint32(0, t.length, !1), new Uint8Array(o, 5).set(t), new Uint8Array(o);
    };
  }, function (e, t, o) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(0),
        s = o(2);

    t.unary = function (e, t) {
      if (e.responseStream) throw new Error(".unary cannot be used with server-streaming methods. Use .invoke or .client instead.");
      if (e.requestStream) throw new Error(".unary cannot be used with client-streaming methods. Use .client instead.");
      var o = null,
          n = null,
          i = s.client(e, {
        host: t.host,
        transport: t.transport,
        debug: t.debug
      });
      return i.onHeaders(function (e) {
        o = e;
      }), i.onMessage(function (e) {
        n = e;
      }), i.onEnd(function (e, s, i) {
        t.onEnd({
          status: e,
          statusMessage: s,
          headers: o || new r.Metadata(),
          message: n,
          trailers: i
        });
      }), i.start(t.metadata), i.send(t.request), i.finishSend(), {
        close: function close() {
          i.close();
        }
      };
    };
  }]);
}),
    _extendStatics = function extendStatics(e, t) {
  return (_extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var o in t) t.hasOwnProperty(o) && (e[o] = t[o]);
  })(e, t);
};

function __extends(e, t) {
  function o() {
    this.constructor = e;
  }

  _extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (o.prototype = t.prototype, new o());
}

function __awaiter$1(e, t, o, r) {
  return new (o || (o = Promise))(function (s, n) {
    function i(e) {
      try {
        u(r.next(e));
      } catch (e) {
        n(e);
      }
    }

    function a(e) {
      try {
        u(r.throw(e));
      } catch (e) {
        n(e);
      }
    }

    function u(e) {
      var t;
      e.done ? s(e.value) : (t = e.value, t instanceof o ? t : new o(function (e) {
        e(t);
      })).then(i, a);
    }

    u((r = r.apply(e, t || [])).next());
  });
}

function __generator(e, t) {
  var o,
      r,
      s,
      n,
      i = {
    label: 0,
    sent: function sent() {
      if (1 & s[0]) throw s[1];
      return s[1];
    },
    trys: [],
    ops: []
  };
  return n = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (n[Symbol.iterator] = function () {
    return this;
  }), n;

  function a(n) {
    return function (a) {
      return function (n) {
        if (o) throw new TypeError("Generator is already executing.");

        for (; i;) try {
          if (o = 1, r && (s = 2 & n[0] ? r.return : n[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, n[1])).done) return s;

          switch (r = 0, s && (n = [2 & n[0], s.value]), n[0]) {
            case 0:
            case 1:
              s = n;
              break;

            case 4:
              return i.label++, {
                value: n[1],
                done: !1
              };

            case 5:
              i.label++, r = n[1], n = [0];
              continue;

            case 7:
              n = i.ops.pop(), i.trys.pop();
              continue;

            default:
              if (!(s = i.trys, (s = s.length > 0 && s[s.length - 1]) || 6 !== n[0] && 2 !== n[0])) {
                i = 0;
                continue;
              }

              if (3 === n[0] && (!s || n[1] > s[0] && n[1] < s[3])) {
                i.label = n[1];
                break;
              }

              if (6 === n[0] && i.label < s[1]) {
                i.label = s[1], s = n;
                break;
              }

              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(n);
                break;
              }

              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }

          n = t.call(e, i);
        } catch (e) {
          n = [6, e], r = 0;
        } finally {
          o = s = 0;
        }

        if (5 & n[0]) throw n[1];
        return {
          value: n[0] ? n[1] : void 0,
          done: !0
        };
      }([n, a]);
    };
  }
}

function __values$1(e) {
  var t = "function" == typeof Symbol && Symbol.iterator,
      o = t && e[t],
      r = 0;
  if (o) return o.call(e);
  if (e && "number" == typeof e.length) return {
    next: function next() {
      return e && r >= e.length && (e = void 0), {
        value: e && e[r++],
        done: !e
      };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __await$1(e) {
  return this instanceof __await$1 ? (this.v = e, this) : new __await$1(e);
}

function __asyncGenerator$1(e, t, o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r,
      s = o.apply(e, t || []),
      n = [];
  return r = {}, i("next"), i("throw"), i("return"), r[Symbol.asyncIterator] = function () {
    return this;
  }, r;

  function i(e) {
    s[e] && (r[e] = function (t) {
      return new Promise(function (o, r) {
        n.push([e, t, o, r]) > 1 || a(e, t);
      });
    });
  }

  function a(e, t) {
    try {
      !function (e) {
        e.value instanceof __await$1 ? Promise.resolve(e.value.v).then(u, g) : p(n[0][2], e);
      }(s[e](t));
    } catch (e) {
      p(n[0][3], e);
    }
  }

  function u(e) {
    a("next", e);
  }

  function g(e) {
    a("throw", e);
  }

  function p(e, t) {
    e(t), n.shift(), n.length && a(n[0][0], n[0][1]);
  }
}

var RepeaterOverflowError = function (e) {
  function t(t) {
    var o = e.call(this, t) || this;
    return Object.defineProperty(o, "name", {
      value: "RepeaterOverflowError",
      enumerable: !1
    }), "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf(o, o.constructor.prototype) : o.__proto__ = o.constructor.prototype, "function" == typeof Error.captureStackTrace && Error.captureStackTrace(o, o.constructor), o;
  }

  return __extends(t, e), t;
}(Error);

function swallow(e) {
  null != e && "function" == typeof e.then && e.then(NOOP, NOOP);
}

!function () {
  function e(e) {
    if (e < 0) throw new RangeError("Capacity may not be less than 0");
    this._c = e, this._q = [];
  }

  Object.defineProperty(e.prototype, "empty", {
    get: function get() {
      return 0 === this._q.length;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "full", {
    get: function get() {
      return this._q.length >= this._c;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.add = function (e) {
    if (this.full) throw new Error("Buffer full");

    this._q.push(e);
  }, e.prototype.remove = function () {
    if (this.empty) throw new Error("Buffer empty");
    return this._q.shift();
  };
}(), function () {
  function e(e) {
    if (e < 1) throw new RangeError("Capacity may not be less than 1");
    this._c = e, this._q = [];
  }

  Object.defineProperty(e.prototype, "empty", {
    get: function get() {
      return 0 === this._q.length;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "full", {
    get: function get() {
      return !1;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.add = function (e) {
    for (; this._q.length >= this._c;) this._q.shift();

    this._q.push(e);
  }, e.prototype.remove = function () {
    if (this.empty) throw new Error("Buffer empty");
    return this._q.shift();
  };
}(), function () {
  function e(e) {
    if (e < 1) throw new RangeError("Capacity may not be less than 1");
    this._c = e, this._q = [];
  }

  Object.defineProperty(e.prototype, "empty", {
    get: function get() {
      return 0 === this._q.length;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "full", {
    get: function get() {
      return !1;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.add = function (e) {
    this._q.length < this._c && this._q.push(e);
  }, e.prototype.remove = function () {
    if (this.empty) throw new Error("Buffer empty");
    return this._q.shift();
  };
}();

var Initial = 0,
    Started = 1,
    Stopped = 2,
    Done = 3,
    Rejected = 4,
    MAX_QUEUE_LENGTH = 1024,
    NOOP = function NOOP() {};

function consumeExecution(e) {
  var t = e.err,
      o = Promise.resolve(e.execution).then(function (e) {
    if (null != t) throw t;
    return e;
  });
  return e.err = void 0, e.execution = o.then(function () {}, function () {}), void 0 === e.pending ? o : e.pending.then(function () {
    return o;
  });
}

function createIteration(e, t) {
  var o = e.state >= Done;
  return Promise.resolve(t).then(function (t) {
    return !o && e.state >= Rejected ? consumeExecution(e).then(function (e) {
      return {
        value: e,
        done: !0
      };
    }) : {
      value: t,
      done: o
    };
  });
}

function stop(e, t) {
  var o, r;
  if (!(e.state >= Stopped)) if (e.state = Stopped, e.onnext(), e.onstop(), null == e.err && (e.err = t), 0 !== e.pushes.length || void 0 !== e.buffer && !e.buffer.empty) try {
    for (var s = __values$1(e.pushes), n = s.next(); !n.done; n = s.next()) {
      n.value.resolve();
    }
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      n && !n.done && (r = s.return) && r.call(s);
    } finally {
      if (o) throw o.error;
    }
  } else finish(e);
}

function finish(e) {
  var t, o;

  if (!(e.state >= Done)) {
    e.state < Stopped && stop(e), e.state = Done, e.buffer = void 0;

    try {
      for (var r = __values$1(e.nexts), s = r.next(); !s.done; s = r.next()) {
        var n = s.value,
            i = void 0 === e.pending ? consumeExecution(e) : e.pending.then(function () {
          return consumeExecution(e);
        });
        n.resolve(createIteration(e, i));
      }
    } catch (e) {
      t = {
        error: e
      };
    } finally {
      try {
        s && !s.done && (o = r.return) && o.call(r);
      } finally {
        if (t) throw t.error;
      }
    }

    e.pushes = [], e.nexts = [];
  }
}

function reject(e) {
  e.state >= Rejected || (e.state < Done && finish(e), e.state = Rejected);
}

function push(e, t) {
  if (swallow(t), e.pushes.length >= MAX_QUEUE_LENGTH) throw new RepeaterOverflowError("No more than " + MAX_QUEUE_LENGTH + " pending calls to push are allowed on a single repeater.");
  if (e.state >= Stopped) return Promise.resolve(void 0);
  var o,
      r = void 0 === e.pending ? Promise.resolve(t) : e.pending.then(function () {
    return t;
  });
  (r = r.catch(function (t) {
    e.state < Stopped && (e.err = t), reject(e);
  }), e.nexts.length) ? (e.nexts.shift().resolve(createIteration(e, r)), o = e.nexts.length ? Promise.resolve(e.nexts[0].value) : new Promise(function (t) {
    return e.onnext = t;
  })) : void 0 === e.buffer || e.buffer.full ? o = new Promise(function (t) {
    return e.pushes.push({
      resolve: t,
      value: r
    });
  }) : (e.buffer.add(r), o = Promise.resolve(void 0));
  var s = !0,
      n = {},
      i = o.catch(function (e) {
    if (s) throw e;
  });
  return n.then = function (e, t) {
    return s = !1, Promise.prototype.then.call(o, e, t);
  }, n.catch = function (e) {
    return s = !1, Promise.prototype.catch.call(o, e);
  }, n.finally = o.finally.bind(o), e.pending = r.then(function () {
    return i;
  }).catch(function (t) {
    e.err = t, reject(e);
  }), n;
}

function createStop(e) {
  var t = stop.bind(null, e),
      o = new Promise(function (t) {
    return e.onstop = t;
  });
  return t.then = o.then.bind(o), t.catch = o.catch.bind(o), t.finally = o.finally.bind(o), t;
}

function execute(e) {
  if (!(e.state >= Started)) {
    e.state = Started;
    var t = push.bind(null, e),
        o = createStop(e);
    e.execution = new Promise(function (r) {
      return r(e.executor(t, o));
    }), e.execution.catch(function () {
      return stop(e);
    });
  }
}

var records = new WeakMap(),
    Repeater = function () {
  function e(e, t) {
    records.set(this, {
      executor: e,
      buffer: t,
      err: void 0,
      state: Initial,
      pushes: [],
      nexts: [],
      pending: void 0,
      execution: void 0,
      onnext: NOOP,
      onstop: NOOP
    });
  }

  return e.prototype.next = function (e) {
    swallow(e);
    var t = records.get(this);
    if (void 0 === t) throw new Error("WeakMap error");
    if (t.nexts.length >= MAX_QUEUE_LENGTH) throw new RepeaterOverflowError("No more than " + MAX_QUEUE_LENGTH + " pending calls to next are allowed on a single repeater.");

    if (t.state <= Initial && execute(t), t.onnext(e), void 0 !== t.buffer && !t.buffer.empty) {
      var o = createIteration(t, t.buffer.remove());

      if (t.pushes.length) {
        var r = t.pushes.shift();
        t.buffer.add(r.value), t.onnext = r.resolve;
      }

      return o;
    }

    if (t.pushes.length) {
      var s = t.pushes.shift();
      return t.onnext = s.resolve, createIteration(t, s.value);
    }

    return t.state >= Stopped ? (finish(t), createIteration(t, consumeExecution(t))) : new Promise(function (o) {
      return t.nexts.push({
        resolve: o,
        value: e
      });
    });
  }, e.prototype.return = function (e) {
    swallow(e);
    var t = records.get(this);
    if (void 0 === t) throw new Error("WeakMap error");
    return finish(t), t.execution = Promise.resolve(t.execution).then(function () {
      return e;
    }), createIteration(t, consumeExecution(t));
  }, e.prototype.throw = function (e) {
    var t = records.get(this);
    if (void 0 === t) throw new Error("WeakMap error");
    return t.state <= Initial || t.state >= Stopped || void 0 !== t.buffer && !t.buffer.empty ? (finish(t), null == t.err && (t.err = e), createIteration(t, consumeExecution(t))) : this.next(Promise.reject(e));
  }, e.prototype[Symbol.asyncIterator] = function () {
    return this;
  }, e.race = race, e.merge = merge, e.zip = zip, e.latest = latest, e;
}();

function getIterators(e, t) {
  var o,
      r,
      s = [],
      n = function n(e) {
    null != e && "function" == typeof e[Symbol.asyncIterator] ? s.push(e[Symbol.asyncIterator]()) : null != e && "function" == typeof e[Symbol.iterator] ? s.push(e[Symbol.iterator]()) : s.push(function () {
      return __asyncGenerator$1(this, arguments, function () {
        return __generator(this, function (o) {
          switch (o.label) {
            case 0:
              return t.yieldValues ? [4, __await$1(e)] : [3, 3];

            case 1:
              return [4, o.sent()];

            case 2:
              o.sent(), o.label = 3;

            case 3:
              return t.returnValues ? [4, __await$1(e)] : [3, 5];

            case 4:
              return [2, o.sent()];

            case 5:
              return [2];
          }
        });
      });
    }());
  };

  try {
    for (var i = __values$1(e), a = i.next(); !a.done; a = i.next()) {
      n(a.value);
    }
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      a && !a.done && (r = i.return) && r.call(i);
    } finally {
      if (o) throw o.error;
    }
  }

  return s;
}

function race(e) {
  var t = this,
      o = getIterators(e, {
    returnValues: !0
  });
  return new Repeater(function (e, r) {
    return __awaiter$1(t, void 0, void 0, function () {
      var t, s, n, i, a, u;
      return __generator(this, function (g) {
        switch (g.label) {
          case 0:
            if (!o.length) return r(), [2];
            s = !1, r.then(function () {
              t(), s = !0;
            }), g.label = 1;

          case 1:
            g.trys.push([1,, 5, 7]), i = void 0, a = 0, u = function u() {
              var s, u, g, p, l, c;
              return __generator(this, function (d) {
                switch (d.label) {
                  case 0:
                    s = a;

                    try {
                      for (l = void 0, u = __values$1(o), g = u.next(); !g.done; g = u.next()) p = g.value, Promise.resolve(p.next()).then(function (e) {
                        e.done ? (r(), void 0 === n && (n = e)) : a === s && (a++, t(e));
                      }, function (e) {
                        return r(e);
                      });
                    } catch (e) {
                      l = {
                        error: e
                      };
                    } finally {
                      try {
                        g && !g.done && (c = u.return) && c.call(u);
                      } finally {
                        if (l) throw l.error;
                      }
                    }

                    return [4, new Promise(function (e) {
                      return t = e;
                    })];

                  case 1:
                    return void 0 === (i = d.sent()) ? [3, 3] : [4, e(i.value)];

                  case 2:
                    d.sent(), d.label = 3;

                  case 3:
                    return [2];
                }
              });
            }, g.label = 2;

          case 2:
            return s ? [3, 4] : [5, u()];

          case 3:
            return g.sent(), [3, 2];

          case 4:
            return [2, n && n.value];

          case 5:
            return r(), [4, Promise.race(o.map(function (e) {
              return e.return && e.return();
            }))];

          case 6:
            return g.sent(), [7];

          case 7:
            return [2];
        }
      });
    });
  });
}

function merge(e) {
  var t = this,
      o = getIterators(e, {
    yieldValues: !0
  });
  return new Repeater(function (e, r) {
    return __awaiter$1(t, void 0, void 0, function () {
      var t,
          s,
          n,
          i = this;
      return __generator(this, function (a) {
        switch (a.label) {
          case 0:
            if (!o.length) return r(), [2];
            t = [], s = !1, r.then(function () {
              var e, o;
              s = !0;

              try {
                for (var r = __values$1(t), n = r.next(); !n.done; n = r.next()) {
                  (0, n.value)();
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  n && !n.done && (o = r.return) && o.call(r);
                } finally {
                  if (e) throw e.error;
                }
              }
            }), a.label = 1;

          case 1:
            return a.trys.push([1,, 3, 4]), [4, Promise.all(o.map(function (o, a) {
              return __awaiter$1(i, void 0, void 0, function () {
                var i;
                return __generator(this, function (u) {
                  switch (u.label) {
                    case 0:
                      u.trys.push([0,, 6, 9]), u.label = 1;

                    case 1:
                      return s ? [3, 5] : (Promise.resolve(o.next()).then(function (e) {
                        return t[a](e);
                      }, function (e) {
                        return r(e);
                      }), [4, new Promise(function (e) {
                        t[a] = e;
                      })]);

                    case 2:
                      return void 0 === (i = u.sent()) ? [3, 4] : i.done ? (n = i, [2]) : [4, e(i.value)];

                    case 3:
                      u.sent(), u.label = 4;

                    case 4:
                      return [3, 1];

                    case 5:
                      return [3, 9];

                    case 6:
                      return o.return ? [4, o.return()] : [3, 8];

                    case 7:
                      u.sent(), u.label = 8;

                    case 8:
                      return [7];

                    case 9:
                      return [2];
                  }
                });
              });
            }))];

          case 2:
            return a.sent(), [2, n && n.value];

          case 3:
            return r(), [7];

          case 4:
            return [2];
        }
      });
    });
  });
}

function zip(e) {
  var t = this,
      o = getIterators(e, {
    returnValues: !0
  });
  return new Repeater(function (e, r) {
    return __awaiter$1(t, void 0, void 0, function () {
      var t, s, n, i;
      return __generator(this, function (a) {
        switch (a.label) {
          case 0:
            if (!o.length) return r(), [2, []];
            s = !1, r.then(function () {
              t(), s = !0;
            }), a.label = 1;

          case 1:
            a.trys.push([1,, 6, 8]), a.label = 2;

          case 2:
            return s ? [3, 5] : (Promise.all(o.map(function (e) {
              return e.next();
            })).then(function (e) {
              return t(e);
            }, function (e) {
              return r(e);
            }), [4, new Promise(function (e) {
              return t = e;
            })]);

          case 3:
            return void 0 === (n = a.sent()) ? [2] : (i = n.map(function (e) {
              return e.value;
            }), n.some(function (e) {
              return e.done;
            }) ? [2, i] : [4, e(i)]);

          case 4:
            return a.sent(), [3, 2];

          case 5:
            return [3, 8];

          case 6:
            return r(), [4, Promise.all(o.map(function (e) {
              return e.return && e.return();
            }))];

          case 7:
            return a.sent(), [7];

          case 8:
            return [2];
        }
      });
    });
  });
}

function latest(e) {
  var t = this,
      o = getIterators(e, {
    yieldValues: !0,
    returnValues: !0
  });
  return new Repeater(function (e, r) {
    return __awaiter$1(t, void 0, void 0, function () {
      var t,
          s,
          n,
          i,
          a,
          u = this;
      return __generator(this, function (g) {
        switch (g.label) {
          case 0:
            if (!o.length) return r(), [2, []];
            s = [], n = !1, r.then(function () {
              var e, o;
              t();

              try {
                for (var r = __values$1(s), i = r.next(); !i.done; i = r.next()) {
                  (0, i.value)();
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (o = r.return) && o.call(r);
                } finally {
                  if (e) throw e.error;
                }
              }

              n = !0;
            }), g.label = 1;

          case 1:
            return g.trys.push([1,, 5, 7]), Promise.all(o.map(function (e) {
              return e.next();
            })).then(function (e) {
              return t(e);
            }, function (e) {
              return r(e);
            }), [4, new Promise(function (e) {
              return t = e;
            })];

          case 2:
            return void 0 === (i = g.sent()) ? [2] : (a = i.map(function (e) {
              return e.value;
            }), i.every(function (e) {
              return e.done;
            }) ? [2, a] : [4, e(a.slice())]);

          case 3:
            return g.sent(), [4, Promise.all(o.map(function (t, o) {
              return __awaiter$1(u, void 0, void 0, function () {
                var u;
                return __generator(this, function (g) {
                  switch (g.label) {
                    case 0:
                      if (i[o].done) return [2, i[o].value];
                      g.label = 1;

                    case 1:
                      return n ? [3, 4] : (Promise.resolve(t.next()).then(function (e) {
                        return s[o](e);
                      }, function (e) {
                        return r(e);
                      }), [4, new Promise(function (e) {
                        return s[o] = e;
                      })]);

                    case 2:
                      return void 0 === (u = g.sent()) ? [2, i[o].value] : u.done ? [2, u.value] : (a[o] = u.value, [4, e(a.slice())]);

                    case 3:
                      return g.sent(), [3, 1];

                    case 4:
                      return [2];
                  }
                });
              });
            }))];

          case 4:
            return [2, g.sent()];

          case 5:
            return r(), [4, Promise.all(o.map(function (e) {
              return e.return && e.return();
            }))];

          case 6:
            return g.sent(), [7];

          case 7:
            return [2];
        }
      });
    });
  });
}

var $jscomp = $jscomp || {};
$jscomp.scope = {}, $jscomp.findInternal = function (e, t, o) {
  e instanceof String && (e = String(e));

  for (var r = e.length, s = 0; s < r; s++) {
    var n = e[s];
    if (t.call(o, n, s, e)) return {
      i: s,
      v: n
    };
  }

  return {
    i: -1,
    v: void 0
  };
}, $jscomp.ASSUME_ES5 = !1, $jscomp.ASSUME_NO_NATIVE_MAP = !1, $jscomp.ASSUME_NO_NATIVE_SET = !1, $jscomp.SIMPLE_FROUND_POLYFILL = !1, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, t, o) {
  e != Array.prototype && e != Object.prototype && (e[t] = o.value);
}, $jscomp.getGlobal = function (e) {
  return "undefined" != typeof window && window === e ? e : void 0 !== commonjsGlobal && null != commonjsGlobal ? commonjsGlobal : e;
}, $jscomp.global = $jscomp.getGlobal(commonjsGlobal), $jscomp.polyfill = function (e, t, o, r) {
  if (t) {
    for (o = $jscomp.global, e = e.split("."), r = 0; r < e.length - 1; r++) {
      var s = e[r];
      s in o || (o[s] = {}), o = o[s];
    }

    (t = t(r = o[e = e[e.length - 1]])) != r && null != t && $jscomp.defineProperty(o, e, {
      configurable: !0,
      writable: !0,
      value: t
    });
  }
}, $jscomp.polyfill("Array.prototype.findIndex", function (e) {
  return e || function (e, t) {
    return $jscomp.findInternal(this, e, t).i;
  };
}, "es6", "es3"), $jscomp.checkStringArgs = function (e, t, o) {
  if (null == e) throw new TypeError("The 'this' value for String.prototype." + o + " must not be null or undefined");
  if (t instanceof RegExp) throw new TypeError("First argument to String.prototype." + o + " must not be a regular expression");
  return e + "";
}, $jscomp.polyfill("String.prototype.endsWith", function (e) {
  return e || function (e, t) {
    var o = $jscomp.checkStringArgs(this, e, "endsWith");
    e += "", void 0 === t && (t = o.length), t = Math.max(0, Math.min(0 | t, o.length));

    for (var r = e.length; 0 < r && 0 < t;) if (o[--t] != e[--r]) return !1;

    return 0 >= r;
  };
}, "es6", "es3"), $jscomp.polyfill("Array.prototype.find", function (e) {
  return e || function (e, t) {
    return $jscomp.findInternal(this, e, t).v;
  };
}, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function (e) {
  return e || function (e, t) {
    var o = $jscomp.checkStringArgs(this, e, "startsWith");
    e += "";
    var r = o.length,
        s = e.length;
    t = Math.max(0, Math.min(0 | t, o.length));

    for (var n = 0; n < s && t < r;) if (o[t++] != e[n++]) return !1;

    return n >= s;
  };
}, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function (e) {
  return e || function (e) {
    var t = $jscomp.checkStringArgs(this, null, "repeat");
    if (0 > e || 1342177279 < e) throw new RangeError("Invalid count value");
    e |= 0;

    for (var o = ""; e;) 1 & e && (o += t), (e >>>= 1) && (t += t);

    return o;
  };
}, "es6", "es3");
var COMPILED$1 = !0,
    goog = goog || {};
goog.global = commonjsGlobal || self, goog.isDef = function (e) {
  return void 0 !== e;
}, goog.isString = function (e) {
  return "string" == typeof e;
}, goog.isBoolean = function (e) {
  return "boolean" == typeof e;
}, goog.isNumber = function (e) {
  return "number" == typeof e;
}, goog.exportPath_ = function (e, t, o) {
  e = e.split("."), o = o || goog.global, e[0] in o || void 0 === o.execScript || o.execScript("var " + e[0]);

  for (var r; e.length && (r = e.shift());) !e.length && goog.isDef(t) ? o[r] = t : o = o[r] && o[r] !== Object.prototype[r] ? o[r] : o[r] = {};
}, goog.define = function (e, t) {
  return t;
}, goog.FEATURESET_YEAR = 2012, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.STRICT_MODE_COMPATIBLE = !1, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function (e) {
  if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
  goog.constructNamespace_(e);
}, goog.constructNamespace_ = function (e, t) {
  goog.exportPath_(e, t);
}, goog.getScriptNonce = function (e) {
  return e && e != goog.global ? goog.getScriptNonce_(e.document) : (null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
}, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function (e) {
  return (e = e.querySelector && e.querySelector("script[nonce]")) && (e = e.nonce || e.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(e) ? e : "";
}, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function (e) {
  if (!goog.isString(e) || !e || -1 == e.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
  if (!goog.isInGoogModuleLoader_()) throw Error("Module " + e + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
  if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
  goog.moduleLoaderState_.moduleName = e;
}, goog.module.get = function (e) {
  return goog.module.getInternal_(e);
}, goog.module.getInternal_ = function (e) {
  return null;
}, goog.ModuleType = {
  ES6: "es6",
  GOOG: "goog"
}, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function () {
  return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
}, goog.isInGoogModuleLoader_ = function () {
  return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
}, goog.isInEs6ModuleLoader_ = function () {
  if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
  var e = goog.global.$jscomp;
  return !!e && "function" == typeof e.getCurrentModulePath && !!e.getCurrentModulePath();
}, goog.module.declareLegacyNamespace = function () {
  goog.moduleLoaderState_.declareLegacyNamespace = !0;
}, goog.declareModuleId = function (e) {
  if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = e;else {
    var t = goog.global.$jscomp;
    if (!t || "function" != typeof t.getCurrentModulePath) throw Error('Module with namespace "' + e + '" has been loaded incorrectly.');
    t = t.require(t.getCurrentModulePath()), goog.loadedModules_[e] = {
      exports: t,
      type: goog.ModuleType.ES6,
      moduleId: e
    };
  }
}, goog.setTestOnly = function (e) {
  if (goog.DISALLOW_TEST_ONLY_CODE) throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
}, goog.forwardDeclare = function (e) {}, goog.getObjectByName = function (e, t) {
  e = e.split("."), t = t || goog.global;

  for (var o = 0; o < e.length; o++) if (t = t[e[o]], !goog.isDefAndNotNull(t)) return null;

  return t;
}, goog.globalize = function (e, t) {
  for (var o in t = t || goog.global, e) t[o] = e[o];
}, goog.addDependency = function (e, t, o, r) {}, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function (e) {
  goog.global.console && goog.global.console.error(e);
}, goog.require = function (e) {}, goog.requireType = function (e) {
  return {};
}, goog.basePath = "", goog.nullFunction = function () {}, goog.abstractMethod = function () {
  throw Error("unimplemented abstract method");
}, goog.addSingletonGetter = function (e) {
  e.instance_ = void 0, e.getInstance = function () {
    return e.instance_ ? e.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = e), e.instance_ = new e());
  };
}, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED$1, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = !1, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function () {
  if (null == goog.hasBadLetScoping) {
    try {
      var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
    } catch (e) {
      a = !1;
    }

    goog.hasBadLetScoping = a;
  }

  return goog.hasBadLetScoping;
}, goog.workaroundSafari10EvalBug = function (e) {
  return "(function(){" + e + "\n;})();\n";
}, goog.loadModule = function (e) {
  var t = goog.moduleLoaderState_;

  try {
    if (goog.moduleLoaderState_ = {
      moduleName: "",
      declareLegacyNamespace: !1,
      type: goog.ModuleType.GOOG
    }, goog.isFunction(e)) var o = e.call(void 0, {});else {
      if (!goog.isString(e)) throw Error("Invalid module definition");
      goog.useSafari10Workaround() && (e = goog.workaroundSafari10EvalBug(e)), o = goog.loadModuleFromSource_.call(void 0, e);
    }
    var r = goog.moduleLoaderState_.moduleName;
    if (!goog.isString(r) || !r) throw Error('Invalid module name "' + r + '"');
    goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(r, o) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof o && null != o && Object.seal(o), goog.loadedModules_[r] = {
      exports: o,
      type: goog.ModuleType.GOOG,
      moduleId: goog.moduleLoaderState_.moduleName
    };
  } finally {
    goog.moduleLoaderState_ = t;
  }
}, goog.loadModuleFromSource_ = function (a) {
  return eval(a), {};
}, goog.normalizePath_ = function (e) {
  e = e.split("/");

  for (var t = 0; t < e.length;) "." == e[t] ? e.splice(t, 1) : t && ".." == e[t] && e[t - 1] && ".." != e[t - 1] ? e.splice(--t, 2) : t++;

  return e.join("/");
}, goog.loadFileSync_ = function (e) {
  if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(e);

  try {
    var t = new goog.global.XMLHttpRequest();
    return t.open("get", e, !1), t.send(), 0 == t.status || 200 == t.status ? t.responseText : null;
  } catch (e) {
    return null;
  }
}, goog.transpile_ = function (e, t, o) {
  var r = goog.global.$jscomp;
  r || (goog.global.$jscomp = r = {});
  var s = r.transpile;

  if (!s) {
    var n = goog.basePath + goog.TRANSPILER,
        i = goog.loadFileSync_(n);

    if (i) {
      if (function () {
        (0, eval)(i + "\n//# sourceURL=" + n);
      }.call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
      goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, s = (r = goog.global.$jscomp).transpile;
    }
  }

  return s || (s = r.transpile = function (e, t) {
    return goog.logToConsole_(t + " requires transpilation but no transpiler was found."), e;
  }), s(e, t, o);
}, goog.typeOf = function (e) {
  var t = typeof e;

  if ("object" == t) {
    if (!e) return "null";
    if (e instanceof Array) return "array";
    if (e instanceof Object) return t;
    var o = Object.prototype.toString.call(e);
    if ("[object Window]" == o) return "object";
    if ("[object Array]" == o || "number" == typeof e.length && void 0 !== e.splice && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("splice")) return "array";
    if ("[object Function]" == o || void 0 !== e.call && void 0 !== e.propertyIsEnumerable && !e.propertyIsEnumerable("call")) return "function";
  } else if ("function" == t && void 0 === e.call) return "object";

  return t;
}, goog.isNull = function (e) {
  return null === e;
}, goog.isDefAndNotNull = function (e) {
  return null != e;
}, goog.isArray = function (e) {
  return "array" == goog.typeOf(e);
}, goog.isArrayLike = function (e) {
  var t = goog.typeOf(e);
  return "array" == t || "object" == t && "number" == typeof e.length;
}, goog.isDateLike = function (e) {
  return goog.isObject(e) && "function" == typeof e.getFullYear;
}, goog.isFunction = function (e) {
  return "function" == goog.typeOf(e);
}, goog.isObject = function (e) {
  var t = typeof e;
  return "object" == t && null != e || "function" == t;
}, goog.getUid = function (e) {
  return e[goog.UID_PROPERTY_] || (e[goog.UID_PROPERTY_] = ++goog.uidCounter_);
}, goog.hasUid = function (e) {
  return !!e[goog.UID_PROPERTY_];
}, goog.removeUid = function (e) {
  null !== e && "removeAttribute" in e && e.removeAttribute(goog.UID_PROPERTY_);

  try {
    delete e[goog.UID_PROPERTY_];
  } catch (e) {}
}, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.getHashCode = goog.getUid, goog.removeHashCode = goog.removeUid, goog.cloneObject = function (e) {
  var t = goog.typeOf(e);

  if ("object" == t || "array" == t) {
    if ("function" == typeof e.clone) return e.clone();

    for (var o in t = "array" == t ? [] : {}, e) t[o] = goog.cloneObject(e[o]);

    return t;
  }

  return e;
}, goog.bindNative_ = function (e, t, o) {
  return e.call.apply(e.bind, arguments);
}, goog.bindJs_ = function (e, t, o) {
  if (!e) throw Error();

  if (2 < arguments.length) {
    var r = Array.prototype.slice.call(arguments, 2);
    return function () {
      var o = Array.prototype.slice.call(arguments);
      return Array.prototype.unshift.apply(o, r), e.apply(t, o);
    };
  }

  return function () {
    return e.apply(t, arguments);
  };
}, goog.bind = function (e, t, o) {
  return Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
}, goog.partial = function (e, t) {
  var o = Array.prototype.slice.call(arguments, 1);
  return function () {
    var t = o.slice();
    return t.push.apply(t, arguments), e.apply(this, t);
  };
}, goog.mixin = function (e, t) {
  for (var o in t) e[o] = t[o];
}, goog.now = goog.TRUSTED_SITE && Date.now || function () {
  return +new Date();
}, goog.globalEval = function (e) {
  if (goog.global.execScript) goog.global.execScript(e, "JavaScript");else {
    if (!goog.global.eval) throw Error("goog.globalEval not available");

    if (null == goog.evalWorksForGlobals_) {
      try {
        goog.global.eval("var _evalTest_ = 1;");
      } catch (e) {}

      if (void 0 !== goog.global._evalTest_) {
        try {
          delete goog.global._evalTest_;
        } catch (e) {}

        goog.evalWorksForGlobals_ = !0;
      } else goog.evalWorksForGlobals_ = !1;
    }

    if (goog.evalWorksForGlobals_) goog.global.eval(e);else {
      var t = goog.global.document,
          o = t.createElement("SCRIPT");
      o.type = "text/javascript", o.defer = !1, o.appendChild(t.createTextNode(e)), t.head.appendChild(o), t.head.removeChild(o);
    }
  }
}, goog.evalWorksForGlobals_ = null, goog.getCssName = function (e, t) {
  if ("." == String(e).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + e);

  var o = function o(e) {
    return goog.cssNameMapping_[e] || e;
  },
      r = function r(e) {
    e = e.split("-");

    for (var t = [], r = 0; r < e.length; r++) t.push(o(e[r]));

    return t.join("-");
  };

  return r = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? o : r : function (e) {
    return e;
  }, e = t ? e + "-" + r(t) : r(e), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(e) : e;
}, goog.setCssNameMapping = function (e, t) {
  goog.cssNameMapping_ = e, goog.cssNameMappingStyle_ = t;
}, goog.getMsg = function (e, t, o) {
  return o && o.html && (e = e.replace(/</g, "&lt;")), t && (e = e.replace(/\{\$([^}]+)}/g, function (e, o) {
    return null != t && o in t ? t[o] : e;
  })), e;
}, goog.getMsgWithFallback = function (e, t) {
  return e;
}, goog.exportSymbol = function (e, t, o) {
  goog.exportPath_(e, t, o);
}, goog.exportProperty = function (e, t, o) {
  e[t] = o;
}, goog.inherits = function (e, t) {
  function o() {}

  o.prototype = t.prototype, e.superClass_ = t.prototype, e.prototype = new o(), e.prototype.constructor = e, e.base = function (e, o, r) {
    for (var s = Array(arguments.length - 2), n = 2; n < arguments.length; n++) s[n - 2] = arguments[n];

    return t.prototype[o].apply(e, s);
  };
}, goog.base = function (e, t, o) {
  var r = arguments.callee.caller;
  if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !r) throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");

  if (void 0 !== r.superClass_) {
    for (var s = Array(arguments.length - 1), n = 1; n < arguments.length; n++) s[n - 1] = arguments[n];

    return r.superClass_.constructor.apply(e, s);
  }

  if ("string" != typeof t && "symbol" != typeof t) throw Error("method names provided to goog.base must be a string or a symbol");

  for (s = Array(arguments.length - 2), n = 2; n < arguments.length; n++) s[n - 2] = arguments[n];

  n = !1;

  for (var i = e.constructor.prototype; i; i = Object.getPrototypeOf(i)) if (i[t] === r) n = !0;else if (n) return i[t].apply(e, s);

  if (e[t] === r) return e.constructor.prototype[t].apply(e, s);
  throw Error("goog.base called from a method of one name to a method of a different name");
}, goog.scope = function (e) {
  if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
  e.call(goog.global);
}, goog.defineClass = function (e, t) {
  var o = t.constructor,
      r = t.statics;
  return o && o != Object.prototype.constructor || (o = function o() {
    throw Error("cannot instantiate an interface (no constructor defined).");
  }), o = goog.defineClass.createSealingConstructor_(o, e), e && goog.inherits(o, e), delete t.constructor, delete t.statics, goog.defineClass.applyProperties_(o.prototype, t), null != r && (r instanceof Function ? r(o) : goog.defineClass.applyProperties_(o, r)), o;
}, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function (e, t) {
  if (!goog.defineClass.SEAL_CLASS_INSTANCES) return e;

  var o = !goog.defineClass.isUnsealable_(t),
      r = function r() {
    var t = e.apply(this, arguments) || this;
    return t[goog.UID_PROPERTY_] = t[goog.UID_PROPERTY_], this.constructor === r && o && Object.seal instanceof Function && Object.seal(t), t;
  };

  return r;
}, goog.defineClass.isUnsealable_ = function (e) {
  return e && e.prototype && e.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
}, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function (e, t) {
  for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);

  for (var r = 0; r < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; r++) o = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[r], Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
}, goog.tagUnsealableClass = function (e) {}, goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable", goog.TRUSTED_TYPES_POLICY_NAME = "", goog.identity_ = function (e) {
  return e;
}, goog.createTrustedTypesPolicy = function (e) {
  var t = null;
  if ("undefined" == typeof TrustedTypes || !TrustedTypes.createPolicy) return t;

  try {
    t = TrustedTypes.createPolicy(e, {
      createHTML: goog.identity_,
      createScript: goog.identity_,
      createScriptURL: goog.identity_,
      createURL: goog.identity_
    });
  } catch (e) {
    goog.logToConsole_(e.message);
  }

  return t;
}, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
var jspb = {
  BinaryConstants: {},
  ConstBinaryMessage: function ConstBinaryMessage() {},
  BinaryMessage: function BinaryMessage() {}
};
jspb.BinaryConstants.FieldType = {
  INVALID: -1,
  DOUBLE: 1,
  FLOAT: 2,
  INT64: 3,
  UINT64: 4,
  INT32: 5,
  FIXED64: 6,
  FIXED32: 7,
  BOOL: 8,
  STRING: 9,
  GROUP: 10,
  MESSAGE: 11,
  BYTES: 12,
  UINT32: 13,
  ENUM: 14,
  SFIXED32: 15,
  SFIXED64: 16,
  SINT32: 17,
  SINT64: 18,
  FHASH64: 30,
  VHASH64: 31
}, jspb.BinaryConstants.WireType = {
  INVALID: -1,
  VARINT: 0,
  FIXED64: 1,
  DELIMITED: 2,
  START_GROUP: 3,
  END_GROUP: 4,
  FIXED32: 5
}, jspb.BinaryConstants.FieldTypeToWireType = function (e) {
  var t = jspb.BinaryConstants.FieldType,
      o = jspb.BinaryConstants.WireType;

  switch (e) {
    case t.INT32:
    case t.INT64:
    case t.UINT32:
    case t.UINT64:
    case t.SINT32:
    case t.SINT64:
    case t.BOOL:
    case t.ENUM:
    case t.VHASH64:
      return o.VARINT;

    case t.DOUBLE:
    case t.FIXED64:
    case t.SFIXED64:
    case t.FHASH64:
      return o.FIXED64;

    case t.STRING:
    case t.MESSAGE:
    case t.BYTES:
      return o.DELIMITED;

    case t.FLOAT:
    case t.FIXED32:
    case t.SFIXED32:
      return o.FIXED32;

    default:
      return o.INVALID;
  }
}, jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1, jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60, jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54, jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22, jspb.BinaryConstants.FLOAT64_EPS = 5e-324, jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324, jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292, jspb.BinaryConstants.TWO_TO_20 = 1048576, jspb.BinaryConstants.TWO_TO_23 = 8388608, jspb.BinaryConstants.TWO_TO_31 = 2147483648, jspb.BinaryConstants.TWO_TO_32 = 4294967296, jspb.BinaryConstants.TWO_TO_52 = 4503599627370496, jspb.BinaryConstants.TWO_TO_63 = 0x8000000000000000, jspb.BinaryConstants.TWO_TO_64 = 0x10000000000000000, jspb.BinaryConstants.ZERO_HASH = "\0\0\0\0\0\0\0\0", goog.dom = {}, goog.dom.NodeType = {
  ELEMENT: 1,
  ATTRIBUTE: 2,
  TEXT: 3,
  CDATA_SECTION: 4,
  ENTITY_REFERENCE: 5,
  ENTITY: 6,
  PROCESSING_INSTRUCTION: 7,
  COMMENT: 8,
  DOCUMENT: 9,
  DOCUMENT_TYPE: 10,
  DOCUMENT_FRAGMENT: 11,
  NOTATION: 12
}, goog.debug = {}, goog.debug.Error = function (e) {
  if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);else {
    var t = Error().stack;
    t && (this.stack = t);
  }
  e && (this.message = String(e)), this.reportErrorToServer = !0;
}, goog.inherits(goog.debug.Error, Error), goog.debug.Error.prototype.name = "CustomError", goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function (e, t) {
  goog.debug.Error.call(this, goog.asserts.subs_(e, t)), this.messagePattern = e;
}, goog.inherits(goog.asserts.AssertionError, goog.debug.Error), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function (e) {
  throw e;
}, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function (e, t) {
  for (var o = "", r = (e = e.split("%s")).length - 1, s = 0; s < r; s++) o += e[s] + (s < t.length ? t[s] : "%s");

  return o + e[r];
}, goog.asserts.doAssertFailure_ = function (e, t, o, r) {
  var s = "Assertion failed";

  if (o) {
    s += ": " + o;
    var n = r;
  } else e && (s += ": " + e, n = t);

  e = new goog.asserts.AssertionError("" + s, n || []), goog.asserts.errorHandler_(e);
}, goog.asserts.setErrorHandler = function (e) {
  goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = e);
}, goog.asserts.assert = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && !e && goog.asserts.doAssertFailure_("", null, t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertExists = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && null == e && goog.asserts.doAssertFailure_("Expected to exist: %s.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.fail = function (e, t) {
  goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (e ? ": " + e : ""), Array.prototype.slice.call(arguments, 1)));
}, goog.asserts.assertNumber = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isNumber(e) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertString = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isString(e) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertFunction = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isFunction(e) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertObject = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isObject(e) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertArray = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isArray(e) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertBoolean = function (e, t, o) {
  return goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(e) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertElement = function (e, t, o) {
  return !goog.asserts.ENABLE_ASSERTS || goog.isObject(e) && e.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertInstanceof = function (e, t, o, r) {
  return !goog.asserts.ENABLE_ASSERTS || e instanceof t || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(t), goog.asserts.getType_(e)], o, Array.prototype.slice.call(arguments, 3)), e;
}, goog.asserts.assertFinite = function (e, t, o) {
  return !goog.asserts.ENABLE_ASSERTS || "number" == typeof e && isFinite(e) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
}, goog.asserts.assertObjectPrototypeIsIntact = function () {
  for (var e in Object.prototype) goog.asserts.fail(e + " should not be enumerable in Object.prototype.");
}, goog.asserts.getType_ = function (e) {
  return e instanceof Function ? e.displayName || e.name || "unknown type name" : e instanceof Object ? e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e) : null === e ? "null" : typeof e;
}, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE, goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR, goog.array.peek = function (e) {
  return e[e.length - 1];
}, goog.array.last = goog.array.peek, goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function (e, t, o) {
  return goog.asserts.assert(null != e.length), Array.prototype.indexOf.call(e, t, o);
} : function (e, t, o) {
  if (o = null == o ? 0 : 0 > o ? Math.max(0, e.length + o) : o, goog.isString(e)) return goog.isString(t) && 1 == t.length ? e.indexOf(t, o) : -1;

  for (; o < e.length; o++) if (o in e && e[o] === t) return o;

  return -1;
}, goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function (e, t, o) {
  return goog.asserts.assert(null != e.length), Array.prototype.lastIndexOf.call(e, t, null == o ? e.length - 1 : o);
} : function (e, t, o) {
  if (0 > (o = null == o ? e.length - 1 : o) && (o = Math.max(0, e.length + o)), goog.isString(e)) return goog.isString(t) && 1 == t.length ? e.lastIndexOf(t, o) : -1;

  for (; 0 <= o; o--) if (o in e && e[o] === t) return o;

  return -1;
}, goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function (e, t, o) {
  goog.asserts.assert(null != e.length), Array.prototype.forEach.call(e, t, o);
} : function (e, t, o) {
  for (var r = e.length, s = goog.isString(e) ? e.split("") : e, n = 0; n < r; n++) n in s && t.call(o, s[n], n, e);
}, goog.array.forEachRight = function (e, t, o) {
  var r = e.length,
      s = goog.isString(e) ? e.split("") : e;

  for (--r; 0 <= r; --r) r in s && t.call(o, s[r], r, e);
}, goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function (e, t, o) {
  return goog.asserts.assert(null != e.length), Array.prototype.filter.call(e, t, o);
} : function (e, t, o) {
  for (var r = e.length, s = [], n = 0, i = goog.isString(e) ? e.split("") : e, a = 0; a < r; a++) if (a in i) {
    var u = i[a];
    t.call(o, u, a, e) && (s[n++] = u);
  }

  return s;
}, goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function (e, t, o) {
  return goog.asserts.assert(null != e.length), Array.prototype.map.call(e, t, o);
} : function (e, t, o) {
  for (var r = e.length, s = Array(r), n = goog.isString(e) ? e.split("") : e, i = 0; i < r; i++) i in n && (s[i] = t.call(o, n[i], i, e));

  return s;
}, goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function (e, t, o, r) {
  return goog.asserts.assert(null != e.length), r && (t = goog.bind(t, r)), Array.prototype.reduce.call(e, t, o);
} : function (e, t, o, r) {
  var s = o;
  return goog.array.forEach(e, function (o, n) {
    s = t.call(r, s, o, n, e);
  }), s;
}, goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function (e, t, o, r) {
  return goog.asserts.assert(null != e.length), goog.asserts.assert(null != t), r && (t = goog.bind(t, r)), Array.prototype.reduceRight.call(e, t, o);
} : function (e, t, o, r) {
  var s = o;
  return goog.array.forEachRight(e, function (o, n) {
    s = t.call(r, s, o, n, e);
  }), s;
}, goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function (e, t, o) {
  return goog.asserts.assert(null != e.length), Array.prototype.some.call(e, t, o);
} : function (e, t, o) {
  for (var r = e.length, s = goog.isString(e) ? e.split("") : e, n = 0; n < r; n++) if (n in s && t.call(o, s[n], n, e)) return !0;

  return !1;
}, goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function (e, t, o) {
  return goog.asserts.assert(null != e.length), Array.prototype.every.call(e, t, o);
} : function (e, t, o) {
  for (var r = e.length, s = goog.isString(e) ? e.split("") : e, n = 0; n < r; n++) if (n in s && !t.call(o, s[n], n, e)) return !1;

  return !0;
}, goog.array.count = function (e, t, o) {
  var r = 0;
  return goog.array.forEach(e, function (e, s, n) {
    t.call(o, e, s, n) && ++r;
  }, o), r;
}, goog.array.find = function (e, t, o) {
  return 0 > (t = goog.array.findIndex(e, t, o)) ? null : goog.isString(e) ? e.charAt(t) : e[t];
}, goog.array.findIndex = function (e, t, o) {
  for (var r = e.length, s = goog.isString(e) ? e.split("") : e, n = 0; n < r; n++) if (n in s && t.call(o, s[n], n, e)) return n;

  return -1;
}, goog.array.findRight = function (e, t, o) {
  return 0 > (t = goog.array.findIndexRight(e, t, o)) ? null : goog.isString(e) ? e.charAt(t) : e[t];
}, goog.array.findIndexRight = function (e, t, o) {
  var r = e.length,
      s = goog.isString(e) ? e.split("") : e;

  for (--r; 0 <= r; r--) if (r in s && t.call(o, s[r], r, e)) return r;

  return -1;
}, goog.array.contains = function (e, t) {
  return 0 <= goog.array.indexOf(e, t);
}, goog.array.isEmpty = function (e) {
  return 0 == e.length;
}, goog.array.clear = function (e) {
  if (!goog.isArray(e)) for (var t = e.length - 1; 0 <= t; t--) delete e[t];
  e.length = 0;
}, goog.array.insert = function (e, t) {
  goog.array.contains(e, t) || e.push(t);
}, goog.array.insertAt = function (e, t, o) {
  goog.array.splice(e, o, 0, t);
}, goog.array.insertArrayAt = function (e, t, o) {
  goog.partial(goog.array.splice, e, o, 0).apply(null, t);
}, goog.array.insertBefore = function (e, t, o) {
  var r;
  2 == arguments.length || 0 > (r = goog.array.indexOf(e, o)) ? e.push(t) : goog.array.insertAt(e, t, r);
}, goog.array.remove = function (e, t) {
  var o;
  return (o = 0 <= (t = goog.array.indexOf(e, t))) && goog.array.removeAt(e, t), o;
}, goog.array.removeLast = function (e, t) {
  return 0 <= (t = goog.array.lastIndexOf(e, t)) && (goog.array.removeAt(e, t), !0);
}, goog.array.removeAt = function (e, t) {
  return goog.asserts.assert(null != e.length), 1 == Array.prototype.splice.call(e, t, 1).length;
}, goog.array.removeIf = function (e, t, o) {
  return 0 <= (t = goog.array.findIndex(e, t, o)) && (goog.array.removeAt(e, t), !0);
}, goog.array.removeAllIf = function (e, t, o) {
  var r = 0;
  return goog.array.forEachRight(e, function (s, n) {
    t.call(o, s, n, e) && goog.array.removeAt(e, n) && r++;
  }), r;
}, goog.array.concat = function (e) {
  return Array.prototype.concat.apply([], arguments);
}, goog.array.join = function (e) {
  return Array.prototype.concat.apply([], arguments);
}, goog.array.toArray = function (e) {
  var t = e.length;

  if (0 < t) {
    for (var o = Array(t), r = 0; r < t; r++) o[r] = e[r];

    return o;
  }

  return [];
}, goog.array.clone = goog.array.toArray, goog.array.extend = function (e, t) {
  for (var o = 1; o < arguments.length; o++) {
    var r = arguments[o];

    if (goog.isArrayLike(r)) {
      var s = e.length || 0,
          n = r.length || 0;
      e.length = s + n;

      for (var i = 0; i < n; i++) e[s + i] = r[i];
    } else e.push(r);
  }
}, goog.array.splice = function (e, t, o, r) {
  return goog.asserts.assert(null != e.length), Array.prototype.splice.apply(e, goog.array.slice(arguments, 1));
}, goog.array.slice = function (e, t, o) {
  return goog.asserts.assert(null != e.length), 2 >= arguments.length ? Array.prototype.slice.call(e, t) : Array.prototype.slice.call(e, t, o);
}, goog.array.removeDuplicates = function (e, t, o) {
  t = t || e;

  var r = function r(e) {
    return goog.isObject(e) ? "o" + goog.getUid(e) : (typeof e).charAt(0) + e;
  };

  o = o || r, r = {};

  for (var s = 0, n = 0; n < e.length;) {
    var i = e[n++],
        a = o(i);
    Object.prototype.hasOwnProperty.call(r, a) || (r[a] = !0, t[s++] = i);
  }

  t.length = s;
}, goog.array.binarySearch = function (e, t, o) {
  return goog.array.binarySearch_(e, o || goog.array.defaultCompare, !1, t);
}, goog.array.binarySelect = function (e, t, o) {
  return goog.array.binarySearch_(e, t, !0, void 0, o);
}, goog.array.binarySearch_ = function (e, t, o, r, s) {
  for (var n, i = 0, a = e.length; i < a;) {
    var u = i + a >> 1,
        g = o ? t.call(s, e[u], u, e) : t(r, e[u]);
    0 < g ? i = u + 1 : (a = u, n = !g);
  }

  return n ? i : ~i;
}, goog.array.sort = function (e, t) {
  e.sort(t || goog.array.defaultCompare);
}, goog.array.stableSort = function (e, t) {
  for (var o = Array(e.length), r = 0; r < e.length; r++) o[r] = {
    index: r,
    value: e[r]
  };

  var s = t || goog.array.defaultCompare;

  for (goog.array.sort(o, function (e, t) {
    return s(e.value, t.value) || e.index - t.index;
  }), r = 0; r < e.length; r++) e[r] = o[r].value;
}, goog.array.sortByKey = function (e, t, o) {
  var r = o || goog.array.defaultCompare;
  goog.array.sort(e, function (e, o) {
    return r(t(e), t(o));
  });
}, goog.array.sortObjectsByKey = function (e, t, o) {
  goog.array.sortByKey(e, function (e) {
    return e[t];
  }, o);
}, goog.array.isSorted = function (e, t, o) {
  t = t || goog.array.defaultCompare;

  for (var r = 1; r < e.length; r++) {
    var s = t(e[r - 1], e[r]);
    if (0 < s || 0 == s && o) return !1;
  }

  return !0;
}, goog.array.equals = function (e, t, o) {
  if (!goog.isArrayLike(e) || !goog.isArrayLike(t) || e.length != t.length) return !1;
  var r = e.length;
  o = o || goog.array.defaultCompareEquality;

  for (var s = 0; s < r; s++) if (!o(e[s], t[s])) return !1;

  return !0;
}, goog.array.compare3 = function (e, t, o) {
  o = o || goog.array.defaultCompare;

  for (var r = Math.min(e.length, t.length), s = 0; s < r; s++) {
    var n = o(e[s], t[s]);
    if (0 != n) return n;
  }

  return goog.array.defaultCompare(e.length, t.length);
}, goog.array.defaultCompare = function (e, t) {
  return e > t ? 1 : e < t ? -1 : 0;
}, goog.array.inverseDefaultCompare = function (e, t) {
  return -goog.array.defaultCompare(e, t);
}, goog.array.defaultCompareEquality = function (e, t) {
  return e === t;
}, goog.array.binaryInsert = function (e, t, o) {
  return 0 > (o = goog.array.binarySearch(e, t, o)) && (goog.array.insertAt(e, t, -(o + 1)), !0);
}, goog.array.binaryRemove = function (e, t, o) {
  return 0 <= (t = goog.array.binarySearch(e, t, o)) && goog.array.removeAt(e, t);
}, goog.array.bucket = function (e, t, o) {
  for (var r = {}, s = 0; s < e.length; s++) {
    var n = e[s],
        i = t.call(o, n, s, e);
    goog.isDef(i) && (r[i] || (r[i] = [])).push(n);
  }

  return r;
}, goog.array.toObject = function (e, t, o) {
  var r = {};
  return goog.array.forEach(e, function (s, n) {
    r[t.call(o, s, n, e)] = s;
  }), r;
}, goog.array.range = function (e, t, o) {
  var r = [],
      s = 0,
      n = e;
  if (void 0 !== t && (s = e, n = t), 0 > (o = o || 1) * (n - s)) return [];
  if (0 < o) for (e = s; e < n; e += o) r.push(e);else for (e = s; e > n; e += o) r.push(e);
  return r;
}, goog.array.repeat = function (e, t) {
  for (var o = [], r = 0; r < t; r++) o[r] = e;

  return o;
}, goog.array.flatten = function (e) {
  for (var t = [], o = 0; o < arguments.length; o++) {
    var r = arguments[o];
    if (goog.isArray(r)) for (var s = 0; s < r.length; s += 8192) {
      var n = goog.array.slice(r, s, s + 8192);
      n = goog.array.flatten.apply(null, n);

      for (var i = 0; i < n.length; i++) t.push(n[i]);
    } else t.push(r);
  }

  return t;
}, goog.array.rotate = function (e, t) {
  return goog.asserts.assert(null != e.length), e.length && (0 < (t %= e.length) ? Array.prototype.unshift.apply(e, e.splice(-t, t)) : 0 > t && Array.prototype.push.apply(e, e.splice(0, -t))), e;
}, goog.array.moveItem = function (e, t, o) {
  goog.asserts.assert(0 <= t && t < e.length), goog.asserts.assert(0 <= o && o < e.length), t = Array.prototype.splice.call(e, t, 1), Array.prototype.splice.call(e, o, 0, t[0]);
}, goog.array.zip = function (e) {
  if (!arguments.length) return [];

  for (var t = [], o = arguments[0].length, r = 1; r < arguments.length; r++) arguments[r].length < o && (o = arguments[r].length);

  for (r = 0; r < o; r++) {
    for (var s = [], n = 0; n < arguments.length; n++) s.push(arguments[n][r]);

    t.push(s);
  }

  return t;
}, goog.array.shuffle = function (e, t) {
  t = t || Math.random;

  for (var o = e.length - 1; 0 < o; o--) {
    var r = Math.floor(t() * (o + 1)),
        s = e[o];
    e[o] = e[r], e[r] = s;
  }
}, goog.array.copyByIndex = function (e, t) {
  var o = [];
  return goog.array.forEach(t, function (t) {
    o.push(e[t]);
  }), o;
}, goog.array.concatMap = function (e, t, o) {
  return goog.array.concat.apply([], goog.array.map(e, t, o));
}, goog.crypt = {}, goog.crypt.stringToByteArray = function (e) {
  for (var t = [], o = 0, r = 0; r < e.length; r++) {
    var s = e.charCodeAt(r);
    255 < s && (t[o++] = 255 & s, s >>= 8), t[o++] = s;
  }

  return t;
}, goog.crypt.byteArrayToString = function (e) {
  if (8192 >= e.length) return String.fromCharCode.apply(null, e);

  for (var t = "", o = 0; o < e.length; o += 8192) {
    var r = goog.array.slice(e, o, o + 8192);
    t += String.fromCharCode.apply(null, r);
  }

  return t;
}, goog.crypt.byteArrayToHex = function (e, t) {
  return goog.array.map(e, function (e) {
    return 1 < (e = e.toString(16)).length ? e : "0" + e;
  }).join(t || "");
}, goog.crypt.hexToByteArray = function (e) {
  goog.asserts.assert(0 == e.length % 2, "Key string length must be multiple of 2");

  for (var t = [], o = 0; o < e.length; o += 2) t.push(parseInt(e.substring(o, o + 2), 16));

  return t;
}, goog.crypt.stringToUtf8ByteArray = function (e) {
  for (var t = [], o = 0, r = 0; r < e.length; r++) {
    var s = e.charCodeAt(r);
    128 > s ? t[o++] = s : (2048 > s ? t[o++] = s >> 6 | 192 : (55296 == (64512 & s) && r + 1 < e.length && 56320 == (64512 & e.charCodeAt(r + 1)) ? (s = 65536 + ((1023 & s) << 10) + (1023 & e.charCodeAt(++r)), t[o++] = s >> 18 | 240, t[o++] = s >> 12 & 63 | 128) : t[o++] = s >> 12 | 224, t[o++] = s >> 6 & 63 | 128), t[o++] = 63 & s | 128);
  }

  return t;
}, goog.crypt.utf8ByteArrayToString = function (e) {
  for (var t = [], o = 0, r = 0; o < e.length;) {
    var s = e[o++];
    if (128 > s) t[r++] = String.fromCharCode(s);else if (191 < s && 224 > s) {
      var n = e[o++];
      t[r++] = String.fromCharCode((31 & s) << 6 | 63 & n);
    } else if (239 < s && 365 > s) {
      n = e[o++];
      var i = e[o++];
      s = ((7 & s) << 18 | (63 & n) << 12 | (63 & i) << 6 | 63 & e[o++]) - 65536, t[r++] = String.fromCharCode(55296 + (s >> 10)), t[r++] = String.fromCharCode(56320 + (1023 & s));
    } else n = e[o++], i = e[o++], t[r++] = String.fromCharCode((15 & s) << 12 | (63 & n) << 6 | 63 & i);
  }

  return t.join("");
}, goog.crypt.xorByteArray = function (e, t) {
  goog.asserts.assert(e.length == t.length, "XOR array lengths must match");

  for (var o = [], r = 0; r < e.length; r++) o.push(e[r] ^ t[r]);

  return o;
}, goog.string = {}, goog.string.internal = {}, goog.string.internal.startsWith = function (e, t) {
  return 0 == e.lastIndexOf(t, 0);
}, goog.string.internal.endsWith = function (e, t) {
  var o = e.length - t.length;
  return 0 <= o && e.indexOf(t, o) == o;
}, goog.string.internal.caseInsensitiveStartsWith = function (e, t) {
  return 0 == goog.string.internal.caseInsensitiveCompare(t, e.substr(0, t.length));
}, goog.string.internal.caseInsensitiveEndsWith = function (e, t) {
  return 0 == goog.string.internal.caseInsensitiveCompare(t, e.substr(e.length - t.length, t.length));
}, goog.string.internal.caseInsensitiveEquals = function (e, t) {
  return e.toLowerCase() == t.toLowerCase();
}, goog.string.internal.isEmptyOrWhitespace = function (e) {
  return /^[\s\xa0]*$/.test(e);
}, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function (e) {
  return e.trim();
} : function (e) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
}, goog.string.internal.caseInsensitiveCompare = function (e, t) {
  return (e = String(e).toLowerCase()) < (t = String(t).toLowerCase()) ? -1 : e == t ? 0 : 1;
}, goog.string.internal.newLineToBr = function (e, t) {
  return e.replace(/(\r\n|\r|\n)/g, t ? "<br />" : "<br>");
}, goog.string.internal.htmlEscape = function (e, t) {
  if (t) e = e.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");else {
    if (!goog.string.internal.ALL_RE_.test(e)) return e;
    -1 != e.indexOf("&") && (e = e.replace(goog.string.internal.AMP_RE_, "&amp;")), -1 != e.indexOf("<") && (e = e.replace(goog.string.internal.LT_RE_, "&lt;")), -1 != e.indexOf(">") && (e = e.replace(goog.string.internal.GT_RE_, "&gt;")), -1 != e.indexOf('"') && (e = e.replace(goog.string.internal.QUOT_RE_, "&quot;")), -1 != e.indexOf("'") && (e = e.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), -1 != e.indexOf("\0") && (e = e.replace(goog.string.internal.NULL_RE_, "&#0;"));
  }
  return e;
}, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function (e, t) {
  return goog.string.internal.newLineToBr(e.replace(/  /g, " &#160;"), t);
}, goog.string.internal.contains = function (e, t) {
  return -1 != e.indexOf(t);
}, goog.string.internal.caseInsensitiveContains = function (e, t) {
  return goog.string.internal.contains(e.toLowerCase(), t.toLowerCase());
}, goog.string.internal.compareVersions = function (e, t) {
  var o = 0;
  e = goog.string.internal.trim(String(e)).split("."), t = goog.string.internal.trim(String(t)).split(".");

  for (var r = Math.max(e.length, t.length), s = 0; 0 == o && s < r; s++) {
    var n = e[s] || "",
        i = t[s] || "";

    do {
      if (n = /(\d*)(\D*)(.*)/.exec(n) || ["", "", "", ""], i = /(\d*)(\D*)(.*)/.exec(i) || ["", "", "", ""], 0 == n[0].length && 0 == i[0].length) break;
      o = 0 == n[1].length ? 0 : parseInt(n[1], 10);
      var a = 0 == i[1].length ? 0 : parseInt(i[1], 10);
      o = goog.string.internal.compareElements_(o, a) || goog.string.internal.compareElements_(0 == n[2].length, 0 == i[2].length) || goog.string.internal.compareElements_(n[2], i[2]), n = n[3], i = i[3];
    } while (0 == o);
  }

  return o;
}, goog.string.internal.compareElements_ = function (e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}, goog.string.TypedString = function () {}, goog.string.Const = function (e, t) {
  this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = e === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && t || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
}, goog.string.Const.prototype.implementsGoogStringTypedString = !0, goog.string.Const.prototype.getTypedStringValue = function () {
  return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
}, goog.string.Const.prototype.toString = function () {
  return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
}, goog.string.Const.unwrap = function (e) {
  return e instanceof goog.string.Const && e.constructor === goog.string.Const && e.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? e.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + e + "'"), "type_error:Const");
}, goog.string.Const.from = function (e) {
  return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, e);
}, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function (e) {
  return goog.fs.url.getUrlObject_().createObjectURL(e);
}, goog.fs.url.revokeObjectUrl = function (e) {
  goog.fs.url.getUrlObject_().revokeObjectURL(e);
}, goog.fs.url.getUrlObject_ = function () {
  var e = goog.fs.url.findUrlObject_();
  if (null != e) return e;
  throw Error("This browser doesn't seem to support blob URLs");
}, goog.fs.url.findUrlObject_ = function () {
  return goog.isDef(goog.global.URL) && goog.isDef(goog.global.URL.createObjectURL) ? goog.global.URL : goog.isDef(goog.global.webkitURL) && goog.isDef(goog.global.webkitURL.createObjectURL) ? goog.global.webkitURL : goog.isDef(goog.global.createObjectURL) ? goog.global : null;
}, goog.fs.url.browserSupportsObjectUrls = function () {
  return null != goog.fs.url.findUrlObject_();
}, goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = !1, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase()), goog.i18n.bidi.Format = {
  LRE: "‪",
  RLE: "‫",
  PDF: "‬",
  LRM: "‎",
  RLM: "‏"
}, goog.i18n.bidi.Dir = {
  LTR: 1,
  RTL: -1,
  NEUTRAL: 0
}, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function (e, t) {
  return "number" == typeof e ? 0 < e ? goog.i18n.bidi.Dir.LTR : 0 > e ? goog.i18n.bidi.Dir.RTL : t ? null : goog.i18n.bidi.Dir.NEUTRAL : null == e ? null : e ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
}, goog.i18n.bidi.ltrChars_ = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ऀ-῿‎Ⰰ-\ud801\ud804-\ud839\ud83c-\udbff豈-﬜︀-﹯﻽-￿", goog.i18n.bidi.rtlChars_ = "֑-ۯۺ-ࣿ‏\ud802-\ud803\ud83a-\ud83bיִ-﷿ﹰ-ﻼ", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function (e, t) {
  return t ? e.replace(goog.i18n.bidi.htmlSkipReg_, "") : e;
}, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function (e, t) {
  return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function (e, t) {
  return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function (e) {
  return goog.i18n.bidi.rtlRe_.test(e);
}, goog.i18n.bidi.isLtrChar = function (e) {
  return goog.i18n.bidi.ltrRe_.test(e);
}, goog.i18n.bidi.isNeutralChar = function (e) {
  return !goog.i18n.bidi.isLtrChar(e) && !goog.i18n.bidi.isRtlChar(e);
}, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function (e, t) {
  return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function (e, t) {
  return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function (e, t) {
  return e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t), goog.i18n.bidi.isRequiredLtrRe_.test(e) || !goog.i18n.bidi.hasAnyLtr(e) && !goog.i18n.bidi.hasAnyRtl(e);
}, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function (e, t) {
  return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function (e, t) {
  return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
}, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function (e) {
  return goog.i18n.bidi.rtlLocalesRe_.test(e);
}, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function (e, t) {
  return t = (void 0 === t ? goog.i18n.bidi.hasAnyRtl(e) : t) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, e.replace(goog.i18n.bidi.bracketGuardTextRe_, t + "$&" + t);
}, goog.i18n.bidi.enforceRtlInHtml = function (e) {
  return "<" == e.charAt(0) ? e.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + e + "</span>";
}, goog.i18n.bidi.enforceRtlInText = function (e) {
  return goog.i18n.bidi.Format.RLE + e + goog.i18n.bidi.Format.PDF;
}, goog.i18n.bidi.enforceLtrInHtml = function (e) {
  return "<" == e.charAt(0) ? e.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + e + "</span>";
}, goog.i18n.bidi.enforceLtrInText = function (e) {
  return goog.i18n.bidi.Format.LRE + e + goog.i18n.bidi.Format.PDF;
}, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function (e) {
  return e.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
}, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function (e) {
  return e.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1״").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1׳");
}, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = .4, goog.i18n.bidi.estimateDirection = function (e, t) {
  var o = 0,
      r = 0,
      s = !1;

  for (e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t).split(goog.i18n.bidi.wordSeparatorRe_), t = 0; t < e.length; t++) {
    var n = e[t];
    goog.i18n.bidi.startsWithRtl(n) ? (o++, r++) : goog.i18n.bidi.isRequiredLtrRe_.test(n) ? s = !0 : goog.i18n.bidi.hasAnyLtr(n) ? r++ : goog.i18n.bidi.hasNumeralsRe_.test(n) && (s = !0);
  }

  return 0 == r ? s ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : o / r > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
}, goog.i18n.bidi.detectRtlDirectionality = function (e, t) {
  return goog.i18n.bidi.estimateDirection(e, t) == goog.i18n.bidi.Dir.RTL;
}, goog.i18n.bidi.setElementDirAndAlign = function (e, t) {
  e && (t = goog.i18n.bidi.toDir(t)) && (e.style.textAlign = t == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, e.dir = t == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
}, goog.i18n.bidi.setElementDirByTextDirectionality = function (e, t) {
  switch (goog.i18n.bidi.estimateDirection(t)) {
    case goog.i18n.bidi.Dir.LTR:
      e.dir = "ltr";
      break;

    case goog.i18n.bidi.Dir.RTL:
      e.dir = "rtl";
      break;

    default:
      e.removeAttribute("dir");
  }
}, goog.i18n.bidi.DirectionalString = function () {}, goog.html.TrustedResourceUrl = function () {
  this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = "", this.trustedURL_ = null, this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
}, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.TrustedResourceUrl.prototype.getDirection = function () {
  return goog.i18n.bidi.Dir.LTR;
}, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function (e, t) {
  var o = goog.html.TrustedResourceUrl.unwrap(this),
      r = (o = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(o))[3] || "";
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(o[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", o[2] || "", e) + goog.html.TrustedResourceUrl.stringifyParams_("#", r, t));
}, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function () {
  return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
}), goog.html.TrustedResourceUrl.unwrap = function (e) {
  return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(e).toString();
}, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function (e) {
  return e instanceof goog.html.TrustedResourceUrl && e.constructor === goog.html.TrustedResourceUrl && e.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:TrustedResourceUrl");
}, goog.html.TrustedResourceUrl.unwrapTrustedURL = function (e) {
  return e.trustedURL_ ? e.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(e);
}, goog.html.TrustedResourceUrl.format = function (e, t) {
  var o = goog.string.Const.unwrap(e);
  if (!goog.html.TrustedResourceUrl.BASE_URL_.test(o)) throw Error("Invalid TrustedResourceUrl format: " + o);
  return e = o.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function (e, r) {
    if (!Object.prototype.hasOwnProperty.call(t, r)) throw Error('Found marker, "' + r + '", in format string, "' + o + '", but no valid label mapping found in args: ' + JSON.stringify(t));
    return (e = t[r]) instanceof goog.string.Const ? goog.string.Const.unwrap(e) : encodeURIComponent(String(e));
  }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function (e, t, o, r) {
  return goog.html.TrustedResourceUrl.format(e, t).cloneWithParams(o, r);
}, goog.html.TrustedResourceUrl.fromConstant = function (e) {
  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
}, goog.html.TrustedResourceUrl.fromConstants = function (e) {
  for (var t = "", o = 0; o < e.length; o++) t += goog.string.Const.unwrap(e[o]);

  return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function (e) {
  var t = new goog.html.TrustedResourceUrl();
  return t.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(e) : e, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY && (t.trustedURL_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(e)), t;
}, goog.html.TrustedResourceUrl.stringifyParams_ = function (e, t, o) {
  if (null == o) return t;
  if (goog.isString(o)) return o ? e + encodeURIComponent(o) : "";

  for (var r in o) {
    var s = o[r];
    s = goog.isArray(s) ? s : [s];

    for (var n = 0; n < s.length; n++) {
      var i = s[n];
      null != i && (t || (t = e), t += (t.length > e.length ? "&" : "") + encodeURIComponent(r) + "=" + encodeURIComponent(String(i)));
    }
  }

  return t;
}, goog.html.SafeUrl = function () {
  this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = "", this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0, goog.html.SafeUrl.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
}, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeUrl.prototype.getDirection = function () {
  return goog.i18n.bidi.Dir.LTR;
}, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function () {
  return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
}), goog.html.SafeUrl.unwrap = function (e) {
  return goog.html.SafeUrl.unwrapTrustedURL(e).toString();
}, goog.html.SafeUrl.unwrapTrustedURL = function (e) {
  return e instanceof goog.html.SafeUrl && e.constructor === goog.html.SafeUrl && e.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeUrl");
}, goog.html.SafeUrl.fromConstant = function (e) {
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
}, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function (e) {
  return goog.html.SAFE_MIME_TYPE_PATTERN_.test(e);
}, goog.html.SafeUrl.fromBlob = function (e) {
  return e = goog.html.SAFE_MIME_TYPE_PATTERN_.test(e.type) ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.fromDataUrl = function (e) {
  var t = (e = e.replace(/(%0A|%0D)/g, "")).match(goog.html.DATA_URL_PATTERN_);
  return t = t && goog.html.SAFE_MIME_TYPE_PATTERN_.test(t[1]), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t ? e : goog.html.SafeUrl.INNOCUOUS_STRING);
}, goog.html.SafeUrl.fromTelUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "tel:") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function (e) {
  return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(e)) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.fromFacebookMessengerUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "fb-messenger://share") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.fromWhatsAppUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "whatsapp://send") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.fromSmsUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.isSmsUrlBodyValid_ = function (e) {
  var t = e.indexOf("#");
  if (0 < t && (e = e.substring(0, t)), !(t = e.match(/[?&]body=/gi))) return !0;
  if (1 < t.length) return !1;
  if (!(e = e.match(/[?&]body=([^&]*)/)[1])) return !0;

  try {
    decodeURIComponent(e);
  } catch (e) {
    return !1;
  }

  return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(e);
}, goog.html.SafeUrl.fromSshUrl = function (e) {
  return goog.string.internal.caseInsensitiveStartsWith(e, "ssh://") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function (e, t) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, e, t);
}, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function (e, t) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, e, t);
}, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function (e, t) {
  return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, e, t);
}, goog.html.SafeUrl.sanitizeExtensionUrl_ = function (e, t, o) {
  return (e = e.exec(t)) ? (e = e[1], -1 == (o instanceof goog.string.Const ? [goog.string.Const.unwrap(o)] : o.map(function (e) {
    return goog.string.Const.unwrap(e);
  })).indexOf(e) && (t = goog.html.SafeUrl.INNOCUOUS_STRING)) : t = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.SafeUrl.fromTrustedResourceUrl = function (e) {
  return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(e));
}, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.sanitize = function (e) {
  return e instanceof goog.html.SafeUrl ? e : (e = "object" == typeof e && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SAFE_URL_PATTERN_.test(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e));
}, goog.html.SafeUrl.sanitizeAssertUnchanged = function (e, t) {
  return e instanceof goog.html.SafeUrl ? e : (e = "object" == typeof e && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), t && /^data:/i.test(e) && (t = goog.html.SafeUrl.fromDataUrl(e)).getTypedStringValue() == e ? t : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(e), "%s does not match the safe URL pattern", e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e)));
}, goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function (e) {
  var t = new goog.html.SafeUrl();
  return t.privateDoNotAccessOrElseSafeUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(e) : e, t;
}, goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeStyle = function () {
  this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "", this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyle.fromConstant = function (e) {
  return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(e, ";"), "Last character of style string is not ';': " + e), goog.asserts.assert(goog.string.internal.contains(e, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + e), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(e));
}, goog.html.SafeStyle.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
}, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function () {
  return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
}), goog.html.SafeStyle.unwrap = function (e) {
  return e instanceof goog.html.SafeStyle && e.constructor === goog.html.SafeStyle && e.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyle");
}, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function (e) {
  return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(e);
}, goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
  return this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = e, this;
}, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function (e) {
  var t,
      o = "";

  for (t in e) {
    if (!/^[-_a-zA-Z0-9]+$/.test(t)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + t);
    var r = e[t];
    null != r && (o += t + ":" + (r = goog.isArray(r) ? goog.array.map(r, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(r)) + ";");
  }

  return o ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(o) : goog.html.SafeStyle.EMPTY;
}, goog.html.SafeStyle.sanitizePropertyValue_ = function (e) {
  if (e instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(e).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
  if (e = e instanceof goog.string.Const ? goog.string.Const.unwrap(e) : goog.html.SafeStyle.sanitizePropertyValueString_(String(e)), /[{;}]/.test(e)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [e]);
  return e;
}, goog.html.SafeStyle.sanitizePropertyValueString_ = function (e) {
  var t = e.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
  return goog.html.SafeStyle.VALUE_RE_.test(t) ? goog.html.SafeStyle.COMMENT_RE_.test(e) ? (goog.asserts.fail("String value disallows comments, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : goog.html.SafeStyle.hasBalancedQuotes_(e) ? goog.html.SafeStyle.hasBalancedSquareBrackets_(e) ? goog.html.SafeStyle.sanitizeUrl_(e) : (goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value requires balanced quotes, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING);
}, goog.html.SafeStyle.hasBalancedQuotes_ = function (e) {
  for (var t = !0, o = !0, r = 0; r < e.length; r++) {
    var s = e.charAt(r);
    "'" == s && o ? t = !t : '"' == s && t && (o = !o);
  }

  return t && o;
}, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function (e) {
  for (var t = !0, o = /^[-_a-zA-Z0-9]$/, r = 0; r < e.length; r++) {
    var s = e.charAt(r);

    if ("]" == s) {
      if (t) return !1;
      t = !0;
    } else if ("[" == s) {
      if (!t) return !1;
      t = !1;
    } else if (!t && !o.test(s)) return !1;
  }

  return t;
}, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]", goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.FUNCTIONS_RE_ = /\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g, goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function (e) {
  return e.replace(goog.html.SafeStyle.URL_RE_, function (e, t, o, r) {
    var s = "";
    return o = o.replace(/^(['"])(.*)\1$/, function (e, t, o) {
      return s = t, o;
    }), e = goog.html.SafeUrl.sanitize(o).getTypedStringValue(), t + s + e + s + r;
  });
}, goog.html.SafeStyle.concat = function (e) {
  var t = "",
      o = function o(e) {
    goog.isArray(e) ? goog.array.forEach(e, o) : t += goog.html.SafeStyle.unwrap(e);
  };

  return goog.array.forEach(arguments, o), t ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t) : goog.html.SafeStyle.EMPTY;
}, goog.html.SafeScript = function () {
  this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "", this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0, goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeScript.fromConstant = function (e) {
  return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeScript.fromConstantAndArgs = function (e, t) {
  for (var o = [], r = 1; r < arguments.length; r++) o.push(goog.html.SafeScript.stringify_(arguments[r]));

  return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(e) + ")(" + o.join(", ") + ");");
}, goog.html.SafeScript.fromJson = function (e) {
  return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(e));
}, goog.html.SafeScript.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
}, goog.DEBUG && (goog.html.SafeScript.prototype.toString = function () {
  return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
}), goog.html.SafeScript.unwrap = function (e) {
  return goog.html.SafeScript.unwrapTrustedScript(e).toString();
}, goog.html.SafeScript.unwrapTrustedScript = function (e) {
  return e instanceof goog.html.SafeScript && e.constructor === goog.html.SafeScript && e.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeScriptWrappedValue_ : (goog.asserts.fail("expected object of type SafeScript, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeScript");
}, goog.html.SafeScript.stringify_ = function (e) {
  return JSON.stringify(e).replace(/</g, "\\x3c");
}, goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function (e) {
  return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(e);
}, goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
  return this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(e) : e, this;
}, goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(""), goog.object = {}, goog.object.is = function (e, t) {
  return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
}, goog.object.forEach = function (e, t, o) {
  for (var r in e) t.call(o, e[r], r, e);
}, goog.object.filter = function (e, t, o) {
  var r,
      s = {};

  for (r in e) t.call(o, e[r], r, e) && (s[r] = e[r]);

  return s;
}, goog.object.map = function (e, t, o) {
  var r,
      s = {};

  for (r in e) s[r] = t.call(o, e[r], r, e);

  return s;
}, goog.object.some = function (e, t, o) {
  for (var r in e) if (t.call(o, e[r], r, e)) return !0;

  return !1;
}, goog.object.every = function (e, t, o) {
  for (var r in e) if (!t.call(o, e[r], r, e)) return !1;

  return !0;
}, goog.object.getCount = function (e) {
  var t,
      o = 0;

  for (t in e) o++;

  return o;
}, goog.object.getAnyKey = function (e) {
  for (var t in e) return t;
}, goog.object.getAnyValue = function (e) {
  for (var t in e) return e[t];
}, goog.object.contains = function (e, t) {
  return goog.object.containsValue(e, t);
}, goog.object.getValues = function (e) {
  var t,
      o = [],
      r = 0;

  for (t in e) o[r++] = e[t];

  return o;
}, goog.object.getKeys = function (e) {
  var t,
      o = [],
      r = 0;

  for (t in e) o[r++] = t;

  return o;
}, goog.object.getValueByKeys = function (e, t) {
  var o = goog.isArrayLike(t),
      r = o ? t : arguments;

  for (o = o ? 0 : 1; o < r.length; o++) {
    if (null == e) return;
    e = e[r[o]];
  }

  return e;
}, goog.object.containsKey = function (e, t) {
  return null !== e && t in e;
}, goog.object.containsValue = function (e, t) {
  for (var o in e) if (e[o] == t) return !0;

  return !1;
}, goog.object.findKey = function (e, t, o) {
  for (var r in e) if (t.call(o, e[r], r, e)) return r;
}, goog.object.findValue = function (e, t, o) {
  return (t = goog.object.findKey(e, t, o)) && e[t];
}, goog.object.isEmpty = function (e) {
  for (var t in e) return !1;

  return !0;
}, goog.object.clear = function (e) {
  for (var t in e) delete e[t];
}, goog.object.remove = function (e, t) {
  var o;
  return (o = t in e) && delete e[t], o;
}, goog.object.add = function (e, t, o) {
  if (null !== e && t in e) throw Error('The object already contains the key "' + t + '"');
  goog.object.set(e, t, o);
}, goog.object.get = function (e, t, o) {
  return null !== e && t in e ? e[t] : o;
}, goog.object.set = function (e, t, o) {
  e[t] = o;
}, goog.object.setIfUndefined = function (e, t, o) {
  return t in e ? e[t] : e[t] = o;
}, goog.object.setWithReturnValueIfNotSet = function (e, t, o) {
  return t in e ? e[t] : (o = o(), e[t] = o);
}, goog.object.equals = function (e, t) {
  for (var o in e) if (!(o in t) || e[o] !== t[o]) return !1;

  for (var r in t) if (!(r in e)) return !1;

  return !0;
}, goog.object.clone = function (e) {
  var t,
      o = {};

  for (t in e) o[t] = e[t];

  return o;
}, goog.object.unsafeClone = function (e) {
  var t = goog.typeOf(e);

  if ("object" == t || "array" == t) {
    if (goog.isFunction(e.clone)) return e.clone();

    for (var o in t = "array" == t ? [] : {}, e) t[o] = goog.object.unsafeClone(e[o]);

    return t;
  }

  return e;
}, goog.object.transpose = function (e) {
  var t,
      o = {};

  for (t in e) o[e[t]] = t;

  return o;
}, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function (e, t) {
  for (var o, r, s = 1; s < arguments.length; s++) {
    for (o in r = arguments[s]) e[o] = r[o];

    for (var n = 0; n < goog.object.PROTOTYPE_FIELDS_.length; n++) o = goog.object.PROTOTYPE_FIELDS_[n], Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }
}, goog.object.create = function (e) {
  var t = arguments.length;
  if (1 == t && goog.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
  if (t % 2) throw Error("Uneven number of arguments");

  for (var o = {}, r = 0; r < t; r += 2) o[arguments[r]] = arguments[r + 1];

  return o;
}, goog.object.createSet = function (e) {
  var t = arguments.length;
  if (1 == t && goog.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);

  for (var o = {}, r = 0; r < t; r++) o[arguments[r]] = !0;

  return o;
}, goog.object.createImmutableView = function (e) {
  var t = e;
  return Object.isFrozen && !Object.isFrozen(e) && (t = Object.create(e), Object.freeze(t)), t;
}, goog.object.isImmutableView = function (e) {
  return !!Object.isFrozen && Object.isFrozen(e);
}, goog.object.getAllPropertyNames = function (e, t, o) {
  if (!e) return [];
  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(e);

  for (var r = {}; e && (e !== Object.prototype || t) && (e !== Function.prototype || o);) {
    for (var s = Object.getOwnPropertyNames(e), n = 0; n < s.length; n++) r[s[n]] = !0;

    e = Object.getPrototypeOf(e);
  }

  return goog.object.getKeys(r);
}, goog.object.getSuperClass = function (e) {
  return (e = Object.getPrototypeOf(e.prototype)) && e.constructor;
}, goog.html.SafeStyleSheet = function () {
  this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "", this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
}, goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyleSheet.createRule = function (e, t) {
  if (goog.string.internal.contains(e, "<")) throw Error("Selector does not allow '<', got: " + e);
  var o = e.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
  if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(o)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + e);
  if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(o)) throw Error("() and [] in selector must be balanced, got: " + e);
  return t instanceof goog.html.SafeStyle || (t = goog.html.SafeStyle.create(t)), e = e + "{" + goog.html.SafeStyle.unwrap(t).replace(/</g, "\\3C ") + "}", goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e);
}, goog.html.SafeStyleSheet.hasBalancedBrackets_ = function (e) {
  for (var t = {
    "(": ")",
    "[": "]"
  }, o = [], r = 0; r < e.length; r++) {
    var s = e[r];
    if (t[s]) o.push(t[s]);else if (goog.object.contains(t, s) && o.pop() != s) return !1;
  }

  return 0 == o.length;
}, goog.html.SafeStyleSheet.concat = function (e) {
  var t = "",
      o = function o(e) {
    goog.isArray(e) ? goog.array.forEach(e, o) : t += goog.html.SafeStyleSheet.unwrap(e);
  };

  return goog.array.forEach(arguments, o), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.SafeStyleSheet.fromConstant = function (e) {
  return 0 === (e = goog.string.Const.unwrap(e)).length ? goog.html.SafeStyleSheet.EMPTY : (goog.asserts.assert(!goog.string.internal.contains(e, "<"), "Forbidden '<' character in style sheet string: " + e), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e));
}, goog.html.SafeStyleSheet.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
}, goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function () {
  return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
}), goog.html.SafeStyleSheet.unwrap = function (e) {
  return e instanceof goog.html.SafeStyleSheet && e.constructor === goog.html.SafeStyleSheet && e.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyleSheet, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyleSheet");
}, goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function (e) {
  return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(e);
}, goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e) {
  return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = e, this;
}, goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  command: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
}, goog.dom.tags.isVoidTag = function (e) {
  return !0 === goog.dom.tags.VOID_TAGS_[e];
}, goog.dom.HtmlElement = function () {}, goog.dom.TagName = function (e) {
  this.tagName_ = e;
}, goog.dom.TagName.prototype.toString = function () {
  return this.tagName_;
}, goog.dom.TagName.A = new goog.dom.TagName("A"), goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR"), goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM"), goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS"), goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET"), goog.dom.TagName.AREA = new goog.dom.TagName("AREA"), goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE"), goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE"), goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO"), goog.dom.TagName.B = new goog.dom.TagName("B"), goog.dom.TagName.BASE = new goog.dom.TagName("BASE"), goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT"), goog.dom.TagName.BDI = new goog.dom.TagName("BDI"), goog.dom.TagName.BDO = new goog.dom.TagName("BDO"), goog.dom.TagName.BIG = new goog.dom.TagName("BIG"), goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE"), goog.dom.TagName.BODY = new goog.dom.TagName("BODY"), goog.dom.TagName.BR = new goog.dom.TagName("BR"), goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON"), goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS"), goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION"), goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER"), goog.dom.TagName.CITE = new goog.dom.TagName("CITE"), goog.dom.TagName.CODE = new goog.dom.TagName("CODE"), goog.dom.TagName.COL = new goog.dom.TagName("COL"), goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP"), goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND"), goog.dom.TagName.DATA = new goog.dom.TagName("DATA"), goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST"), goog.dom.TagName.DD = new goog.dom.TagName("DD"), goog.dom.TagName.DEL = new goog.dom.TagName("DEL"), goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS"), goog.dom.TagName.DFN = new goog.dom.TagName("DFN"), goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG"), goog.dom.TagName.DIR = new goog.dom.TagName("DIR"), goog.dom.TagName.DIV = new goog.dom.TagName("DIV"), goog.dom.TagName.DL = new goog.dom.TagName("DL"), goog.dom.TagName.DT = new goog.dom.TagName("DT"), goog.dom.TagName.EM = new goog.dom.TagName("EM"), goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED"), goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET"), goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION"), goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE"), goog.dom.TagName.FONT = new goog.dom.TagName("FONT"), goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER"), goog.dom.TagName.FORM = new goog.dom.TagName("FORM"), goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME"), goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET"), goog.dom.TagName.H1 = new goog.dom.TagName("H1"), goog.dom.TagName.H2 = new goog.dom.TagName("H2"), goog.dom.TagName.H3 = new goog.dom.TagName("H3"), goog.dom.TagName.H4 = new goog.dom.TagName("H4"), goog.dom.TagName.H5 = new goog.dom.TagName("H5"), goog.dom.TagName.H6 = new goog.dom.TagName("H6"), goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD"), goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER"), goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP"), goog.dom.TagName.HR = new goog.dom.TagName("HR"), goog.dom.TagName.HTML = new goog.dom.TagName("HTML"), goog.dom.TagName.I = new goog.dom.TagName("I"), goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME"), goog.dom.TagName.IMG = new goog.dom.TagName("IMG"), goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT"), goog.dom.TagName.INS = new goog.dom.TagName("INS"), goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX"), goog.dom.TagName.KBD = new goog.dom.TagName("KBD"), goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN"), goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL"), goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND"), goog.dom.TagName.LI = new goog.dom.TagName("LI"), goog.dom.TagName.LINK = new goog.dom.TagName("LINK"), goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN"), goog.dom.TagName.MAP = new goog.dom.TagName("MAP"), goog.dom.TagName.MARK = new goog.dom.TagName("MARK"), goog.dom.TagName.MATH = new goog.dom.TagName("MATH"), goog.dom.TagName.MENU = new goog.dom.TagName("MENU"), goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM"), goog.dom.TagName.META = new goog.dom.TagName("META"), goog.dom.TagName.METER = new goog.dom.TagName("METER"), goog.dom.TagName.NAV = new goog.dom.TagName("NAV"), goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES"), goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT"), goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT"), goog.dom.TagName.OL = new goog.dom.TagName("OL"), goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP"), goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION"), goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT"), goog.dom.TagName.P = new goog.dom.TagName("P"), goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM"), goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE"), goog.dom.TagName.PRE = new goog.dom.TagName("PRE"), goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS"), goog.dom.TagName.Q = new goog.dom.TagName("Q"), goog.dom.TagName.RP = new goog.dom.TagName("RP"), goog.dom.TagName.RT = new goog.dom.TagName("RT"), goog.dom.TagName.RTC = new goog.dom.TagName("RTC"), goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY"), goog.dom.TagName.S = new goog.dom.TagName("S"), goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP"), goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT"), goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION"), goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT"), goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL"), goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE"), goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN"), goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE"), goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG"), goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE"), goog.dom.TagName.SUB = new goog.dom.TagName("SUB"), goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY"), goog.dom.TagName.SUP = new goog.dom.TagName("SUP"), goog.dom.TagName.SVG = new goog.dom.TagName("SVG"), goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE"), goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY"), goog.dom.TagName.TD = new goog.dom.TagName("TD"), goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE"), goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA"), goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT"), goog.dom.TagName.TH = new goog.dom.TagName("TH"), goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD"), goog.dom.TagName.TIME = new goog.dom.TagName("TIME"), goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE"), goog.dom.TagName.TR = new goog.dom.TagName("TR"), goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK"), goog.dom.TagName.TT = new goog.dom.TagName("TT"), goog.dom.TagName.U = new goog.dom.TagName("U"), goog.dom.TagName.UL = new goog.dom.TagName("UL"), goog.dom.TagName.VAR = new goog.dom.TagName("VAR"), goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO"), goog.dom.TagName.WBR = new goog.dom.TagName("WBR"), goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function () {
  var e = goog.labs.userAgent.util.getNavigator_();
  return e && (e = e.userAgent) ? e : "";
}, goog.labs.userAgent.util.getNavigator_ = function () {
  return goog.global.navigator;
}, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function (e) {
  goog.labs.userAgent.util.userAgent_ = e || goog.labs.userAgent.util.getNativeUserAgentString_();
}, goog.labs.userAgent.util.getUserAgent = function () {
  return goog.labs.userAgent.util.userAgent_;
}, goog.labs.userAgent.util.matchUserAgent = function (e) {
  var t = goog.labs.userAgent.util.getUserAgent();
  return goog.string.internal.contains(t, e);
}, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function (e) {
  var t = goog.labs.userAgent.util.getUserAgent();
  return goog.string.internal.caseInsensitiveContains(t, e);
}, goog.labs.userAgent.util.extractVersionTuples = function (e) {
  for (var t, o = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, r = []; t = o.exec(e);) r.push([t[1], t[2], t[3] || void 0]);

  return r;
}, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Opera");
}, goog.labs.userAgent.browser.matchIE_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
}, goog.labs.userAgent.browser.matchEdgeHtml_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Edge");
}, goog.labs.userAgent.browser.matchEdgeChromium_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Edg/");
}, goog.labs.userAgent.browser.matchOperaChromium_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("OPR");
}, goog.labs.userAgent.browser.matchFirefox_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
}, goog.labs.userAgent.browser.matchSafari_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
}, goog.labs.userAgent.browser.matchCoast_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Coast");
}, goog.labs.userAgent.browser.matchIosWebview_ = function () {
  return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
}, goog.labs.userAgent.browser.matchChrome_ = function () {
  return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
}, goog.labs.userAgent.browser.matchAndroidBrowser_ = function () {
  return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
}, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function () {
  return goog.labs.userAgent.util.matchUserAgent("Silk");
}, goog.labs.userAgent.browser.getVersion = function () {
  function e(e) {
    return e = goog.array.find(e, r), o[e] || "";
  }

  var t = goog.labs.userAgent.util.getUserAgent();
  if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(t);
  t = goog.labs.userAgent.util.extractVersionTuples(t);
  var o = {};
  goog.array.forEach(t, function (e) {
    o[e[0]] = e[1];
  });
  var r = goog.partial(goog.object.containsKey, o);
  return goog.labs.userAgent.browser.isOpera() ? e(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? e(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? e(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? e(["Chrome", "CriOS"]) : (t = t[2]) && t[1] || "";
}, goog.labs.userAgent.browser.isVersionOrHigher = function (e) {
  return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), e);
}, goog.labs.userAgent.browser.getIEVersion_ = function (e) {
  var t = /rv: *([\d\.]*)/.exec(e);
  if (t && t[1]) return t[1];
  t = "";
  var o = /MSIE +([\d\.]+)/.exec(e);
  if (o && o[1]) if (e = /Trident\/(\d.\d)/.exec(e), "7.0" == o[1]) {
    if (e && e[1]) switch (e[1]) {
      case "4.0":
        t = "8.0";
        break;

      case "5.0":
        t = "9.0";
        break;

      case "6.0":
        t = "10.0";
        break;

      case "7.0":
        t = "11.0";
    } else t = "7.0";
  } else t = o[1];
  return t;
}, goog.html.SafeHtml = function () {
  this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "", this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_, this.dir_ = null;
}, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeHtml.prototype.getDirection = function () {
  return this.dir_;
}, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0, goog.html.SafeHtml.prototype.getTypedStringValue = function () {
  return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
}, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function () {
  return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
}), goog.html.SafeHtml.unwrap = function (e) {
  return goog.html.SafeHtml.unwrapTrustedHTML(e).toString();
}, goog.html.SafeHtml.unwrapTrustedHTML = function (e) {
  return e instanceof goog.html.SafeHtml && e.constructor === goog.html.SafeHtml && e.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeHtml");
}, goog.html.SafeHtml.htmlEscape = function (e) {
  if (e instanceof goog.html.SafeHtml) return e;
  var t = "object" == typeof e,
      o = null;
  return t && e.implementsGoogI18nBidiDirectionalString && (o = e.getDirection()), e = t && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(e), o);
}, goog.html.SafeHtml.htmlEscapePreservingNewlines = function (e) {
  return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
}, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function (e) {
  return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
}, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = {
  action: !0,
  cite: !0,
  data: !0,
  formaction: !0,
  href: !0,
  manifest: !0,
  poster: !0,
  src: !0
}, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = {
  APPLET: !0,
  BASE: !0,
  EMBED: !0,
  IFRAME: !0,
  LINK: !0,
  MATH: !0,
  META: !0,
  OBJECT: !0,
  SCRIPT: !0,
  STYLE: !0,
  SVG: !0,
  TEMPLATE: !0
}, goog.html.SafeHtml.create = function (e, t, o) {
  return goog.html.SafeHtml.verifyTagName(String(e)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(e), t, o);
}, goog.html.SafeHtml.verifyTagName = function (e) {
  if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(e)) throw Error("Invalid tag name <" + e + ">.");
  if (e.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error("Tag name <" + e + "> is not allowed for SafeHtml.");
}, goog.html.SafeHtml.createIframe = function (e, t, o, r) {
  e && goog.html.TrustedResourceUrl.unwrap(e);
  var s = {};
  return s.src = e || null, s.srcdoc = t && goog.html.SafeHtml.unwrap(t), e = goog.html.SafeHtml.combineAttributes(s, {
    sandbox: ""
  }, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, r);
}, goog.html.SafeHtml.createSandboxIframe = function (e, t, o, r) {
  if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error("The browser does not support sandboxed iframes.");
  var s = {};
  return s.src = e ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)) : null, s.srcdoc = t || null, s.sandbox = "", e = goog.html.SafeHtml.combineAttributes(s, {}, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, r);
}, goog.html.SafeHtml.canUseSandboxIframe = function () {
  return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
}, goog.html.SafeHtml.createScriptSrc = function (e, t) {
  return goog.html.TrustedResourceUrl.unwrap(e), e = goog.html.SafeHtml.combineAttributes({
    src: e
  }, {}, t), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", e);
}, goog.html.SafeHtml.createScript = function (e, t) {
  for (var o in t) {
    var r = o.toLowerCase();
    if ("language" == r || "src" == r || "text" == r || "type" == r) throw Error('Cannot set "' + r + '" attribute');
  }

  for (o = "", e = goog.array.concat(e), r = 0; r < e.length; r++) o += goog.html.SafeScript.unwrap(e[r]);

  return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", t, e);
}, goog.html.SafeHtml.createStyle = function (e, t) {
  t = goog.html.SafeHtml.combineAttributes({
    type: "text/css"
  }, {}, t);
  var o = "";
  e = goog.array.concat(e);

  for (var r = 0; r < e.length; r++) o += goog.html.SafeStyleSheet.unwrap(e[r]);

  return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", t, e);
}, goog.html.SafeHtml.createMetaRefresh = function (e, t) {
  return e = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(e, ";") && (e = "'" + e.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
    "http-equiv": "refresh",
    content: (t || 0) + "; url=" + e
  });
}, goog.html.SafeHtml.getAttrNameAndValue_ = function (e, t, o) {
  if (o instanceof goog.string.Const) o = goog.string.Const.unwrap(o);else if ("style" == t.toLowerCase()) o = goog.html.SafeHtml.getStyleValue_(o);else {
    if (/^on/i.test(t)) throw Error('Attribute "' + t + '" requires goog.string.Const value, "' + o + '" given.');
    if (t.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (o instanceof goog.html.TrustedResourceUrl) o = goog.html.TrustedResourceUrl.unwrap(o);else if (o instanceof goog.html.SafeUrl) o = goog.html.SafeUrl.unwrap(o);else {
      if (!goog.isString(o)) throw Error('Attribute "' + t + '" on tag "' + e + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + o + '" given.');
      o = goog.html.SafeUrl.sanitize(o).getTypedStringValue();
    }
  }
  return o.implementsGoogStringTypedString && (o = o.getTypedStringValue()), goog.asserts.assert(goog.isString(o) || goog.isNumber(o), "String or number value expected, got " + typeof o + " with value: " + o), t + '="' + goog.string.internal.htmlEscape(String(o)) + '"';
}, goog.html.SafeHtml.getStyleValue_ = function (e) {
  if (!goog.isObject(e)) throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof e + " given: " + e);
  return e instanceof goog.html.SafeStyle || (e = goog.html.SafeStyle.create(e)), goog.html.SafeStyle.unwrap(e);
}, goog.html.SafeHtml.createWithDir = function (e, t, o, r) {
  return (t = goog.html.SafeHtml.create(t, o, r)).dir_ = e, t;
}, goog.html.SafeHtml.join = function (e, t) {
  var o = (e = goog.html.SafeHtml.htmlEscape(e)).getDirection(),
      r = [],
      s = function s(e) {
    goog.isArray(e) ? goog.array.forEach(e, s) : (e = goog.html.SafeHtml.htmlEscape(e), r.push(goog.html.SafeHtml.unwrap(e)), e = e.getDirection(), o == goog.i18n.bidi.Dir.NEUTRAL ? o = e : e != goog.i18n.bidi.Dir.NEUTRAL && o != e && (o = null));
  };

  return goog.array.forEach(t, s), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r.join(goog.html.SafeHtml.unwrap(e)), o);
}, goog.html.SafeHtml.concat = function (e) {
  return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
}, goog.html.SafeHtml.concatWithDir = function (e, t) {
  var o = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
  return o.dir_ = e, o;
}, goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function (e, t) {
  return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(e, t);
}, goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function (e, t) {
  return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(e) : e, this.dir_ = t, this;
}, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function (e, t, o) {
  var r = null,
      s = "<" + e + goog.html.SafeHtml.stringifyAttributes(e, t);
  return goog.isDefAndNotNull(o) ? goog.isArray(o) || (o = [o]) : o = [], goog.dom.tags.isVoidTag(e.toLowerCase()) ? (goog.asserts.assert(!o.length, "Void tag <" + e + "> does not allow content."), s += ">") : (r = goog.html.SafeHtml.concat(o), s += ">" + goog.html.SafeHtml.unwrap(r) + "</" + e + ">", r = r.getDirection()), (e = t && t.dir) && (r = /^(ltr|rtl|auto)$/i.test(e) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(s, r);
}, goog.html.SafeHtml.stringifyAttributes = function (e, t) {
  var o = "";
  if (t) for (var r in t) {
    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(r)) throw Error('Invalid attribute name "' + r + '".');
    var s = t[r];
    goog.isDefAndNotNull(s) && (o += " " + goog.html.SafeHtml.getAttrNameAndValue_(e, r, s));
  }
  return o;
}, goog.html.SafeHtml.combineAttributes = function (e, t, o) {
  var r,
      s = {};

  for (r in e) goog.asserts.assert(r.toLowerCase() == r, "Must be lower case"), s[r] = e[r];

  for (r in t) goog.asserts.assert(r.toLowerCase() == r, "Must be lower case"), s[r] = t[r];

  for (r in o) {
    var n = r.toLowerCase();
    if (n in e) throw Error('Cannot override "' + n + '" attribute, got "' + r + '" with value "' + o[r] + '"');
    n in t && delete s[n], s[r] = o[r];
  }

  return s;
}, goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function (e, t, o) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(t, o || null);
}, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function (e, t) {
  return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
}, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function (e) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var t = goog.dom.asserts.getWindow_(e);
    t && (!e || !(e instanceof t.Location) && e instanceof t.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(e));
  }

  return e;
}, goog.dom.asserts.assertIsElementType_ = function (e, t) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var o = goog.dom.asserts.getWindow_(e);
    o && void 0 !== o[t] && (e && (e instanceof o[t] || !(e instanceof o.Location || e instanceof o.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", t, goog.dom.asserts.debugStringForType_(e)));
  }

  return e;
}, goog.dom.asserts.assertIsHTMLAnchorElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLAnchorElement");
}, goog.dom.asserts.assertIsHTMLButtonElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLButtonElement");
}, goog.dom.asserts.assertIsHTMLLinkElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLLinkElement");
}, goog.dom.asserts.assertIsHTMLImageElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLImageElement");
}, goog.dom.asserts.assertIsHTMLAudioElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLAudioElement");
}, goog.dom.asserts.assertIsHTMLVideoElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLVideoElement");
}, goog.dom.asserts.assertIsHTMLInputElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLInputElement");
}, goog.dom.asserts.assertIsHTMLTextAreaElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLTextAreaElement");
}, goog.dom.asserts.assertIsHTMLCanvasElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLCanvasElement");
}, goog.dom.asserts.assertIsHTMLEmbedElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLEmbedElement");
}, goog.dom.asserts.assertIsHTMLFormElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLFormElement");
}, goog.dom.asserts.assertIsHTMLFrameElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLFrameElement");
}, goog.dom.asserts.assertIsHTMLIFrameElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLIFrameElement");
}, goog.dom.asserts.assertIsHTMLObjectElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLObjectElement");
}, goog.dom.asserts.assertIsHTMLScriptElement = function (e) {
  return goog.dom.asserts.assertIsElementType_(e, "HTMLScriptElement");
}, goog.dom.asserts.debugStringForType_ = function (e) {
  if (!goog.isObject(e)) return void 0 === e ? "undefined" : null === e ? "null" : typeof e;

  try {
    return e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e);
  } catch (e) {
    return "<object could not be stringified>";
  }
}, goog.dom.asserts.getWindow_ = function (e) {
  try {
    var t = e && e.ownerDocument,
        o = t && (t.defaultView || t.parentWindow);
    if ((o = o || goog.global).Element && o.Location) return o;
  } catch (e) {}

  return null;
}, goog.functions = {}, goog.functions.constant = function (e) {
  return function () {
    return e;
  };
}, goog.functions.FALSE = function () {
  return !1;
}, goog.functions.TRUE = function () {
  return !0;
}, goog.functions.NULL = function () {
  return null;
}, goog.functions.identity = function (e, t) {
  return e;
}, goog.functions.error = function (e) {
  return function () {
    throw Error(e);
  };
}, goog.functions.fail = function (e) {
  return function () {
    throw e;
  };
}, goog.functions.lock = function (e, t) {
  return t = t || 0, function () {
    return e.apply(this, Array.prototype.slice.call(arguments, 0, t));
  };
}, goog.functions.nth = function (e) {
  return function () {
    return arguments[e];
  };
}, goog.functions.partialRight = function (e, t) {
  var o = Array.prototype.slice.call(arguments, 1);
  return function () {
    var t = Array.prototype.slice.call(arguments);
    return t.push.apply(t, o), e.apply(this, t);
  };
}, goog.functions.withReturnValue = function (e, t) {
  return goog.functions.sequence(e, goog.functions.constant(t));
}, goog.functions.equalTo = function (e, t) {
  return function (o) {
    return t ? e == o : e === o;
  };
}, goog.functions.compose = function (e, t) {
  var o = arguments,
      r = o.length;
  return function () {
    var e;
    r && (e = o[r - 1].apply(this, arguments));

    for (var t = r - 2; 0 <= t; t--) e = o[t].call(this, e);

    return e;
  };
}, goog.functions.sequence = function (e) {
  var t = arguments,
      o = t.length;
  return function () {
    for (var e, r = 0; r < o; r++) e = t[r].apply(this, arguments);

    return e;
  };
}, goog.functions.and = function (e) {
  var t = arguments,
      o = t.length;
  return function () {
    for (var e = 0; e < o; e++) if (!t[e].apply(this, arguments)) return !1;

    return !0;
  };
}, goog.functions.or = function (e) {
  var t = arguments,
      o = t.length;
  return function () {
    for (var e = 0; e < o; e++) if (t[e].apply(this, arguments)) return !0;

    return !1;
  };
}, goog.functions.not = function (e) {
  return function () {
    return !e.apply(this, arguments);
  };
}, goog.functions.create = function (e, t) {
  var o = function o() {};

  return o.prototype = e.prototype, o = new o(), e.apply(o, Array.prototype.slice.call(arguments, 1)), o;
}, goog.functions.CACHE_RETURN_VALUE = !0, goog.functions.cacheReturnValue = function (e) {
  var t,
      o = !1;
  return function () {
    return goog.functions.CACHE_RETURN_VALUE ? (o || (t = e(), o = !0), t) : e();
  };
}, goog.functions.once = function (e) {
  var t = e;
  return function () {
    if (t) {
      var e = t;
      t = null, e();
    }
  };
}, goog.functions.debounce = function (e, t, o) {
  var r = 0;
  return function (s) {
    goog.global.clearTimeout(r);
    var n = arguments;
    r = goog.global.setTimeout(function () {
      e.apply(o, n);
    }, t);
  };
}, goog.functions.throttle = function (e, t, o) {
  var r = 0,
      s = !1,
      n = [],
      i = function i() {
    r = 0, s && (s = !1, a());
  },
      a = function a() {
    r = goog.global.setTimeout(i, t), e.apply(o, n);
  };

  return function (e) {
    n = arguments, r ? s = !0 : a();
  };
}, goog.functions.rateLimit = function (e, t, o) {
  var r = 0,
      s = function s() {
    r = 0;
  };

  return function (n) {
    r || (r = goog.global.setTimeout(s, t), e.apply(o, arguments));
  };
}, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = {
  AFTERBEGIN: "afterbegin",
  AFTEREND: "afterend",
  BEFOREBEGIN: "beforebegin",
  BEFOREEND: "beforeend"
}, goog.dom.safe.insertAdjacentHtml = function (e, t, o) {
  e.insertAdjacentHTML(t, goog.html.SafeHtml.unwrapTrustedHTML(o));
}, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
  MATH: !0,
  SCRIPT: !0,
  STYLE: !0,
  SVG: !0,
  TEMPLATE: !0
}, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function () {
  if (goog.DEBUG && "undefined" == typeof document) return !1;
  var e = document.createElement("div"),
      t = document.createElement("div");
  return t.appendChild(document.createElement("div")), e.appendChild(t), !(goog.DEBUG && !e.firstChild) && (t = e.firstChild.firstChild, e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !t.parentElement);
}), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function (e, t) {
  if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; e.lastChild;) e.removeChild(e.lastChild);
  e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
}, goog.dom.safe.setInnerHtml = function (e, t) {
  if (goog.asserts.ENABLE_ASSERTS) {
    var o = e.tagName.toUpperCase();
    if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[o]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + e.tagName + ".");
  }

  goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(e, t);
}, goog.dom.safe.setOuterHtml = function (e, t) {
  e.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
}, goog.dom.safe.setFormElementAction = function (e, t) {
  t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLFormElement(e).action = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setButtonFormAction = function (e, t) {
  t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLButtonElement(e).formAction = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setInputFormAction = function (e, t) {
  t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLInputElement(e).formAction = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setStyle = function (e, t) {
  e.style.cssText = goog.html.SafeStyle.unwrap(t);
}, goog.dom.safe.documentWrite = function (e, t) {
  e.write(goog.html.SafeHtml.unwrapTrustedHTML(t));
}, goog.dom.safe.setAnchorHref = function (e, t) {
  goog.dom.asserts.assertIsHTMLAnchorElement(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setImageSrc = function (e, t) {
  if (goog.dom.asserts.assertIsHTMLImageElement(e), !(t instanceof goog.html.SafeUrl)) {
    var o = /^data:image\//i.test(t);
    t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
  }

  e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setAudioSrc = function (e, t) {
  if (goog.dom.asserts.assertIsHTMLAudioElement(e), !(t instanceof goog.html.SafeUrl)) {
    var o = /^data:audio\//i.test(t);
    t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
  }

  e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setVideoSrc = function (e, t) {
  if (goog.dom.asserts.assertIsHTMLVideoElement(e), !(t instanceof goog.html.SafeUrl)) {
    var o = /^data:video\//i.test(t);
    t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
  }

  e.src = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setEmbedSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLEmbedElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
}, goog.dom.safe.setFrameSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setIframeSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLIFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(t);
}, goog.dom.safe.setIframeSrcdoc = function (e, t) {
  goog.dom.asserts.assertIsHTMLIFrameElement(e), e.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(t);
}, goog.dom.safe.setLinkHrefAndRel = function (e, t, o) {
  goog.dom.asserts.assertIsHTMLLinkElement(e), e.rel = o, goog.string.internal.caseInsensitiveContains(o, "stylesheet") ? (goog.asserts.assert(t instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), e.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(t)) : e.href = t instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(t) : t instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(t) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(t));
}, goog.dom.safe.setObjectData = function (e, t) {
  goog.dom.asserts.assertIsHTMLObjectElement(e), e.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
}, goog.dom.safe.setScriptSrc = function (e, t) {
  goog.dom.asserts.assertIsHTMLScriptElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t), (t = goog.getScriptNonce()) && e.setAttribute("nonce", t);
}, goog.dom.safe.setScriptContent = function (e, t) {
  goog.dom.asserts.assertIsHTMLScriptElement(e), e.text = goog.html.SafeScript.unwrapTrustedScript(t), (t = goog.getScriptNonce()) && e.setAttribute("nonce", t);
}, goog.dom.safe.setLocationHref = function (e, t) {
  goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrapTrustedURL(t);
}, goog.dom.safe.assignLocation = function (e, t) {
  goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.assign(goog.html.SafeUrl.unwrapTrustedURL(t));
}, goog.dom.safe.replaceLocation = function (e, t) {
  goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.replace(goog.html.SafeUrl.unwrapTrustedURL(t));
}, goog.dom.safe.openInWindow = function (e, t, o, r, s) {
  return e = e instanceof goog.html.SafeUrl ? e : goog.html.SafeUrl.sanitizeAssertUnchanged(e), (t || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(e), o ? goog.string.Const.unwrap(o) : "", r, s);
}, goog.dom.safe.parseFromStringHtml = function (e, t) {
  return goog.dom.safe.parseFromString(e, t, "text/html");
}, goog.dom.safe.parseFromString = function (e, t, o) {
  return e.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(t), o);
}, goog.dom.safe.createImageFromBlob = function (e) {
  if (!/^image\/.*/g.test(e.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
  var t = goog.global.URL.createObjectURL(e);
  return (e = new goog.global.Image()).onload = function () {
    goog.global.URL.revokeObjectURL(t);
  }, goog.dom.safe.setImageSrc(e, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), t)), e;
}, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = {
  NBSP: " "
}, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function (e, t) {
  for (var o = e.split("%s"), r = "", s = Array.prototype.slice.call(arguments, 1); s.length && 1 < o.length;) r += o.shift() + s.shift();

  return r + o.join("%s");
}, goog.string.collapseWhitespace = function (e) {
  return e.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
}, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function (e) {
  return 0 == e.length;
}, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function (e) {
  return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(e));
}, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function (e) {
  return !/[^\t\n\r ]/.test(e);
}, goog.string.isAlpha = function (e) {
  return !/[^a-zA-Z]/.test(e);
}, goog.string.isNumeric = function (e) {
  return !/[^0-9]/.test(e);
}, goog.string.isAlphaNumeric = function (e) {
  return !/[^a-zA-Z0-9]/.test(e);
}, goog.string.isSpace = function (e) {
  return " " == e;
}, goog.string.isUnicodeChar = function (e) {
  return 1 == e.length && " " <= e && "~" >= e || "" <= e && "�" >= e;
}, goog.string.stripNewlines = function (e) {
  return e.replace(/(\r\n|\r|\n)+/g, " ");
}, goog.string.canonicalizeNewlines = function (e) {
  return e.replace(/(\r\n|\r|\n)/g, "\n");
}, goog.string.normalizeWhitespace = function (e) {
  return e.replace(/\xa0|\s/g, " ");
}, goog.string.normalizeSpaces = function (e) {
  return e.replace(/\xa0|[ \t]+/g, " ");
}, goog.string.collapseBreakingSpaces = function (e) {
  return e.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
}, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function (e) {
  return e.replace(/^[\s\xa0]+/, "");
}, goog.string.trimRight = function (e) {
  return e.replace(/[\s\xa0]+$/, "");
}, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function (e, t, o) {
  if (e == t) return 0;
  if (!e) return -1;
  if (!t) return 1;

  for (var r = e.toLowerCase().match(o), s = t.toLowerCase().match(o), n = Math.min(r.length, s.length), i = 0; i < n; i++) {
    o = r[i];
    var a = s[i];
    if (o != a) return e = parseInt(o, 10), !isNaN(e) && (t = parseInt(a, 10), !isNaN(t) && e - t) ? e - t : o < a ? -1 : 1;
  }

  return r.length != s.length ? r.length - s.length : e < t ? -1 : 1;
}, goog.string.intAwareCompare = function (e, t) {
  return goog.string.numberAwareCompare_(e, t, /\d+|\D+/g);
}, goog.string.floatAwareCompare = function (e, t) {
  return goog.string.numberAwareCompare_(e, t, /\d+|\.\d+|\D+/g);
}, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function (e) {
  return encodeURIComponent(String(e));
}, goog.string.urlDecode = function (e) {
  return decodeURIComponent(e.replace(/\+/g, " "));
}, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function (e, t) {
  return e = goog.string.internal.htmlEscape(e, t), goog.string.DETECT_DOUBLE_ESCAPING && (e = e.replace(goog.string.E_RE_, "&#101;")), e;
}, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function (e) {
  return goog.string.contains(e, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(e) : goog.string.unescapePureXmlEntities_(e) : e;
}, goog.string.unescapeEntitiesWithDocument = function (e, t) {
  return goog.string.contains(e, "&") ? goog.string.unescapeEntitiesUsingDom_(e, t) : e;
}, goog.string.unescapeEntitiesUsingDom_ = function (e, t) {
  var o = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"'
  },
      r = t ? t.createElement("div") : goog.global.document.createElement("div");
  return e.replace(goog.string.HTML_ENTITY_PATTERN_, function (e, t) {
    var s = o[e];
    return s || ("#" == t.charAt(0) && (t = Number("0" + t.substr(1)), isNaN(t) || (s = String.fromCharCode(t))), s || (goog.dom.safe.setInnerHtml(r, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e + " ")), s = r.firstChild.nodeValue.slice(0, -1)), o[e] = s);
  });
}, goog.string.unescapePureXmlEntities_ = function (e) {
  return e.replace(/&([^;]+);/g, function (e, t) {
    switch (t) {
      case "amp":
        return "&";

      case "lt":
        return "<";

      case "gt":
        return ">";

      case "quot":
        return '"';

      default:
        return "#" != t.charAt(0) || (t = Number("0" + t.substr(1)), isNaN(t)) ? e : String.fromCharCode(t);
    }
  });
}, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function (e, t) {
  return goog.string.newLineToBr(e.replace(/  /g, " &#160;"), t);
}, goog.string.preserveSpaces = function (e) {
  return e.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
}, goog.string.stripQuotes = function (e, t) {
  for (var o = t.length, r = 0; r < o; r++) {
    var s = 1 == o ? t : t.charAt(r);
    if (e.charAt(0) == s && e.charAt(e.length - 1) == s) return e.substring(1, e.length - 1);
  }

  return e;
}, goog.string.truncate = function (e, t, o) {
  return o && (e = goog.string.unescapeEntities(e)), e.length > t && (e = e.substring(0, t - 3) + "..."), o && (e = goog.string.htmlEscape(e)), e;
}, goog.string.truncateMiddle = function (e, t, o, r) {
  if (o && (e = goog.string.unescapeEntities(e)), r && e.length > t) {
    r > t && (r = t);
    var s = e.length - r;
    e = e.substring(0, t - r) + "..." + e.substring(s);
  } else e.length > t && (r = Math.floor(t / 2), s = e.length - r, e = e.substring(0, r + t % 2) + "..." + e.substring(s));

  return o && (e = goog.string.htmlEscape(e)), e;
}, goog.string.specialEscapeChars_ = {
  "\0": "\\0",
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "\t": "\\t",
  "\v": "\\x0B",
  '"': '\\"',
  "\\": "\\\\",
  "<": "\\u003C"
}, goog.string.jsEscapeCache_ = {
  "'": "\\'"
}, goog.string.quote = function (e) {
  e = String(e);

  for (var t = ['"'], o = 0; o < e.length; o++) {
    var r = e.charAt(o),
        s = r.charCodeAt(0);
    t[o + 1] = goog.string.specialEscapeChars_[r] || (31 < s && 127 > s ? r : goog.string.escapeChar(r));
  }

  return t.push('"'), t.join("");
}, goog.string.escapeString = function (e) {
  for (var t = [], o = 0; o < e.length; o++) t[o] = goog.string.escapeChar(e.charAt(o));

  return t.join("");
}, goog.string.escapeChar = function (e) {
  if (e in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[e];
  if (e in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[e] = goog.string.specialEscapeChars_[e];
  var t = e.charCodeAt(0);
  if (31 < t && 127 > t) var o = e;else 256 > t ? (o = "\\x", (16 > t || 256 < t) && (o += "0")) : (o = "\\u", 4096 > t && (o += "0")), o += t.toString(16).toUpperCase();
  return goog.string.jsEscapeCache_[e] = o;
}, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function (e, t) {
  return e && t ? e.split(t).length - 1 : 0;
}, goog.string.removeAt = function (e, t, o) {
  var r = e;
  return 0 <= t && t < e.length && 0 < o && (r = e.substr(0, t) + e.substr(t + o, e.length - t - o)), r;
}, goog.string.remove = function (e, t) {
  return e.replace(t, "");
}, goog.string.removeAll = function (e, t) {
  return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, "");
}, goog.string.replaceAll = function (e, t, o) {
  return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, o.replace(/\$/g, "$$$$"));
}, goog.string.regExpEscape = function (e) {
  return String(e).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
}, goog.string.repeat = String.prototype.repeat ? function (e, t) {
  return e.repeat(t);
} : function (e, t) {
  return Array(t + 1).join(e);
}, goog.string.padNumber = function (e, t, o) {
  return -1 == (o = (e = goog.isDef(o) ? e.toFixed(o) : String(e)).indexOf(".")) && (o = e.length), goog.string.repeat("0", Math.max(0, t - o)) + e;
}, goog.string.makeSafe = function (e) {
  return null == e ? "" : String(e);
}, goog.string.buildString = function (e) {
  return Array.prototype.join.call(arguments, "");
}, goog.string.getRandomString = function () {
  return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
}, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function (e) {
  for (var t = 0, o = 0; o < e.length; ++o) t = 31 * t + e.charCodeAt(o) >>> 0;

  return t;
}, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function () {
  return "goog_" + goog.string.uniqueStringCounter_++;
}, goog.string.toNumber = function (e) {
  var t = Number(e);
  return 0 == t && goog.string.isEmptyOrWhitespace(e) ? NaN : t;
}, goog.string.isLowerCamelCase = function (e) {
  return /^[a-z]+([A-Z][a-z]*)*$/.test(e);
}, goog.string.isUpperCamelCase = function (e) {
  return /^([A-Z][a-z]*)+$/.test(e);
}, goog.string.toCamelCase = function (e) {
  return String(e).replace(/\-([a-z])/g, function (e, t) {
    return t.toUpperCase();
  });
}, goog.string.toSelectorCase = function (e) {
  return String(e).replace(/([A-Z])/g, "-$1").toLowerCase();
}, goog.string.toTitleCase = function (e, t) {
  return t = goog.isString(t) ? goog.string.regExpEscape(t) : "\\s", e.replace(new RegExp("(^" + (t ? "|[" + t + "]+" : "") + ")([a-z])", "g"), function (e, t, o) {
    return t + o.toUpperCase();
  });
}, goog.string.capitalize = function (e) {
  return String(e.charAt(0)).toUpperCase() + String(e.substr(1)).toLowerCase();
}, goog.string.parseInt = function (e) {
  return isFinite(e) && (e = String(e)), goog.isString(e) ? /^\s*-?0x/i.test(e) ? parseInt(e, 16) : parseInt(e, 10) : NaN;
}, goog.string.splitLimit = function (e, t, o) {
  e = e.split(t);

  for (var r = []; 0 < o && e.length;) r.push(e.shift()), o--;

  return e.length && r.push(e.join(t)), r;
}, goog.string.lastComponent = function (e, t) {
  if (!t) return e;
  "string" == typeof t && (t = [t]);

  for (var o = -1, r = 0; r < t.length; r++) if ("" != t[r]) {
    var s = e.lastIndexOf(t[r]);
    s > o && (o = s);
  }

  return -1 == o ? e : e.slice(o + 1);
}, goog.string.editDistance = function (e, t) {
  var o = [],
      r = [];
  if (e == t) return 0;
  if (!e.length || !t.length) return Math.max(e.length, t.length);

  for (var s = 0; s < t.length + 1; s++) o[s] = s;

  for (s = 0; s < e.length; s++) {
    r[0] = s + 1;

    for (var n = 0; n < t.length; n++) r[n + 1] = Math.min(r[n] + 1, o[n + 1] + 1, o[n] + Number(e[s] != t[n]));

    for (n = 0; n < o.length; n++) o[n] = r[n];
  }

  return r[t.length];
}, goog.labs.userAgent.platform = {}, goog.labs.userAgent.platform.isAndroid = function () {
  return goog.labs.userAgent.util.matchUserAgent("Android");
}, goog.labs.userAgent.platform.isIpod = function () {
  return goog.labs.userAgent.util.matchUserAgent("iPod");
}, goog.labs.userAgent.platform.isIphone = function () {
  return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
}, goog.labs.userAgent.platform.isIpad = function () {
  return goog.labs.userAgent.util.matchUserAgent("iPad");
}, goog.labs.userAgent.platform.isIos = function () {
  return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
}, goog.labs.userAgent.platform.isMacintosh = function () {
  return goog.labs.userAgent.util.matchUserAgent("Macintosh");
}, goog.labs.userAgent.platform.isLinux = function () {
  return goog.labs.userAgent.util.matchUserAgent("Linux");
}, goog.labs.userAgent.platform.isWindows = function () {
  return goog.labs.userAgent.util.matchUserAgent("Windows");
}, goog.labs.userAgent.platform.isChromeOS = function () {
  return goog.labs.userAgent.util.matchUserAgent("CrOS");
}, goog.labs.userAgent.platform.isChromecast = function () {
  return goog.labs.userAgent.util.matchUserAgent("CrKey");
}, goog.labs.userAgent.platform.isKaiOS = function () {
  return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
}, goog.labs.userAgent.platform.isGo2Phone = function () {
  return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP");
}, goog.labs.userAgent.platform.getVersion = function () {
  var e = goog.labs.userAgent.util.getUserAgent(),
      t = "";
  return goog.labs.userAgent.platform.isWindows() ? t = (e = (t = /Windows (?:NT|Phone) ([0-9.]+)/).exec(e)) ? e[1] : "0.0" : goog.labs.userAgent.platform.isIos() ? t = (e = (t = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/).exec(e)) && e[1].replace(/_/g, ".") : goog.labs.userAgent.platform.isMacintosh() ? t = (e = (t = /Mac OS X ([0-9_.]+)/).exec(e)) ? e[1].replace(/_/g, ".") : "10" : goog.labs.userAgent.platform.isKaiOS() ? t = (e = (t = /(?:KaiOS)\/(\S+)/i).exec(e)) && e[1] : goog.labs.userAgent.platform.isAndroid() ? t = (e = (t = /Android\s+([^\);]+)(\)|;)/).exec(e)) && e[1] : goog.labs.userAgent.platform.isChromeOS() && (t = (e = (t = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/).exec(e)) && e[1]), t || "";
}, goog.labs.userAgent.platform.isVersionOrHigher = function (e) {
  return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), e);
}, goog.reflect = {}, goog.reflect.object = function (e, t) {
  return t;
}, goog.reflect.objectProperty = function (e, t) {
  return e;
}, goog.reflect.sinkValue = function (e) {
  return goog.reflect.sinkValue[" "](e), e;
}, goog.reflect.sinkValue[" "] = goog.nullFunction, goog.reflect.canAccessProperty = function (e, t) {
  try {
    return goog.reflect.sinkValue(e[t]), !0;
  } catch (e) {}

  return !1;
}, goog.reflect.cache = function (e, t, o, r) {
  return r = r ? r(t) : t, Object.prototype.hasOwnProperty.call(e, r) ? e[r] : e[r] = o(t);
}, goog.labs.userAgent.engine = {}, goog.labs.userAgent.engine.isPresto = function () {
  return goog.labs.userAgent.util.matchUserAgent("Presto");
}, goog.labs.userAgent.engine.isTrident = function () {
  return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
}, goog.labs.userAgent.engine.isEdge = function () {
  return goog.labs.userAgent.util.matchUserAgent("Edge");
}, goog.labs.userAgent.engine.isWebKit = function () {
  return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
}, goog.labs.userAgent.engine.isGecko = function () {
  return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
}, goog.labs.userAgent.engine.getVersion = function () {
  var e = goog.labs.userAgent.util.getUserAgent();

  if (e) {
    e = goog.labs.userAgent.util.extractVersionTuples(e);
    var t,
        o = goog.labs.userAgent.engine.getEngineTuple_(e);
    if (o) return "Gecko" == o[0] ? goog.labs.userAgent.engine.getVersionForKey_(e, "Firefox") : o[1];
    if ((e = e[0]) && (t = e[2]) && (t = /Trident\/([^\s;]+)/.exec(t))) return t[1];
  }

  return "";
}, goog.labs.userAgent.engine.getEngineTuple_ = function (e) {
  if (!goog.labs.userAgent.engine.isEdge()) return e[1];

  for (var t = 0; t < e.length; t++) {
    var o = e[t];
    if ("Edge" == o[0]) return o;
  }
}, goog.labs.userAgent.engine.isVersionOrHigher = function (e) {
  return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), e);
}, goog.labs.userAgent.engine.getVersionForKey_ = function (e, t) {
  return (e = goog.array.find(e, function (e) {
    return t == e[0];
  })) && e[1] || "";
}, goog.userAgent = {}, goog.userAgent.ASSUME_IE = !1, goog.userAgent.ASSUME_EDGE = !1, goog.userAgent.ASSUME_GECKO = !1, goog.userAgent.ASSUME_WEBKIT = !1, goog.userAgent.ASSUME_MOBILE_WEBKIT = !1, goog.userAgent.ASSUME_OPERA = !1, goog.userAgent.ASSUME_ANY_VERSION = !1, goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA, goog.userAgent.getUserAgentString = function () {
  return goog.labs.userAgent.util.getUserAgent();
}, goog.userAgent.getNavigatorTyped = function () {
  return goog.global.navigator || null;
}, goog.userAgent.getNavigator = function () {
  return goog.userAgent.getNavigatorTyped();
}, goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera(), goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE(), goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge(), goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE, goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko();
goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit(), goog.userAgent.isMobile_ = function () {
  return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
}, goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_(), goog.userAgent.SAFARI = goog.userAgent.WEBKIT, goog.userAgent.determinePlatform_ = function () {
  var e = goog.userAgent.getNavigatorTyped();
  return e && e.platform || "";
}, goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_(), goog.userAgent.ASSUME_MAC = !1, goog.userAgent.ASSUME_WINDOWS = !1, goog.userAgent.ASSUME_LINUX = !1, goog.userAgent.ASSUME_X11 = !1, goog.userAgent.ASSUME_ANDROID = !1, goog.userAgent.ASSUME_IPHONE = !1, goog.userAgent.ASSUME_IPAD = !1, goog.userAgent.ASSUME_IPOD = !1, goog.userAgent.ASSUME_KAIOS = !1, goog.userAgent.ASSUME_GO2PHONE = !1, goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD, goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh(), goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows(), goog.userAgent.isLegacyLinux_ = function () {
  return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
}, goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_(), goog.userAgent.isX11_ = function () {
  var e = goog.userAgent.getNavigatorTyped();
  return !!e && goog.string.contains(e.appVersion || "", "X11");
}, goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_(), goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid(), goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone(), goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod(), goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos(), goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS(), goog.userAgent.GO2PHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_GO2PHONE : goog.labs.userAgent.platform.isGo2Phone(), goog.userAgent.determineVersion_ = function () {
  var e = "",
      t = goog.userAgent.getVersionRegexResult_();
  return t && (e = t ? t[1] : ""), goog.userAgent.IE && null != (t = goog.userAgent.getDocumentMode_()) && t > parseFloat(e) ? String(t) : e;
}, goog.userAgent.getVersionRegexResult_ = function () {
  var e = goog.userAgent.getUserAgentString();
  return goog.userAgent.GECKO ? /rv:([^\);]+)(\)|;)/.exec(e) : goog.userAgent.EDGE ? /Edge\/([\d\.]+)/.exec(e) : goog.userAgent.IE ? /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(e) : goog.userAgent.WEBKIT ? /WebKit\/(\S+)/.exec(e) : goog.userAgent.OPERA ? /(?:Version)[ \/]?(\S+)/.exec(e) : void 0;
}, goog.userAgent.getDocumentMode_ = function () {
  var e = goog.global.document;
  return e ? e.documentMode : void 0;
}, goog.userAgent.VERSION = goog.userAgent.determineVersion_(), goog.userAgent.compare = function (e, t) {
  return goog.string.compareVersions(e, t);
}, goog.userAgent.isVersionOrHigherCache_ = {}, goog.userAgent.isVersionOrHigher = function (e) {
  return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, e, function () {
    return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, e);
  });
}, goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher, goog.userAgent.isDocumentModeOrHigher = function (e) {
  return Number(goog.userAgent.DOCUMENT_MODE) >= e;
}, goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher, goog.userAgent.DOCUMENT_MODE = function () {
  if (goog.global.document && goog.userAgent.IE) return goog.userAgent.getDocumentMode_();
}(), goog.userAgent.product = {}, goog.userAgent.product.ASSUME_FIREFOX = !1, goog.userAgent.product.ASSUME_IPHONE = !1, goog.userAgent.product.ASSUME_IPAD = !1, goog.userAgent.product.ASSUME_ANDROID = !1, goog.userAgent.product.ASSUME_CHROME = !1, goog.userAgent.product.ASSUME_SAFARI = !1, goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI, goog.userAgent.product.OPERA = goog.userAgent.OPERA, goog.userAgent.product.IE = goog.userAgent.IE, goog.userAgent.product.EDGE = goog.userAgent.EDGE, goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox(), goog.userAgent.product.isIphoneOrIpod_ = function () {
  return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
}, goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_(), goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser(), goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome(), goog.userAgent.product.isSafariDesktop_ = function () {
  return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
}, goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_(), goog.crypt.base64 = {}, goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=", goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.", goog.crypt.base64.Alphabet = {
  DEFAULT: 0,
  NO_PADDING: 1,
  WEBSAFE: 2,
  WEBSAFE_DOT_PADDING: 3,
  WEBSAFE_NO_PADDING: 4
}, goog.crypt.base64.paddingChars_ = "=.", goog.crypt.base64.isPadding_ = function (e) {
  return goog.string.contains(goog.crypt.base64.paddingChars_, e);
}, goog.crypt.base64.byteToCharMaps_ = {}, goog.crypt.base64.charToByteMap_ = null, goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA, goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || "function" == typeof goog.global.btoa, goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && "function" == typeof goog.global.atob, goog.crypt.base64.encodeByteArray = function (e, t) {
  goog.asserts.assert(goog.isArrayLike(e), "encodeByteArray takes an array as a parameter"), void 0 === t && (t = goog.crypt.base64.Alphabet.DEFAULT), goog.crypt.base64.init_(), t = goog.crypt.base64.byteToCharMaps_[t];

  for (var o = [], r = 0; r < e.length; r += 3) {
    var s = e[r],
        n = r + 1 < e.length,
        i = n ? e[r + 1] : 0,
        a = r + 2 < e.length,
        u = a ? e[r + 2] : 0,
        g = s >> 2;
    s = (3 & s) << 4 | i >> 4, i = (15 & i) << 2 | u >> 6, u &= 63, a || (u = 64, n || (i = 64)), o.push(t[g], t[s], t[i] || "", t[u] || "");
  }

  return o.join("");
}, goog.crypt.base64.encodeString = function (e, t) {
  return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !t ? goog.global.btoa(e) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(e), t);
}, goog.crypt.base64.decodeString = function (e, t) {
  if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !t) return goog.global.atob(e);
  var o = "";
  return goog.crypt.base64.decodeStringInternal_(e, function (e) {
    o += String.fromCharCode(e);
  }), o;
}, goog.crypt.base64.decodeStringToByteArray = function (e, t) {
  var o = [];
  return goog.crypt.base64.decodeStringInternal_(e, function (e) {
    o.push(e);
  }), o;
}, goog.crypt.base64.decodeStringToUint8Array = function (e) {
  goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
  var t = e.length,
      o = 3 * t / 4;
  o % 3 ? o = Math.floor(o) : goog.crypt.base64.isPadding_(e[t - 1]) && (o = goog.crypt.base64.isPadding_(e[t - 2]) ? o - 2 : o - 1);
  var r = new Uint8Array(o),
      s = 0;
  return goog.crypt.base64.decodeStringInternal_(e, function (e) {
    r[s++] = e;
  }), r.subarray(0, s);
}, goog.crypt.base64.decodeStringInternal_ = function (e, t) {
  function o(t) {
    for (; r < e.length;) {
      var o = e.charAt(r++),
          s = goog.crypt.base64.charToByteMap_[o];
      if (null != s) return s;
      if (!goog.string.isEmptyOrWhitespace(o)) throw Error("Unknown base64 encoding at char: " + o);
    }

    return t;
  }

  goog.crypt.base64.init_();

  for (var r = 0;;) {
    var s = o(-1),
        n = o(0),
        i = o(64),
        a = o(64);
    if (64 === a && -1 === s) break;
    t(s << 2 | n >> 4), 64 != i && (t(n << 4 & 240 | i >> 2), 64 != a && t(i << 6 & 192 | a));
  }
}, goog.crypt.base64.init_ = function () {
  if (!goog.crypt.base64.charToByteMap_) {
    goog.crypt.base64.charToByteMap_ = {};

    for (var e = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), t = ["+/=", "+/", "-_=", "-_.", "-_"], o = 0; 5 > o; o++) {
      var r = e.concat(t[o].split(""));
      goog.crypt.base64.byteToCharMaps_[o] = r;

      for (var s = 0; s < r.length; s++) {
        var n = r[s],
            i = goog.crypt.base64.charToByteMap_[n];
        void 0 === i ? goog.crypt.base64.charToByteMap_[n] = s : goog.asserts.assert(i === s);
      }
    }
  }
}, jspb.utils = {}, jspb.utils.split64Low = 0, jspb.utils.split64High = 0, jspb.utils.splitUint64 = function (e) {
  var t = e >>> 0;
  e = Math.floor((e - t) / jspb.BinaryConstants.TWO_TO_32) >>> 0, jspb.utils.split64Low = t, jspb.utils.split64High = e;
}, jspb.utils.splitInt64 = function (e) {
  var t = 0 > e,
      o = (e = Math.abs(e)) >>> 0;
  e = Math.floor((e - o) / jspb.BinaryConstants.TWO_TO_32), e >>>= 0, t && (e = ~e >>> 0, 4294967295 < (o = 1 + (~o >>> 0)) && (o = 0, 4294967295 < ++e && (e = 0))), jspb.utils.split64Low = o, jspb.utils.split64High = e;
}, jspb.utils.splitZigzag64 = function (e) {
  var t = 0 > e;
  e = 2 * Math.abs(e), jspb.utils.splitUint64(e), e = jspb.utils.split64Low;
  var o = jspb.utils.split64High;
  t && (0 == e ? 0 == o ? o = e = 4294967295 : (o--, e = 4294967295) : e--), jspb.utils.split64Low = e, jspb.utils.split64High = o;
}, jspb.utils.splitFloat32 = function (e) {
  var t = 0 > e ? 1 : 0;
  if (0 === (e = t ? -e : e)) 0 < 1 / e ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);else if (isNaN(e)) jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;else if (e > jspb.BinaryConstants.FLOAT32_MAX) jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | 2139095040) >>> 0;else if (e < jspb.BinaryConstants.FLOAT32_MIN) e = Math.round(e / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | e) >>> 0;else {
    var o = Math.floor(Math.log(e) / Math.LN2);
    e *= Math.pow(2, -o), e = 8388607 & Math.round(e * jspb.BinaryConstants.TWO_TO_23), jspb.utils.split64High = 0, jspb.utils.split64Low = (t << 31 | o + 127 << 23 | e) >>> 0;
  }
}, jspb.utils.splitFloat64 = function (e) {
  var t = 0 > e ? 1 : 0;
  if (0 === (e = t ? -e : e)) jspb.utils.split64High = 0 < 1 / e ? 0 : 2147483648, jspb.utils.split64Low = 0;else if (isNaN(e)) jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;else if (e > jspb.BinaryConstants.FLOAT64_MAX) jspb.utils.split64High = (t << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;else if (e < jspb.BinaryConstants.FLOAT64_MIN) {
    var o = e / Math.pow(2, -1074);
    e = o / jspb.BinaryConstants.TWO_TO_32, jspb.utils.split64High = (t << 31 | e) >>> 0, jspb.utils.split64Low = o >>> 0;
  } else {
    var r = 0;
    if (2 <= (o = e)) for (; 2 <= o && 1023 > r;) r++, o /= 2;else for (; 1 > o && -1022 < r;) o *= 2, r--;
    e = (o = e * Math.pow(2, -r)) * jspb.BinaryConstants.TWO_TO_20 & 1048575, o = o * jspb.BinaryConstants.TWO_TO_52 >>> 0, jspb.utils.split64High = (t << 31 | r + 1023 << 20 | e) >>> 0, jspb.utils.split64Low = o;
  }
}, jspb.utils.splitHash64 = function (e) {
  var t = e.charCodeAt(0),
      o = e.charCodeAt(1),
      r = e.charCodeAt(2),
      s = e.charCodeAt(3),
      n = e.charCodeAt(4),
      i = e.charCodeAt(5),
      a = e.charCodeAt(6);
  e = e.charCodeAt(7), jspb.utils.split64Low = t + (o << 8) + (r << 16) + (s << 24) >>> 0, jspb.utils.split64High = n + (i << 8) + (a << 16) + (e << 24) >>> 0;
}, jspb.utils.joinUint64 = function (e, t) {
  return t * jspb.BinaryConstants.TWO_TO_32 + (e >>> 0);
}, jspb.utils.joinInt64 = function (e, t) {
  var o = 2147483648 & t;
  return o && (t = ~t >>> 0, 0 == (e = 1 + ~e >>> 0) && (t = t + 1 >>> 0)), e = jspb.utils.joinUint64(e, t), o ? -e : e;
}, jspb.utils.toZigzag64 = function (e, t, o) {
  var r = t >> 31;
  return o(e << 1 ^ r, (t << 1 | e >>> 31) ^ r);
}, jspb.utils.joinZigzag64 = function (e, t) {
  return jspb.utils.fromZigzag64(e, t, jspb.utils.joinInt64);
}, jspb.utils.fromZigzag64 = function (e, t, o) {
  var r = -(1 & e);
  return o((e >>> 1 | t << 31) ^ r, t >>> 1 ^ r);
}, jspb.utils.joinFloat32 = function (e, t) {
  t = 2 * (e >> 31) + 1;
  var o = e >>> 23 & 255;
  return e &= 8388607, 255 == o ? e ? NaN : 1 / 0 * t : 0 == o ? t * Math.pow(2, -149) * e : t * Math.pow(2, o - 150) * (e + Math.pow(2, 23));
}, jspb.utils.joinFloat64 = function (e, t) {
  var o = 2 * (t >> 31) + 1,
      r = t >>> 20 & 2047;
  return e = jspb.BinaryConstants.TWO_TO_32 * (1048575 & t) + e, 2047 == r ? e ? NaN : 1 / 0 * o : 0 == r ? o * Math.pow(2, -1074) * e : o * Math.pow(2, r - 1075) * (e + jspb.BinaryConstants.TWO_TO_52);
}, jspb.utils.joinHash64 = function (e, t) {
  return String.fromCharCode(e >>> 0 & 255, e >>> 8 & 255, e >>> 16 & 255, e >>> 24 & 255, t >>> 0 & 255, t >>> 8 & 255, t >>> 16 & 255, t >>> 24 & 255);
}, jspb.utils.DIGITS = "0123456789abcdef".split(""), jspb.utils.ZERO_CHAR_CODE_ = 48, jspb.utils.A_CHAR_CODE_ = 97, jspb.utils.joinUnsignedDecimalString = function (e, t) {
  function o(e, t) {
    return e = e ? String(e) : "", t ? "0000000".slice(e.length) + e : e;
  }

  if (2097151 >= t) return "" + jspb.utils.joinUint64(e, t);
  var r = (e >>> 24 | t << 8) >>> 0 & 16777215;
  return e = (16777215 & e) + 6777216 * r + 6710656 * (t = t >> 16 & 65535), r += 8147497 * t, t *= 2, 1e7 <= e && (r += Math.floor(e / 1e7), e %= 1e7), 1e7 <= r && (t += Math.floor(r / 1e7), r %= 1e7), o(t, 0) + o(r, t) + o(e, 1);
}, jspb.utils.joinSignedDecimalString = function (e, t) {
  var o = 2147483648 & t;
  return o && (t = ~t + (0 == (e = 1 + ~e >>> 0) ? 1 : 0) >>> 0), e = jspb.utils.joinUnsignedDecimalString(e, t), o ? "-" + e : e;
}, jspb.utils.hash64ToDecimalString = function (e, t) {
  jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
  var o = jspb.utils.split64High;
  return t ? jspb.utils.joinSignedDecimalString(e, o) : jspb.utils.joinUnsignedDecimalString(e, o);
}, jspb.utils.hash64ArrayToDecimalStrings = function (e, t) {
  for (var o = Array(e.length), r = 0; r < e.length; r++) o[r] = jspb.utils.hash64ToDecimalString(e[r], t);

  return o;
}, jspb.utils.decimalStringToHash64 = function (e) {
  function t(e, t) {
    for (var o = 0; 8 > o && (1 !== e || 0 < t); o++) t = e * r[o] + t, r[o] = 255 & t, t >>>= 8;
  }

  goog.asserts.assert(0 < e.length);
  var o = !1;
  "-" === e[0] && (o = !0, e = e.slice(1));

  for (var r = [0, 0, 0, 0, 0, 0, 0, 0], s = 0; s < e.length; s++) t(10, e.charCodeAt(s) - jspb.utils.ZERO_CHAR_CODE_);

  return o && (function () {
    for (var e = 0; 8 > e; e++) r[e] = 255 & ~r[e];
  }(), t(1, 1)), goog.crypt.byteArrayToString(r);
}, jspb.utils.splitDecimalString = function (e) {
  jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e));
}, jspb.utils.toHexDigit_ = function (e) {
  return String.fromCharCode(10 > e ? jspb.utils.ZERO_CHAR_CODE_ + e : jspb.utils.A_CHAR_CODE_ - 10 + e);
}, jspb.utils.fromHexCharCode_ = function (e) {
  return e >= jspb.utils.A_CHAR_CODE_ ? e - jspb.utils.A_CHAR_CODE_ + 10 : e - jspb.utils.ZERO_CHAR_CODE_;
}, jspb.utils.hash64ToHexString = function (e) {
  var t = Array(18);
  t[0] = "0", t[1] = "x";

  for (var o = 0; 8 > o; o++) {
    var r = e.charCodeAt(7 - o);
    t[2 * o + 2] = jspb.utils.toHexDigit_(r >> 4), t[2 * o + 3] = jspb.utils.toHexDigit_(15 & r);
  }

  return t.join("");
}, jspb.utils.hexStringToHash64 = function (e) {
  e = e.toLowerCase(), goog.asserts.assert(18 == e.length), goog.asserts.assert("0" == e[0]), goog.asserts.assert("x" == e[1]);

  for (var t = "", o = 0; 8 > o; o++) {
    var r = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * o + 2)),
        s = jspb.utils.fromHexCharCode_(e.charCodeAt(2 * o + 3));
    t = String.fromCharCode(16 * r + s) + t;
  }

  return t;
}, jspb.utils.hash64ToNumber = function (e, t) {
  jspb.utils.splitHash64(e), e = jspb.utils.split64Low;
  var o = jspb.utils.split64High;
  return t ? jspb.utils.joinInt64(e, o) : jspb.utils.joinUint64(e, o);
}, jspb.utils.numberToHash64 = function (e) {
  return jspb.utils.splitInt64(e), jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.utils.countVarints = function (e, t, o) {
  for (var r = 0, s = t; s < o; s++) r += e[s] >> 7;

  return o - t - r;
}, jspb.utils.countVarintFields = function (e, t, o, r) {
  var s = 0;
  if (128 > (r = 8 * r + jspb.BinaryConstants.WireType.VARINT)) for (; t < o && e[t++] == r;) for (s++;;) {
    var n = e[t++];
    if (0 == (128 & n)) break;
  } else for (; t < o;) {
    for (n = r; 128 < n;) {
      if (e[t] != (127 & n | 128)) return s;
      t++, n >>= 7;
    }

    if (e[t++] != n) break;

    for (s++; 0 != (128 & (n = e[t++])););
  }
  return s;
}, jspb.utils.countFixedFields_ = function (e, t, o, r, s) {
  var n = 0;
  if (128 > r) for (; t < o && e[t++] == r;) n++, t += s;else for (; t < o;) {
    for (var i = r; 128 < i;) {
      if (e[t++] != (127 & i | 128)) return n;
      i >>= 7;
    }

    if (e[t++] != i) break;
    n++, t += s;
  }
  return n;
}, jspb.utils.countFixed32Fields = function (e, t, o, r) {
  return jspb.utils.countFixedFields_(e, t, o, 8 * r + jspb.BinaryConstants.WireType.FIXED32, 4);
}, jspb.utils.countFixed64Fields = function (e, t, o, r) {
  return jspb.utils.countFixedFields_(e, t, o, 8 * r + jspb.BinaryConstants.WireType.FIXED64, 8);
}, jspb.utils.countDelimitedFields = function (e, t, o, r) {
  var s = 0;

  for (r = 8 * r + jspb.BinaryConstants.WireType.DELIMITED; t < o;) {
    for (var n = r; 128 < n;) {
      if (e[t++] != (127 & n | 128)) return s;
      n >>= 7;
    }

    if (e[t++] != n) break;
    s++;

    for (var i = 0, a = 1; i += (127 & (n = e[t++])) * a, a *= 128, 0 != (128 & n););

    t += i;
  }

  return s;
}, jspb.utils.debugBytesToTextFormat = function (e) {
  var t = '"';

  if (e) {
    e = jspb.utils.byteSourceToUint8Array(e);

    for (var o = 0; o < e.length; o++) t += "\\x", 16 > e[o] && (t += "0"), t += e[o].toString(16);
  }

  return t + '"';
}, jspb.utils.debugScalarToTextFormat = function (e) {
  return "string" == typeof e ? goog.string.quote(e) : e.toString();
}, jspb.utils.stringToByteArray = function (e) {
  for (var t = new Uint8Array(e.length), o = 0; o < e.length; o++) {
    var r = e.charCodeAt(o);
    if (255 < r) throw Error("Conversion error: string contains codepoint outside of byte range");
    t[o] = r;
  }

  return t;
}, jspb.utils.byteSourceToUint8Array = function (e) {
  return e.constructor === Uint8Array ? e : e.constructor === ArrayBuffer || "undefined" != typeof Buffer && e.constructor === Buffer || e.constructor === Array ? new Uint8Array(e) : e.constructor === String ? goog.crypt.base64.decodeStringToUint8Array(e) : (goog.asserts.fail("Type not convertible to Uint8Array."), new Uint8Array(0));
}, jspb.BinaryDecoder = function (e, t, o) {
  this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1, e && this.setBlock(e, t, o);
}, jspb.BinaryDecoder.instanceCache_ = [], jspb.BinaryDecoder.alloc = function (e, t, o) {
  if (jspb.BinaryDecoder.instanceCache_.length) {
    var r = jspb.BinaryDecoder.instanceCache_.pop();
    return e && r.setBlock(e, t, o), r;
  }

  return new jspb.BinaryDecoder(e, t, o);
}, jspb.BinaryDecoder.prototype.free = function () {
  this.clear(), 100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
}, jspb.BinaryDecoder.prototype.clone = function () {
  return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
}, jspb.BinaryDecoder.prototype.clear = function () {
  this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1;
}, jspb.BinaryDecoder.prototype.getBuffer = function () {
  return this.bytes_;
}, jspb.BinaryDecoder.prototype.setBlock = function (e, t, o) {
  this.bytes_ = jspb.utils.byteSourceToUint8Array(e), this.start_ = void 0 !== t ? t : 0, this.end_ = void 0 !== o ? this.start_ + o : this.bytes_.length, this.cursor_ = this.start_;
}, jspb.BinaryDecoder.prototype.getEnd = function () {
  return this.end_;
}, jspb.BinaryDecoder.prototype.setEnd = function (e) {
  this.end_ = e;
}, jspb.BinaryDecoder.prototype.reset = function () {
  this.cursor_ = this.start_;
}, jspb.BinaryDecoder.prototype.getCursor = function () {
  return this.cursor_;
}, jspb.BinaryDecoder.prototype.setCursor = function (e) {
  this.cursor_ = e;
}, jspb.BinaryDecoder.prototype.advance = function (e) {
  this.cursor_ += e, goog.asserts.assert(this.cursor_ <= this.end_);
}, jspb.BinaryDecoder.prototype.atEnd = function () {
  return this.cursor_ == this.end_;
}, jspb.BinaryDecoder.prototype.pastEnd = function () {
  return this.cursor_ > this.end_;
}, jspb.BinaryDecoder.prototype.getError = function () {
  return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
}, jspb.BinaryDecoder.prototype.readSplitVarint64 = function (e) {
  for (var t = 128, o = 0, r = 0, s = 0; 4 > s && 128 <= t; s++) o |= (127 & (t = this.bytes_[this.cursor_++])) << 7 * s;

  if (128 <= t && (o |= (127 & (t = this.bytes_[this.cursor_++])) << 28, r |= (127 & t) >> 4), 128 <= t) for (s = 0; 5 > s && 128 <= t; s++) r |= (127 & (t = this.bytes_[this.cursor_++])) << 7 * s + 3;
  if (128 > t) return e(o >>> 0, r >>> 0);
  goog.asserts.fail("Failed to read varint, encoding is invalid."), this.error_ = !0;
}, jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function (e) {
  return this.readSplitVarint64(function (t, o) {
    return jspb.utils.fromZigzag64(t, o, e);
  });
}, jspb.BinaryDecoder.prototype.readSplitFixed64 = function (e) {
  var t = this.bytes_,
      o = this.cursor_;
  this.cursor_ += 8;

  for (var r = 0, s = 0, n = o + 7; n >= o; n--) r = r << 8 | t[n], s = s << 8 | t[n + 4];

  return e(r, s);
}, jspb.BinaryDecoder.prototype.skipVarint = function () {
  for (; 128 & this.bytes_[this.cursor_];) this.cursor_++;

  this.cursor_++;
}, jspb.BinaryDecoder.prototype.unskipVarint = function (e) {
  for (; 128 < e;) this.cursor_--, e >>>= 7;

  this.cursor_--;
}, jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function () {
  var e = this.bytes_,
      t = e[this.cursor_ + 0],
      o = 127 & t;
  return 128 > t ? (this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), o) : (o |= (127 & (t = e[this.cursor_ + 1])) << 7, 128 > t ? (this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), o) : (o |= (127 & (t = e[this.cursor_ + 2])) << 14, 128 > t ? (this.cursor_ += 3, goog.asserts.assert(this.cursor_ <= this.end_), o) : (o |= (127 & (t = e[this.cursor_ + 3])) << 21, 128 > t ? (this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), o) : (o |= (15 & (t = e[this.cursor_ + 4])) << 28, 128 > t ? (this.cursor_ += 5, goog.asserts.assert(this.cursor_ <= this.end_), o >>> 0) : (this.cursor_ += 5, 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && 128 <= e[this.cursor_++] && goog.asserts.assert(!1), goog.asserts.assert(this.cursor_ <= this.end_), o)))));
}, jspb.BinaryDecoder.prototype.readSignedVarint32 = jspb.BinaryDecoder.prototype.readUnsignedVarint32, jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function () {
  return this.readUnsignedVarint32().toString();
}, jspb.BinaryDecoder.prototype.readSignedVarint32String = function () {
  return this.readSignedVarint32().toString();
}, jspb.BinaryDecoder.prototype.readZigzagVarint32 = function () {
  var e = this.readUnsignedVarint32();
  return e >>> 1 ^ -(1 & e);
}, jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function () {
  return this.readSplitVarint64(jspb.utils.joinUint64);
}, jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function () {
  return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
}, jspb.BinaryDecoder.prototype.readSignedVarint64 = function () {
  return this.readSplitVarint64(jspb.utils.joinInt64);
}, jspb.BinaryDecoder.prototype.readSignedVarint64String = function () {
  return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
}, jspb.BinaryDecoder.prototype.readZigzagVarint64 = function () {
  return this.readSplitVarint64(jspb.utils.joinZigzag64);
}, jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function () {
  return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
}, jspb.BinaryDecoder.prototype.readZigzagVarint64String = function () {
  return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
}, jspb.BinaryDecoder.prototype.readUint8 = function () {
  var e = this.bytes_[this.cursor_ + 0];
  return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), e;
}, jspb.BinaryDecoder.prototype.readUint16 = function () {
  var e = this.bytes_[this.cursor_ + 0],
      t = this.bytes_[this.cursor_ + 1];
  return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), e << 0 | t << 8;
}, jspb.BinaryDecoder.prototype.readUint32 = function () {
  var e = this.bytes_[this.cursor_ + 0],
      t = this.bytes_[this.cursor_ + 1],
      o = this.bytes_[this.cursor_ + 2],
      r = this.bytes_[this.cursor_ + 3];
  return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), (e << 0 | t << 8 | o << 16 | r << 24) >>> 0;
}, jspb.BinaryDecoder.prototype.readUint64 = function () {
  var e = this.readUint32(),
      t = this.readUint32();
  return jspb.utils.joinUint64(e, t);
}, jspb.BinaryDecoder.prototype.readUint64String = function () {
  var e = this.readUint32(),
      t = this.readUint32();
  return jspb.utils.joinUnsignedDecimalString(e, t);
}, jspb.BinaryDecoder.prototype.readInt8 = function () {
  var e = this.bytes_[this.cursor_ + 0];
  return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), e << 24 >> 24;
}, jspb.BinaryDecoder.prototype.readInt16 = function () {
  var e = this.bytes_[this.cursor_ + 0],
      t = this.bytes_[this.cursor_ + 1];
  return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), (e << 0 | t << 8) << 16 >> 16;
}, jspb.BinaryDecoder.prototype.readInt32 = function () {
  var e = this.bytes_[this.cursor_ + 0],
      t = this.bytes_[this.cursor_ + 1],
      o = this.bytes_[this.cursor_ + 2],
      r = this.bytes_[this.cursor_ + 3];
  return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), e << 0 | t << 8 | o << 16 | r << 24;
}, jspb.BinaryDecoder.prototype.readInt64 = function () {
  var e = this.readUint32(),
      t = this.readUint32();
  return jspb.utils.joinInt64(e, t);
}, jspb.BinaryDecoder.prototype.readInt64String = function () {
  var e = this.readUint32(),
      t = this.readUint32();
  return jspb.utils.joinSignedDecimalString(e, t);
}, jspb.BinaryDecoder.prototype.readFloat = function () {
  var e = this.readUint32();
  return jspb.utils.joinFloat32(e, 0);
}, jspb.BinaryDecoder.prototype.readDouble = function () {
  var e = this.readUint32(),
      t = this.readUint32();
  return jspb.utils.joinFloat64(e, t);
}, jspb.BinaryDecoder.prototype.readBool = function () {
  return !!this.bytes_[this.cursor_++];
}, jspb.BinaryDecoder.prototype.readEnum = function () {
  return this.readSignedVarint32();
}, jspb.BinaryDecoder.prototype.readString = function (e) {
  var t = this.bytes_,
      o = this.cursor_;
  e = o + e;

  for (var r = [], s = ""; o < e;) {
    var n = t[o++];
    if (128 > n) r.push(n);else {
      if (192 > n) continue;

      if (224 > n) {
        var i = t[o++];
        r.push((31 & n) << 6 | 63 & i);
      } else if (240 > n) {
        i = t[o++];
        var a = t[o++];
        r.push((15 & n) << 12 | (63 & i) << 6 | 63 & a);
      } else if (248 > n) {
        n = (7 & n) << 18 | (63 & (i = t[o++])) << 12 | (63 & (a = t[o++])) << 6 | 63 & t[o++], n -= 65536, r.push(55296 + (n >> 10 & 1023), 56320 + (1023 & n));
      }
    }
    8192 <= r.length && (s += String.fromCharCode.apply(null, r), r.length = 0);
  }

  return s += goog.crypt.byteArrayToString(r), this.cursor_ = o, s;
}, jspb.BinaryDecoder.prototype.readStringWithLength = function () {
  var e = this.readUnsignedVarint32();
  return this.readString(e);
}, jspb.BinaryDecoder.prototype.readBytes = function (e) {
  if (0 > e || this.cursor_ + e > this.bytes_.length) return this.error_ = !0, goog.asserts.fail("Invalid byte length!"), new Uint8Array(0);
  var t = this.bytes_.subarray(this.cursor_, this.cursor_ + e);
  return this.cursor_ += e, goog.asserts.assert(this.cursor_ <= this.end_), t;
}, jspb.BinaryDecoder.prototype.readVarintHash64 = function () {
  return this.readSplitVarint64(jspb.utils.joinHash64);
}, jspb.BinaryDecoder.prototype.readFixedHash64 = function () {
  var e = this.bytes_,
      t = this.cursor_,
      o = e[t + 0],
      r = e[t + 1],
      s = e[t + 2],
      n = e[t + 3],
      i = e[t + 4],
      a = e[t + 5],
      u = e[t + 6];
  return e = e[t + 7], this.cursor_ += 8, String.fromCharCode(o, r, s, n, i, a, u, e);
}, jspb.BinaryReader = function (e, t, o) {
  this.decoder_ = jspb.BinaryDecoder.alloc(e, t, o), this.fieldCursor_ = this.decoder_.getCursor(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null;
}, jspb.BinaryReader.instanceCache_ = [], jspb.BinaryReader.alloc = function (e, t, o) {
  if (jspb.BinaryReader.instanceCache_.length) {
    var r = jspb.BinaryReader.instanceCache_.pop();
    return e && r.decoder_.setBlock(e, t, o), r;
  }

  return new jspb.BinaryReader(e, t, o);
}, jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc, jspb.BinaryReader.prototype.free = function () {
  this.decoder_.clear(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null, 100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
}, jspb.BinaryReader.prototype.getFieldCursor = function () {
  return this.fieldCursor_;
}, jspb.BinaryReader.prototype.getCursor = function () {
  return this.decoder_.getCursor();
}, jspb.BinaryReader.prototype.getBuffer = function () {
  return this.decoder_.getBuffer();
}, jspb.BinaryReader.prototype.getFieldNumber = function () {
  return this.nextField_;
}, jspb.BinaryReader.prototype.getWireType = function () {
  return this.nextWireType_;
}, jspb.BinaryReader.prototype.isDelimited = function () {
  return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
}, jspb.BinaryReader.prototype.isEndGroup = function () {
  return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
}, jspb.BinaryReader.prototype.getError = function () {
  return this.error_ || this.decoder_.getError();
}, jspb.BinaryReader.prototype.setBlock = function (e, t, o) {
  this.decoder_.setBlock(e, t, o), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
}, jspb.BinaryReader.prototype.reset = function () {
  this.decoder_.reset(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
}, jspb.BinaryReader.prototype.advance = function (e) {
  this.decoder_.advance(e);
}, jspb.BinaryReader.prototype.nextField = function () {
  if (this.decoder_.atEnd()) return !1;
  if (this.getError()) return goog.asserts.fail("Decoder hit an error"), !1;
  this.fieldCursor_ = this.decoder_.getCursor();
  var e = this.decoder_.readUnsignedVarint32(),
      t = e >>> 3;
  return (e &= 7) != jspb.BinaryConstants.WireType.VARINT && e != jspb.BinaryConstants.WireType.FIXED32 && e != jspb.BinaryConstants.WireType.FIXED64 && e != jspb.BinaryConstants.WireType.DELIMITED && e != jspb.BinaryConstants.WireType.START_GROUP && e != jspb.BinaryConstants.WireType.END_GROUP ? (goog.asserts.fail("Invalid wire type: %s (at position %s)", e, this.fieldCursor_), this.error_ = !0, !1) : (this.nextField_ = t, this.nextWireType_ = e, !0);
}, jspb.BinaryReader.prototype.unskipHeader = function () {
  this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
}, jspb.BinaryReader.prototype.skipMatchingFields = function () {
  var e = this.nextField_;

  for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == e;) this.skipField();

  this.decoder_.atEnd() || this.unskipHeader();
}, jspb.BinaryReader.prototype.skipVarintField = function () {
  this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
}, jspb.BinaryReader.prototype.skipDelimitedField = function () {
  if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED) goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();else {
    var e = this.decoder_.readUnsignedVarint32();
    this.decoder_.advance(e);
  }
}, jspb.BinaryReader.prototype.skipFixed32Field = function () {
  this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (goog.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
}, jspb.BinaryReader.prototype.skipFixed64Field = function () {
  this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (goog.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
}, jspb.BinaryReader.prototype.skipGroup = function () {
  for (var e = this.nextField_;;) {
    if (!this.nextField()) {
      goog.asserts.fail("Unmatched start-group tag: stream EOF"), this.error_ = !0;
      break;
    }

    if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
      this.nextField_ != e && (goog.asserts.fail("Unmatched end-group tag"), this.error_ = !0);
      break;
    }

    this.skipField();
  }
}, jspb.BinaryReader.prototype.skipField = function () {
  switch (this.nextWireType_) {
    case jspb.BinaryConstants.WireType.VARINT:
      this.skipVarintField();
      break;

    case jspb.BinaryConstants.WireType.FIXED64:
      this.skipFixed64Field();
      break;

    case jspb.BinaryConstants.WireType.DELIMITED:
      this.skipDelimitedField();
      break;

    case jspb.BinaryConstants.WireType.FIXED32:
      this.skipFixed32Field();
      break;

    case jspb.BinaryConstants.WireType.START_GROUP:
      this.skipGroup();
      break;

    default:
      goog.asserts.fail("Invalid wire encoding for field.");
  }
}, jspb.BinaryReader.prototype.registerReadCallback = function (e, t) {
  null === this.readCallbacks_ && (this.readCallbacks_ = {}), goog.asserts.assert(!this.readCallbacks_[e]), this.readCallbacks_[e] = t;
}, jspb.BinaryReader.prototype.runReadCallback = function (e) {
  return goog.asserts.assert(null !== this.readCallbacks_), e = this.readCallbacks_[e], goog.asserts.assert(e), e(this);
}, jspb.BinaryReader.prototype.readAny = function (e) {
  this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(e);
  var t = jspb.BinaryConstants.FieldType;

  switch (e) {
    case t.DOUBLE:
      return this.readDouble();

    case t.FLOAT:
      return this.readFloat();

    case t.INT64:
      return this.readInt64();

    case t.UINT64:
      return this.readUint64();

    case t.INT32:
      return this.readInt32();

    case t.FIXED64:
      return this.readFixed64();

    case t.FIXED32:
      return this.readFixed32();

    case t.BOOL:
      return this.readBool();

    case t.STRING:
      return this.readString();

    case t.GROUP:
      goog.asserts.fail("Group field type not supported in readAny()");

    case t.MESSAGE:
      goog.asserts.fail("Message field type not supported in readAny()");

    case t.BYTES:
      return this.readBytes();

    case t.UINT32:
      return this.readUint32();

    case t.ENUM:
      return this.readEnum();

    case t.SFIXED32:
      return this.readSfixed32();

    case t.SFIXED64:
      return this.readSfixed64();

    case t.SINT32:
      return this.readSint32();

    case t.SINT64:
      return this.readSint64();

    case t.FHASH64:
      return this.readFixedHash64();

    case t.VHASH64:
      return this.readVarintHash64();

    default:
      goog.asserts.fail("Invalid field type in readAny()");
  }

  return 0;
}, jspb.BinaryReader.prototype.readMessage = function (e, t) {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var o = this.decoder_.getEnd(),
      r = this.decoder_.readUnsignedVarint32();
  r = this.decoder_.getCursor() + r, this.decoder_.setEnd(r), t(e, this), this.decoder_.setCursor(r), this.decoder_.setEnd(o);
}, jspb.BinaryReader.prototype.readGroup = function (e, t, o) {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP), goog.asserts.assert(this.nextField_ == e), o(t, this), this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (goog.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = !0);
}, jspb.BinaryReader.prototype.getFieldDecoder = function () {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var e = this.decoder_.readUnsignedVarint32(),
      t = this.decoder_.getCursor(),
      o = t + e;
  return e = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), t, e), this.decoder_.setCursor(o), e;
}, jspb.BinaryReader.prototype.readInt32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32();
}, jspb.BinaryReader.prototype.readInt32String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32String();
}, jspb.BinaryReader.prototype.readInt64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
}, jspb.BinaryReader.prototype.readInt64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64String();
}, jspb.BinaryReader.prototype.readUint32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32();
}, jspb.BinaryReader.prototype.readUint32String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32String();
}, jspb.BinaryReader.prototype.readUint64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64();
}, jspb.BinaryReader.prototype.readUint64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64String();
}, jspb.BinaryReader.prototype.readSint32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint32();
}, jspb.BinaryReader.prototype.readSint64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64();
}, jspb.BinaryReader.prototype.readSint64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64String();
}, jspb.BinaryReader.prototype.readFixed32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readUint32();
}, jspb.BinaryReader.prototype.readFixed64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64();
}, jspb.BinaryReader.prototype.readFixed64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64String();
}, jspb.BinaryReader.prototype.readSfixed32 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32();
}, jspb.BinaryReader.prototype.readSfixed32String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32().toString();
}, jspb.BinaryReader.prototype.readSfixed64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64();
}, jspb.BinaryReader.prototype.readSfixed64String = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64String();
}, jspb.BinaryReader.prototype.readFloat = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readFloat();
}, jspb.BinaryReader.prototype.readDouble = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readDouble();
}, jspb.BinaryReader.prototype.readBool = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), !!this.decoder_.readUnsignedVarint32();
}, jspb.BinaryReader.prototype.readEnum = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
}, jspb.BinaryReader.prototype.readString = function () {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var e = this.decoder_.readUnsignedVarint32();
  return this.decoder_.readString(e);
}, jspb.BinaryReader.prototype.readBytes = function () {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var e = this.decoder_.readUnsignedVarint32();
  return this.decoder_.readBytes(e);
}, jspb.BinaryReader.prototype.readVarintHash64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readVarintHash64();
}, jspb.BinaryReader.prototype.readSintHash64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarintHash64();
}, jspb.BinaryReader.prototype.readSplitVarint64 = function (e) {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(e);
}, jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function (e) {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(function (t, o) {
    return jspb.utils.fromZigzag64(t, o, e);
  });
}, jspb.BinaryReader.prototype.readFixedHash64 = function () {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readFixedHash64();
}, jspb.BinaryReader.prototype.readSplitFixed64 = function (e) {
  return goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readSplitFixed64(e);
}, jspb.BinaryReader.prototype.readPackedField_ = function (e) {
  goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
  var t = this.decoder_.readUnsignedVarint32();
  t = this.decoder_.getCursor() + t;

  for (var o = []; this.decoder_.getCursor() < t;) o.push(e.call(this.decoder_));

  return o;
}, jspb.BinaryReader.prototype.readPackedInt32 = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint32);
}, jspb.BinaryReader.prototype.readPackedInt32String = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint32String);
}, jspb.BinaryReader.prototype.readPackedInt64 = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint64);
}, jspb.BinaryReader.prototype.readPackedInt64String = function () {
  return this.readPackedField_(this.decoder_.readSignedVarint64String);
}, jspb.BinaryReader.prototype.readPackedUint32 = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint32);
}, jspb.BinaryReader.prototype.readPackedUint32String = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
}, jspb.BinaryReader.prototype.readPackedUint64 = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint64);
}, jspb.BinaryReader.prototype.readPackedUint64String = function () {
  return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
}, jspb.BinaryReader.prototype.readPackedSint32 = function () {
  return this.readPackedField_(this.decoder_.readZigzagVarint32);
}, jspb.BinaryReader.prototype.readPackedSint64 = function () {
  return this.readPackedField_(this.decoder_.readZigzagVarint64);
}, jspb.BinaryReader.prototype.readPackedSint64String = function () {
  return this.readPackedField_(this.decoder_.readZigzagVarint64String);
}, jspb.BinaryReader.prototype.readPackedFixed32 = function () {
  return this.readPackedField_(this.decoder_.readUint32);
}, jspb.BinaryReader.prototype.readPackedFixed64 = function () {
  return this.readPackedField_(this.decoder_.readUint64);
}, jspb.BinaryReader.prototype.readPackedFixed64String = function () {
  return this.readPackedField_(this.decoder_.readUint64String);
}, jspb.BinaryReader.prototype.readPackedSfixed32 = function () {
  return this.readPackedField_(this.decoder_.readInt32);
}, jspb.BinaryReader.prototype.readPackedSfixed64 = function () {
  return this.readPackedField_(this.decoder_.readInt64);
}, jspb.BinaryReader.prototype.readPackedSfixed64String = function () {
  return this.readPackedField_(this.decoder_.readInt64String);
}, jspb.BinaryReader.prototype.readPackedFloat = function () {
  return this.readPackedField_(this.decoder_.readFloat);
}, jspb.BinaryReader.prototype.readPackedDouble = function () {
  return this.readPackedField_(this.decoder_.readDouble);
}, jspb.BinaryReader.prototype.readPackedBool = function () {
  return this.readPackedField_(this.decoder_.readBool);
}, jspb.BinaryReader.prototype.readPackedEnum = function () {
  return this.readPackedField_(this.decoder_.readEnum);
}, jspb.BinaryReader.prototype.readPackedVarintHash64 = function () {
  return this.readPackedField_(this.decoder_.readVarintHash64);
}, jspb.BinaryReader.prototype.readPackedFixedHash64 = function () {
  return this.readPackedField_(this.decoder_.readFixedHash64);
}, jspb.Map = function (e, t) {
  this.arr_ = e, this.valueCtor_ = t, this.map_ = {}, this.arrClean = !0, 0 < this.arr_.length && this.loadFromArray_();
}, jspb.Map.prototype.loadFromArray_ = function () {
  for (var e = 0; e < this.arr_.length; e++) {
    var t = this.arr_[e],
        o = t[0];
    this.map_[o.toString()] = new jspb.Map.Entry_(o, t[1]);
  }

  this.arrClean = !0;
}, jspb.Map.prototype.toArray = function () {
  if (this.arrClean) {
    if (this.valueCtor_) {
      var e,
          t = this.map_;

      for (e in t) if (Object.prototype.hasOwnProperty.call(t, e)) {
        var o = t[e].valueWrapper;
        o && o.toArray();
      }
    }
  } else {
    for (this.arr_.length = 0, (t = this.stringKeys_()).sort(), e = 0; e < t.length; e++) {
      var r = this.map_[t[e]];
      (o = r.valueWrapper) && o.toArray(), this.arr_.push([r.key, r.value]);
    }

    this.arrClean = !0;
  }

  return this.arr_;
}, jspb.Map.prototype.toObject = function (e, t) {
  for (var o = this.toArray(), r = [], s = 0; s < o.length; s++) {
    var n = this.map_[o[s][0].toString()];
    this.wrapEntry_(n);
    var i = n.valueWrapper;
    i ? (goog.asserts.assert(t), r.push([n.key, t(e, i)])) : r.push([n.key, n.value]);
  }

  return r;
}, jspb.Map.fromObject = function (e, t, o) {
  t = new jspb.Map([], t);

  for (var r = 0; r < e.length; r++) {
    var s = e[r][0],
        n = o(e[r][1]);
    t.set(s, n);
  }

  return t;
}, jspb.Map.ArrayIteratorIterable_ = function (e) {
  this.idx_ = 0, this.arr_ = e;
}, jspb.Map.ArrayIteratorIterable_.prototype.next = function () {
  return this.idx_ < this.arr_.length ? {
    done: !1,
    value: this.arr_[this.idx_++]
  } : {
    done: !0,
    value: void 0
  };
}, "undefined" != typeof Symbol && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function () {
  return this;
}), jspb.Map.prototype.getLength = function () {
  return this.stringKeys_().length;
}, jspb.Map.prototype.clear = function () {
  this.map_ = {}, this.arrClean = !1;
}, jspb.Map.prototype.del = function (e) {
  e = e.toString();
  var t = this.map_.hasOwnProperty(e);
  return delete this.map_[e], this.arrClean = !1, t;
}, jspb.Map.prototype.getEntryList = function () {
  var e = [],
      t = this.stringKeys_();
  t.sort();

  for (var o = 0; o < t.length; o++) {
    var r = this.map_[t[o]];
    e.push([r.key, r.value]);
  }

  return e;
}, jspb.Map.prototype.entries = function () {
  var e = [],
      t = this.stringKeys_();
  t.sort();

  for (var o = 0; o < t.length; o++) {
    var r = this.map_[t[o]];
    e.push([r.key, this.wrapEntry_(r)]);
  }

  return new jspb.Map.ArrayIteratorIterable_(e);
}, jspb.Map.prototype.keys = function () {
  var e = [],
      t = this.stringKeys_();
  t.sort();

  for (var o = 0; o < t.length; o++) e.push(this.map_[t[o]].key);

  return new jspb.Map.ArrayIteratorIterable_(e);
}, jspb.Map.prototype.values = function () {
  var e = [],
      t = this.stringKeys_();
  t.sort();

  for (var o = 0; o < t.length; o++) e.push(this.wrapEntry_(this.map_[t[o]]));

  return new jspb.Map.ArrayIteratorIterable_(e);
}, jspb.Map.prototype.forEach = function (e, t) {
  var o = this.stringKeys_();
  o.sort();

  for (var r = 0; r < o.length; r++) {
    var s = this.map_[o[r]];
    e.call(t, this.wrapEntry_(s), s.key, this);
  }
}, jspb.Map.prototype.set = function (e, t) {
  var o = new jspb.Map.Entry_(e);
  return this.valueCtor_ ? (o.valueWrapper = t, o.value = t.toArray()) : o.value = t, this.map_[e.toString()] = o, this.arrClean = !1, this;
}, jspb.Map.prototype.wrapEntry_ = function (e) {
  return this.valueCtor_ ? (e.valueWrapper || (e.valueWrapper = new this.valueCtor_(e.value)), e.valueWrapper) : e.value;
}, jspb.Map.prototype.get = function (e) {
  if (e = this.map_[e.toString()]) return this.wrapEntry_(e);
}, jspb.Map.prototype.has = function (e) {
  return e.toString() in this.map_;
}, jspb.Map.prototype.serializeBinary = function (e, t, o, r, s) {
  var n = this.stringKeys_();
  n.sort();

  for (var i = 0; i < n.length; i++) {
    var a = this.map_[n[i]];
    t.beginSubMessage(e), o.call(t, 1, a.key), this.valueCtor_ ? r.call(t, 2, this.wrapEntry_(a), s) : r.call(t, 2, a.value), t.endSubMessage();
  }
}, jspb.Map.deserializeBinary = function (e, t, o, r, s, n, i) {
  for (; t.nextField() && !t.isEndGroup();) {
    var a = t.getFieldNumber();
    1 == a ? n = o.call(t) : 2 == a && (e.valueCtor_ ? (goog.asserts.assert(s), i || (i = new e.valueCtor_()), r.call(t, i, s)) : i = r.call(t));
  }

  goog.asserts.assert(null != n), goog.asserts.assert(null != i), e.set(n, i);
}, jspb.Map.prototype.stringKeys_ = function () {
  var e,
      t = this.map_,
      o = [];

  for (e in t) Object.prototype.hasOwnProperty.call(t, e) && o.push(e);

  return o;
}, jspb.Map.Entry_ = function (e, t) {
  this.key = e, this.value = t, this.valueWrapper = void 0;
}, jspb.ExtensionFieldInfo = function (e, t, o, r, s) {
  this.fieldIndex = e, this.fieldName = t, this.ctor = o, this.toObjectFn = r, this.isRepeated = s;
}, jspb.ExtensionFieldBinaryInfo = function (e, t, o, r, s, n) {
  this.fieldInfo = e, this.binaryReaderFn = t, this.binaryWriterFn = o, this.binaryMessageSerializeFn = r, this.binaryMessageDeserializeFn = s, this.isPacked = n;
}, jspb.ExtensionFieldInfo.prototype.isMessageType = function () {
  return !!this.ctor;
}, jspb.Message = function () {}, jspb.Message.GENERATE_TO_OBJECT = !0, jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE, jspb.Message.GENERATE_TO_STRING = !0, jspb.Message.ASSUME_LOCAL_ARRAYS = !1, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = !0, jspb.Message.SUPPORTS_UINT8ARRAY_ = "function" == typeof Uint8Array, jspb.Message.prototype.getJsPbMessageId = function () {
  return this.messageId_;
}, jspb.Message.getIndex_ = function (e, t) {
  return t + e.arrayIndexOffset_;
}, jspb.Message.hiddenES6Property_ = function () {}, jspb.Message.getFieldNumber_ = function (e, t) {
  return t - e.arrayIndexOffset_;
}, jspb.Message.initialize = function (e, t, o, r, s, n) {
  if (e.wrappers_ = null, t || (t = o ? [o] : []), e.messageId_ = o ? String(o) : void 0, e.arrayIndexOffset_ = 0 === o ? -1 : 0, e.array = t, jspb.Message.initPivotAndExtensionObject_(e, r), e.convertedPrimitiveFields_ = {}, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (e.repeatedFields = s), s) for (t = 0; t < s.length; t++) (o = s[t]) < e.pivot_ ? (o = jspb.Message.getIndex_(e, o), e.array[o] = e.array[o] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[o] = e.extensionObject_[o] || jspb.Message.EMPTY_LIST_SENTINEL_);
  if (n && n.length) for (t = 0; t < n.length; t++) jspb.Message.computeOneofCase(e, n[t]);
}, jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [], jspb.Message.isArray_ = function (e) {
  return jspb.Message.ASSUME_LOCAL_ARRAYS ? e instanceof Array : Array.isArray(e);
}, jspb.Message.isExtensionObject_ = function (e) {
  return !(null === e || "object" != typeof e || jspb.Message.isArray_(e) || jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array);
}, jspb.Message.initPivotAndExtensionObject_ = function (e, t) {
  var o = e.array.length,
      r = -1;
  if (o && (r = o - 1, o = e.array[r], jspb.Message.isExtensionObject_(o))) return e.pivot_ = jspb.Message.getFieldNumber_(e, r), void (e.extensionObject_ = o);
  -1 < t ? (e.pivot_ = Math.max(t, jspb.Message.getFieldNumber_(e, r + 1)), e.extensionObject_ = null) : e.pivot_ = Number.MAX_VALUE;
}, jspb.Message.maybeInitEmptyExtensionObject_ = function (e) {
  var t = jspb.Message.getIndex_(e, e.pivot_);
  e.array[t] || (e.extensionObject_ = e.array[t] = {});
}, jspb.Message.toObjectList = function (e, t, o) {
  for (var r = [], s = 0; s < e.length; s++) r[s] = t.call(e[s], o, e[s]);

  return r;
}, jspb.Message.toObjectExtension = function (e, t, o, r, s) {
  for (var n in o) {
    var i = o[n],
        a = r.call(e, i);

    if (null != a) {
      for (var u in i.fieldName) if (i.fieldName.hasOwnProperty(u)) break;

      t[u] = i.toObjectFn ? i.isRepeated ? jspb.Message.toObjectList(a, i.toObjectFn, s) : i.toObjectFn(s, a) : a;
    }
  }
}, jspb.Message.serializeBinaryExtensions = function (e, t, o, r) {
  for (var s in o) {
    var n = o[s],
        i = n.fieldInfo;
    if (!n.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
    var a = r.call(e, i);
    if (null != a) if (i.isMessageType()) {
      if (!n.binaryMessageSerializeFn) throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
      n.binaryWriterFn.call(t, i.fieldIndex, a, n.binaryMessageSerializeFn);
    } else n.binaryWriterFn.call(t, i.fieldIndex, a);
  }
}, jspb.Message.readBinaryExtension = function (e, t, o, r, s) {
  var n = o[t.getFieldNumber()];

  if (n) {
    if (o = n.fieldInfo, !n.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");

    if (o.isMessageType()) {
      var i = new o.ctor();
      n.binaryReaderFn.call(t, i, n.binaryMessageDeserializeFn);
    } else i = n.binaryReaderFn.call(t);

    o.isRepeated && !n.isPacked ? (t = r.call(e, o)) ? t.push(i) : s.call(e, o, [i]) : s.call(e, o, i);
  } else t.skipField();
}, jspb.Message.getField = function (e, t) {
  if (t < e.pivot_) {
    t = jspb.Message.getIndex_(e, t);
    var o = e.array[t];
    return o === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.array[t] = [] : o;
  }

  if (e.extensionObject_) return (o = e.extensionObject_[t]) === jspb.Message.EMPTY_LIST_SENTINEL_ ? e.extensionObject_[t] = [] : o;
}, jspb.Message.getRepeatedField = function (e, t) {
  return jspb.Message.getField(e, t);
}, jspb.Message.getOptionalFloatingPointField = function (e, t) {
  return null == (e = jspb.Message.getField(e, t)) ? e : +e;
}, jspb.Message.getBooleanField = function (e, t) {
  return null == (e = jspb.Message.getField(e, t)) ? e : !!e;
}, jspb.Message.getRepeatedFloatingPointField = function (e, t) {
  var o = jspb.Message.getRepeatedField(e, t);

  if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[t]) {
    for (var r = 0; r < o.length; r++) o[r] = +o[r];

    e.convertedPrimitiveFields_[t] = !0;
  }

  return o;
}, jspb.Message.getRepeatedBooleanField = function (e, t) {
  var o = jspb.Message.getRepeatedField(e, t);

  if (e.convertedPrimitiveFields_ || (e.convertedPrimitiveFields_ = {}), !e.convertedPrimitiveFields_[t]) {
    for (var r = 0; r < o.length; r++) o[r] = !!o[r];

    e.convertedPrimitiveFields_[t] = !0;
  }

  return o;
}, jspb.Message.bytesAsB64 = function (e) {
  return null == e || "string" == typeof e ? e : jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array ? goog.crypt.base64.encodeByteArray(e) : (goog.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(e)), null);
}, jspb.Message.bytesAsU8 = function (e) {
  return null == e || e instanceof Uint8Array ? e : "string" == typeof e ? goog.crypt.base64.decodeStringToUint8Array(e) : (goog.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(e)), null);
}, jspb.Message.bytesListAsB64 = function (e) {
  return jspb.Message.assertConsistentTypes_(e), e.length && "string" != typeof e[0] ? goog.array.map(e, jspb.Message.bytesAsB64) : e;
}, jspb.Message.bytesListAsU8 = function (e) {
  return jspb.Message.assertConsistentTypes_(e), !e.length || e[0] instanceof Uint8Array ? e : goog.array.map(e, jspb.Message.bytesAsU8);
}, jspb.Message.assertConsistentTypes_ = function (e) {
  if (goog.DEBUG && e && 1 < e.length) {
    var t = goog.typeOf(e[0]);
    goog.array.forEach(e, function (e) {
      goog.typeOf(e) != t && goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(e) + " expected " + t);
    });
  }
}, jspb.Message.getFieldWithDefault = function (e, t, o) {
  return null == (e = jspb.Message.getField(e, t)) ? o : e;
}, jspb.Message.getBooleanFieldWithDefault = function (e, t, o) {
  return null == (e = jspb.Message.getBooleanField(e, t)) ? o : e;
}, jspb.Message.getFloatingPointFieldWithDefault = function (e, t, o) {
  return null == (e = jspb.Message.getOptionalFloatingPointField(e, t)) ? o : e;
}, jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault, jspb.Message.getMapField = function (e, t, o, r) {
  if (e.wrappers_ || (e.wrappers_ = {}), t in e.wrappers_) return e.wrappers_[t];
  var s = jspb.Message.getField(e, t);

  if (!s) {
    if (o) return;
    s = [], jspb.Message.setField(e, t, s);
  }

  return e.wrappers_[t] = new jspb.Map(s, r);
}, jspb.Message.setField = function (e, t, o) {
  return goog.asserts.assertInstanceof(e, jspb.Message), t < e.pivot_ ? e.array[jspb.Message.getIndex_(e, t)] = o : (jspb.Message.maybeInitEmptyExtensionObject_(e), e.extensionObject_[t] = o), e;
}, jspb.Message.setProto3IntField = function (e, t, o) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, o, 0);
}, jspb.Message.setProto3FloatField = function (e, t, o) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, o, 0);
}, jspb.Message.setProto3BooleanField = function (e, t, o) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, o, !1);
}, jspb.Message.setProto3StringField = function (e, t, o) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, o, "");
}, jspb.Message.setProto3BytesField = function (e, t, o) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, o, "");
}, jspb.Message.setProto3EnumField = function (e, t, o) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, o, 0);
}, jspb.Message.setProto3StringIntField = function (e, t, o) {
  return jspb.Message.setFieldIgnoringDefault_(e, t, o, "0");
}, jspb.Message.setFieldIgnoringDefault_ = function (e, t, o, r) {
  return goog.asserts.assertInstanceof(e, jspb.Message), o !== r ? jspb.Message.setField(e, t, o) : t < e.pivot_ ? e.array[jspb.Message.getIndex_(e, t)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(e), delete e.extensionObject_[t]), e;
}, jspb.Message.addToRepeatedField = function (e, t, o, r) {
  return goog.asserts.assertInstanceof(e, jspb.Message), t = jspb.Message.getRepeatedField(e, t), null != r ? t.splice(r, 0, o) : t.push(o), e;
}, jspb.Message.setOneofField = function (e, t, o, r) {
  return goog.asserts.assertInstanceof(e, jspb.Message), (o = jspb.Message.computeOneofCase(e, o)) && o !== t && void 0 !== r && (e.wrappers_ && o in e.wrappers_ && (e.wrappers_[o] = void 0), jspb.Message.setField(e, o, void 0)), jspb.Message.setField(e, t, r);
}, jspb.Message.computeOneofCase = function (e, t) {
  for (var o, r, s = 0; s < t.length; s++) {
    var n = t[s],
        i = jspb.Message.getField(e, n);
    null != i && (o = n, r = i, jspb.Message.setField(e, n, void 0));
  }

  return o ? (jspb.Message.setField(e, o, r), o) : 0;
}, jspb.Message.getWrapperField = function (e, t, o, r) {
  if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[o]) {
    var s = jspb.Message.getField(e, o);
    (r || s) && (e.wrappers_[o] = new t(s));
  }

  return e.wrappers_[o];
}, jspb.Message.getRepeatedWrapperField = function (e, t, o) {
  return jspb.Message.wrapRepeatedField_(e, t, o), (t = e.wrappers_[o]) == jspb.Message.EMPTY_LIST_SENTINEL_ && (t = e.wrappers_[o] = []), t;
}, jspb.Message.wrapRepeatedField_ = function (e, t, o) {
  if (e.wrappers_ || (e.wrappers_ = {}), !e.wrappers_[o]) {
    for (var r = jspb.Message.getRepeatedField(e, o), s = [], n = 0; n < r.length; n++) s[n] = new t(r[n]);

    e.wrappers_[o] = s;
  }
}, jspb.Message.setWrapperField = function (e, t, o) {
  goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
  var r = o ? o.toArray() : o;
  return e.wrappers_[t] = o, jspb.Message.setField(e, t, r);
}, jspb.Message.setOneofWrapperField = function (e, t, o, r) {
  goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {});
  var s = r ? r.toArray() : r;
  return e.wrappers_[t] = r, jspb.Message.setOneofField(e, t, o, s);
}, jspb.Message.setRepeatedWrapperField = function (e, t, o) {
  goog.asserts.assertInstanceof(e, jspb.Message), e.wrappers_ || (e.wrappers_ = {}), o = o || [];

  for (var r = [], s = 0; s < o.length; s++) r[s] = o[s].toArray();

  return e.wrappers_[t] = o, jspb.Message.setField(e, t, r);
}, jspb.Message.addToRepeatedWrapperField = function (e, t, o, r, s) {
  jspb.Message.wrapRepeatedField_(e, r, t);
  var n = e.wrappers_[t];
  return n || (n = e.wrappers_[t] = []), o = o || new r(), e = jspb.Message.getRepeatedField(e, t), null != s ? (n.splice(s, 0, o), e.splice(s, 0, o.toArray())) : (n.push(o), e.push(o.toArray())), o;
}, jspb.Message.toMap = function (e, t, o, r) {
  for (var s = {}, n = 0; n < e.length; n++) s[t.call(e[n])] = o ? o.call(e[n], r, e[n]) : e[n];

  return s;
}, jspb.Message.prototype.syncMapFields_ = function () {
  if (this.wrappers_) for (var e in this.wrappers_) {
    var t = this.wrappers_[e];
    if (Array.isArray(t)) for (var o = 0; o < t.length; o++) t[o] && t[o].toArray();else t && t.toArray();
  }
}, jspb.Message.prototype.toArray = function () {
  return this.syncMapFields_(), this.array;
}, jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function () {
  return this.syncMapFields_(), this.array.toString();
}), jspb.Message.prototype.getExtension = function (e) {
  if (this.extensionObject_) {
    this.wrappers_ || (this.wrappers_ = {});
    var t = e.fieldIndex;

    if (e.isRepeated) {
      if (e.isMessageType()) return this.wrappers_[t] || (this.wrappers_[t] = goog.array.map(this.extensionObject_[t] || [], function (t) {
        return new e.ctor(t);
      })), this.wrappers_[t];
    } else if (e.isMessageType()) return !this.wrappers_[t] && this.extensionObject_[t] && (this.wrappers_[t] = new e.ctor(this.extensionObject_[t])), this.wrappers_[t];

    return this.extensionObject_[t];
  }
}, jspb.Message.prototype.setExtension = function (e, t) {
  this.wrappers_ || (this.wrappers_ = {}), jspb.Message.maybeInitEmptyExtensionObject_(this);
  var o = e.fieldIndex;
  return e.isRepeated ? (t = t || [], e.isMessageType() ? (this.wrappers_[o] = t, this.extensionObject_[o] = goog.array.map(t, function (e) {
    return e.toArray();
  })) : this.extensionObject_[o] = t) : e.isMessageType() ? (this.wrappers_[o] = t, this.extensionObject_[o] = t ? t.toArray() : t) : this.extensionObject_[o] = t, this;
}, jspb.Message.difference = function (e, t) {
  if (!(e instanceof t.constructor)) throw Error("Messages have different types.");
  var o = e.toArray();
  t = t.toArray();
  var r = [],
      s = 0,
      n = o.length > t.length ? o.length : t.length;

  for (e.getJsPbMessageId() && (r[0] = e.getJsPbMessageId(), s = 1); s < n; s++) jspb.Message.compareFields(o[s], t[s]) || (r[s] = t[s]);

  return new e.constructor(r);
}, jspb.Message.equals = function (e, t) {
  return e == t || !(!e || !t) && e instanceof t.constructor && jspb.Message.compareFields(e.toArray(), t.toArray());
}, jspb.Message.compareExtensions = function (e, t) {
  e = e || {}, t = t || {};
  var o,
      r = {};

  for (o in e) r[o] = 0;

  for (o in t) r[o] = 0;

  for (o in r) if (!jspb.Message.compareFields(e[o], t[o])) return !1;

  return !0;
}, jspb.Message.compareFields = function (e, t) {
  if (e == t) return !0;
  if (!goog.isObject(e) || !goog.isObject(t)) return !!("number" == typeof e && isNaN(e) || "number" == typeof t && isNaN(t)) && String(e) == String(t);
  if (e.constructor != t.constructor) return !1;

  if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e.constructor === Uint8Array) {
    if (e.length != t.length) return !1;

    for (var o = 0; o < e.length; o++) if (e[o] != t[o]) return !1;

    return !0;
  }

  if (e.constructor === Array) {
    var r = void 0,
        s = void 0,
        n = Math.max(e.length, t.length);

    for (o = 0; o < n; o++) {
      var i = e[o],
          a = t[o];
      if (i && i.constructor == Object && (goog.asserts.assert(void 0 === r), goog.asserts.assert(o === e.length - 1), r = i, i = void 0), a && a.constructor == Object && (goog.asserts.assert(void 0 === s), goog.asserts.assert(o === t.length - 1), s = a, a = void 0), !jspb.Message.compareFields(i, a)) return !1;
    }

    return !r && !s || (r = r || {}, s = s || {}, jspb.Message.compareExtensions(r, s));
  }

  if (e.constructor === Object) return jspb.Message.compareExtensions(e, t);
  throw Error("Invalid type in JSPB array");
}, jspb.Message.prototype.cloneMessage = function () {
  return jspb.Message.cloneMessage(this);
}, jspb.Message.prototype.clone = function () {
  return jspb.Message.cloneMessage(this);
}, jspb.Message.clone = function (e) {
  return jspb.Message.cloneMessage(e);
}, jspb.Message.cloneMessage = function (e) {
  return new e.constructor(jspb.Message.clone_(e.toArray()));
}, jspb.Message.copyInto = function (e, t) {
  goog.asserts.assertInstanceof(e, jspb.Message), goog.asserts.assertInstanceof(t, jspb.Message), goog.asserts.assert(e.constructor == t.constructor, "Copy source and target message should have the same type."), e = jspb.Message.clone(e);

  for (var o = t.toArray(), r = e.toArray(), s = o.length = 0; s < r.length; s++) o[s] = r[s];

  t.wrappers_ = e.wrappers_, t.extensionObject_ = e.extensionObject_;
}, jspb.Message.clone_ = function (e) {
  if (Array.isArray(e)) {
    for (var t = Array(e.length), o = 0; o < e.length; o++) {
      var r = e[o];
      null != r && (t[o] = "object" == typeof r ? jspb.Message.clone_(goog.asserts.assert(r)) : r);
    }

    return t;
  }

  if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e instanceof Uint8Array) return new Uint8Array(e);

  for (o in t = {}, e) null != (r = e[o]) && (t[o] = "object" == typeof r ? jspb.Message.clone_(goog.asserts.assert(r)) : r);

  return t;
}, jspb.Message.registerMessageType = function (e, t) {
  t.messageId = e;
}, jspb.Message.messageSetExtensions = {}, jspb.Message.messageSetExtensionsBinary = {}, jspb.arith = {}, jspb.arith.UInt64 = function (e, t) {
  this.lo = e, this.hi = t;
}, jspb.arith.UInt64.prototype.cmp = function (e) {
  return this.hi < e.hi || this.hi == e.hi && this.lo < e.lo ? -1 : this.hi == e.hi && this.lo == e.lo ? 0 : 1;
}, jspb.arith.UInt64.prototype.rightShift = function () {
  return new jspb.arith.UInt64((this.lo >>> 1 | (1 & this.hi) << 31) >>> 0, this.hi >>> 1 >>> 0);
}, jspb.arith.UInt64.prototype.leftShift = function () {
  return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
}, jspb.arith.UInt64.prototype.msb = function () {
  return !!(2147483648 & this.hi);
}, jspb.arith.UInt64.prototype.lsb = function () {
  return !!(1 & this.lo);
}, jspb.arith.UInt64.prototype.zero = function () {
  return 0 == this.lo && 0 == this.hi;
}, jspb.arith.UInt64.prototype.add = function (e) {
  return new jspb.arith.UInt64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
}, jspb.arith.UInt64.prototype.sub = function (e) {
  return new jspb.arith.UInt64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
}, jspb.arith.UInt64.mul32x32 = function (e, t) {
  var o = 65535 & e,
      r = 65535 & t,
      s = t >>> 16;

  for (t = o * r + 65536 * (o * s & 65535) + 65536 * ((e >>>= 16) * r & 65535), o = e * s + (o * s >>> 16) + (e * r >>> 16); 4294967296 <= t;) t -= 4294967296, o += 1;

  return new jspb.arith.UInt64(t >>> 0, o >>> 0);
}, jspb.arith.UInt64.prototype.mul = function (e) {
  var t = jspb.arith.UInt64.mul32x32(this.lo, e);
  return (e = jspb.arith.UInt64.mul32x32(this.hi, e)).hi = e.lo, e.lo = 0, t.add(e);
}, jspb.arith.UInt64.prototype.div = function (e) {
  if (0 == e) return [];
  var t = new jspb.arith.UInt64(0, 0),
      o = new jspb.arith.UInt64(this.lo, this.hi);
  e = new jspb.arith.UInt64(e, 0);

  for (var r = new jspb.arith.UInt64(1, 0); !e.msb();) e = e.leftShift(), r = r.leftShift();

  for (; !r.zero();) 0 >= e.cmp(o) && (t = t.add(r), o = o.sub(e)), e = e.rightShift(), r = r.rightShift();

  return [t, o];
}, jspb.arith.UInt64.prototype.toString = function () {
  for (var e = "", t = this; !t.zero();) {
    var o = (t = t.div(10))[0];
    e = t[1].lo + e, t = o;
  }

  return "" == e && (e = "0"), e;
}, jspb.arith.UInt64.fromString = function (e) {
  for (var t = new jspb.arith.UInt64(0, 0), o = new jspb.arith.UInt64(0, 0), r = 0; r < e.length; r++) {
    if ("0" > e[r] || "9" < e[r]) return null;
    var s = parseInt(e[r], 10);
    o.lo = s, t = t.mul(10).add(o);
  }

  return t;
}, jspb.arith.UInt64.prototype.clone = function () {
  return new jspb.arith.UInt64(this.lo, this.hi);
}, jspb.arith.Int64 = function (e, t) {
  this.lo = e, this.hi = t;
}, jspb.arith.Int64.prototype.add = function (e) {
  return new jspb.arith.Int64((this.lo + e.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e.lo ? 1 : 0) >>> 0);
}, jspb.arith.Int64.prototype.sub = function (e) {
  return new jspb.arith.Int64((this.lo - e.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e.hi & 4294967295) >>> 0) - (0 > this.lo - e.lo ? 1 : 0) >>> 0);
}, jspb.arith.Int64.prototype.clone = function () {
  return new jspb.arith.Int64(this.lo, this.hi);
}, jspb.arith.Int64.prototype.toString = function () {
  var e = 0 != (2147483648 & this.hi),
      t = new jspb.arith.UInt64(this.lo, this.hi);
  return e && (t = new jspb.arith.UInt64(0, 0).sub(t)), (e ? "-" : "") + t.toString();
}, jspb.arith.Int64.fromString = function (e) {
  var t = 0 < e.length && "-" == e[0];
  return t && (e = e.substring(1)), null === (e = jspb.arith.UInt64.fromString(e)) ? null : (t && (e = new jspb.arith.UInt64(0, 0).sub(e)), new jspb.arith.Int64(e.lo, e.hi));
}, jspb.BinaryEncoder = function () {
  this.buffer_ = [];
}, jspb.BinaryEncoder.prototype.length = function () {
  return this.buffer_.length;
}, jspb.BinaryEncoder.prototype.end = function () {
  var e = this.buffer_;
  return this.buffer_ = [], e;
}, jspb.BinaryEncoder.prototype.writeSplitVarint64 = function (e, t) {
  for (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(t == Math.floor(t)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32); 0 < t || 127 < e;) this.buffer_.push(127 & e | 128), e = (e >>> 7 | t << 25) >>> 0, t >>>= 7;

  this.buffer_.push(e);
}, jspb.BinaryEncoder.prototype.writeSplitFixed64 = function (e, t) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(t == Math.floor(t)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUint32(e), this.writeUint32(t);
}, jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function (e) {
  for (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32); 127 < e;) this.buffer_.push(127 & e | 128), e >>>= 7;

  this.buffer_.push(e);
}, jspb.BinaryEncoder.prototype.writeSignedVarint32 = function (e) {
  if (goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), 0 <= e) this.writeUnsignedVarint32(e);else {
    for (var t = 0; 9 > t; t++) this.buffer_.push(127 & e | 128), e >>= 7;

    this.buffer_.push(1);
  }
}, jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeSignedVarint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeUnsignedVarint32((e << 1 ^ e >> 31) >>> 0);
}, jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitZigzag64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function (e) {
  this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(e));
}, jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function (e) {
  var t = this;
  jspb.utils.splitHash64(e), jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function (e, o) {
    t.writeSplitVarint64(e >>> 0, o >>> 0);
  });
}, jspb.BinaryEncoder.prototype.writeUint8 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && 256 > e), this.buffer_.push(e >>> 0 & 255);
}, jspb.BinaryEncoder.prototype.writeUint16 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && 65536 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
}, jspb.BinaryEncoder.prototype.writeUint32 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_32), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
}, jspb.BinaryEncoder.prototype.writeUint64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(0 <= e && e < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitUint64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeInt8 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(-128 <= e && 128 > e), this.buffer_.push(e >>> 0 & 255);
}, jspb.BinaryEncoder.prototype.writeInt16 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(-32768 <= e && 32768 > e), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255);
}, jspb.BinaryEncoder.prototype.writeInt32 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.buffer_.push(e >>> 0 & 255), this.buffer_.push(e >>> 8 & 255), this.buffer_.push(e >>> 16 & 255), this.buffer_.push(e >>> 24 & 255);
}, jspb.BinaryEncoder.prototype.writeInt64 = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_63 && e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeInt64String = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(+e >= -jspb.BinaryConstants.TWO_TO_63 && +e < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e)), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeFloat = function (e) {
  goog.asserts.assert(1 / 0 === e || -1 / 0 === e || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT32_MAX && e <= jspb.BinaryConstants.FLOAT32_MAX), jspb.utils.splitFloat32(e), this.writeUint32(jspb.utils.split64Low);
}, jspb.BinaryEncoder.prototype.writeDouble = function (e) {
  goog.asserts.assert(1 / 0 === e || -1 / 0 === e || isNaN(e) || e >= -jspb.BinaryConstants.FLOAT64_MAX && e <= jspb.BinaryConstants.FLOAT64_MAX), jspb.utils.splitFloat64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeBool = function (e) {
  goog.asserts.assert("boolean" == typeof e || "number" == typeof e), this.buffer_.push(e ? 1 : 0);
}, jspb.BinaryEncoder.prototype.writeEnum = function (e) {
  goog.asserts.assert(e == Math.floor(e)), goog.asserts.assert(e >= -jspb.BinaryConstants.TWO_TO_31 && e < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32(e);
}, jspb.BinaryEncoder.prototype.writeBytes = function (e) {
  this.buffer_.push.apply(this.buffer_, e);
}, jspb.BinaryEncoder.prototype.writeVarintHash64 = function (e) {
  jspb.utils.splitHash64(e), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeFixedHash64 = function (e) {
  jspb.utils.splitHash64(e), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
}, jspb.BinaryEncoder.prototype.writeString = function (e) {
  for (var t = this.buffer_.length, o = 0; o < e.length; o++) {
    var r = e.charCodeAt(o);
    if (128 > r) this.buffer_.push(r);else if (2048 > r) this.buffer_.push(r >> 6 | 192), this.buffer_.push(63 & r | 128);else if (65536 > r) if (55296 <= r && 56319 >= r && o + 1 < e.length) {
      var s = e.charCodeAt(o + 1);
      56320 <= s && 57343 >= s && (r = 1024 * (r - 55296) + s - 56320 + 65536, this.buffer_.push(r >> 18 | 240), this.buffer_.push(r >> 12 & 63 | 128), this.buffer_.push(r >> 6 & 63 | 128), this.buffer_.push(63 & r | 128), o++);
    } else this.buffer_.push(r >> 12 | 224), this.buffer_.push(r >> 6 & 63 | 128), this.buffer_.push(63 & r | 128);
  }

  return this.buffer_.length - t;
}, jspb.BinaryWriter = function () {
  this.blocks_ = [], this.totalLength_ = 0, this.encoder_ = new jspb.BinaryEncoder(), this.bookmarks_ = [];
}, jspb.BinaryWriter.prototype.appendUint8Array_ = function (e) {
  var t = this.encoder_.end();
  this.blocks_.push(t), this.blocks_.push(e), this.totalLength_ += t.length + e.length;
}, jspb.BinaryWriter.prototype.beginDelimited_ = function (e) {
  return this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), e = this.encoder_.end(), this.blocks_.push(e), this.totalLength_ += e.length, e.push(this.totalLength_), e;
}, jspb.BinaryWriter.prototype.endDelimited_ = function (e) {
  var t = e.pop();

  for (t = this.totalLength_ + this.encoder_.length() - t, goog.asserts.assert(0 <= t); 127 < t;) e.push(127 & t | 128), t >>>= 7, this.totalLength_++;

  e.push(t), this.totalLength_++;
}, jspb.BinaryWriter.prototype.writeSerializedMessage = function (e, t, o) {
  this.appendUint8Array_(e.subarray(t, o));
}, jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function (e, t, o) {
  null != e && null != t && null != o && this.writeSerializedMessage(e, t, o);
}, jspb.BinaryWriter.prototype.reset = function () {
  this.blocks_ = [], this.encoder_.end(), this.totalLength_ = 0, this.bookmarks_ = [];
}, jspb.BinaryWriter.prototype.getResultBuffer = function () {
  goog.asserts.assert(0 == this.bookmarks_.length);

  for (var e = new Uint8Array(this.totalLength_ + this.encoder_.length()), t = this.blocks_, o = t.length, r = 0, s = 0; s < o; s++) {
    var n = t[s];
    e.set(n, r), r += n.length;
  }

  return t = this.encoder_.end(), e.set(t, r), r += t.length, goog.asserts.assert(r == e.length), this.blocks_ = [e], e;
}, jspb.BinaryWriter.prototype.getResultBase64String = function (e) {
  return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), e);
}, jspb.BinaryWriter.prototype.beginSubMessage = function (e) {
  this.bookmarks_.push(this.beginDelimited_(e));
}, jspb.BinaryWriter.prototype.endSubMessage = function () {
  goog.asserts.assert(0 <= this.bookmarks_.length), this.endDelimited_(this.bookmarks_.pop());
}, jspb.BinaryWriter.prototype.writeFieldHeader_ = function (e, t) {
  goog.asserts.assert(1 <= e && e == Math.floor(e)), this.encoder_.writeUnsignedVarint32(8 * e + t);
}, jspb.BinaryWriter.prototype.writeAny = function (e, t, o) {
  var r = jspb.BinaryConstants.FieldType;

  switch (e) {
    case r.DOUBLE:
      this.writeDouble(t, o);
      break;

    case r.FLOAT:
      this.writeFloat(t, o);
      break;

    case r.INT64:
      this.writeInt64(t, o);
      break;

    case r.UINT64:
      this.writeUint64(t, o);
      break;

    case r.INT32:
      this.writeInt32(t, o);
      break;

    case r.FIXED64:
      this.writeFixed64(t, o);
      break;

    case r.FIXED32:
      this.writeFixed32(t, o);
      break;

    case r.BOOL:
      this.writeBool(t, o);
      break;

    case r.STRING:
      this.writeString(t, o);
      break;

    case r.GROUP:
      goog.asserts.fail("Group field type not supported in writeAny()");
      break;

    case r.MESSAGE:
      goog.asserts.fail("Message field type not supported in writeAny()");
      break;

    case r.BYTES:
      this.writeBytes(t, o);
      break;

    case r.UINT32:
      this.writeUint32(t, o);
      break;

    case r.ENUM:
      this.writeEnum(t, o);
      break;

    case r.SFIXED32:
      this.writeSfixed32(t, o);
      break;

    case r.SFIXED64:
      this.writeSfixed64(t, o);
      break;

    case r.SINT32:
      this.writeSint32(t, o);
      break;

    case r.SINT64:
      this.writeSint64(t, o);
      break;

    case r.FHASH64:
      this.writeFixedHash64(t, o);
      break;

    case r.VHASH64:
      this.writeVarintHash64(t, o);
      break;

    default:
      goog.asserts.fail("Invalid field type in writeAny()");
  }
}, jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(t));
}, jspb.BinaryWriter.prototype.writeSignedVarint32_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t));
}, jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(t));
}, jspb.BinaryWriter.prototype.writeSignedVarint64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(t));
}, jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(t));
}, jspb.BinaryWriter.prototype.writeInt32 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeInt32String = function (e, t) {
  null != t && (t = parseInt(t, 10), goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeInt64 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(e, t));
}, jspb.BinaryWriter.prototype.writeInt64String = function (e, t) {
  null != t && (t = jspb.arith.Int64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeUint32 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeUint32String = function (e, t) {
  null != t && (t = parseInt(t, 10), goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeUint64 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(e, t));
}, jspb.BinaryWriter.prototype.writeUint64String = function (e, t) {
  null != t && (t = jspb.arith.UInt64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeSint32 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(e, t));
}, jspb.BinaryWriter.prototype.writeSint64 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(e, t));
}, jspb.BinaryWriter.prototype.writeSintHash64 = function (e, t) {
  null != t && this.writeZigzagVarintHash64_(e, t);
}, jspb.BinaryWriter.prototype.writeSint64String = function (e, t) {
  null != t && this.writeZigzagVarint64String_(e, t);
}, jspb.BinaryWriter.prototype.writeFixed32 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(t));
}, jspb.BinaryWriter.prototype.writeFixed64 = function (e, t) {
  null != t && (goog.asserts.assert(0 <= t && t < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(t));
}, jspb.BinaryWriter.prototype.writeFixed64String = function (e, t) {
  null != t && (t = jspb.arith.UInt64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeSfixed32 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(t));
}, jspb.BinaryWriter.prototype.writeSfixed64 = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_63 && t < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(t));
}, jspb.BinaryWriter.prototype.writeSfixed64String = function (e, t) {
  null != t && (t = jspb.arith.Int64.fromString(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t.lo, t.hi));
}, jspb.BinaryWriter.prototype.writeFloat = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(t));
}, jspb.BinaryWriter.prototype.writeDouble = function (e, t) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(t));
}, jspb.BinaryWriter.prototype.writeBool = function (e, t) {
  null != t && (goog.asserts.assert("boolean" == typeof t || "number" == typeof t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(t));
}, jspb.BinaryWriter.prototype.writeEnum = function (e, t) {
  null != t && (goog.asserts.assert(t >= -jspb.BinaryConstants.TWO_TO_31 && t < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t));
}, jspb.BinaryWriter.prototype.writeString = function (e, t) {
  null != t && (e = this.beginDelimited_(e), this.encoder_.writeString(t), this.endDelimited_(e));
}, jspb.BinaryWriter.prototype.writeBytes = function (e, t) {
  null != t && (t = jspb.utils.byteSourceToUint8Array(t), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t.length), this.appendUint8Array_(t));
}, jspb.BinaryWriter.prototype.writeMessage = function (e, t, o) {
  null != t && (e = this.beginDelimited_(e), o(t, this), this.endDelimited_(e));
}, jspb.BinaryWriter.prototype.writeMessageSet = function (e, t, o) {
  null != t && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(e), e = this.beginDelimited_(3), o(t, this), this.endDelimited_(e), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
}, jspb.BinaryWriter.prototype.writeGroup = function (e, t, o) {
  null != t && (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), o(t, this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP));
}, jspb.BinaryWriter.prototype.writeFixedHash64 = function (e, t) {
  null != t && (goog.asserts.assert(8 == t.length), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(t));
}, jspb.BinaryWriter.prototype.writeVarintHash64 = function (e, t) {
  null != t && (goog.asserts.assert(8 == t.length), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(t));
}, jspb.BinaryWriter.prototype.writeSplitFixed64 = function (e, t, o) {
  this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t, o);
}, jspb.BinaryWriter.prototype.writeSplitVarint64 = function (e, t, o) {
  this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t, o);
}, jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function (e, t, o) {
  this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.VARINT);
  var r = this.encoder_;
  jspb.utils.toZigzag64(t, o, function (e, t) {
    r.writeSplitVarint64(e >>> 0, t >>> 0);
  });
}, jspb.BinaryWriter.prototype.writeRepeatedInt32 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeSignedVarint32_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedInt32String = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeInt32String(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedInt64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeSignedVarint64_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function (e, t, o, r) {
  if (null != t) for (var s = 0; s < t.length; s++) this.writeSplitFixed64(e, o(t[s]), r(t[s]));
}, jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function (e, t, o, r) {
  if (null != t) for (var s = 0; s < t.length; s++) this.writeSplitVarint64(e, o(t[s]), r(t[s]));
}, jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function (e, t, o, r) {
  if (null != t) for (var s = 0; s < t.length; s++) this.writeSplitZigzagVarint64(e, o(t[s]), r(t[s]));
}, jspb.BinaryWriter.prototype.writeRepeatedInt64String = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeInt64String(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint32 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeUnsignedVarint32_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint32String = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeUint32String(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeUnsignedVarint64_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedUint64String = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeUint64String(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSint32 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeZigzagVarint32_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSint64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeZigzagVarint64_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSint64String = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeZigzagVarint64String_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeZigzagVarintHash64_(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeFixed32(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeFixed64(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeFixed64String(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeSfixed32(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeSfixed64(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeSfixed64String(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedFloat = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeFloat(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedDouble = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeDouble(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedBool = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeBool(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedEnum = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeEnum(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedString = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeString(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedBytes = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeBytes(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedMessage = function (e, t, o) {
  if (null != t) for (var r = 0; r < t.length; r++) {
    var s = this.beginDelimited_(e);
    o(t[r], this), this.endDelimited_(s);
  }
}, jspb.BinaryWriter.prototype.writeRepeatedGroup = function (e, t, o) {
  if (null != t) for (var r = 0; r < t.length; r++) this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.START_GROUP), o(t[r], this), this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.END_GROUP);
}, jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeFixedHash64(e, t[o]);
}, jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function (e, t) {
  if (null != t) for (var o = 0; o < t.length; o++) this.writeVarintHash64(e, t[o]);
}, jspb.BinaryWriter.prototype.writePackedInt32 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeSignedVarint32(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedInt32String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeSignedVarint32(parseInt(t[o], 10));

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedInt64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeSignedVarint64(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function (e, t, o, r) {
  if (null != t) {
    e = this.beginDelimited_(e);

    for (var s = 0; s < t.length; s++) this.encoder_.writeSplitFixed64(o(t[s]), r(t[s]));

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function (e, t, o, r) {
  if (null != t) {
    e = this.beginDelimited_(e);

    for (var s = 0; s < t.length; s++) this.encoder_.writeSplitVarint64(o(t[s]), r(t[s]));

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function (e, t, o, r) {
  if (null != t) {
    e = this.beginDelimited_(e);

    for (var s = this.encoder_, n = 0; n < t.length; n++) jspb.utils.toZigzag64(o(t[n]), r(t[n]), function (e, t) {
      s.writeSplitVarint64(e >>> 0, t >>> 0);
    });

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedInt64String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) {
      var r = jspb.arith.Int64.fromString(t[o]);
      this.encoder_.writeSplitVarint64(r.lo, r.hi);
    }

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint32 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeUnsignedVarint32(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint32String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeUnsignedVarint32(parseInt(t[o], 10));

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeUnsignedVarint64(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedUint64String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) {
      var r = jspb.arith.UInt64.fromString(t[o]);
      this.encoder_.writeSplitVarint64(r.lo, r.hi);
    }

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSint32 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeZigzagVarint32(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSint64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeZigzagVarint64(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSint64String = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(t[o]));

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedSintHash64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeZigzagVarintHash64(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedFixed32 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeUint32(t[e]);
}, jspb.BinaryWriter.prototype.writePackedFixed64 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeUint64(t[e]);
}, jspb.BinaryWriter.prototype.writePackedFixed64String = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) {
    var o = jspb.arith.UInt64.fromString(t[e]);
    this.encoder_.writeSplitFixed64(o.lo, o.hi);
  }
}, jspb.BinaryWriter.prototype.writePackedSfixed32 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt32(t[e]);
}, jspb.BinaryWriter.prototype.writePackedSfixed64 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt64(t[e]);
}, jspb.BinaryWriter.prototype.writePackedSfixed64String = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeInt64String(t[e]);
}, jspb.BinaryWriter.prototype.writePackedFloat = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t.length), e = 0; e < t.length; e++) this.encoder_.writeFloat(t[e]);
}, jspb.BinaryWriter.prototype.writePackedDouble = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeDouble(t[e]);
}, jspb.BinaryWriter.prototype.writePackedBool = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t.length), e = 0; e < t.length; e++) this.encoder_.writeBool(t[e]);
}, jspb.BinaryWriter.prototype.writePackedEnum = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeEnum(t[o]);

    this.endDelimited_(e);
  }
}, jspb.BinaryWriter.prototype.writePackedFixedHash64 = function (e, t) {
  if (null != t && t.length) for (this.writeFieldHeader_(e, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t.length), e = 0; e < t.length; e++) this.encoder_.writeFixedHash64(t[e]);
}, jspb.BinaryWriter.prototype.writePackedVarintHash64 = function (e, t) {
  if (null != t && t.length) {
    e = this.beginDelimited_(e);

    for (var o = 0; o < t.length; o++) this.encoder_.writeVarintHash64(t[o]);

    this.endDelimited_(e);
  }
}, jspb.Export = {};

var _Map = jspb.Map,
    Message = jspb.Message,
    BinaryReader = jspb.BinaryReader,
    BinaryWriter = jspb.BinaryWriter,
    ExtensionFieldInfo = jspb.ExtensionFieldInfo,
    ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo,
    exportSymbol = goog.exportSymbol,
    inherits = goog.inherits,
    object = {
  extend: goog.object.extend
},
    typeOf = goog.typeOf,
    googleProtobuf = {
  Map: _Map,
  Message: Message,
  BinaryReader: BinaryReader,
  BinaryWriter: BinaryWriter,
  ExtensionFieldInfo: ExtensionFieldInfo,
  ExtensionFieldBinaryInfo: ExtensionFieldBinaryInfo,
  exportSymbol: exportSymbol,
  inherits: inherits,
  object: object,
  typeOf: typeOf
},
    bucketsd_pb = createCommonjsModule(function (e, t) {
  var o = googleProtobuf,
      r = Function("return this")();
  o.exportSymbol("proto.api.bucketsd.pb.Archive", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchiveConfig", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchiveRenew", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchiveRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchiveResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchiveStatus", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchiveWatchRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchiveWatchResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.Archives", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchivesRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.ArchivesResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.CreateRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.CreateResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.DealInfo", null, r), o.exportSymbol("proto.api.bucketsd.pb.DefaultArchiveConfigRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.DefaultArchiveConfigResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.LinksRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.LinksResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.ListIpfsPathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.ListIpfsPathResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.ListPathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.ListPathResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.ListRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.ListResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.Metadata", null, r), o.exportSymbol("proto.api.bucketsd.pb.MovePathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.MovePathResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.PathAccessRole", null, r), o.exportSymbol("proto.api.bucketsd.pb.PathItem", null, r), o.exportSymbol("proto.api.bucketsd.pb.PullIpfsPathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.PullIpfsPathResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.PullPathAccessRolesRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.PullPathAccessRolesResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.PullPathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.PullPathResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathAccessRolesRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathAccessRolesResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathRequest.Header", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathRequest.PayloadCase", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathResponse.Event", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathsRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathsRequest.Chunk", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathsRequest.Header", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathsRequest.PayloadCase", null, r), o.exportSymbol("proto.api.bucketsd.pb.PushPathsResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.RemovePathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.RemovePathResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.RemoveRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.RemoveResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.Root", null, r), o.exportSymbol("proto.api.bucketsd.pb.RootRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.RootResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse", null, r), o.exportSymbol("proto.api.bucketsd.pb.SetPathRequest", null, r), o.exportSymbol("proto.api.bucketsd.pb.SetPathResponse", null, r), proto.api.bucketsd.pb.Metadata = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.Metadata, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.Metadata.displayName = "proto.api.bucketsd.pb.Metadata"), proto.api.bucketsd.pb.Root = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.Root, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.Root.displayName = "proto.api.bucketsd.pb.Root"), proto.api.bucketsd.pb.ListRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ListRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ListRequest.displayName = "proto.api.bucketsd.pb.ListRequest"), proto.api.bucketsd.pb.ListResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, proto.api.bucketsd.pb.ListResponse.repeatedFields_, null);
  }, o.inherits(proto.api.bucketsd.pb.ListResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ListResponse.displayName = "proto.api.bucketsd.pb.ListResponse"), proto.api.bucketsd.pb.CreateRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.CreateRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.CreateRequest.displayName = "proto.api.bucketsd.pb.CreateRequest"), proto.api.bucketsd.pb.CreateResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.CreateResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.CreateResponse.displayName = "proto.api.bucketsd.pb.CreateResponse"), proto.api.bucketsd.pb.RootRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.RootRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.RootRequest.displayName = "proto.api.bucketsd.pb.RootRequest"), proto.api.bucketsd.pb.RootResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.RootResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.RootResponse.displayName = "proto.api.bucketsd.pb.RootResponse"), proto.api.bucketsd.pb.LinksRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.LinksRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.LinksRequest.displayName = "proto.api.bucketsd.pb.LinksRequest"), proto.api.bucketsd.pb.LinksResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.LinksResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.LinksResponse.displayName = "proto.api.bucketsd.pb.LinksResponse"), proto.api.bucketsd.pb.ListPathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ListPathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ListPathRequest.displayName = "proto.api.bucketsd.pb.ListPathRequest"), proto.api.bucketsd.pb.ListPathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ListPathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ListPathResponse.displayName = "proto.api.bucketsd.pb.ListPathResponse"), proto.api.bucketsd.pb.PathItem = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, proto.api.bucketsd.pb.PathItem.repeatedFields_, null);
  }, o.inherits(proto.api.bucketsd.pb.PathItem, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PathItem.displayName = "proto.api.bucketsd.pb.PathItem"), proto.api.bucketsd.pb.ListIpfsPathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ListIpfsPathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ListIpfsPathRequest.displayName = "proto.api.bucketsd.pb.ListIpfsPathRequest"), proto.api.bucketsd.pb.ListIpfsPathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ListIpfsPathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ListIpfsPathResponse.displayName = "proto.api.bucketsd.pb.ListIpfsPathResponse"), proto.api.bucketsd.pb.PushPathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.api.bucketsd.pb.PushPathRequest.oneofGroups_);
  }, o.inherits(proto.api.bucketsd.pb.PushPathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathRequest.displayName = "proto.api.bucketsd.pb.PushPathRequest"), proto.api.bucketsd.pb.PushPathRequest.Header = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathRequest.Header, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathRequest.Header.displayName = "proto.api.bucketsd.pb.PushPathRequest.Header"), proto.api.bucketsd.pb.PushPathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathResponse.displayName = "proto.api.bucketsd.pb.PushPathResponse"), proto.api.bucketsd.pb.PushPathResponse.Event = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathResponse.Event, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathResponse.Event.displayName = "proto.api.bucketsd.pb.PushPathResponse.Event"), proto.api.bucketsd.pb.PushPathsRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, proto.api.bucketsd.pb.PushPathsRequest.oneofGroups_);
  }, o.inherits(proto.api.bucketsd.pb.PushPathsRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathsRequest.displayName = "proto.api.bucketsd.pb.PushPathsRequest"), proto.api.bucketsd.pb.PushPathsRequest.Header = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathsRequest.Header, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathsRequest.Header.displayName = "proto.api.bucketsd.pb.PushPathsRequest.Header"), proto.api.bucketsd.pb.PushPathsRequest.Chunk = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathsRequest.Chunk, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathsRequest.Chunk.displayName = "proto.api.bucketsd.pb.PushPathsRequest.Chunk"), proto.api.bucketsd.pb.PushPathsResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathsResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathsResponse.displayName = "proto.api.bucketsd.pb.PushPathsResponse"), proto.api.bucketsd.pb.PullPathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PullPathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PullPathRequest.displayName = "proto.api.bucketsd.pb.PullPathRequest"), proto.api.bucketsd.pb.PullPathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PullPathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PullPathResponse.displayName = "proto.api.bucketsd.pb.PullPathResponse"), proto.api.bucketsd.pb.PullIpfsPathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PullIpfsPathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PullIpfsPathRequest.displayName = "proto.api.bucketsd.pb.PullIpfsPathRequest"), proto.api.bucketsd.pb.PullIpfsPathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PullIpfsPathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PullIpfsPathResponse.displayName = "proto.api.bucketsd.pb.PullIpfsPathResponse"), proto.api.bucketsd.pb.SetPathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.SetPathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.SetPathRequest.displayName = "proto.api.bucketsd.pb.SetPathRequest"), proto.api.bucketsd.pb.SetPathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.SetPathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.SetPathResponse.displayName = "proto.api.bucketsd.pb.SetPathResponse"), proto.api.bucketsd.pb.MovePathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.MovePathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.MovePathRequest.displayName = "proto.api.bucketsd.pb.MovePathRequest"), proto.api.bucketsd.pb.MovePathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.MovePathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.MovePathResponse.displayName = "proto.api.bucketsd.pb.MovePathResponse"), proto.api.bucketsd.pb.RemoveRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.RemoveRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.RemoveRequest.displayName = "proto.api.bucketsd.pb.RemoveRequest"), proto.api.bucketsd.pb.RemoveResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.RemoveResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.RemoveResponse.displayName = "proto.api.bucketsd.pb.RemoveResponse"), proto.api.bucketsd.pb.RemovePathRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.RemovePathRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.RemovePathRequest.displayName = "proto.api.bucketsd.pb.RemovePathRequest"), proto.api.bucketsd.pb.RemovePathResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.RemovePathResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.RemovePathResponse.displayName = "proto.api.bucketsd.pb.RemovePathResponse"), proto.api.bucketsd.pb.PushPathAccessRolesRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathAccessRolesRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathAccessRolesRequest.displayName = "proto.api.bucketsd.pb.PushPathAccessRolesRequest"), proto.api.bucketsd.pb.PushPathAccessRolesResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PushPathAccessRolesResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PushPathAccessRolesResponse.displayName = "proto.api.bucketsd.pb.PushPathAccessRolesResponse"), proto.api.bucketsd.pb.PullPathAccessRolesRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PullPathAccessRolesRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PullPathAccessRolesRequest.displayName = "proto.api.bucketsd.pb.PullPathAccessRolesRequest"), proto.api.bucketsd.pb.PullPathAccessRolesResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.PullPathAccessRolesResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.PullPathAccessRolesResponse.displayName = "proto.api.bucketsd.pb.PullPathAccessRolesResponse"), proto.api.bucketsd.pb.ArchiveConfig = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, proto.api.bucketsd.pb.ArchiveConfig.repeatedFields_, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchiveConfig, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchiveConfig.displayName = "proto.api.bucketsd.pb.ArchiveConfig"), proto.api.bucketsd.pb.Archives = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, proto.api.bucketsd.pb.Archives.repeatedFields_, null);
  }, o.inherits(proto.api.bucketsd.pb.Archives, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.Archives.displayName = "proto.api.bucketsd.pb.Archives"), proto.api.bucketsd.pb.Archive = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, proto.api.bucketsd.pb.Archive.repeatedFields_, null);
  }, o.inherits(proto.api.bucketsd.pb.Archive, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.Archive.displayName = "proto.api.bucketsd.pb.Archive"), proto.api.bucketsd.pb.DealInfo = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.DealInfo, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.DealInfo.displayName = "proto.api.bucketsd.pb.DealInfo"), proto.api.bucketsd.pb.ArchiveRenew = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchiveRenew, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchiveRenew.displayName = "proto.api.bucketsd.pb.ArchiveRenew"), proto.api.bucketsd.pb.DefaultArchiveConfigRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.DefaultArchiveConfigRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.DefaultArchiveConfigRequest.displayName = "proto.api.bucketsd.pb.DefaultArchiveConfigRequest"), proto.api.bucketsd.pb.DefaultArchiveConfigResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.DefaultArchiveConfigResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.DefaultArchiveConfigResponse.displayName = "proto.api.bucketsd.pb.DefaultArchiveConfigResponse"), proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.displayName = "proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest"), proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.displayName = "proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse"), proto.api.bucketsd.pb.ArchiveRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchiveRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchiveRequest.displayName = "proto.api.bucketsd.pb.ArchiveRequest"), proto.api.bucketsd.pb.ArchiveResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchiveResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchiveResponse.displayName = "proto.api.bucketsd.pb.ArchiveResponse"), proto.api.bucketsd.pb.ArchivesRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchivesRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchivesRequest.displayName = "proto.api.bucketsd.pb.ArchivesRequest"), proto.api.bucketsd.pb.ArchivesResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, proto.api.bucketsd.pb.ArchivesResponse.repeatedFields_, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchivesResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchivesResponse.displayName = "proto.api.bucketsd.pb.ArchivesResponse"), proto.api.bucketsd.pb.ArchiveWatchRequest = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchiveWatchRequest, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchiveWatchRequest.displayName = "proto.api.bucketsd.pb.ArchiveWatchRequest"), proto.api.bucketsd.pb.ArchiveWatchResponse = function (e) {
    googleProtobuf.Message.initialize(this, e, 0, -1, null, null);
  }, o.inherits(proto.api.bucketsd.pb.ArchiveWatchResponse, googleProtobuf.Message), o.DEBUG && !COMPILED && (proto.api.bucketsd.pb.ArchiveWatchResponse.displayName = "proto.api.bucketsd.pb.ArchiveWatchResponse"), googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.Metadata.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.Metadata.toObject(e, this);
  }, proto.api.bucketsd.pb.Metadata.toObject = function (e, t) {
    var o,
        r = {
      rolesMap: (o = t.getRolesMap()) ? o.toObject(e, void 0) : [],
      updatedAt: googleProtobuf.Message.getFieldWithDefault(t, 2, 0),
      key: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.Metadata.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.Metadata();
    return proto.api.bucketsd.pb.Metadata.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.Metadata.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = e.getRolesMap();
          t.readMessage(o, function (e, t) {
            googleProtobuf.Map.deserializeBinary(e, t, googleProtobuf.BinaryReader.prototype.readString, googleProtobuf.BinaryReader.prototype.readEnum, null, "", 0);
          });
          break;

        case 2:
          o = t.readInt64();
          e.setUpdatedAt(o);
          break;

        case 3:
          o = t.readString();
          e.setKey(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.Metadata.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.Metadata.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.Metadata.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getRolesMap(!0)) && o.getLength() > 0 && o.serializeBinary(1, t, googleProtobuf.BinaryWriter.prototype.writeString, googleProtobuf.BinaryWriter.prototype.writeEnum), 0 !== (o = e.getUpdatedAt()) && t.writeInt64(2, o), (o = e.getKey()).length > 0 && t.writeString(3, o);
  }, proto.api.bucketsd.pb.Metadata.prototype.getRolesMap = function (e) {
    return googleProtobuf.Message.getMapField(this, 1, e, null);
  }, proto.api.bucketsd.pb.Metadata.prototype.clearRolesMap = function () {
    return this.getRolesMap().clear(), this;
  }, proto.api.bucketsd.pb.Metadata.prototype.getUpdatedAt = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, 0);
  }, proto.api.bucketsd.pb.Metadata.prototype.setUpdatedAt = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 2, e);
  }, proto.api.bucketsd.pb.Metadata.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.Metadata.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.Root.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.Root.toObject(e, this);
  }, proto.api.bucketsd.pb.Root.toObject = function (e, t) {
    var o,
        r = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      name: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 3, ""),
      createdAt: googleProtobuf.Message.getFieldWithDefault(t, 4, 0),
      updatedAt: googleProtobuf.Message.getFieldWithDefault(t, 5, 0),
      thread: googleProtobuf.Message.getFieldWithDefault(t, 6, ""),
      owner: googleProtobuf.Message.getFieldWithDefault(t, 7, ""),
      version: googleProtobuf.Message.getFieldWithDefault(t, 8, 0),
      metadata: (o = t.getMetadata()) && proto.api.bucketsd.pb.Metadata.toObject(e, o),
      linkKey: googleProtobuf.Message.getFieldWithDefault(t, 10, ""),
      pathMetadataMap: (o = t.getPathMetadataMap()) ? o.toObject(e, proto.api.bucketsd.pb.Metadata.toObject) : [],
      archives: (o = t.getArchives()) && proto.api.bucketsd.pb.Archives.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.Root.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.Root();
    return proto.api.bucketsd.pb.Root.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setName(o);
          break;

        case 3:
          o = t.readString();
          e.setPath(o);
          break;

        case 4:
          o = t.readInt64();
          e.setCreatedAt(o);
          break;

        case 5:
          o = t.readInt64();
          e.setUpdatedAt(o);
          break;

        case 6:
          o = t.readString();
          e.setThread(o);
          break;

        case 7:
          o = t.readString();
          e.setOwner(o);
          break;

        case 8:
          o = t.readInt32();
          e.setVersion(o);
          break;

        case 9:
          o = new proto.api.bucketsd.pb.Metadata();
          t.readMessage(o, proto.api.bucketsd.pb.Metadata.deserializeBinaryFromReader), e.setMetadata(o);
          break;

        case 10:
          o = t.readString();
          e.setLinkKey(o);
          break;

        case 11:
          o = e.getPathMetadataMap();
          t.readMessage(o, function (e, t) {
            googleProtobuf.Map.deserializeBinary(e, t, googleProtobuf.BinaryReader.prototype.readString, googleProtobuf.BinaryReader.prototype.readMessage, proto.api.bucketsd.pb.Metadata.deserializeBinaryFromReader, "", new proto.api.bucketsd.pb.Metadata());
          });
          break;

        case 12:
          o = new proto.api.bucketsd.pb.Archives();
          t.readMessage(o, proto.api.bucketsd.pb.Archives.deserializeBinaryFromReader), e.setArchives(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.Root.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.Root.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.Root.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getName()).length > 0 && t.writeString(2, o), (o = e.getPath()).length > 0 && t.writeString(3, o), 0 !== (o = e.getCreatedAt()) && t.writeInt64(4, o), 0 !== (o = e.getUpdatedAt()) && t.writeInt64(5, o), (o = e.getThread()).length > 0 && t.writeString(6, o), (o = e.getOwner()).length > 0 && t.writeString(7, o), 0 !== (o = e.getVersion()) && t.writeInt32(8, o), null != (o = e.getMetadata()) && t.writeMessage(9, o, proto.api.bucketsd.pb.Metadata.serializeBinaryToWriter), (o = e.getLinkKey()).length > 0 && t.writeString(10, o), (o = e.getPathMetadataMap(!0)) && o.getLength() > 0 && o.serializeBinary(11, t, googleProtobuf.BinaryWriter.prototype.writeString, googleProtobuf.BinaryWriter.prototype.writeMessage, proto.api.bucketsd.pb.Metadata.serializeBinaryToWriter), null != (o = e.getArchives()) && t.writeMessage(12, o, proto.api.bucketsd.pb.Archives.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.Root.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.Root.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.Root.prototype.getName = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.Root.prototype.setName = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.Root.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.Root.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, proto.api.bucketsd.pb.Root.prototype.getCreatedAt = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 4, 0);
  }, proto.api.bucketsd.pb.Root.prototype.setCreatedAt = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 4, e);
  }, proto.api.bucketsd.pb.Root.prototype.getUpdatedAt = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 5, 0);
  }, proto.api.bucketsd.pb.Root.prototype.setUpdatedAt = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 5, e);
  }, proto.api.bucketsd.pb.Root.prototype.getThread = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 6, "");
  }, proto.api.bucketsd.pb.Root.prototype.setThread = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 6, e);
  }, proto.api.bucketsd.pb.Root.prototype.getOwner = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 7, "");
  }, proto.api.bucketsd.pb.Root.prototype.setOwner = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 7, e);
  }, proto.api.bucketsd.pb.Root.prototype.getVersion = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 8, 0);
  }, proto.api.bucketsd.pb.Root.prototype.setVersion = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 8, e);
  }, proto.api.bucketsd.pb.Root.prototype.getMetadata = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Metadata, 9);
  }, proto.api.bucketsd.pb.Root.prototype.setMetadata = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 9, e);
  }, proto.api.bucketsd.pb.Root.prototype.clearMetadata = function () {
    return this.setMetadata(void 0);
  }, proto.api.bucketsd.pb.Root.prototype.hasMetadata = function () {
    return null != googleProtobuf.Message.getField(this, 9);
  }, proto.api.bucketsd.pb.Root.prototype.getLinkKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 10, "");
  }, proto.api.bucketsd.pb.Root.prototype.setLinkKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 10, e);
  }, proto.api.bucketsd.pb.Root.prototype.getPathMetadataMap = function (e) {
    return googleProtobuf.Message.getMapField(this, 11, e, proto.api.bucketsd.pb.Metadata);
  }, proto.api.bucketsd.pb.Root.prototype.clearPathMetadataMap = function () {
    return this.getPathMetadataMap().clear(), this;
  }, proto.api.bucketsd.pb.Root.prototype.getArchives = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Archives, 12);
  }, proto.api.bucketsd.pb.Root.prototype.setArchives = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 12, e);
  }, proto.api.bucketsd.pb.Root.prototype.clearArchives = function () {
    return this.setArchives(void 0);
  }, proto.api.bucketsd.pb.Root.prototype.hasArchives = function () {
    return null != googleProtobuf.Message.getField(this, 12);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ListRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ListRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.ListRequest.toObject = function (e, t) {
    var o = {};
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ListRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ListRequest();
    return proto.api.bucketsd.pb.ListRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ListRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      t.getFieldNumber();
      t.skipField();
    }

    return e;
  }, proto.api.bucketsd.pb.ListRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ListRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ListRequest.serializeBinaryToWriter = function (e, t) {}, proto.api.bucketsd.pb.ListResponse.repeatedFields_ = [1], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ListResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ListResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.ListResponse.toObject = function (e, t) {
    var o = {
      rootsList: googleProtobuf.Message.toObjectList(t.getRootsList(), proto.api.bucketsd.pb.Root.toObject, e)
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ListResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ListResponse();
    return proto.api.bucketsd.pb.ListResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ListResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.Root();
          t.readMessage(o, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader), e.addRoots(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ListResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ListResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ListResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getRootsList()).length > 0 && t.writeRepeatedMessage(1, o, proto.api.bucketsd.pb.Root.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.ListResponse.prototype.getRootsList = function () {
    return googleProtobuf.Message.getRepeatedWrapperField(this, proto.api.bucketsd.pb.Root, 1);
  }, proto.api.bucketsd.pb.ListResponse.prototype.setRootsList = function (e) {
    return googleProtobuf.Message.setRepeatedWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.ListResponse.prototype.addRoots = function (e, t) {
    return googleProtobuf.Message.addToRepeatedWrapperField(this, 1, e, proto.api.bucketsd.pb.Root, t);
  }, proto.api.bucketsd.pb.ListResponse.prototype.clearRootsList = function () {
    return this.setRootsList([]);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.CreateRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.CreateRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.CreateRequest.toObject = function (e, t) {
    var o = {
      name: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      bootstrapCid: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      pb_private: googleProtobuf.Message.getBooleanFieldWithDefault(t, 3, !1),
      unfreeze: googleProtobuf.Message.getBooleanFieldWithDefault(t, 4, !1)
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.CreateRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.CreateRequest();
    return proto.api.bucketsd.pb.CreateRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.CreateRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setName(o);
          break;

        case 2:
          o = t.readString();
          e.setBootstrapCid(o);
          break;

        case 3:
          o = t.readBool();
          e.setPrivate(o);
          break;

        case 4:
          o = t.readBool();
          e.setUnfreeze(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.CreateRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.CreateRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.CreateRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getName()).length > 0 && t.writeString(1, o), (o = e.getBootstrapCid()).length > 0 && t.writeString(2, o), (o = e.getPrivate()) && t.writeBool(3, o), (o = e.getUnfreeze()) && t.writeBool(4, o);
  }, proto.api.bucketsd.pb.CreateRequest.prototype.getName = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.CreateRequest.prototype.setName = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.CreateRequest.prototype.getBootstrapCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.CreateRequest.prototype.setBootstrapCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.CreateRequest.prototype.getPrivate = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 3, !1);
  }, proto.api.bucketsd.pb.CreateRequest.prototype.setPrivate = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 3, e);
  }, proto.api.bucketsd.pb.CreateRequest.prototype.getUnfreeze = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 4, !1);
  }, proto.api.bucketsd.pb.CreateRequest.prototype.setUnfreeze = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 4, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.CreateResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.CreateResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.CreateResponse.toObject = function (e, t) {
    var o,
        r = {
      root: (o = t.getRoot()) && proto.api.bucketsd.pb.Root.toObject(e, o),
      links: (o = t.getLinks()) && proto.api.bucketsd.pb.LinksResponse.toObject(e, o),
      seed: t.getSeed_asB64(),
      seedCid: googleProtobuf.Message.getFieldWithDefault(t, 4, ""),
      pinned: googleProtobuf.Message.getFieldWithDefault(t, 5, 0),
      retrievalId: googleProtobuf.Message.getFieldWithDefault(t, 6, "")
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.CreateResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.CreateResponse();
    return proto.api.bucketsd.pb.CreateResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.CreateResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.Root();
          t.readMessage(o, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader), e.setRoot(o);
          break;

        case 2:
          o = new proto.api.bucketsd.pb.LinksResponse();
          t.readMessage(o, proto.api.bucketsd.pb.LinksResponse.deserializeBinaryFromReader), e.setLinks(o);
          break;

        case 3:
          o = t.readBytes();
          e.setSeed(o);
          break;

        case 4:
          o = t.readString();
          e.setSeedCid(o);
          break;

        case 5:
          o = t.readInt64();
          e.setPinned(o);
          break;

        case 6:
          o = t.readString();
          e.setRetrievalId(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.CreateResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.CreateResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.CreateResponse.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    null != (o = e.getRoot()) && t.writeMessage(1, o, proto.api.bucketsd.pb.Root.serializeBinaryToWriter), null != (o = e.getLinks()) && t.writeMessage(2, o, proto.api.bucketsd.pb.LinksResponse.serializeBinaryToWriter), (o = e.getSeed_asU8()).length > 0 && t.writeBytes(3, o), (o = e.getSeedCid()).length > 0 && t.writeString(4, o), 0 !== (o = e.getPinned()) && t.writeInt64(5, o), (o = e.getRetrievalId()).length > 0 && t.writeString(6, o);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getRoot = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Root, 1);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.clearRoot = function () {
    return this.setRoot(void 0);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.hasRoot = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getLinks = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.LinksResponse, 2);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.setLinks = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 2, e);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.clearLinks = function () {
    return this.setLinks(void 0);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.hasLinks = function () {
    return null != googleProtobuf.Message.getField(this, 2);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getSeed = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getSeed_asB64 = function () {
    return googleProtobuf.Message.bytesAsB64(this.getSeed());
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getSeed_asU8 = function () {
    return googleProtobuf.Message.bytesAsU8(this.getSeed());
  }, proto.api.bucketsd.pb.CreateResponse.prototype.setSeed = function (e) {
    return googleProtobuf.Message.setProto3BytesField(this, 3, e);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getSeedCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 4, "");
  }, proto.api.bucketsd.pb.CreateResponse.prototype.setSeedCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 4, e);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getPinned = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 5, 0);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.setPinned = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 5, e);
  }, proto.api.bucketsd.pb.CreateResponse.prototype.getRetrievalId = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 6, "");
  }, proto.api.bucketsd.pb.CreateResponse.prototype.setRetrievalId = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 6, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.RootRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.RootRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.RootRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.RootRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.RootRequest();
    return proto.api.bucketsd.pb.RootRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.RootRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.RootRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.RootRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.RootRequest.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getKey()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.RootRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.RootRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.RootResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.RootResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.RootResponse.toObject = function (e, t) {
    var o,
        r = {
      root: (o = t.getRoot()) && proto.api.bucketsd.pb.Root.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.RootResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.RootResponse();
    return proto.api.bucketsd.pb.RootResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.RootResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.Root();
          t.readMessage(o, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader), e.setRoot(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.RootResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.RootResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.RootResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    null != (o = e.getRoot()) && t.writeMessage(1, o, proto.api.bucketsd.pb.Root.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.RootResponse.prototype.getRoot = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Root, 1);
  }, proto.api.bucketsd.pb.RootResponse.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.RootResponse.prototype.clearRoot = function () {
    return this.setRoot(void 0);
  }, proto.api.bucketsd.pb.RootResponse.prototype.hasRoot = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.LinksRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.LinksRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.LinksRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.LinksRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.LinksRequest();
    return proto.api.bucketsd.pb.LinksRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.LinksRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.LinksRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.LinksRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.LinksRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o);
  }, proto.api.bucketsd.pb.LinksRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.LinksRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.LinksRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.LinksRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.LinksResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.LinksResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.LinksResponse.toObject = function (e, t) {
    var o = {
      url: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      www: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      ipns: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.LinksResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.LinksResponse();
    return proto.api.bucketsd.pb.LinksResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.LinksResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setUrl(o);
          break;

        case 2:
          o = t.readString();
          e.setWww(o);
          break;

        case 3:
          o = t.readString();
          e.setIpns(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.LinksResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.LinksResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.LinksResponse.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getUrl()).length > 0 && t.writeString(1, o), (o = e.getWww()).length > 0 && t.writeString(2, o), (o = e.getIpns()).length > 0 && t.writeString(3, o);
  }, proto.api.bucketsd.pb.LinksResponse.prototype.getUrl = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.LinksResponse.prototype.setUrl = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.LinksResponse.prototype.getWww = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.LinksResponse.prototype.setWww = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.LinksResponse.prototype.getIpns = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.LinksResponse.prototype.setIpns = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ListPathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ListPathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.ListPathRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ListPathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ListPathRequest();
    return proto.api.bucketsd.pb.ListPathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ListPathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ListPathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ListPathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ListPathRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o);
  }, proto.api.bucketsd.pb.ListPathRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.ListPathRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.ListPathRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.ListPathRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ListPathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ListPathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.ListPathResponse.toObject = function (e, t) {
    var o,
        r = {
      item: (o = t.getItem()) && proto.api.bucketsd.pb.PathItem.toObject(e, o),
      root: (o = t.getRoot()) && proto.api.bucketsd.pb.Root.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.ListPathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ListPathResponse();
    return proto.api.bucketsd.pb.ListPathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ListPathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.PathItem();
          t.readMessage(o, proto.api.bucketsd.pb.PathItem.deserializeBinaryFromReader), e.setItem(o);
          break;

        case 2:
          o = new proto.api.bucketsd.pb.Root();
          t.readMessage(o, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader), e.setRoot(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ListPathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ListPathResponse.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    null != (o = e.getItem()) && t.writeMessage(1, o, proto.api.bucketsd.pb.PathItem.serializeBinaryToWriter), null != (o = e.getRoot()) && t.writeMessage(2, o, proto.api.bucketsd.pb.Root.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.getItem = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.PathItem, 1);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.setItem = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.clearItem = function () {
    return this.setItem(void 0);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.hasItem = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.getRoot = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Root, 2);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 2, e);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.clearRoot = function () {
    return this.setRoot(void 0);
  }, proto.api.bucketsd.pb.ListPathResponse.prototype.hasRoot = function () {
    return null != googleProtobuf.Message.getField(this, 2);
  }, proto.api.bucketsd.pb.PathItem.repeatedFields_ = [6], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PathItem.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PathItem.toObject(e, this);
  }, proto.api.bucketsd.pb.PathItem.toObject = function (e, t) {
    var o,
        r = {
      cid: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      name: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 3, ""),
      size: googleProtobuf.Message.getFieldWithDefault(t, 4, 0),
      isDir: googleProtobuf.Message.getBooleanFieldWithDefault(t, 5, !1),
      itemsList: googleProtobuf.Message.toObjectList(t.getItemsList(), proto.api.bucketsd.pb.PathItem.toObject, e),
      itemsCount: googleProtobuf.Message.getFieldWithDefault(t, 7, 0),
      metadata: (o = t.getMetadata()) && proto.api.bucketsd.pb.Metadata.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PathItem.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PathItem();
    return proto.api.bucketsd.pb.PathItem.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PathItem.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setCid(o);
          break;

        case 2:
          o = t.readString();
          e.setName(o);
          break;

        case 3:
          o = t.readString();
          e.setPath(o);
          break;

        case 4:
          o = t.readInt64();
          e.setSize(o);
          break;

        case 5:
          o = t.readBool();
          e.setIsDir(o);
          break;

        case 6:
          o = new proto.api.bucketsd.pb.PathItem();
          t.readMessage(o, proto.api.bucketsd.pb.PathItem.deserializeBinaryFromReader), e.addItems(o);
          break;

        case 7:
          o = t.readInt32();
          e.setItemsCount(o);
          break;

        case 9:
          o = new proto.api.bucketsd.pb.Metadata();
          t.readMessage(o, proto.api.bucketsd.pb.Metadata.deserializeBinaryFromReader), e.setMetadata(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PathItem.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PathItem.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PathItem.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getCid()).length > 0 && t.writeString(1, o), (o = e.getName()).length > 0 && t.writeString(2, o), (o = e.getPath()).length > 0 && t.writeString(3, o), 0 !== (o = e.getSize()) && t.writeInt64(4, o), (o = e.getIsDir()) && t.writeBool(5, o), (o = e.getItemsList()).length > 0 && t.writeRepeatedMessage(6, o, proto.api.bucketsd.pb.PathItem.serializeBinaryToWriter), 0 !== (o = e.getItemsCount()) && t.writeInt32(7, o), null != (o = e.getMetadata()) && t.writeMessage(9, o, proto.api.bucketsd.pb.Metadata.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.PathItem.prototype.getCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PathItem.prototype.setCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.getName = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PathItem.prototype.setName = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.PathItem.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.getSize = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 4, 0);
  }, proto.api.bucketsd.pb.PathItem.prototype.setSize = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 4, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.getIsDir = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 5, !1);
  }, proto.api.bucketsd.pb.PathItem.prototype.setIsDir = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 5, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.getItemsList = function () {
    return googleProtobuf.Message.getRepeatedWrapperField(this, proto.api.bucketsd.pb.PathItem, 6);
  }, proto.api.bucketsd.pb.PathItem.prototype.setItemsList = function (e) {
    return googleProtobuf.Message.setRepeatedWrapperField(this, 6, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.addItems = function (e, t) {
    return googleProtobuf.Message.addToRepeatedWrapperField(this, 6, e, proto.api.bucketsd.pb.PathItem, t);
  }, proto.api.bucketsd.pb.PathItem.prototype.clearItemsList = function () {
    return this.setItemsList([]);
  }, proto.api.bucketsd.pb.PathItem.prototype.getItemsCount = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 7, 0);
  }, proto.api.bucketsd.pb.PathItem.prototype.setItemsCount = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 7, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.getMetadata = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Metadata, 9);
  }, proto.api.bucketsd.pb.PathItem.prototype.setMetadata = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 9, e);
  }, proto.api.bucketsd.pb.PathItem.prototype.clearMetadata = function () {
    return this.setMetadata(void 0);
  }, proto.api.bucketsd.pb.PathItem.prototype.hasMetadata = function () {
    return null != googleProtobuf.Message.getField(this, 9);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ListIpfsPathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ListIpfsPathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.ListIpfsPathRequest.toObject = function (e, t) {
    var o = {
      path: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ListIpfsPathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ListIpfsPathRequest();
    return proto.api.bucketsd.pb.ListIpfsPathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ListIpfsPathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setPath(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ListIpfsPathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ListIpfsPathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ListIpfsPathRequest.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getPath()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.ListIpfsPathRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.ListIpfsPathRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ListIpfsPathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ListIpfsPathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.toObject = function (e, t) {
    var o,
        r = {
      item: (o = t.getItem()) && proto.api.bucketsd.pb.PathItem.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.ListIpfsPathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ListIpfsPathResponse();
    return proto.api.bucketsd.pb.ListIpfsPathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.PathItem();
          t.readMessage(o, proto.api.bucketsd.pb.PathItem.deserializeBinaryFromReader), e.setItem(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ListIpfsPathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    null != (o = e.getItem()) && t.writeMessage(1, o, proto.api.bucketsd.pb.PathItem.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.prototype.getItem = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.PathItem, 1);
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.prototype.setItem = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.prototype.clearItem = function () {
    return this.setItem(void 0);
  }, proto.api.bucketsd.pb.ListIpfsPathResponse.prototype.hasItem = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.PushPathRequest.oneofGroups_ = [[1, 2]], proto.api.bucketsd.pb.PushPathRequest.PayloadCase = {
    PAYLOAD_NOT_SET: 0,
    HEADER: 1,
    CHUNK: 2
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.getPayloadCase = function () {
    return googleProtobuf.Message.computeOneofCase(this, proto.api.bucketsd.pb.PushPathRequest.oneofGroups_[0]);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathRequest.toObject = function (e, t) {
    var o,
        r = {
      header: (o = t.getHeader()) && proto.api.bucketsd.pb.PushPathRequest.Header.toObject(e, o),
      chunk: t.getChunk_asB64()
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PushPathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathRequest();
    return proto.api.bucketsd.pb.PushPathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.PushPathRequest.Header();
          t.readMessage(o, proto.api.bucketsd.pb.PushPathRequest.Header.deserializeBinaryFromReader), e.setHeader(o);
          break;

        case 2:
          o = t.readBytes();
          e.setChunk(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    null != (o = e.getHeader()) && t.writeMessage(1, o, proto.api.bucketsd.pb.PushPathRequest.Header.serializeBinaryToWriter), null != (o = googleProtobuf.Message.getField(e, 2)) && t.writeBytes(2, o);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathRequest.Header.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathRequest.Header.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathRequest.Header.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      root: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PushPathRequest.Header.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathRequest.Header();
    return proto.api.bucketsd.pb.PushPathRequest.Header.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathRequest.Header.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        case 3:
          o = t.readString();
          e.setRoot(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathRequest.Header.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathRequest.Header.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathRequest.Header.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o), (o = e.getRoot()).length > 0 && t.writeString(3, o);
  }, proto.api.bucketsd.pb.PushPathRequest.Header.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PushPathRequest.Header.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PushPathRequest.Header.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PushPathRequest.Header.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.PushPathRequest.Header.prototype.getRoot = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.PushPathRequest.Header.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.getHeader = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.PushPathRequest.Header, 1);
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.setHeader = function (e) {
    return googleProtobuf.Message.setOneofWrapperField(this, 1, proto.api.bucketsd.pb.PushPathRequest.oneofGroups_[0], e);
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.clearHeader = function () {
    return this.setHeader(void 0);
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.hasHeader = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.getChunk = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.getChunk_asB64 = function () {
    return googleProtobuf.Message.bytesAsB64(this.getChunk());
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.getChunk_asU8 = function () {
    return googleProtobuf.Message.bytesAsU8(this.getChunk());
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.setChunk = function (e) {
    return googleProtobuf.Message.setOneofField(this, 2, proto.api.bucketsd.pb.PushPathRequest.oneofGroups_[0], e);
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.clearChunk = function () {
    return googleProtobuf.Message.setOneofField(this, 2, proto.api.bucketsd.pb.PushPathRequest.oneofGroups_[0], void 0);
  }, proto.api.bucketsd.pb.PushPathRequest.prototype.hasChunk = function () {
    return null != googleProtobuf.Message.getField(this, 2);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathResponse.toObject = function (e, t) {
    var o,
        r = {
      event: (o = t.getEvent()) && proto.api.bucketsd.pb.PushPathResponse.Event.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PushPathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathResponse();
    return proto.api.bucketsd.pb.PushPathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.PushPathResponse.Event();
          t.readMessage(o, proto.api.bucketsd.pb.PushPathResponse.Event.deserializeBinaryFromReader), e.setEvent(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    null != (o = e.getEvent()) && t.writeMessage(1, o, proto.api.bucketsd.pb.PushPathResponse.Event.serializeBinaryToWriter);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathResponse.Event.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathResponse.Event.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.toObject = function (e, t) {
    var o,
        r = {
      name: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      bytes: googleProtobuf.Message.getFieldWithDefault(t, 3, 0),
      size: googleProtobuf.Message.getFieldWithDefault(t, 4, ""),
      root: (o = t.getRoot()) && proto.api.bucketsd.pb.Root.toObject(e, o),
      pinned: googleProtobuf.Message.getFieldWithDefault(t, 6, 0)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PushPathResponse.Event.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathResponse.Event();
    return proto.api.bucketsd.pb.PushPathResponse.Event.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setName(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        case 3:
          o = t.readInt64();
          e.setBytes(o);
          break;

        case 4:
          o = t.readString();
          e.setSize(o);
          break;

        case 5:
          o = new proto.api.bucketsd.pb.Root();
          t.readMessage(o, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader), e.setRoot(o);
          break;

        case 6:
          o = t.readInt64();
          e.setPinned(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathResponse.Event.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathResponse.Event.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getName()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o), 0 !== (o = e.getBytes()) && t.writeInt64(3, o), (o = e.getSize()).length > 0 && t.writeString(4, o), null != (o = e.getRoot()) && t.writeMessage(5, o, proto.api.bucketsd.pb.Root.serializeBinaryToWriter), 0 !== (o = e.getPinned()) && t.writeInt64(6, o);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.getName = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.setName = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.getBytes = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, 0);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.setBytes = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 3, e);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.getSize = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 4, "");
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.setSize = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 4, e);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.getRoot = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Root, 5);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 5, e);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.clearRoot = function () {
    return this.setRoot(void 0);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.hasRoot = function () {
    return null != googleProtobuf.Message.getField(this, 5);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.getPinned = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 6, 0);
  }, proto.api.bucketsd.pb.PushPathResponse.Event.prototype.setPinned = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 6, e);
  }, proto.api.bucketsd.pb.PushPathResponse.prototype.getEvent = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.PushPathResponse.Event, 1);
  }, proto.api.bucketsd.pb.PushPathResponse.prototype.setEvent = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.PushPathResponse.prototype.clearEvent = function () {
    return this.setEvent(void 0);
  }, proto.api.bucketsd.pb.PushPathResponse.prototype.hasEvent = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.PushPathsRequest.oneofGroups_ = [[1, 2]], proto.api.bucketsd.pb.PushPathsRequest.PayloadCase = {
    PAYLOAD_NOT_SET: 0,
    HEADER: 1,
    CHUNK: 2
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.getPayloadCase = function () {
    return googleProtobuf.Message.computeOneofCase(this, proto.api.bucketsd.pb.PushPathsRequest.oneofGroups_[0]);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathsRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathsRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathsRequest.toObject = function (e, t) {
    var o,
        r = {
      header: (o = t.getHeader()) && proto.api.bucketsd.pb.PushPathsRequest.Header.toObject(e, o),
      chunk: (o = t.getChunk()) && proto.api.bucketsd.pb.PushPathsRequest.Chunk.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PushPathsRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathsRequest();
    return proto.api.bucketsd.pb.PushPathsRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathsRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.PushPathsRequest.Header();
          t.readMessage(o, proto.api.bucketsd.pb.PushPathsRequest.Header.deserializeBinaryFromReader), e.setHeader(o);
          break;

        case 2:
          o = new proto.api.bucketsd.pb.PushPathsRequest.Chunk();
          t.readMessage(o, proto.api.bucketsd.pb.PushPathsRequest.Chunk.deserializeBinaryFromReader), e.setChunk(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathsRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathsRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    null != (o = e.getHeader()) && t.writeMessage(1, o, proto.api.bucketsd.pb.PushPathsRequest.Header.serializeBinaryToWriter), null != (o = e.getChunk()) && t.writeMessage(2, o, proto.api.bucketsd.pb.PushPathsRequest.Chunk.serializeBinaryToWriter);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathsRequest.Header.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathsRequest.Header.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      root: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PushPathsRequest.Header.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathsRequest.Header();
    return proto.api.bucketsd.pb.PushPathsRequest.Header.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setRoot(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathsRequest.Header.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getRoot()).length > 0 && t.writeString(2, o);
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.prototype.getRoot = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PushPathsRequest.Header.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathsRequest.Chunk.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.toObject = function (e, t) {
    var o = {
      path: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      data: t.getData_asB64()
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PushPathsRequest.Chunk.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathsRequest.Chunk();
    return proto.api.bucketsd.pb.PushPathsRequest.Chunk.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setPath(o);
          break;

        case 2:
          o = t.readBytes();
          e.setData(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathsRequest.Chunk.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getPath()).length > 0 && t.writeString(1, o), (o = e.getData_asU8()).length > 0 && t.writeBytes(2, o);
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.getData = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.getData_asB64 = function () {
    return googleProtobuf.Message.bytesAsB64(this.getData());
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.getData_asU8 = function () {
    return googleProtobuf.Message.bytesAsU8(this.getData());
  }, proto.api.bucketsd.pb.PushPathsRequest.Chunk.prototype.setData = function (e) {
    return googleProtobuf.Message.setProto3BytesField(this, 2, e);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.getHeader = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.PushPathsRequest.Header, 1);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.setHeader = function (e) {
    return googleProtobuf.Message.setOneofWrapperField(this, 1, proto.api.bucketsd.pb.PushPathsRequest.oneofGroups_[0], e);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.clearHeader = function () {
    return this.setHeader(void 0);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.hasHeader = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.getChunk = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.PushPathsRequest.Chunk, 2);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.setChunk = function (e) {
    return googleProtobuf.Message.setOneofWrapperField(this, 2, proto.api.bucketsd.pb.PushPathsRequest.oneofGroups_[0], e);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.clearChunk = function () {
    return this.setChunk(void 0);
  }, proto.api.bucketsd.pb.PushPathsRequest.prototype.hasChunk = function () {
    return null != googleProtobuf.Message.getField(this, 2);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathsResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathsResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathsResponse.toObject = function (e, t) {
    var o,
        r = {
      path: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      cid: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      size: googleProtobuf.Message.getFieldWithDefault(t, 3, 0),
      pinned: googleProtobuf.Message.getFieldWithDefault(t, 4, 0),
      root: (o = t.getRoot()) && proto.api.bucketsd.pb.Root.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PushPathsResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathsResponse();
    return proto.api.bucketsd.pb.PushPathsResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathsResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setPath(o);
          break;

        case 2:
          o = t.readString();
          e.setCid(o);
          break;

        case 3:
          o = t.readInt64();
          e.setSize(o);
          break;

        case 4:
          o = t.readInt64();
          e.setPinned(o);
          break;

        case 5:
          o = new proto.api.bucketsd.pb.Root();
          t.readMessage(o, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader), e.setRoot(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathsResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathsResponse.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getPath()).length > 0 && t.writeString(1, o), (o = e.getCid()).length > 0 && t.writeString(2, o), 0 !== (o = e.getSize()) && t.writeInt64(3, o), 0 !== (o = e.getPinned()) && t.writeInt64(4, o), null != (o = e.getRoot()) && t.writeMessage(5, o, proto.api.bucketsd.pb.Root.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.getCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.setCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.getSize = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, 0);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.setSize = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 3, e);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.getPinned = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 4, 0);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.setPinned = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 4, e);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.getRoot = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Root, 5);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 5, e);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.clearRoot = function () {
    return this.setRoot(void 0);
  }, proto.api.bucketsd.pb.PushPathsResponse.prototype.hasRoot = function () {
    return null != googleProtobuf.Message.getField(this, 5);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PullPathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PullPathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.PullPathRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PullPathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PullPathRequest();
    return proto.api.bucketsd.pb.PullPathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PullPathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PullPathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PullPathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PullPathRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o);
  }, proto.api.bucketsd.pb.PullPathRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PullPathRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PullPathRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PullPathRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PullPathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PullPathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.PullPathResponse.toObject = function (e, t) {
    var o = {
      chunk: t.getChunk_asB64()
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PullPathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PullPathResponse();
    return proto.api.bucketsd.pb.PullPathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PullPathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readBytes();
          e.setChunk(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PullPathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PullPathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PullPathResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getChunk_asU8()).length > 0 && t.writeBytes(1, o);
  }, proto.api.bucketsd.pb.PullPathResponse.prototype.getChunk = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PullPathResponse.prototype.getChunk_asB64 = function () {
    return googleProtobuf.Message.bytesAsB64(this.getChunk());
  }, proto.api.bucketsd.pb.PullPathResponse.prototype.getChunk_asU8 = function () {
    return googleProtobuf.Message.bytesAsU8(this.getChunk());
  }, proto.api.bucketsd.pb.PullPathResponse.prototype.setChunk = function (e) {
    return googleProtobuf.Message.setProto3BytesField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PullIpfsPathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PullIpfsPathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.PullIpfsPathRequest.toObject = function (e, t) {
    var o = {
      path: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PullIpfsPathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PullIpfsPathRequest();
    return proto.api.bucketsd.pb.PullIpfsPathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PullIpfsPathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setPath(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PullIpfsPathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PullIpfsPathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PullIpfsPathRequest.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getPath()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.PullIpfsPathRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PullIpfsPathRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PullIpfsPathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PullIpfsPathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.toObject = function (e, t) {
    var o = {
      chunk: t.getChunk_asB64()
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PullIpfsPathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PullIpfsPathResponse();
    return proto.api.bucketsd.pb.PullIpfsPathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readBytes();
          e.setChunk(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PullIpfsPathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getChunk_asU8()).length > 0 && t.writeBytes(1, o);
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.prototype.getChunk = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.prototype.getChunk_asB64 = function () {
    return googleProtobuf.Message.bytesAsB64(this.getChunk());
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.prototype.getChunk_asU8 = function () {
    return googleProtobuf.Message.bytesAsU8(this.getChunk());
  }, proto.api.bucketsd.pb.PullIpfsPathResponse.prototype.setChunk = function (e) {
    return googleProtobuf.Message.setProto3BytesField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.SetPathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.SetPathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.SetPathRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      cid: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.SetPathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.SetPathRequest();
    return proto.api.bucketsd.pb.SetPathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.SetPathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        case 3:
          o = t.readString();
          e.setCid(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.SetPathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.SetPathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.SetPathRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o), (o = e.getCid()).length > 0 && t.writeString(3, o);
  }, proto.api.bucketsd.pb.SetPathRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.SetPathRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.SetPathRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.SetPathRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.SetPathRequest.prototype.getCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.SetPathRequest.prototype.setCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.SetPathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.SetPathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.SetPathResponse.toObject = function (e, t) {
    var o = {
      pinned: googleProtobuf.Message.getFieldWithDefault(t, 1, 0)
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.SetPathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.SetPathResponse();
    return proto.api.bucketsd.pb.SetPathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.SetPathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readInt64();
          e.setPinned(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.SetPathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.SetPathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.SetPathResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    0 !== (o = e.getPinned()) && t.writeInt64(1, o);
  }, proto.api.bucketsd.pb.SetPathResponse.prototype.getPinned = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, 0);
  }, proto.api.bucketsd.pb.SetPathResponse.prototype.setPinned = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.MovePathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.MovePathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.MovePathRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      fromPath: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      toPath: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.MovePathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.MovePathRequest();
    return proto.api.bucketsd.pb.MovePathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.MovePathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setFromPath(o);
          break;

        case 3:
          o = t.readString();
          e.setToPath(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.MovePathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.MovePathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.MovePathRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getFromPath()).length > 0 && t.writeString(2, o), (o = e.getToPath()).length > 0 && t.writeString(3, o);
  }, proto.api.bucketsd.pb.MovePathRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.MovePathRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.MovePathRequest.prototype.getFromPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.MovePathRequest.prototype.setFromPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.MovePathRequest.prototype.getToPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.MovePathRequest.prototype.setToPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.MovePathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.MovePathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.MovePathResponse.toObject = function (e, t) {
    var o = {};
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.MovePathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.MovePathResponse();
    return proto.api.bucketsd.pb.MovePathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.MovePathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      t.getFieldNumber();
      t.skipField();
    }

    return e;
  }, proto.api.bucketsd.pb.MovePathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.MovePathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.MovePathResponse.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.RemoveRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.RemoveRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.RemoveRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.RemoveRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.RemoveRequest();
    return proto.api.bucketsd.pb.RemoveRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.RemoveRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.RemoveRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.RemoveRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.RemoveRequest.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getKey()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.RemoveRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.RemoveRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.RemoveResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.RemoveResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.RemoveResponse.toObject = function (e, t) {
    var o = {
      pinned: googleProtobuf.Message.getFieldWithDefault(t, 1, 0)
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.RemoveResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.RemoveResponse();
    return proto.api.bucketsd.pb.RemoveResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.RemoveResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readInt64();
          e.setPinned(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.RemoveResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.RemoveResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.RemoveResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    0 !== (o = e.getPinned()) && t.writeInt64(1, o);
  }, proto.api.bucketsd.pb.RemoveResponse.prototype.getPinned = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, 0);
  }, proto.api.bucketsd.pb.RemoveResponse.prototype.setPinned = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.RemovePathRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.RemovePathRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.RemovePathRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      root: googleProtobuf.Message.getFieldWithDefault(t, 3, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.RemovePathRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.RemovePathRequest();
    return proto.api.bucketsd.pb.RemovePathRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.RemovePathRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        case 3:
          o = t.readString();
          e.setRoot(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.RemovePathRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.RemovePathRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.RemovePathRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o), (o = e.getRoot()).length > 0 && t.writeString(3, o);
  }, proto.api.bucketsd.pb.RemovePathRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.RemovePathRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.RemovePathRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.RemovePathRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.RemovePathRequest.prototype.getRoot = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.RemovePathRequest.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.RemovePathResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.RemovePathResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.RemovePathResponse.toObject = function (e, t) {
    var o,
        r = {
      root: (o = t.getRoot()) && proto.api.bucketsd.pb.Root.toObject(e, o),
      pinned: googleProtobuf.Message.getFieldWithDefault(t, 2, 0)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.RemovePathResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.RemovePathResponse();
    return proto.api.bucketsd.pb.RemovePathResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.RemovePathResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.Root();
          t.readMessage(o, proto.api.bucketsd.pb.Root.deserializeBinaryFromReader), e.setRoot(o);
          break;

        case 2:
          o = t.readInt64();
          e.setPinned(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.RemovePathResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.RemovePathResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.RemovePathResponse.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    null != (o = e.getRoot()) && t.writeMessage(1, o, proto.api.bucketsd.pb.Root.serializeBinaryToWriter), 0 !== (o = e.getPinned()) && t.writeInt64(2, o);
  }, proto.api.bucketsd.pb.RemovePathResponse.prototype.getRoot = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Root, 1);
  }, proto.api.bucketsd.pb.RemovePathResponse.prototype.setRoot = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.RemovePathResponse.prototype.clearRoot = function () {
    return this.setRoot(void 0);
  }, proto.api.bucketsd.pb.RemovePathResponse.prototype.hasRoot = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.RemovePathResponse.prototype.getPinned = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, 0);
  }, proto.api.bucketsd.pb.RemovePathResponse.prototype.setPinned = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 2, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathAccessRolesRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.toObject = function (e, t) {
    var o,
        r = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      rolesMap: (o = t.getRolesMap()) ? o.toObject(e, void 0) : []
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PushPathAccessRolesRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathAccessRolesRequest();
    return proto.api.bucketsd.pb.PushPathAccessRolesRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        case 3:
          o = e.getRolesMap();
          t.readMessage(o, function (e, t) {
            googleProtobuf.Map.deserializeBinary(e, t, googleProtobuf.BinaryReader.prototype.readString, googleProtobuf.BinaryReader.prototype.readEnum, null, "", 0);
          });
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathAccessRolesRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o), (o = e.getRolesMap(!0)) && o.getLength() > 0 && o.serializeBinary(3, t, googleProtobuf.BinaryWriter.prototype.writeString, googleProtobuf.BinaryWriter.prototype.writeEnum);
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.getRolesMap = function (e) {
    return googleProtobuf.Message.getMapField(this, 3, e, null);
  }, proto.api.bucketsd.pb.PushPathAccessRolesRequest.prototype.clearRolesMap = function () {
    return this.getRolesMap().clear(), this;
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PushPathAccessRolesResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PushPathAccessRolesResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.PushPathAccessRolesResponse.toObject = function (e, t) {
    var o = {
      pinned: googleProtobuf.Message.getFieldWithDefault(t, 1, 0)
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PushPathAccessRolesResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PushPathAccessRolesResponse();
    return proto.api.bucketsd.pb.PushPathAccessRolesResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PushPathAccessRolesResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readInt64();
          e.setPinned(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PushPathAccessRolesResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PushPathAccessRolesResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PushPathAccessRolesResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    0 !== (o = e.getPinned()) && t.writeInt64(1, o);
  }, proto.api.bucketsd.pb.PushPathAccessRolesResponse.prototype.getPinned = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, 0);
  }, proto.api.bucketsd.pb.PushPathAccessRolesResponse.prototype.setPinned = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PullPathAccessRolesRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PullPathAccessRolesRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      path: googleProtobuf.Message.getFieldWithDefault(t, 2, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.PullPathAccessRolesRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PullPathAccessRolesRequest();
    return proto.api.bucketsd.pb.PullPathAccessRolesRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = t.readString();
          e.setPath(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PullPathAccessRolesRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), (o = e.getPath()).length > 0 && t.writeString(2, o);
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.prototype.getPath = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.PullPathAccessRolesRequest.prototype.setPath = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.PullPathAccessRolesResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.PullPathAccessRolesResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.PullPathAccessRolesResponse.toObject = function (e, t) {
    var o,
        r = {
      rolesMap: (o = t.getRolesMap()) ? o.toObject(e, void 0) : []
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.PullPathAccessRolesResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.PullPathAccessRolesResponse();
    return proto.api.bucketsd.pb.PullPathAccessRolesResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.PullPathAccessRolesResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = e.getRolesMap();
          t.readMessage(o, function (e, t) {
            googleProtobuf.Map.deserializeBinary(e, t, googleProtobuf.BinaryReader.prototype.readString, googleProtobuf.BinaryReader.prototype.readEnum, null, "", 0);
          });
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.PullPathAccessRolesResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.PullPathAccessRolesResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.PullPathAccessRolesResponse.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getRolesMap(!0)) && o.getLength() > 0 && o.serializeBinary(1, t, googleProtobuf.BinaryWriter.prototype.writeString, googleProtobuf.BinaryWriter.prototype.writeEnum);
  }, proto.api.bucketsd.pb.PullPathAccessRolesResponse.prototype.getRolesMap = function (e) {
    return googleProtobuf.Message.getMapField(this, 1, e, null);
  }, proto.api.bucketsd.pb.PullPathAccessRolesResponse.prototype.clearRolesMap = function () {
    return this.getRolesMap().clear(), this;
  }, proto.api.bucketsd.pb.ArchiveConfig.repeatedFields_ = [3, 4, 5], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchiveConfig.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchiveConfig.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchiveConfig.toObject = function (e, t) {
    var o,
        r = {
      repFactor: googleProtobuf.Message.getFieldWithDefault(t, 1, 0),
      dealMinDuration: googleProtobuf.Message.getFieldWithDefault(t, 2, 0),
      excludedMinersList: null == (o = googleProtobuf.Message.getRepeatedField(t, 3)) ? void 0 : o,
      trustedMinersList: null == (o = googleProtobuf.Message.getRepeatedField(t, 4)) ? void 0 : o,
      countryCodesList: null == (o = googleProtobuf.Message.getRepeatedField(t, 5)) ? void 0 : o,
      renew: (o = t.getRenew()) && proto.api.bucketsd.pb.ArchiveRenew.toObject(e, o),
      maxPrice: googleProtobuf.Message.getFieldWithDefault(t, 7, 0),
      fastRetrieval: googleProtobuf.Message.getBooleanFieldWithDefault(t, 8, !1),
      dealStartOffset: googleProtobuf.Message.getFieldWithDefault(t, 9, 0),
      verifiedDeal: googleProtobuf.Message.getBooleanFieldWithDefault(t, 10, !1)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.ArchiveConfig.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchiveConfig();
    return proto.api.bucketsd.pb.ArchiveConfig.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchiveConfig.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readInt32();
          e.setRepFactor(o);
          break;

        case 2:
          o = t.readInt64();
          e.setDealMinDuration(o);
          break;

        case 3:
          o = t.readString();
          e.addExcludedMiners(o);
          break;

        case 4:
          o = t.readString();
          e.addTrustedMiners(o);
          break;

        case 5:
          o = t.readString();
          e.addCountryCodes(o);
          break;

        case 6:
          o = new proto.api.bucketsd.pb.ArchiveRenew();
          t.readMessage(o, proto.api.bucketsd.pb.ArchiveRenew.deserializeBinaryFromReader), e.setRenew(o);
          break;

        case 7:
          o = t.readUint64();
          e.setMaxPrice(o);
          break;

        case 8:
          o = t.readBool();
          e.setFastRetrieval(o);
          break;

        case 9:
          o = t.readInt64();
          e.setDealStartOffset(o);
          break;

        case 10:
          o = t.readBool();
          e.setVerifiedDeal(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchiveConfig.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchiveConfig.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    0 !== (o = e.getRepFactor()) && t.writeInt32(1, o), 0 !== (o = e.getDealMinDuration()) && t.writeInt64(2, o), (o = e.getExcludedMinersList()).length > 0 && t.writeRepeatedString(3, o), (o = e.getTrustedMinersList()).length > 0 && t.writeRepeatedString(4, o), (o = e.getCountryCodesList()).length > 0 && t.writeRepeatedString(5, o), null != (o = e.getRenew()) && t.writeMessage(6, o, proto.api.bucketsd.pb.ArchiveRenew.serializeBinaryToWriter), 0 !== (o = e.getMaxPrice()) && t.writeUint64(7, o), (o = e.getFastRetrieval()) && t.writeBool(8, o), 0 !== (o = e.getDealStartOffset()) && t.writeInt64(9, o), (o = e.getVerifiedDeal()) && t.writeBool(10, o);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getRepFactor = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, 0);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setRepFactor = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 1, e);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getDealMinDuration = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, 0);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setDealMinDuration = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 2, e);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getExcludedMinersList = function () {
    return googleProtobuf.Message.getRepeatedField(this, 3);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setExcludedMinersList = function (e) {
    return googleProtobuf.Message.setField(this, 3, e || []);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.addExcludedMiners = function (e, t) {
    return googleProtobuf.Message.addToRepeatedField(this, 3, e, t);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.clearExcludedMinersList = function () {
    return this.setExcludedMinersList([]);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getTrustedMinersList = function () {
    return googleProtobuf.Message.getRepeatedField(this, 4);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setTrustedMinersList = function (e) {
    return googleProtobuf.Message.setField(this, 4, e || []);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.addTrustedMiners = function (e, t) {
    return googleProtobuf.Message.addToRepeatedField(this, 4, e, t);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.clearTrustedMinersList = function () {
    return this.setTrustedMinersList([]);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getCountryCodesList = function () {
    return googleProtobuf.Message.getRepeatedField(this, 5);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setCountryCodesList = function (e) {
    return googleProtobuf.Message.setField(this, 5, e || []);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.addCountryCodes = function (e, t) {
    return googleProtobuf.Message.addToRepeatedField(this, 5, e, t);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.clearCountryCodesList = function () {
    return this.setCountryCodesList([]);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getRenew = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.ArchiveRenew, 6);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setRenew = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 6, e);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.clearRenew = function () {
    return this.setRenew(void 0);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.hasRenew = function () {
    return null != googleProtobuf.Message.getField(this, 6);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getMaxPrice = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 7, 0);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setMaxPrice = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 7, e);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getFastRetrieval = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 8, !1);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setFastRetrieval = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 8, e);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getDealStartOffset = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 9, 0);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setDealStartOffset = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 9, e);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.getVerifiedDeal = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 10, !1);
  }, proto.api.bucketsd.pb.ArchiveConfig.prototype.setVerifiedDeal = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 10, e);
  }, proto.api.bucketsd.pb.Archives.repeatedFields_ = [2], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.Archives.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.Archives.toObject(e, this);
  }, proto.api.bucketsd.pb.Archives.toObject = function (e, t) {
    var o,
        r = {
      current: (o = t.getCurrent()) && proto.api.bucketsd.pb.Archive.toObject(e, o),
      historyList: googleProtobuf.Message.toObjectList(t.getHistoryList(), proto.api.bucketsd.pb.Archive.toObject, e)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.Archives.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.Archives();
    return proto.api.bucketsd.pb.Archives.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.Archives.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.Archive();
          t.readMessage(o, proto.api.bucketsd.pb.Archive.deserializeBinaryFromReader), e.setCurrent(o);
          break;

        case 2:
          o = new proto.api.bucketsd.pb.Archive();
          t.readMessage(o, proto.api.bucketsd.pb.Archive.deserializeBinaryFromReader), e.addHistory(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.Archives.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.Archives.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.Archives.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    null != (o = e.getCurrent()) && t.writeMessage(1, o, proto.api.bucketsd.pb.Archive.serializeBinaryToWriter), (o = e.getHistoryList()).length > 0 && t.writeRepeatedMessage(2, o, proto.api.bucketsd.pb.Archive.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.Archives.prototype.getCurrent = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Archive, 1);
  }, proto.api.bucketsd.pb.Archives.prototype.setCurrent = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.Archives.prototype.clearCurrent = function () {
    return this.setCurrent(void 0);
  }, proto.api.bucketsd.pb.Archives.prototype.hasCurrent = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.Archives.prototype.getHistoryList = function () {
    return googleProtobuf.Message.getRepeatedWrapperField(this, proto.api.bucketsd.pb.Archive, 2);
  }, proto.api.bucketsd.pb.Archives.prototype.setHistoryList = function (e) {
    return googleProtobuf.Message.setRepeatedWrapperField(this, 2, e);
  }, proto.api.bucketsd.pb.Archives.prototype.addHistory = function (e, t) {
    return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, e, proto.api.bucketsd.pb.Archive, t);
  }, proto.api.bucketsd.pb.Archives.prototype.clearHistoryList = function () {
    return this.setHistoryList([]);
  }, proto.api.bucketsd.pb.Archive.repeatedFields_ = [8], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.Archive.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.Archive.toObject(e, this);
  }, proto.api.bucketsd.pb.Archive.toObject = function (e, t) {
    var o = {
      cid: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      jobId: googleProtobuf.Message.getFieldWithDefault(t, 2, ""),
      archiveStatus: googleProtobuf.Message.getFieldWithDefault(t, 3, 0),
      aborted: googleProtobuf.Message.getBooleanFieldWithDefault(t, 4, !1),
      abortedMsg: googleProtobuf.Message.getFieldWithDefault(t, 5, ""),
      failureMsg: googleProtobuf.Message.getFieldWithDefault(t, 6, ""),
      createdAt: googleProtobuf.Message.getFieldWithDefault(t, 7, 0),
      dealInfoList: googleProtobuf.Message.toObjectList(t.getDealInfoList(), proto.api.bucketsd.pb.DealInfo.toObject, e)
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.Archive.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.Archive();
    return proto.api.bucketsd.pb.Archive.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.Archive.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setCid(o);
          break;

        case 2:
          o = t.readString();
          e.setJobId(o);
          break;

        case 3:
          o = t.readEnum();
          e.setArchiveStatus(o);
          break;

        case 4:
          o = t.readBool();
          e.setAborted(o);
          break;

        case 5:
          o = t.readString();
          e.setAbortedMsg(o);
          break;

        case 6:
          o = t.readString();
          e.setFailureMsg(o);
          break;

        case 7:
          o = t.readInt64();
          e.setCreatedAt(o);
          break;

        case 8:
          o = new proto.api.bucketsd.pb.DealInfo();
          t.readMessage(o, proto.api.bucketsd.pb.DealInfo.deserializeBinaryFromReader), e.addDealInfo(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.Archive.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.Archive.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.Archive.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getCid()).length > 0 && t.writeString(1, o), (o = e.getJobId()).length > 0 && t.writeString(2, o), 0 !== (o = e.getArchiveStatus()) && t.writeEnum(3, o), (o = e.getAborted()) && t.writeBool(4, o), (o = e.getAbortedMsg()).length > 0 && t.writeString(5, o), (o = e.getFailureMsg()).length > 0 && t.writeString(6, o), 0 !== (o = e.getCreatedAt()) && t.writeInt64(7, o), (o = e.getDealInfoList()).length > 0 && t.writeRepeatedMessage(8, o, proto.api.bucketsd.pb.DealInfo.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.Archive.prototype.getCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.Archive.prototype.setCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.Archive.prototype.getJobId = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, "");
  }, proto.api.bucketsd.pb.Archive.prototype.setJobId = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 2, e);
  }, proto.api.bucketsd.pb.Archive.prototype.getArchiveStatus = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, 0);
  }, proto.api.bucketsd.pb.Archive.prototype.setArchiveStatus = function (e) {
    return googleProtobuf.Message.setProto3EnumField(this, 3, e);
  }, proto.api.bucketsd.pb.Archive.prototype.getAborted = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 4, !1);
  }, proto.api.bucketsd.pb.Archive.prototype.setAborted = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 4, e);
  }, proto.api.bucketsd.pb.Archive.prototype.getAbortedMsg = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 5, "");
  }, proto.api.bucketsd.pb.Archive.prototype.setAbortedMsg = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 5, e);
  }, proto.api.bucketsd.pb.Archive.prototype.getFailureMsg = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 6, "");
  }, proto.api.bucketsd.pb.Archive.prototype.setFailureMsg = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 6, e);
  }, proto.api.bucketsd.pb.Archive.prototype.getCreatedAt = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 7, 0);
  }, proto.api.bucketsd.pb.Archive.prototype.setCreatedAt = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 7, e);
  }, proto.api.bucketsd.pb.Archive.prototype.getDealInfoList = function () {
    return googleProtobuf.Message.getRepeatedWrapperField(this, proto.api.bucketsd.pb.DealInfo, 8);
  }, proto.api.bucketsd.pb.Archive.prototype.setDealInfoList = function (e) {
    return googleProtobuf.Message.setRepeatedWrapperField(this, 8, e);
  }, proto.api.bucketsd.pb.Archive.prototype.addDealInfo = function (e, t) {
    return googleProtobuf.Message.addToRepeatedWrapperField(this, 8, e, proto.api.bucketsd.pb.DealInfo, t);
  }, proto.api.bucketsd.pb.Archive.prototype.clearDealInfoList = function () {
    return this.setDealInfoList([]);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.DealInfo.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.DealInfo.toObject(e, this);
  }, proto.api.bucketsd.pb.DealInfo.toObject = function (e, t) {
    var o = {
      proposalCid: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      stateId: googleProtobuf.Message.getFieldWithDefault(t, 2, 0),
      stateName: googleProtobuf.Message.getFieldWithDefault(t, 3, ""),
      miner: googleProtobuf.Message.getFieldWithDefault(t, 4, ""),
      pieceCid: googleProtobuf.Message.getFieldWithDefault(t, 5, ""),
      size: googleProtobuf.Message.getFieldWithDefault(t, 6, 0),
      pricePerEpoch: googleProtobuf.Message.getFieldWithDefault(t, 7, 0),
      startEpoch: googleProtobuf.Message.getFieldWithDefault(t, 8, 0),
      duration: googleProtobuf.Message.getFieldWithDefault(t, 9, 0),
      dealId: googleProtobuf.Message.getFieldWithDefault(t, 10, 0),
      activationEpoch: googleProtobuf.Message.getFieldWithDefault(t, 11, 0),
      message: googleProtobuf.Message.getFieldWithDefault(t, 12, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.DealInfo.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.DealInfo();
    return proto.api.bucketsd.pb.DealInfo.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.DealInfo.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setProposalCid(o);
          break;

        case 2:
          o = t.readUint64();
          e.setStateId(o);
          break;

        case 3:
          o = t.readString();
          e.setStateName(o);
          break;

        case 4:
          o = t.readString();
          e.setMiner(o);
          break;

        case 5:
          o = t.readString();
          e.setPieceCid(o);
          break;

        case 6:
          o = t.readUint64();
          e.setSize(o);
          break;

        case 7:
          o = t.readUint64();
          e.setPricePerEpoch(o);
          break;

        case 8:
          o = t.readUint64();
          e.setStartEpoch(o);
          break;

        case 9:
          o = t.readUint64();
          e.setDuration(o);
          break;

        case 10:
          o = t.readUint64();
          e.setDealId(o);
          break;

        case 11:
          o = t.readInt64();
          e.setActivationEpoch(o);
          break;

        case 12:
          o = t.readString();
          e.setMessage(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.DealInfo.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.DealInfo.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.DealInfo.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getProposalCid()).length > 0 && t.writeString(1, o), 0 !== (o = e.getStateId()) && t.writeUint64(2, o), (o = e.getStateName()).length > 0 && t.writeString(3, o), (o = e.getMiner()).length > 0 && t.writeString(4, o), (o = e.getPieceCid()).length > 0 && t.writeString(5, o), 0 !== (o = e.getSize()) && t.writeUint64(6, o), 0 !== (o = e.getPricePerEpoch()) && t.writeUint64(7, o), 0 !== (o = e.getStartEpoch()) && t.writeUint64(8, o), 0 !== (o = e.getDuration()) && t.writeUint64(9, o), 0 !== (o = e.getDealId()) && t.writeUint64(10, o), 0 !== (o = e.getActivationEpoch()) && t.writeInt64(11, o), (o = e.getMessage()).length > 0 && t.writeString(12, o);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getProposalCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.DealInfo.prototype.setProposalCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getStateId = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, 0);
  }, proto.api.bucketsd.pb.DealInfo.prototype.setStateId = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 2, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getStateName = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 3, "");
  }, proto.api.bucketsd.pb.DealInfo.prototype.setStateName = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 3, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getMiner = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 4, "");
  }, proto.api.bucketsd.pb.DealInfo.prototype.setMiner = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 4, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getPieceCid = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 5, "");
  }, proto.api.bucketsd.pb.DealInfo.prototype.setPieceCid = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 5, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getSize = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 6, 0);
  }, proto.api.bucketsd.pb.DealInfo.prototype.setSize = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 6, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getPricePerEpoch = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 7, 0);
  }, proto.api.bucketsd.pb.DealInfo.prototype.setPricePerEpoch = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 7, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getStartEpoch = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 8, 0);
  }, proto.api.bucketsd.pb.DealInfo.prototype.setStartEpoch = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 8, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getDuration = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 9, 0);
  }, proto.api.bucketsd.pb.DealInfo.prototype.setDuration = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 9, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getDealId = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 10, 0);
  }, proto.api.bucketsd.pb.DealInfo.prototype.setDealId = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 10, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getActivationEpoch = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 11, 0);
  }, proto.api.bucketsd.pb.DealInfo.prototype.setActivationEpoch = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 11, e);
  }, proto.api.bucketsd.pb.DealInfo.prototype.getMessage = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 12, "");
  }, proto.api.bucketsd.pb.DealInfo.prototype.setMessage = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 12, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchiveRenew.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchiveRenew.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchiveRenew.toObject = function (e, t) {
    var o = {
      enabled: googleProtobuf.Message.getBooleanFieldWithDefault(t, 1, !1),
      threshold: googleProtobuf.Message.getFieldWithDefault(t, 2, 0)
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ArchiveRenew.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchiveRenew();
    return proto.api.bucketsd.pb.ArchiveRenew.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchiveRenew.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readBool();
          e.setEnabled(o);
          break;

        case 2:
          o = t.readInt32();
          e.setThreshold(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ArchiveRenew.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchiveRenew.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchiveRenew.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getEnabled()) && t.writeBool(1, o), 0 !== (o = e.getThreshold()) && t.writeInt32(2, o);
  }, proto.api.bucketsd.pb.ArchiveRenew.prototype.getEnabled = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 1, !1);
  }, proto.api.bucketsd.pb.ArchiveRenew.prototype.setEnabled = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 1, e);
  }, proto.api.bucketsd.pb.ArchiveRenew.prototype.getThreshold = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 2, 0);
  }, proto.api.bucketsd.pb.ArchiveRenew.prototype.setThreshold = function (e) {
    return googleProtobuf.Message.setProto3IntField(this, 2, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.DefaultArchiveConfigRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.DefaultArchiveConfigRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.DefaultArchiveConfigRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.DefaultArchiveConfigRequest();
    return proto.api.bucketsd.pb.DefaultArchiveConfigRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.DefaultArchiveConfigRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.DefaultArchiveConfigRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.DefaultArchiveConfigRequest.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getKey()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.DefaultArchiveConfigRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.DefaultArchiveConfigResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.DefaultArchiveConfigResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.toObject = function (e, t) {
    var o,
        r = {
      archiveConfig: (o = t.getArchiveConfig()) && proto.api.bucketsd.pb.ArchiveConfig.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.DefaultArchiveConfigResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.DefaultArchiveConfigResponse();
    return proto.api.bucketsd.pb.DefaultArchiveConfigResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.ArchiveConfig();
          t.readMessage(o, proto.api.bucketsd.pb.ArchiveConfig.deserializeBinaryFromReader), e.setArchiveConfig(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.DefaultArchiveConfigResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    null != (o = e.getArchiveConfig()) && t.writeMessage(1, o, proto.api.bucketsd.pb.ArchiveConfig.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.prototype.getArchiveConfig = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.ArchiveConfig, 1);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.prototype.setArchiveConfig = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.prototype.clearArchiveConfig = function () {
    return this.setArchiveConfig(void 0);
  }, proto.api.bucketsd.pb.DefaultArchiveConfigResponse.prototype.hasArchiveConfig = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.toObject = function (e, t) {
    var o,
        r = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      archiveConfig: (o = t.getArchiveConfig()) && proto.api.bucketsd.pb.ArchiveConfig.toObject(e, o)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest();
    return proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = new proto.api.bucketsd.pb.ArchiveConfig();
          t.readMessage(o, proto.api.bucketsd.pb.ArchiveConfig.deserializeBinaryFromReader), e.setArchiveConfig(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), null != (o = e.getArchiveConfig()) && t.writeMessage(2, o, proto.api.bucketsd.pb.ArchiveConfig.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.getArchiveConfig = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.ArchiveConfig, 2);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.setArchiveConfig = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 2, e);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.clearArchiveConfig = function () {
    return this.setArchiveConfig(void 0);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigRequest.prototype.hasArchiveConfig = function () {
    return null != googleProtobuf.Message.getField(this, 2);
  };
  googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.toObject = function (e, t) {
    var o = {};
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse();
    return proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      t.getFieldNumber();
      t.skipField();
    }

    return e;
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.SetDefaultArchiveConfigResponse.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchiveRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchiveRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchiveRequest.toObject = function (e, t) {
    var o,
        r = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, ""),
      archiveConfig: (o = t.getArchiveConfig()) && proto.api.bucketsd.pb.ArchiveConfig.toObject(e, o),
      skipAutomaticVerifiedDeal: googleProtobuf.Message.getBooleanFieldWithDefault(t, 3, !1)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.ArchiveRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchiveRequest();
    return proto.api.bucketsd.pb.ArchiveRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchiveRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        case 2:
          o = new proto.api.bucketsd.pb.ArchiveConfig();
          t.readMessage(o, proto.api.bucketsd.pb.ArchiveConfig.deserializeBinaryFromReader), e.setArchiveConfig(o);
          break;

        case 3:
          o = t.readBool();
          e.setSkipAutomaticVerifiedDeal(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchiveRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchiveRequest.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    (o = e.getKey()).length > 0 && t.writeString(1, o), null != (o = e.getArchiveConfig()) && t.writeMessage(2, o, proto.api.bucketsd.pb.ArchiveConfig.serializeBinaryToWriter), (o = e.getSkipAutomaticVerifiedDeal()) && t.writeBool(3, o);
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.getArchiveConfig = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.ArchiveConfig, 2);
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.setArchiveConfig = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 2, e);
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.clearArchiveConfig = function () {
    return this.setArchiveConfig(void 0);
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.hasArchiveConfig = function () {
    return null != googleProtobuf.Message.getField(this, 2);
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.getSkipAutomaticVerifiedDeal = function () {
    return googleProtobuf.Message.getBooleanFieldWithDefault(this, 3, !1);
  }, proto.api.bucketsd.pb.ArchiveRequest.prototype.setSkipAutomaticVerifiedDeal = function (e) {
    return googleProtobuf.Message.setProto3BooleanField(this, 3, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchiveResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchiveResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchiveResponse.toObject = function (e, t) {
    var o = {};
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ArchiveResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchiveResponse();
    return proto.api.bucketsd.pb.ArchiveResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchiveResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      t.getFieldNumber();
      t.skipField();
    }

    return e;
  }, proto.api.bucketsd.pb.ArchiveResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchiveResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchiveResponse.serializeBinaryToWriter = function (e, t) {}, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchivesRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchivesRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchivesRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ArchivesRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchivesRequest();
    return proto.api.bucketsd.pb.ArchivesRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchivesRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ArchivesRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchivesRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchivesRequest.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getKey()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.ArchivesRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.ArchivesRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.ArchivesResponse.repeatedFields_ = [2], googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchivesResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchivesResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchivesResponse.toObject = function (e, t) {
    var o,
        r = {
      current: (o = t.getCurrent()) && proto.api.bucketsd.pb.Archive.toObject(e, o),
      historyList: googleProtobuf.Message.toObjectList(t.getHistoryList(), proto.api.bucketsd.pb.Archive.toObject, e)
    };
    return e && (r.$jspbMessageInstance = t), r;
  }), proto.api.bucketsd.pb.ArchivesResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchivesResponse();
    return proto.api.bucketsd.pb.ArchivesResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchivesResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = new proto.api.bucketsd.pb.Archive();
          t.readMessage(o, proto.api.bucketsd.pb.Archive.deserializeBinaryFromReader), e.setCurrent(o);
          break;

        case 2:
          o = new proto.api.bucketsd.pb.Archive();
          t.readMessage(o, proto.api.bucketsd.pb.Archive.deserializeBinaryFromReader), e.addHistory(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchivesResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchivesResponse.serializeBinaryToWriter = function (e, t) {
    var o = void 0;
    null != (o = e.getCurrent()) && t.writeMessage(1, o, proto.api.bucketsd.pb.Archive.serializeBinaryToWriter), (o = e.getHistoryList()).length > 0 && t.writeRepeatedMessage(2, o, proto.api.bucketsd.pb.Archive.serializeBinaryToWriter);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.getCurrent = function () {
    return googleProtobuf.Message.getWrapperField(this, proto.api.bucketsd.pb.Archive, 1);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.setCurrent = function (e) {
    return googleProtobuf.Message.setWrapperField(this, 1, e);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.clearCurrent = function () {
    return this.setCurrent(void 0);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.hasCurrent = function () {
    return null != googleProtobuf.Message.getField(this, 1);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.getHistoryList = function () {
    return googleProtobuf.Message.getRepeatedWrapperField(this, proto.api.bucketsd.pb.Archive, 2);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.setHistoryList = function (e) {
    return googleProtobuf.Message.setRepeatedWrapperField(this, 2, e);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.addHistory = function (e, t) {
    return googleProtobuf.Message.addToRepeatedWrapperField(this, 2, e, proto.api.bucketsd.pb.Archive, t);
  }, proto.api.bucketsd.pb.ArchivesResponse.prototype.clearHistoryList = function () {
    return this.setHistoryList([]);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchiveWatchRequest.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchiveWatchRequest.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchiveWatchRequest.toObject = function (e, t) {
    var o = {
      key: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ArchiveWatchRequest.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchiveWatchRequest();
    return proto.api.bucketsd.pb.ArchiveWatchRequest.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchiveWatchRequest.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setKey(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ArchiveWatchRequest.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchiveWatchRequest.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchiveWatchRequest.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getKey()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.ArchiveWatchRequest.prototype.getKey = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.ArchiveWatchRequest.prototype.setKey = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, googleProtobuf.Message.GENERATE_TO_OBJECT && (proto.api.bucketsd.pb.ArchiveWatchResponse.prototype.toObject = function (e) {
    return proto.api.bucketsd.pb.ArchiveWatchResponse.toObject(e, this);
  }, proto.api.bucketsd.pb.ArchiveWatchResponse.toObject = function (e, t) {
    var o = {
      msg: googleProtobuf.Message.getFieldWithDefault(t, 1, "")
    };
    return e && (o.$jspbMessageInstance = t), o;
  }), proto.api.bucketsd.pb.ArchiveWatchResponse.deserializeBinary = function (e) {
    var t = new googleProtobuf.BinaryReader(e),
        o = new proto.api.bucketsd.pb.ArchiveWatchResponse();
    return proto.api.bucketsd.pb.ArchiveWatchResponse.deserializeBinaryFromReader(o, t);
  }, proto.api.bucketsd.pb.ArchiveWatchResponse.deserializeBinaryFromReader = function (e, t) {
    for (; t.nextField() && !t.isEndGroup();) {
      switch (t.getFieldNumber()) {
        case 1:
          var o = t.readString();
          e.setMsg(o);
          break;

        default:
          t.skipField();
      }
    }

    return e;
  }, proto.api.bucketsd.pb.ArchiveWatchResponse.prototype.serializeBinary = function () {
    var e = new googleProtobuf.BinaryWriter();
    return proto.api.bucketsd.pb.ArchiveWatchResponse.serializeBinaryToWriter(this, e), e.getResultBuffer();
  }, proto.api.bucketsd.pb.ArchiveWatchResponse.serializeBinaryToWriter = function (e, t) {
    var o;
    (o = e.getMsg()).length > 0 && t.writeString(1, o);
  }, proto.api.bucketsd.pb.ArchiveWatchResponse.prototype.getMsg = function () {
    return googleProtobuf.Message.getFieldWithDefault(this, 1, "");
  }, proto.api.bucketsd.pb.ArchiveWatchResponse.prototype.setMsg = function (e) {
    return googleProtobuf.Message.setProto3StringField(this, 1, e);
  }, proto.api.bucketsd.pb.PathAccessRole = {
    PATH_ACCESS_ROLE_UNSPECIFIED: 0,
    PATH_ACCESS_ROLE_READER: 1,
    PATH_ACCESS_ROLE_WRITER: 2,
    PATH_ACCESS_ROLE_ADMIN: 3
  }, proto.api.bucketsd.pb.ArchiveStatus = {
    ARCHIVE_STATUS_UNSPECIFIED: 0,
    ARCHIVE_STATUS_QUEUED: 1,
    ARCHIVE_STATUS_EXECUTING: 2,
    ARCHIVE_STATUS_FAILED: 3,
    ARCHIVE_STATUS_CANCELED: 4,
    ARCHIVE_STATUS_SUCCESS: 5
  }, o.object.extend(t, proto.api.bucketsd.pb);
}),
    grpc = grpcWebClient_umd.grpc,
    APIService = function () {
  function e() {}

  return e.serviceName = "api.bucketsd.pb.APIService", e;
}();

APIService.List = {
  methodName: "List",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.ListRequest,
  responseType: bucketsd_pb.ListResponse
}, APIService.Create = {
  methodName: "Create",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.CreateRequest,
  responseType: bucketsd_pb.CreateResponse
}, APIService.Root = {
  methodName: "Root",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.RootRequest,
  responseType: bucketsd_pb.RootResponse
}, APIService.Links = {
  methodName: "Links",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.LinksRequest,
  responseType: bucketsd_pb.LinksResponse
}, APIService.ListPath = {
  methodName: "ListPath",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.ListPathRequest,
  responseType: bucketsd_pb.ListPathResponse
}, APIService.ListIpfsPath = {
  methodName: "ListIpfsPath",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.ListIpfsPathRequest,
  responseType: bucketsd_pb.ListIpfsPathResponse
}, APIService.PushPath = {
  methodName: "PushPath",
  service: APIService,
  requestStream: !0,
  responseStream: !0,
  requestType: bucketsd_pb.PushPathRequest,
  responseType: bucketsd_pb.PushPathResponse
}, APIService.PushPaths = {
  methodName: "PushPaths",
  service: APIService,
  requestStream: !0,
  responseStream: !0,
  requestType: bucketsd_pb.PushPathsRequest,
  responseType: bucketsd_pb.PushPathsResponse
}, APIService.PullPath = {
  methodName: "PullPath",
  service: APIService,
  requestStream: !1,
  responseStream: !0,
  requestType: bucketsd_pb.PullPathRequest,
  responseType: bucketsd_pb.PullPathResponse
}, APIService.PullIpfsPath = {
  methodName: "PullIpfsPath",
  service: APIService,
  requestStream: !1,
  responseStream: !0,
  requestType: bucketsd_pb.PullIpfsPathRequest,
  responseType: bucketsd_pb.PullIpfsPathResponse
}, APIService.SetPath = {
  methodName: "SetPath",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.SetPathRequest,
  responseType: bucketsd_pb.SetPathResponse
}, APIService.MovePath = {
  methodName: "MovePath",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.MovePathRequest,
  responseType: bucketsd_pb.MovePathResponse
}, APIService.Remove = {
  methodName: "Remove",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.RemoveRequest,
  responseType: bucketsd_pb.RemoveResponse
}, APIService.RemovePath = {
  methodName: "RemovePath",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.RemovePathRequest,
  responseType: bucketsd_pb.RemovePathResponse
}, APIService.PushPathAccessRoles = {
  methodName: "PushPathAccessRoles",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.PushPathAccessRolesRequest,
  responseType: bucketsd_pb.PushPathAccessRolesResponse
}, APIService.PullPathAccessRoles = {
  methodName: "PullPathAccessRoles",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.PullPathAccessRolesRequest,
  responseType: bucketsd_pb.PullPathAccessRolesResponse
}, APIService.DefaultArchiveConfig = {
  methodName: "DefaultArchiveConfig",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.DefaultArchiveConfigRequest,
  responseType: bucketsd_pb.DefaultArchiveConfigResponse
}, APIService.SetDefaultArchiveConfig = {
  methodName: "SetDefaultArchiveConfig",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.SetDefaultArchiveConfigRequest,
  responseType: bucketsd_pb.SetDefaultArchiveConfigResponse
}, APIService.Archive = {
  methodName: "Archive",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.ArchiveRequest,
  responseType: bucketsd_pb.ArchiveResponse
}, APIService.Archives = {
  methodName: "Archives",
  service: APIService,
  requestStream: !1,
  responseStream: !1,
  requestType: bucketsd_pb.ArchivesRequest,
  responseType: bucketsd_pb.ArchivesResponse
}, APIService.ArchiveWatch = {
  methodName: "ArchiveWatch",
  service: APIService,
  requestStream: !1,
  responseStream: !0,
  requestType: bucketsd_pb.ArchiveWatchRequest,
  responseType: bucketsd_pb.ArchiveWatchResponse
};
var APIService_1 = APIService;

function APIServiceClient(e, t) {
  this.serviceHost = e, this.options = t || {};
}

APIServiceClient.prototype.list = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.List, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.create = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.Create, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.root = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.Root, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.links = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.Links, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.listPath = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.ListPath, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.listIpfsPath = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.ListIpfsPath, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.pushPath = function (e) {
  var t = {
    data: [],
    end: [],
    status: []
  },
      o = grpc.client(APIService.PushPath, {
    host: this.serviceHost,
    metadata: e,
    transport: this.options.transport
  });
  return o.onEnd(function (e, o, r) {
    t.status.forEach(function (t) {
      t({
        code: e,
        details: o,
        metadata: r
      });
    }), t.end.forEach(function (t) {
      t({
        code: e,
        details: o,
        metadata: r
      });
    }), t = null;
  }), o.onMessage(function (e) {
    t.data.forEach(function (t) {
      t(e);
    });
  }), o.start(e), {
    on: function on(e, o) {
      return t[e].push(o), this;
    },
    write: function write(e) {
      return o.send(e), this;
    },
    end: function end() {
      o.finishSend();
    },
    cancel: function cancel() {
      t = null, o.close();
    }
  };
}, APIServiceClient.prototype.pushPaths = function (e) {
  var t = {
    data: [],
    end: [],
    status: []
  },
      o = grpc.client(APIService.PushPaths, {
    host: this.serviceHost,
    metadata: e,
    transport: this.options.transport
  });
  return o.onEnd(function (e, o, r) {
    t.status.forEach(function (t) {
      t({
        code: e,
        details: o,
        metadata: r
      });
    }), t.end.forEach(function (t) {
      t({
        code: e,
        details: o,
        metadata: r
      });
    }), t = null;
  }), o.onMessage(function (e) {
    t.data.forEach(function (t) {
      t(e);
    });
  }), o.start(e), {
    on: function on(e, o) {
      return t[e].push(o), this;
    },
    write: function write(e) {
      return o.send(e), this;
    },
    end: function end() {
      o.finishSend();
    },
    cancel: function cancel() {
      t = null, o.close();
    }
  };
}, APIServiceClient.prototype.pullPath = function (e, t) {
  var o = {
    data: [],
    end: [],
    status: []
  },
      r = grpc.invoke(APIService.PullPath, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function onMessage(e) {
      o.data.forEach(function (t) {
        t(e);
      });
    },
    onEnd: function onEnd(e, t, r) {
      o.status.forEach(function (o) {
        o({
          code: e,
          details: t,
          metadata: r
        });
      }), o.end.forEach(function (o) {
        o({
          code: e,
          details: t,
          metadata: r
        });
      }), o = null;
    }
  });
  return {
    on: function on(e, t) {
      return o[e].push(t), this;
    },
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.pullIpfsPath = function (e, t) {
  var o = {
    data: [],
    end: [],
    status: []
  },
      r = grpc.invoke(APIService.PullIpfsPath, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function onMessage(e) {
      o.data.forEach(function (t) {
        t(e);
      });
    },
    onEnd: function onEnd(e, t, r) {
      o.status.forEach(function (o) {
        o({
          code: e,
          details: t,
          metadata: r
        });
      }), o.end.forEach(function (o) {
        o({
          code: e,
          details: t,
          metadata: r
        });
      }), o = null;
    }
  });
  return {
    on: function on(e, t) {
      return o[e].push(t), this;
    },
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.setPath = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.SetPath, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.movePath = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.MovePath, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.remove = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.Remove, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.removePath = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.RemovePath, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.pushPathAccessRoles = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.PushPathAccessRoles, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.pullPathAccessRoles = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.PullPathAccessRoles, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.defaultArchiveConfig = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.DefaultArchiveConfig, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.setDefaultArchiveConfig = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.SetDefaultArchiveConfig, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.archive = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.Archive, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.archives = function (e, t, o) {
  2 === arguments.length && (o = arguments[1]);
  var r = grpc.unary(APIService.Archives, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function onEnd(e) {
      if (o) if (e.status !== grpc.Code.OK) {
        var t = new Error(e.statusMessage);
        t.code = e.status, t.metadata = e.trailers, o(t, null);
      } else o(null, e.message);
    }
  });
  return {
    cancel: function cancel() {
      o = null, r.close();
    }
  };
}, APIServiceClient.prototype.archiveWatch = function (e, t) {
  var o = {
    data: [],
    end: [],
    status: []
  },
      r = grpc.invoke(APIService.ArchiveWatch, {
    request: e,
    host: this.serviceHost,
    metadata: t,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function onMessage(e) {
      o.data.forEach(function (t) {
        t(e);
      });
    },
    onEnd: function onEnd(e, t, r) {
      o.status.forEach(function (o) {
        o({
          code: e,
          details: t,
          metadata: r
        });
      }), o.end.forEach(function (o) {
        o({
          code: e,
          details: t,
          metadata: r
        });
      }), o = null;
    }
  });
  return {
    on: function on(e, t) {
      return o[e].push(t), this;
    },
    cancel: function cancel() {
      o = null, r.close();
    }
  };
};
var APIServiceClient_1 = APIServiceClient,
    e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
"undefined" != typeof WebSocket ? WebSocket : "undefined" != typeof MozWebSocket ? MozWebSocket : void 0 !== e ? e.WebSocket || e.MozWebSocket : "undefined" != typeof window ? window.WebSocket || window.MozWebSocket : "undefined" != typeof self && (self.WebSocket || self.MozWebSocket);
var t,
    r = (function (t) {
  var o, r;
  o = e, r = function r() {
    var e = function e() {},
        t = "undefined",
        o = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent),
        r = ["trace", "debug", "info", "warn", "error"];

    function s(e, t) {
      var o = e[t];
      if ("function" == typeof o.bind) return o.bind(e);

      try {
        return Function.prototype.bind.call(o, e);
      } catch (t) {
        return function () {
          return Function.prototype.apply.apply(o, [e, arguments]);
        };
      }
    }

    function n() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }

    function i(r) {
      return "debug" === r && (r = "log"), typeof console !== t && ("trace" === r && o ? n : void 0 !== console[r] ? s(console, r) : void 0 !== console.log ? s(console, "log") : e);
    }

    function a(t, o) {
      for (var s = 0; s < r.length; s++) {
        var n = r[s];
        this[n] = s < t ? e : this.methodFactory(n, t, o);
      }

      this.log = this.debug;
    }

    function u(e, o, r) {
      return function () {
        typeof console !== t && (a.call(this, o, r), this[e].apply(this, arguments));
      };
    }

    function g(e, t, o) {
      return i(e) || u.apply(this, arguments);
    }

    function p(e, o, s) {
      var n,
          i = this,
          u = "loglevel";

      function p() {
        var e;

        if (typeof window !== t && u) {
          try {
            e = window.localStorage[u];
          } catch (e) {}

          if (typeof e === t) try {
            var o = window.document.cookie,
                r = o.indexOf(encodeURIComponent(u) + "=");
            -1 !== r && (e = /^([^;]+)/.exec(o.slice(r))[1]);
          } catch (e) {}
          return void 0 === i.levels[e] && (e = void 0), e;
        }
      }

      "string" == typeof e ? u += ":" + e : "symbol" == typeof e && (u = void 0), i.name = e, i.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, i.methodFactory = s || g, i.getLevel = function () {
        return n;
      }, i.setLevel = function (o, s) {
        if ("string" == typeof o && void 0 !== i.levels[o.toUpperCase()] && (o = i.levels[o.toUpperCase()]), !("number" == typeof o && o >= 0 && o <= i.levels.SILENT)) throw "log.setLevel() called with invalid level: " + o;
        if (n = o, !1 !== s && function (e) {
          var o = (r[e] || "silent").toUpperCase();

          if (typeof window !== t && u) {
            try {
              return void (window.localStorage[u] = o);
            } catch (e) {}

            try {
              window.document.cookie = encodeURIComponent(u) + "=" + o + ";";
            } catch (e) {}
          }
        }(o), a.call(i, o, e), typeof console === t && o < i.levels.SILENT) return "No console available for logging";
      }, i.setDefaultLevel = function (e) {
        p() || i.setLevel(e, !1);
      }, i.enableAll = function (e) {
        i.setLevel(i.levels.TRACE, e);
      }, i.disableAll = function (e) {
        i.setLevel(i.levels.SILENT, e);
      };
      var l = p();
      null == l && (l = null == o ? "WARN" : o), i.setLevel(l, !1);
    }

    var l = new p(),
        c = {};

    l.getLogger = function (e) {
      if ("symbol" != typeof e && "string" != typeof e || "" === e) throw new TypeError("You must supply a name when creating a logger.");
      var t = c[e];
      return t || (t = c[e] = new p(e, l.getLevel(), l.methodFactory)), t;
    };

    var d = typeof window !== t ? window.log : void 0;
    return l.noConflict = function () {
      return typeof window !== t && window.log === l && (window.log = d), l;
    }, l.getLoggers = function () {
      return c;
    }, l.default = l, l;
  }, t.exports ? t.exports = r() : o.log = r();
}(t = {
  exports: {}
}, t.exports), t.exports),
    l;

function base(e) {
  if (e.length >= 255) throw new TypeError("Alphabet too long");

  for (var t = new Uint8Array(256), o = 0; o < t.length; o++) t[o] = 255;

  for (var r = 0; r < e.length; r++) {
    var s = e.charAt(r),
        n = s.charCodeAt(0);
    if (255 !== t[n]) throw new TypeError(s + " is ambiguous");
    t[n] = r;
  }

  var i = e.length,
      a = e.charAt(0),
      u = Math.log(i) / Math.log(256),
      g = Math.log(256) / Math.log(i);

  function p(e) {
    if ("string" != typeof e) throw new TypeError("Expected String");
    if (0 === e.length) return new Uint8Array();
    var o = 0;

    if (" " !== e[o]) {
      for (var r = 0, s = 0; e[o] === a;) r++, o++;

      for (var n = (e.length - o) * u + 1 >>> 0, g = new Uint8Array(n); e[o];) {
        var p = t[e.charCodeAt(o)];
        if (255 === p) return;

        for (var l = 0, c = n - 1; (0 !== p || l < s) && -1 !== c; c--, l++) p += i * g[c] >>> 0, g[c] = p % 256 >>> 0, p = p / 256 >>> 0;

        if (0 !== p) throw new Error("Non-zero carry");
        s = l, o++;
      }

      if (" " !== e[o]) {
        for (var d = n - s; d !== n && 0 === g[d];) d++;

        for (var f = new Uint8Array(r + (n - d)), b = r; d !== n;) f[b++] = g[d++];

        return f;
      }
    }
  }

  return {
    encode: function encode(t) {
      if (t instanceof Uint8Array || (ArrayBuffer.isView(t) ? t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Array.isArray(t) && (t = Uint8Array.from(t))), !(t instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
      if (0 === t.length) return "";

      for (var o = 0, r = 0, s = 0, n = t.length; s !== n && 0 === t[s];) s++, o++;

      for (var u = (n - s) * g + 1 >>> 0, p = new Uint8Array(u); s !== n;) {
        for (var l = t[s], c = 0, d = u - 1; (0 !== l || c < r) && -1 !== d; d--, c++) l += 256 * p[d] >>> 0, p[d] = l % i >>> 0, l = l / i >>> 0;

        if (0 !== l) throw new Error("Non-zero carry");
        r = c, s++;
      }

      for (var f = u - r; f !== u && 0 === p[f];) f++;

      for (var b = a.repeat(o); f < u; ++f) b += e.charAt(p[f]);

      return b;
    },
    decodeUnsafe: p,
    decode: function decode(e) {
      var t = p(e);
      if (t) return t;
      throw new Error("Non-base" + i + " character");
    }
  };
}

r.getLogger("grpc-transport"), function (e) {
  e[e.FINISH_SEND = 1] = "FINISH_SEND";
}(l || (l = {}));

var src$1 = base,
    isBufferBrowser = function isBufferBrowser(e) {
  return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
},
    inherits_browser = createCommonjsModule(function (e) {
  "function" == typeof Object.create ? e.exports = function (e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  } : e.exports = function (e, t) {
    e.super_ = t;

    var o = function o() {};

    o.prototype = t.prototype, e.prototype = new o(), e.prototype.constructor = e;
  };
}),
    util = createCommonjsModule(function (e, t) {
  var o = Object.getOwnPropertyDescriptors || function (e) {
    for (var t = Object.keys(e), o = {}, r = 0; r < t.length; r++) o[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);

    return o;
  },
      r = /%[sdj%]/g;

  t.format = function (e) {
    if (!h(e)) {
      for (var t = [], o = 0; o < arguments.length; o++) t.push(i(arguments[o]));

      return t.join(" ");
    }

    o = 1;

    for (var s = arguments, n = s.length, a = String(e).replace(r, function (e) {
      if ("%%" === e) return "%";
      if (o >= n) return e;

      switch (e) {
        case "%s":
          return String(s[o++]);

        case "%d":
          return Number(s[o++]);

        case "%j":
          try {
            return JSON.stringify(s[o++]);
          } catch (e) {
            return "[Circular]";
          }

        default:
          return e;
      }
    }), u = s[o]; o < n; u = s[++o]) f(u) || !_(u) ? a += " " + u : a += " " + i(u);

    return a;
  }, t.deprecate = function (e, o) {
    if ("undefined" != typeof process && !0 === process.noDeprecation) return e;
    if ("undefined" == typeof process) return function () {
      return t.deprecate(e, o).apply(this, arguments);
    };
    var r = !1;
    return function () {
      if (!r) {
        if (process.throwDeprecation) throw new Error(o);
        process.traceDeprecation ? console.trace(o) : console.error(o), r = !0;
      }

      return e.apply(this, arguments);
    };
  };
  var s,
      n = {};

  function i(e, o) {
    var r = {
      seen: [],
      stylize: u
    };
    return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), d(o) ? r.showHidden = o : o && t._extend(r, o), y(r.showHidden) && (r.showHidden = !1), y(r.depth) && (r.depth = 2), y(r.colors) && (r.colors = !1), y(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = a), g(r, e, r.depth);
  }

  function a(e, t) {
    var o = i.styles[t];
    return o ? "[" + i.colors[o][0] + "m" + e + "[" + i.colors[o][1] + "m" : e;
  }

  function u(e, t) {
    return e;
  }

  function g(e, o, r) {
    if (e.customInspect && o && P(o.inspect) && o.inspect !== t.inspect && (!o.constructor || o.constructor.prototype !== o)) {
      var s = o.inspect(r, e);
      return h(s) || (s = g(e, s, r)), s;
    }

    var n = function (e, t) {
      if (y(t)) return e.stylize("undefined", "undefined");

      if (h(t)) {
        var o = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return e.stylize(o, "string");
      }

      if (b(t)) return e.stylize("" + t, "number");
      if (d(t)) return e.stylize("" + t, "boolean");
      if (f(t)) return e.stylize("null", "null");
    }(e, o);

    if (n) return n;

    var i = Object.keys(o),
        a = function (e) {
      var t = {};
      return e.forEach(function (e, o) {
        t[e] = !0;
      }), t;
    }(i);

    if (e.showHidden && (i = Object.getOwnPropertyNames(o)), R(o) && (i.indexOf("message") >= 0 || i.indexOf("description") >= 0)) return p(o);

    if (0 === i.length) {
      if (P(o)) {
        var u = o.name ? ": " + o.name : "";
        return e.stylize("[Function" + u + "]", "special");
      }

      if (m(o)) return e.stylize(RegExp.prototype.toString.call(o), "regexp");
      if (v(o)) return e.stylize(Date.prototype.toString.call(o), "date");
      if (R(o)) return p(o);
    }

    var _,
        S = "",
        k = !1,
        A = ["{", "}"];

    (c(o) && (k = !0, A = ["[", "]"]), P(o)) && (S = " [Function" + (o.name ? ": " + o.name : "") + "]");
    return m(o) && (S = " " + RegExp.prototype.toString.call(o)), v(o) && (S = " " + Date.prototype.toUTCString.call(o)), R(o) && (S = " " + p(o)), 0 !== i.length || k && 0 != o.length ? r < 0 ? m(o) ? e.stylize(RegExp.prototype.toString.call(o), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(o), _ = k ? function (e, t, o, r, s) {
      for (var n = [], i = 0, a = t.length; i < a; ++i) T(t, String(i)) ? n.push(l(e, t, o, r, String(i), !0)) : n.push("");

      return s.forEach(function (s) {
        s.match(/^\d+$/) || n.push(l(e, t, o, r, s, !0));
      }), n;
    }(e, o, r, a, i) : i.map(function (t) {
      return l(e, o, r, a, t, k);
    }), e.seen.pop(), function (e, t, o) {
      if (e.reduce(function (e, t) {
        return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0) > 60) return o[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + o[1];
      return o[0] + t + " " + e.join(", ") + " " + o[1];
    }(_, S, A)) : A[0] + S + A[1];
  }

  function p(e) {
    return "[" + Error.prototype.toString.call(e) + "]";
  }

  function l(e, t, o, r, s, n) {
    var i, a, u;

    if ((u = Object.getOwnPropertyDescriptor(t, s) || {
      value: t[s]
    }).get ? a = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (a = e.stylize("[Setter]", "special")), T(r, s) || (i = "[" + s + "]"), a || (e.seen.indexOf(u.value) < 0 ? (a = f(o) ? g(e, u.value, null) : g(e, u.value, o - 1)).indexOf("\n") > -1 && (a = n ? a.split("\n").map(function (e) {
      return "  " + e;
    }).join("\n").substr(2) : "\n" + a.split("\n").map(function (e) {
      return "   " + e;
    }).join("\n")) : a = e.stylize("[Circular]", "special")), y(i)) {
      if (n && s.match(/^\d+$/)) return a;
      (i = JSON.stringify("" + s)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (i = i.substr(1, i.length - 2), i = e.stylize(i, "name")) : (i = i.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), i = e.stylize(i, "string"));
    }

    return i + ": " + a;
  }

  function c(e) {
    return Array.isArray(e);
  }

  function d(e) {
    return "boolean" == typeof e;
  }

  function f(e) {
    return null === e;
  }

  function b(e) {
    return "number" == typeof e;
  }

  function h(e) {
    return "string" == typeof e;
  }

  function y(e) {
    return void 0 === e;
  }

  function m(e) {
    return _(e) && "[object RegExp]" === S(e);
  }

  function _(e) {
    return "object" == typeof e && null !== e;
  }

  function v(e) {
    return _(e) && "[object Date]" === S(e);
  }

  function R(e) {
    return _(e) && ("[object Error]" === S(e) || e instanceof Error);
  }

  function P(e) {
    return "function" == typeof e;
  }

  function S(e) {
    return Object.prototype.toString.call(e);
  }

  function k(e) {
    return e < 10 ? "0" + e.toString(10) : e.toString(10);
  }

  t.debuglog = function (e) {
    if (y(s) && (s = process.env.NODE_DEBUG || ""), e = e.toUpperCase(), !n[e]) if (new RegExp("\\b" + e + "\\b", "i").test(s)) {
      var o = process.pid;

      n[e] = function () {
        var r = t.format.apply(t, arguments);
        console.error("%s %d: %s", e, o, r);
      };
    } else n[e] = function () {};
    return n[e];
  }, t.inspect = i, i.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, i.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    regexp: "red"
  }, t.isArray = c, t.isBoolean = d, t.isNull = f, t.isNullOrUndefined = function (e) {
    return null == e;
  }, t.isNumber = b, t.isString = h, t.isSymbol = function (e) {
    return "symbol" == typeof e;
  }, t.isUndefined = y, t.isRegExp = m, t.isObject = _, t.isDate = v, t.isError = R, t.isFunction = P, t.isPrimitive = function (e) {
    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
  }, t.isBuffer = isBufferBrowser;
  var A = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  function E() {
    var e = new Date(),
        t = [k(e.getHours()), k(e.getMinutes()), k(e.getSeconds())].join(":");
    return [e.getDate(), A[e.getMonth()], t].join(" ");
  }

  function T(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }

  t.log = function () {
    console.log("%s - %s", E(), t.format.apply(t, arguments));
  }, t.inherits = inherits_browser, t._extend = function (e, t) {
    if (!t || !_(t)) return e;

    for (var o = Object.keys(t), r = o.length; r--;) e[o[r]] = t[o[r]];

    return e;
  };
  var w = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

  function M(e, t) {
    if (!e) {
      var o = new Error("Promise was rejected with a falsy value");
      o.reason = e, e = o;
    }

    return t(e);
  }

  t.promisify = function (e) {
    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

    if (w && e[w]) {
      var t;
      if ("function" != typeof (t = e[w])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(t, w, {
        value: t,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), t;
    }

    function t() {
      for (var t, o, r = new Promise(function (e, r) {
        t = e, o = r;
      }), s = [], n = 0; n < arguments.length; n++) s.push(arguments[n]);

      s.push(function (e, r) {
        e ? o(e) : t(r);
      });

      try {
        e.apply(this, s);
      } catch (e) {
        o(e);
      }

      return r;
    }

    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), w && Object.defineProperty(t, w, {
      value: t,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(t, o(e));
  }, t.promisify.custom = w, t.callbackify = function (e) {
    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

    function t() {
      for (var t = [], o = 0; o < arguments.length; o++) t.push(arguments[o]);

      var r = t.pop();
      if ("function" != typeof r) throw new TypeError("The last argument must be of type Function");

      var s = this,
          n = function n() {
        return r.apply(s, arguments);
      };

      e.apply(this, t).then(function (e) {
        process.nextTick(n, null, e);
      }, function (e) {
        process.nextTick(M, e, n);
      });
    }

    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, o(e)), t;
  };
}),
    TextEncoder_1 = "undefined" != typeof TextEncoder ? TextEncoder : util.TextEncoder,
    TextDecoder_1 = "undefined" != typeof TextDecoder ? TextDecoder : util.TextDecoder,
    lib = {
  TextEncoder: TextEncoder_1,
  TextDecoder: TextDecoder_1
};

const TextEncoder$1 = lib.TextEncoder,
      TextDecoder$1 = lib.TextDecoder,
      textDecoder = new TextDecoder$1(),
      decodeText = e => textDecoder.decode(e),
      textEncoder = new TextEncoder$1(),
      encodeText = e => textEncoder.encode(e);

function concat(e, t) {
  const o = new Uint8Array(t);
  let r = 0;

  for (const t of e) o.set(t, r), r += t.length;

  return o;
}

var util$1 = {
  decodeText: decodeText,
  encodeText: encodeText,
  concat: concat
};
const encodeText$1 = util$1.encodeText;

class Base {
  constructor(e, t, o, r) {
    this.name = e, this.code = t, this.codeBuf = encodeText$1(this.code), this.alphabet = r, this.codec = o(r);
  }

  encode(e) {
    return this.codec.encode(e);
  }

  decode(e) {
    for (const t of e) if (this.alphabet && this.alphabet.indexOf(t) < 0) throw new Error("invalid character '".concat(t, "' in '").concat(e, "'"));

    return this.codec.decode(e);
  }

}

var base$1 = Base;

const _decode = (e, t, o) => {
  const r = {};

  for (let e = 0; e < t.length; ++e) r[t[e]] = e;

  let s = e.length;

  for (; "=" === e[s - 1];) --s;

  const n = new Uint8Array(s * o / 8 | 0);
  let i = 0,
      a = 0,
      u = 0;

  for (let t = 0; t < s; ++t) {
    const s = r[e[t]];
    if (void 0 === s) throw new SyntaxError("Invalid character " + e[t]);
    a = a << o | s, i += o, i >= 8 && (i -= 8, n[u++] = 255 & a >> i);
  }

  if (i >= o || 255 & a << 8 - i) throw new SyntaxError("Unexpected end of data");
  return n;
},
      _encode = (e, t, o) => {
  const r = "=" === t[t.length - 1],
        s = (1 << o) - 1;
  let n = "",
      i = 0,
      a = 0;

  for (let r = 0; r < e.length; ++r) for (a = a << 8 | e[r], i += 8; i > o;) i -= o, n += t[s & a >> i];

  if (i && (n += t[s & a << o - i]), r) for (; n.length * o & 7;) n += "=";
  return n;
},
      rfc4648 = e => t => ({
  encode: o => _encode(o, t, e),
  decode: o => _decode(o, t, e)
});

var rfc4648_1 = {
  rfc4648: rfc4648
};

const rfc4648$1 = rfc4648_1.rfc4648,
      decodeText$1 = util$1.decodeText,
      encodeText$2 = util$1.encodeText,
      identity = () => ({
  encode: decodeText$1,
  decode: encodeText$2
}),
      constants = [["identity", "\0", identity, ""], ["base2", "0", rfc4648$1(1), "01"], ["base8", "7", rfc4648$1(3), "01234567"], ["base10", "9", src$1, "0123456789"], ["base16", "f", rfc4648$1(4), "0123456789abcdef"], ["base16upper", "F", rfc4648$1(4), "0123456789ABCDEF"], ["base32hex", "v", rfc4648$1(5), "0123456789abcdefghijklmnopqrstuv"], ["base32hexupper", "V", rfc4648$1(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV"], ["base32hexpad", "t", rfc4648$1(5), "0123456789abcdefghijklmnopqrstuv="], ["base32hexpadupper", "T", rfc4648$1(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV="], ["base32", "b", rfc4648$1(5), "abcdefghijklmnopqrstuvwxyz234567"], ["base32upper", "B", rfc4648$1(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"], ["base32pad", "c", rfc4648$1(5), "abcdefghijklmnopqrstuvwxyz234567="], ["base32padupper", "C", rfc4648$1(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567="], ["base32z", "h", rfc4648$1(5), "ybndrfg8ejkmcpqxot1uwisza345h769"], ["base36", "k", src$1, "0123456789abcdefghijklmnopqrstuvwxyz"], ["base36upper", "K", src$1, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"], ["base58btc", "z", src$1, "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"], ["base58flickr", "Z", src$1, "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"], ["base64", "m", rfc4648$1(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"], ["base64pad", "M", rfc4648$1(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="], ["base64url", "u", rfc4648$1(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"], ["base64urlpad", "U", rfc4648$1(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="]],
      names = constants.reduce((e, t) => (e[t[0]] = new base$1(t[0], t[1], t[2], t[3]), e), {}),
      codes = constants.reduce((e, t) => (e[t[1]] = names[t[0]], e), {});

var constants_1 = {
  names: names,
  codes: codes
},
    src$2 = createCommonjsModule(function (e, t) {
  const o = util$1.encodeText,
        r = util$1.decodeText,
        s = util$1.concat;

  function n(e) {
    if (constants_1.names[e]) return constants_1.names[e];
    if (constants_1.codes[e]) return constants_1.codes[e];
    throw new Error("Unsupported encoding: ".concat(e));
  }

  (t = e.exports = function (e, t) {
    if (!t) throw new Error("requires an encoded Uint8Array");

    const _n = n(e),
          o = _n.name,
          i = _n.codeBuf;

    return function (e, t) {
      n(e).decode(r(t));
    }(o, t), s([i, t], i.length + t.length);
  }).encode = function (e, t) {
    const r = n(e),
          i = o(r.encode(t));
    return s([r.codeBuf, i], r.codeBuf.length + i.length);
  }, t.decode = function (e) {
    e instanceof Uint8Array && (e = r(e));
    const t = e[0];
    return ["f", "F", "v", "V", "t", "T", "b", "B", "c", "C", "h", "k", "K"].includes(t) && (e = e.toLowerCase()), n(e[0]).decode(e.substring(1));
  }, t.isEncoded = function (e) {
    if (e instanceof Uint8Array && (e = r(e)), "[object String]" !== Object.prototype.toString.call(e)) return !1;

    try {
      return n(e[0]).name;
    } catch (e) {
      return !1;
    }
  }, t.encoding = n, t.encodingFromData = function (e) {
    return e instanceof Uint8Array && (e = r(e)), n(e[0]);
  }, t.names = Object.freeze(constants_1.names), t.codes = Object.freeze(constants_1.codes);
}),
    encode_1 = encode$1,
    MSB = 128,
    REST = 127,
    MSBALL = ~REST,
    INT = Math.pow(2, 31);

function encode$1(e, t, o) {
  if (Number.MAX_SAFE_INTEGER && e > Number.MAX_SAFE_INTEGER) throw encode$1.bytes = 0, new RangeError("Could not encode varint");
  t = t || [];

  for (var r = o = o || 0; e >= INT;) t[o++] = 255 & e | MSB, e /= 128;

  for (; e & MSBALL;) t[o++] = 255 & e | MSB, e >>>= 7;

  return t[o] = 0 | e, encode$1.bytes = o - r + 1, t;
}

var decode$1 = read,
    MSB$1 = 128,
    REST$1 = 127;

function read(e, t) {
  var o,
      r = 0,
      s = 0,
      n = t = t || 0,
      i = e.length;

  do {
    if (n >= i || s > 49) throw read.bytes = 0, new RangeError("Could not decode varint");
    o = e[n++], r += s < 28 ? (o & REST$1) << s : (o & REST$1) * Math.pow(2, s), s += 7;
  } while (o >= MSB$1);

  return read.bytes = n - t, r;
}

var N1 = Math.pow(2, 7),
    N2 = Math.pow(2, 14),
    N3 = Math.pow(2, 21),
    N4 = Math.pow(2, 28),
    N5 = Math.pow(2, 35),
    N6 = Math.pow(2, 42),
    N7 = Math.pow(2, 49),
    N8 = Math.pow(2, 56),
    N9 = Math.pow(2, 63),
    length = function length(e) {
  return e < N1 ? 1 : e < N2 ? 2 : e < N3 ? 3 : e < N4 ? 4 : e < N5 ? 5 : e < N6 ? 6 : e < N7 ? 7 : e < N8 ? 8 : e < N9 ? 9 : 10;
},
    varint = {
  encode: encode_1,
  decode: decode$1,
  encodingLength: length
};

const names$1 = Object.freeze({
  identity: 0,
  sha1: 17,
  "sha2-256": 18,
  "sha2-512": 19,
  "sha3-512": 20,
  "sha3-384": 21,
  "sha3-256": 22,
  "sha3-224": 23,
  "shake-128": 24,
  "shake-256": 25,
  "keccak-224": 26,
  "keccak-256": 27,
  "keccak-384": 28,
  "keccak-512": 29,
  blake3: 30,
  "murmur3-128": 34,
  "murmur3-32": 35,
  "dbl-sha2-256": 86,
  md4: 212,
  md5: 213,
  bmt: 214,
  "sha2-256-trunc254-padded": 4114,
  "ripemd-128": 4178,
  "ripemd-160": 4179,
  "ripemd-256": 4180,
  "ripemd-320": 4181,
  x11: 4352,
  kangarootwelve: 7425,
  "sm3-256": 21325,
  "blake2b-8": 45569,
  "blake2b-16": 45570,
  "blake2b-24": 45571,
  "blake2b-32": 45572,
  "blake2b-40": 45573,
  "blake2b-48": 45574,
  "blake2b-56": 45575,
  "blake2b-64": 45576,
  "blake2b-72": 45577,
  "blake2b-80": 45578,
  "blake2b-88": 45579,
  "blake2b-96": 45580,
  "blake2b-104": 45581,
  "blake2b-112": 45582,
  "blake2b-120": 45583,
  "blake2b-128": 45584,
  "blake2b-136": 45585,
  "blake2b-144": 45586,
  "blake2b-152": 45587,
  "blake2b-160": 45588,
  "blake2b-168": 45589,
  "blake2b-176": 45590,
  "blake2b-184": 45591,
  "blake2b-192": 45592,
  "blake2b-200": 45593,
  "blake2b-208": 45594,
  "blake2b-216": 45595,
  "blake2b-224": 45596,
  "blake2b-232": 45597,
  "blake2b-240": 45598,
  "blake2b-248": 45599,
  "blake2b-256": 45600,
  "blake2b-264": 45601,
  "blake2b-272": 45602,
  "blake2b-280": 45603,
  "blake2b-288": 45604,
  "blake2b-296": 45605,
  "blake2b-304": 45606,
  "blake2b-312": 45607,
  "blake2b-320": 45608,
  "blake2b-328": 45609,
  "blake2b-336": 45610,
  "blake2b-344": 45611,
  "blake2b-352": 45612,
  "blake2b-360": 45613,
  "blake2b-368": 45614,
  "blake2b-376": 45615,
  "blake2b-384": 45616,
  "blake2b-392": 45617,
  "blake2b-400": 45618,
  "blake2b-408": 45619,
  "blake2b-416": 45620,
  "blake2b-424": 45621,
  "blake2b-432": 45622,
  "blake2b-440": 45623,
  "blake2b-448": 45624,
  "blake2b-456": 45625,
  "blake2b-464": 45626,
  "blake2b-472": 45627,
  "blake2b-480": 45628,
  "blake2b-488": 45629,
  "blake2b-496": 45630,
  "blake2b-504": 45631,
  "blake2b-512": 45632,
  "blake2s-8": 45633,
  "blake2s-16": 45634,
  "blake2s-24": 45635,
  "blake2s-32": 45636,
  "blake2s-40": 45637,
  "blake2s-48": 45638,
  "blake2s-56": 45639,
  "blake2s-64": 45640,
  "blake2s-72": 45641,
  "blake2s-80": 45642,
  "blake2s-88": 45643,
  "blake2s-96": 45644,
  "blake2s-104": 45645,
  "blake2s-112": 45646,
  "blake2s-120": 45647,
  "blake2s-128": 45648,
  "blake2s-136": 45649,
  "blake2s-144": 45650,
  "blake2s-152": 45651,
  "blake2s-160": 45652,
  "blake2s-168": 45653,
  "blake2s-176": 45654,
  "blake2s-184": 45655,
  "blake2s-192": 45656,
  "blake2s-200": 45657,
  "blake2s-208": 45658,
  "blake2s-216": 45659,
  "blake2s-224": 45660,
  "blake2s-232": 45661,
  "blake2s-240": 45662,
  "blake2s-248": 45663,
  "blake2s-256": 45664,
  "skein256-8": 45825,
  "skein256-16": 45826,
  "skein256-24": 45827,
  "skein256-32": 45828,
  "skein256-40": 45829,
  "skein256-48": 45830,
  "skein256-56": 45831,
  "skein256-64": 45832,
  "skein256-72": 45833,
  "skein256-80": 45834,
  "skein256-88": 45835,
  "skein256-96": 45836,
  "skein256-104": 45837,
  "skein256-112": 45838,
  "skein256-120": 45839,
  "skein256-128": 45840,
  "skein256-136": 45841,
  "skein256-144": 45842,
  "skein256-152": 45843,
  "skein256-160": 45844,
  "skein256-168": 45845,
  "skein256-176": 45846,
  "skein256-184": 45847,
  "skein256-192": 45848,
  "skein256-200": 45849,
  "skein256-208": 45850,
  "skein256-216": 45851,
  "skein256-224": 45852,
  "skein256-232": 45853,
  "skein256-240": 45854,
  "skein256-248": 45855,
  "skein256-256": 45856,
  "skein512-8": 45857,
  "skein512-16": 45858,
  "skein512-24": 45859,
  "skein512-32": 45860,
  "skein512-40": 45861,
  "skein512-48": 45862,
  "skein512-56": 45863,
  "skein512-64": 45864,
  "skein512-72": 45865,
  "skein512-80": 45866,
  "skein512-88": 45867,
  "skein512-96": 45868,
  "skein512-104": 45869,
  "skein512-112": 45870,
  "skein512-120": 45871,
  "skein512-128": 45872,
  "skein512-136": 45873,
  "skein512-144": 45874,
  "skein512-152": 45875,
  "skein512-160": 45876,
  "skein512-168": 45877,
  "skein512-176": 45878,
  "skein512-184": 45879,
  "skein512-192": 45880,
  "skein512-200": 45881,
  "skein512-208": 45882,
  "skein512-216": 45883,
  "skein512-224": 45884,
  "skein512-232": 45885,
  "skein512-240": 45886,
  "skein512-248": 45887,
  "skein512-256": 45888,
  "skein512-264": 45889,
  "skein512-272": 45890,
  "skein512-280": 45891,
  "skein512-288": 45892,
  "skein512-296": 45893,
  "skein512-304": 45894,
  "skein512-312": 45895,
  "skein512-320": 45896,
  "skein512-328": 45897,
  "skein512-336": 45898,
  "skein512-344": 45899,
  "skein512-352": 45900,
  "skein512-360": 45901,
  "skein512-368": 45902,
  "skein512-376": 45903,
  "skein512-384": 45904,
  "skein512-392": 45905,
  "skein512-400": 45906,
  "skein512-408": 45907,
  "skein512-416": 45908,
  "skein512-424": 45909,
  "skein512-432": 45910,
  "skein512-440": 45911,
  "skein512-448": 45912,
  "skein512-456": 45913,
  "skein512-464": 45914,
  "skein512-472": 45915,
  "skein512-480": 45916,
  "skein512-488": 45917,
  "skein512-496": 45918,
  "skein512-504": 45919,
  "skein512-512": 45920,
  "skein1024-8": 45921,
  "skein1024-16": 45922,
  "skein1024-24": 45923,
  "skein1024-32": 45924,
  "skein1024-40": 45925,
  "skein1024-48": 45926,
  "skein1024-56": 45927,
  "skein1024-64": 45928,
  "skein1024-72": 45929,
  "skein1024-80": 45930,
  "skein1024-88": 45931,
  "skein1024-96": 45932,
  "skein1024-104": 45933,
  "skein1024-112": 45934,
  "skein1024-120": 45935,
  "skein1024-128": 45936,
  "skein1024-136": 45937,
  "skein1024-144": 45938,
  "skein1024-152": 45939,
  "skein1024-160": 45940,
  "skein1024-168": 45941,
  "skein1024-176": 45942,
  "skein1024-184": 45943,
  "skein1024-192": 45944,
  "skein1024-200": 45945,
  "skein1024-208": 45946,
  "skein1024-216": 45947,
  "skein1024-224": 45948,
  "skein1024-232": 45949,
  "skein1024-240": 45950,
  "skein1024-248": 45951,
  "skein1024-256": 45952,
  "skein1024-264": 45953,
  "skein1024-272": 45954,
  "skein1024-280": 45955,
  "skein1024-288": 45956,
  "skein1024-296": 45957,
  "skein1024-304": 45958,
  "skein1024-312": 45959,
  "skein1024-320": 45960,
  "skein1024-328": 45961,
  "skein1024-336": 45962,
  "skein1024-344": 45963,
  "skein1024-352": 45964,
  "skein1024-360": 45965,
  "skein1024-368": 45966,
  "skein1024-376": 45967,
  "skein1024-384": 45968,
  "skein1024-392": 45969,
  "skein1024-400": 45970,
  "skein1024-408": 45971,
  "skein1024-416": 45972,
  "skein1024-424": 45973,
  "skein1024-432": 45974,
  "skein1024-440": 45975,
  "skein1024-448": 45976,
  "skein1024-456": 45977,
  "skein1024-464": 45978,
  "skein1024-472": 45979,
  "skein1024-480": 45980,
  "skein1024-488": 45981,
  "skein1024-496": 45982,
  "skein1024-504": 45983,
  "skein1024-512": 45984,
  "skein1024-520": 45985,
  "skein1024-528": 45986,
  "skein1024-536": 45987,
  "skein1024-544": 45988,
  "skein1024-552": 45989,
  "skein1024-560": 45990,
  "skein1024-568": 45991,
  "skein1024-576": 45992,
  "skein1024-584": 45993,
  "skein1024-592": 45994,
  "skein1024-600": 45995,
  "skein1024-608": 45996,
  "skein1024-616": 45997,
  "skein1024-624": 45998,
  "skein1024-632": 45999,
  "skein1024-640": 46e3,
  "skein1024-648": 46001,
  "skein1024-656": 46002,
  "skein1024-664": 46003,
  "skein1024-672": 46004,
  "skein1024-680": 46005,
  "skein1024-688": 46006,
  "skein1024-696": 46007,
  "skein1024-704": 46008,
  "skein1024-712": 46009,
  "skein1024-720": 46010,
  "skein1024-728": 46011,
  "skein1024-736": 46012,
  "skein1024-744": 46013,
  "skein1024-752": 46014,
  "skein1024-760": 46015,
  "skein1024-768": 46016,
  "skein1024-776": 46017,
  "skein1024-784": 46018,
  "skein1024-792": 46019,
  "skein1024-800": 46020,
  "skein1024-808": 46021,
  "skein1024-816": 46022,
  "skein1024-824": 46023,
  "skein1024-832": 46024,
  "skein1024-840": 46025,
  "skein1024-848": 46026,
  "skein1024-856": 46027,
  "skein1024-864": 46028,
  "skein1024-872": 46029,
  "skein1024-880": 46030,
  "skein1024-888": 46031,
  "skein1024-896": 46032,
  "skein1024-904": 46033,
  "skein1024-912": 46034,
  "skein1024-920": 46035,
  "skein1024-928": 46036,
  "skein1024-936": 46037,
  "skein1024-944": 46038,
  "skein1024-952": 46039,
  "skein1024-960": 46040,
  "skein1024-968": 46041,
  "skein1024-976": 46042,
  "skein1024-984": 46043,
  "skein1024-992": 46044,
  "skein1024-1000": 46045,
  "skein1024-1008": 46046,
  "skein1024-1016": 46047,
  "skein1024-1024": 46048,
  "poseidon-bls12_381-a2-fc1": 46081,
  "poseidon-bls12_381-a2-fc1-sc": 46082
});
var constants$1 = {
  names: names$1
};
const getCodec = src$2.encoding,
      TextDecoder$2 = lib.TextDecoder,
      utf8Decoder = new TextDecoder$2("utf8");

function uint8ArrayToAsciiString(e) {
  let t = "";

  for (let o = 0; o < e.length; o++) t += String.fromCharCode(e[o]);

  return t;
}

function toString(e, t = "utf8") {
  return "utf8" === t || "utf-8" === t ? utf8Decoder.decode(e) : "ascii" === t ? uint8ArrayToAsciiString(e) : getCodec(t).encode(e);
}

var toString_1 = toString;
const getCodec$1 = src$2.encoding,
      TextEncoder$2 = lib.TextEncoder,
      utf8Encoder = new TextEncoder$2();

function asciiStringToUint8Array(e) {
  const t = new Uint8Array(e.length);

  for (let o = 0; o < e.length; o++) t[o] = e.charCodeAt(o);

  return t;
}

function fromString(e, t = "utf8") {
  return "utf8" === t || "utf-8" === t ? utf8Encoder.encode(e) : "ascii" === t ? asciiStringToUint8Array(e) : getCodec$1(t).decode(e);
}

var fromString_1 = fromString;

function concat$1(e, t) {
  t || (t = e.reduce((e, t) => e + t.length, 0));
  const o = new Uint8Array(t);
  let r = 0;

  for (const t of e) o.set(t, r), r += t.length;

  return o;
}

var concat_1 = concat$1;
const names$2 = constants$1.names,
      codes$1 = {};

for (const e in names$2) {
  const t = e;
  codes$1[names$2[t]] = t;
}

function toHexString(e) {
  if (!(e instanceof Uint8Array)) throw new Error("must be passed a Uint8Array");
  return toString_1(e, "base16");
}

function fromHexString(e) {
  return fromString_1(e, "base16");
}

function toB58String(e) {
  if (!(e instanceof Uint8Array)) throw new Error("must be passed a Uint8Array");
  return toString_1(src$2.encode("base58btc", e)).slice(1);
}

function fromB58String(e) {
  const t = e instanceof Uint8Array ? toString_1(e) : e;
  return src$2.decode("z" + t);
}

function decode$2(e) {
  if (!(e instanceof Uint8Array)) throw new Error("multihash must be a Uint8Array");
  if (e.length < 2) throw new Error("multihash too short. must be > 2 bytes.");
  const t = varint.decode(e);
  if (!isValidCode(t)) throw new Error("multihash unknown function code: 0x".concat(t.toString(16)));
  e = e.slice(varint.decode.bytes);
  const o = varint.decode(e);
  if (o < 0) throw new Error("multihash invalid length: ".concat(o));
  if ((e = e.slice(varint.decode.bytes)).length !== o) throw new Error("multihash length inconsistent: 0x".concat(toString_1(e, "base16")));
  return {
    code: t,
    name: codes$1[t],
    length: o,
    digest: e
  };
}

function encode$2(e, t, o) {
  if (!e || void 0 === t) throw new Error("multihash encode requires at least two args: digest, code");
  const r = coerceCode(t);
  if (!(e instanceof Uint8Array)) throw new Error("digest should be a Uint8Array");
  if (null == o && (o = e.length), o && e.length !== o) throw new Error("digest length should be equal to specified length.");
  const s = varint.encode(r),
        n = varint.encode(o);
  return concat_1([s, n, e], s.length + n.length + e.length);
}

function coerceCode(e) {
  let t = e;

  if ("string" == typeof e) {
    if (void 0 === names$2[e]) throw new Error("Unrecognized hash function named: ".concat(e));
    t = names$2[e];
  }

  if ("number" != typeof t) throw new Error("Hash function code should be a number. Got: ".concat(t));
  if (void 0 === codes$1[t] && !isAppCode(t)) throw new Error("Unrecognized function code: ".concat(t));
  return t;
}

function isAppCode(e) {
  return e > 0 && e < 16;
}

function isValidCode(e) {
  return !!isAppCode(e) || !!codes$1[e];
}

function validate(e) {
  decode$2(e);
}

function prefix(e) {
  return validate(e), e.subarray(0, 2);
}

var src$3 = {
  names: names$2,
  codes: Object.freeze(codes$1),
  toHexString: toHexString,
  fromHexString: fromHexString,
  toB58String: toB58String,
  fromB58String: fromB58String,
  decode: decode$2,
  encode: encode$2,
  coerceCode: coerceCode,
  isAppCode: isAppCode,
  validate: validate,
  prefix: prefix,
  isValidCode: isValidCode
};
const baseTable = Object.freeze({
  identity: 0,
  cidv1: 1,
  cidv2: 2,
  cidv3: 3,
  ip4: 4,
  tcp: 6,
  sha1: 17,
  "sha2-256": 18,
  "sha2-512": 19,
  "sha3-512": 20,
  "sha3-384": 21,
  "sha3-256": 22,
  "sha3-224": 23,
  "shake-128": 24,
  "shake-256": 25,
  "keccak-224": 26,
  "keccak-256": 27,
  "keccak-384": 28,
  "keccak-512": 29,
  blake3: 30,
  dccp: 33,
  "murmur3-128": 34,
  "murmur3-32": 35,
  ip6: 41,
  ip6zone: 42,
  path: 47,
  multicodec: 48,
  multihash: 49,
  multiaddr: 50,
  multibase: 51,
  dns: 53,
  dns4: 54,
  dns6: 55,
  dnsaddr: 56,
  protobuf: 80,
  cbor: 81,
  raw: 85,
  "dbl-sha2-256": 86,
  rlp: 96,
  bencode: 99,
  "dag-pb": 112,
  "dag-cbor": 113,
  "libp2p-key": 114,
  "git-raw": 120,
  "torrent-info": 123,
  "torrent-file": 124,
  "leofcoin-block": 129,
  "leofcoin-tx": 130,
  "leofcoin-pr": 131,
  sctp: 132,
  "dag-jose": 133,
  "dag-cose": 134,
  "eth-block": 144,
  "eth-block-list": 145,
  "eth-tx-trie": 146,
  "eth-tx": 147,
  "eth-tx-receipt-trie": 148,
  "eth-tx-receipt": 149,
  "eth-state-trie": 150,
  "eth-account-snapshot": 151,
  "eth-storage-trie": 152,
  "bitcoin-block": 176,
  "bitcoin-tx": 177,
  "bitcoin-witness-commitment": 178,
  "zcash-block": 192,
  "zcash-tx": 193,
  docid: 206,
  "stellar-block": 208,
  "stellar-tx": 209,
  md4: 212,
  md5: 213,
  bmt: 214,
  "decred-block": 224,
  "decred-tx": 225,
  "ipld-ns": 226,
  "ipfs-ns": 227,
  "swarm-ns": 228,
  "ipns-ns": 229,
  zeronet: 230,
  "secp256k1-pub": 231,
  "bls12_381-g1-pub": 234,
  "bls12_381-g2-pub": 235,
  "x25519-pub": 236,
  "ed25519-pub": 237,
  "bls12_381-g1g2-pub": 238,
  "dash-block": 240,
  "dash-tx": 241,
  "swarm-manifest": 250,
  "swarm-feed": 251,
  udp: 273,
  "p2p-webrtc-star": 275,
  "p2p-webrtc-direct": 276,
  "p2p-stardust": 277,
  "p2p-circuit": 290,
  "dag-json": 297,
  udt: 301,
  utp: 302,
  unix: 400,
  p2p: 421,
  ipfs: 421,
  https: 443,
  onion: 444,
  onion3: 445,
  garlic64: 446,
  garlic32: 447,
  tls: 448,
  quic: 460,
  ws: 477,
  wss: 478,
  "p2p-websocket-star": 479,
  http: 480,
  json: 512,
  messagepack: 513,
  "libp2p-peer-record": 769,
  "sha2-256-trunc254-padded": 4114,
  "ripemd-128": 4178,
  "ripemd-160": 4179,
  "ripemd-256": 4180,
  "ripemd-320": 4181,
  x11: 4352,
  "p256-pub": 4608,
  "p384-pub": 4609,
  "p521-pub": 4610,
  "ed448-pub": 4611,
  "x448-pub": 4612,
  "ed25519-priv": 4864,
  kangarootwelve: 7425,
  "sm3-256": 21325,
  "blake2b-8": 45569,
  "blake2b-16": 45570,
  "blake2b-24": 45571,
  "blake2b-32": 45572,
  "blake2b-40": 45573,
  "blake2b-48": 45574,
  "blake2b-56": 45575,
  "blake2b-64": 45576,
  "blake2b-72": 45577,
  "blake2b-80": 45578,
  "blake2b-88": 45579,
  "blake2b-96": 45580,
  "blake2b-104": 45581,
  "blake2b-112": 45582,
  "blake2b-120": 45583,
  "blake2b-128": 45584,
  "blake2b-136": 45585,
  "blake2b-144": 45586,
  "blake2b-152": 45587,
  "blake2b-160": 45588,
  "blake2b-168": 45589,
  "blake2b-176": 45590,
  "blake2b-184": 45591,
  "blake2b-192": 45592,
  "blake2b-200": 45593,
  "blake2b-208": 45594,
  "blake2b-216": 45595,
  "blake2b-224": 45596,
  "blake2b-232": 45597,
  "blake2b-240": 45598,
  "blake2b-248": 45599,
  "blake2b-256": 45600,
  "blake2b-264": 45601,
  "blake2b-272": 45602,
  "blake2b-280": 45603,
  "blake2b-288": 45604,
  "blake2b-296": 45605,
  "blake2b-304": 45606,
  "blake2b-312": 45607,
  "blake2b-320": 45608,
  "blake2b-328": 45609,
  "blake2b-336": 45610,
  "blake2b-344": 45611,
  "blake2b-352": 45612,
  "blake2b-360": 45613,
  "blake2b-368": 45614,
  "blake2b-376": 45615,
  "blake2b-384": 45616,
  "blake2b-392": 45617,
  "blake2b-400": 45618,
  "blake2b-408": 45619,
  "blake2b-416": 45620,
  "blake2b-424": 45621,
  "blake2b-432": 45622,
  "blake2b-440": 45623,
  "blake2b-448": 45624,
  "blake2b-456": 45625,
  "blake2b-464": 45626,
  "blake2b-472": 45627,
  "blake2b-480": 45628,
  "blake2b-488": 45629,
  "blake2b-496": 45630,
  "blake2b-504": 45631,
  "blake2b-512": 45632,
  "blake2s-8": 45633,
  "blake2s-16": 45634,
  "blake2s-24": 45635,
  "blake2s-32": 45636,
  "blake2s-40": 45637,
  "blake2s-48": 45638,
  "blake2s-56": 45639,
  "blake2s-64": 45640,
  "blake2s-72": 45641,
  "blake2s-80": 45642,
  "blake2s-88": 45643,
  "blake2s-96": 45644,
  "blake2s-104": 45645,
  "blake2s-112": 45646,
  "blake2s-120": 45647,
  "blake2s-128": 45648,
  "blake2s-136": 45649,
  "blake2s-144": 45650,
  "blake2s-152": 45651,
  "blake2s-160": 45652,
  "blake2s-168": 45653,
  "blake2s-176": 45654,
  "blake2s-184": 45655,
  "blake2s-192": 45656,
  "blake2s-200": 45657,
  "blake2s-208": 45658,
  "blake2s-216": 45659,
  "blake2s-224": 45660,
  "blake2s-232": 45661,
  "blake2s-240": 45662,
  "blake2s-248": 45663,
  "blake2s-256": 45664,
  "skein256-8": 45825,
  "skein256-16": 45826,
  "skein256-24": 45827,
  "skein256-32": 45828,
  "skein256-40": 45829,
  "skein256-48": 45830,
  "skein256-56": 45831,
  "skein256-64": 45832,
  "skein256-72": 45833,
  "skein256-80": 45834,
  "skein256-88": 45835,
  "skein256-96": 45836,
  "skein256-104": 45837,
  "skein256-112": 45838,
  "skein256-120": 45839,
  "skein256-128": 45840,
  "skein256-136": 45841,
  "skein256-144": 45842,
  "skein256-152": 45843,
  "skein256-160": 45844,
  "skein256-168": 45845,
  "skein256-176": 45846,
  "skein256-184": 45847,
  "skein256-192": 45848,
  "skein256-200": 45849,
  "skein256-208": 45850,
  "skein256-216": 45851,
  "skein256-224": 45852,
  "skein256-232": 45853,
  "skein256-240": 45854,
  "skein256-248": 45855,
  "skein256-256": 45856,
  "skein512-8": 45857,
  "skein512-16": 45858,
  "skein512-24": 45859,
  "skein512-32": 45860,
  "skein512-40": 45861,
  "skein512-48": 45862,
  "skein512-56": 45863,
  "skein512-64": 45864,
  "skein512-72": 45865,
  "skein512-80": 45866,
  "skein512-88": 45867,
  "skein512-96": 45868,
  "skein512-104": 45869,
  "skein512-112": 45870,
  "skein512-120": 45871,
  "skein512-128": 45872,
  "skein512-136": 45873,
  "skein512-144": 45874,
  "skein512-152": 45875,
  "skein512-160": 45876,
  "skein512-168": 45877,
  "skein512-176": 45878,
  "skein512-184": 45879,
  "skein512-192": 45880,
  "skein512-200": 45881,
  "skein512-208": 45882,
  "skein512-216": 45883,
  "skein512-224": 45884,
  "skein512-232": 45885,
  "skein512-240": 45886,
  "skein512-248": 45887,
  "skein512-256": 45888,
  "skein512-264": 45889,
  "skein512-272": 45890,
  "skein512-280": 45891,
  "skein512-288": 45892,
  "skein512-296": 45893,
  "skein512-304": 45894,
  "skein512-312": 45895,
  "skein512-320": 45896,
  "skein512-328": 45897,
  "skein512-336": 45898,
  "skein512-344": 45899,
  "skein512-352": 45900,
  "skein512-360": 45901,
  "skein512-368": 45902,
  "skein512-376": 45903,
  "skein512-384": 45904,
  "skein512-392": 45905,
  "skein512-400": 45906,
  "skein512-408": 45907,
  "skein512-416": 45908,
  "skein512-424": 45909,
  "skein512-432": 45910,
  "skein512-440": 45911,
  "skein512-448": 45912,
  "skein512-456": 45913,
  "skein512-464": 45914,
  "skein512-472": 45915,
  "skein512-480": 45916,
  "skein512-488": 45917,
  "skein512-496": 45918,
  "skein512-504": 45919,
  "skein512-512": 45920,
  "skein1024-8": 45921,
  "skein1024-16": 45922,
  "skein1024-24": 45923,
  "skein1024-32": 45924,
  "skein1024-40": 45925,
  "skein1024-48": 45926,
  "skein1024-56": 45927,
  "skein1024-64": 45928,
  "skein1024-72": 45929,
  "skein1024-80": 45930,
  "skein1024-88": 45931,
  "skein1024-96": 45932,
  "skein1024-104": 45933,
  "skein1024-112": 45934,
  "skein1024-120": 45935,
  "skein1024-128": 45936,
  "skein1024-136": 45937,
  "skein1024-144": 45938,
  "skein1024-152": 45939,
  "skein1024-160": 45940,
  "skein1024-168": 45941,
  "skein1024-176": 45942,
  "skein1024-184": 45943,
  "skein1024-192": 45944,
  "skein1024-200": 45945,
  "skein1024-208": 45946,
  "skein1024-216": 45947,
  "skein1024-224": 45948,
  "skein1024-232": 45949,
  "skein1024-240": 45950,
  "skein1024-248": 45951,
  "skein1024-256": 45952,
  "skein1024-264": 45953,
  "skein1024-272": 45954,
  "skein1024-280": 45955,
  "skein1024-288": 45956,
  "skein1024-296": 45957,
  "skein1024-304": 45958,
  "skein1024-312": 45959,
  "skein1024-320": 45960,
  "skein1024-328": 45961,
  "skein1024-336": 45962,
  "skein1024-344": 45963,
  "skein1024-352": 45964,
  "skein1024-360": 45965,
  "skein1024-368": 45966,
  "skein1024-376": 45967,
  "skein1024-384": 45968,
  "skein1024-392": 45969,
  "skein1024-400": 45970,
  "skein1024-408": 45971,
  "skein1024-416": 45972,
  "skein1024-424": 45973,
  "skein1024-432": 45974,
  "skein1024-440": 45975,
  "skein1024-448": 45976,
  "skein1024-456": 45977,
  "skein1024-464": 45978,
  "skein1024-472": 45979,
  "skein1024-480": 45980,
  "skein1024-488": 45981,
  "skein1024-496": 45982,
  "skein1024-504": 45983,
  "skein1024-512": 45984,
  "skein1024-520": 45985,
  "skein1024-528": 45986,
  "skein1024-536": 45987,
  "skein1024-544": 45988,
  "skein1024-552": 45989,
  "skein1024-560": 45990,
  "skein1024-568": 45991,
  "skein1024-576": 45992,
  "skein1024-584": 45993,
  "skein1024-592": 45994,
  "skein1024-600": 45995,
  "skein1024-608": 45996,
  "skein1024-616": 45997,
  "skein1024-624": 45998,
  "skein1024-632": 45999,
  "skein1024-640": 46e3,
  "skein1024-648": 46001,
  "skein1024-656": 46002,
  "skein1024-664": 46003,
  "skein1024-672": 46004,
  "skein1024-680": 46005,
  "skein1024-688": 46006,
  "skein1024-696": 46007,
  "skein1024-704": 46008,
  "skein1024-712": 46009,
  "skein1024-720": 46010,
  "skein1024-728": 46011,
  "skein1024-736": 46012,
  "skein1024-744": 46013,
  "skein1024-752": 46014,
  "skein1024-760": 46015,
  "skein1024-768": 46016,
  "skein1024-776": 46017,
  "skein1024-784": 46018,
  "skein1024-792": 46019,
  "skein1024-800": 46020,
  "skein1024-808": 46021,
  "skein1024-816": 46022,
  "skein1024-824": 46023,
  "skein1024-832": 46024,
  "skein1024-840": 46025,
  "skein1024-848": 46026,
  "skein1024-856": 46027,
  "skein1024-864": 46028,
  "skein1024-872": 46029,
  "skein1024-880": 46030,
  "skein1024-888": 46031,
  "skein1024-896": 46032,
  "skein1024-904": 46033,
  "skein1024-912": 46034,
  "skein1024-920": 46035,
  "skein1024-928": 46036,
  "skein1024-936": 46037,
  "skein1024-944": 46038,
  "skein1024-952": 46039,
  "skein1024-960": 46040,
  "skein1024-968": 46041,
  "skein1024-976": 46042,
  "skein1024-984": 46043,
  "skein1024-992": 46044,
  "skein1024-1000": 46045,
  "skein1024-1008": 46046,
  "skein1024-1016": 46047,
  "skein1024-1024": 46048,
  "poseidon-bls12_381-a2-fc1": 46081,
  "poseidon-bls12_381-a2-fc1-sc": 46082,
  "zeroxcert-imprint-256": 52753,
  "fil-commitment-unsealed": 61697,
  "fil-commitment-sealed": 61698,
  "holochain-adr-v0": 8417572,
  "holochain-adr-v1": 8483108,
  "holochain-key-v0": 9728292,
  "holochain-key-v1": 9793828,
  "holochain-sig-v0": 10645796,
  "holochain-sig-v1": 10711332,
  "skynet-ns": 11639056
});
var baseTable_1 = {
  baseTable: baseTable
};
const baseTable$1 = baseTable_1.baseTable,
      nameTable = new Map();

for (const e in baseTable$1) {
  const t = baseTable$1[e];
  nameTable.set(t, e);
}

var intTable = Object.freeze(nameTable);
const names$3 = constants_1.names,
      TextDecoder$3 = lib.TextDecoder,
      utf8Decoder$1 = new TextDecoder$3("utf8");

function uint8ArrayToAsciiString$1(e) {
  let t = "";

  for (let o = 0; o < e.length; o++) t += String.fromCharCode(e[o]);

  return t;
}

function toString$1(e, t = "utf8") {
  if ("utf8" === t || "utf-8" === t) return utf8Decoder$1.decode(e);
  if ("ascii" === t) return uint8ArrayToAsciiString$1(e);
  const o = names$3[t];
  if (!o) throw new Error("Unknown base");
  return o.encode(e);
}

var toString_1$1 = toString$1;
const names$4 = constants_1.names,
      TextEncoder$3 = lib.TextEncoder,
      utf8Encoder$1 = new TextEncoder$3();

function asciiStringToUint8Array$1(e) {
  const t = new Uint8Array(e.length);

  for (let o = 0; o < e.length; o++) t[o] = e.charCodeAt(o);

  return t;
}

function fromString$1(e, t = "utf8") {
  if ("utf8" === t || "utf-8" === t) return utf8Encoder$1.encode(e);
  if ("ascii" === t) return asciiStringToUint8Array$1(e);
  const o = names$4[t];
  if (!o) throw new Error("Unknown base");
  return o.decode(e);
}

var fromString_1$1 = fromString$1,
    util$2 = {
  numberToUint8Array: numberToUint8Array,
  uint8ArrayToNumber: uint8ArrayToNumber,
  varintUint8ArrayEncode: varintUint8ArrayEncode,
  varintEncode: varintEncode
};

function uint8ArrayToNumber(e) {
  return parseInt(toString_1$1(e, "base16"), 16);
}

function numberToUint8Array(e) {
  let t = e.toString(16);
  return t.length % 2 == 1 && (t = "0" + t), fromString_1$1(t, "base16");
}

function varintUint8ArrayEncode(e) {
  return Uint8Array.from(varint.encode(uint8ArrayToNumber(e)));
}

function varintEncode(e) {
  return Uint8Array.from(varint.encode(e));
}

const baseTable$2 = baseTable_1.baseTable,
      varintEncode$1 = util$2.varintEncode,
      varintTable = {};

for (const e in baseTable$2) {
  const t = baseTable$2[e];
  varintTable[e] = varintEncode$1(t);
}

var varintTable_1 = Object.freeze(varintTable);

function concat$2(e, t) {
  t || (t = e.reduce((e, t) => e + t.length, 0));
  const o = new Uint8Array(t);
  let r = 0;

  for (const t of e) o.set(t, r), r += t.length;

  return o;
}

var concat_1$1 = concat$2;
const baseTable$3 = baseTable_1.baseTable,
      constants$2 = {};

for (const _ref3 of Object.entries(baseTable$3)) {
  var _ref4 = _slicedToArray(_ref3, 2);

  const e = _ref4[0];
  const t = _ref4[1];
  const o = e.toUpperCase().replace(/-/g, "_");
  constants$2[o] = t;
}

var constants_1$1 = Object.freeze(constants$2);
const baseTable$4 = baseTable_1.baseTable,
      tableByCode = {};

for (const _ref5 of Object.entries(baseTable$4)) {
  var _ref6 = _slicedToArray(_ref5, 2);

  const e = _ref6[0];
  const t = _ref6[1];
  void 0 === tableByCode[t] && (tableByCode[t] = e);
}

var print = Object.freeze(tableByCode);

function addPrefix(e, t) {
  let o;
  if (e instanceof Uint8Array) o = util$2.varintUint8ArrayEncode(e);else {
    if (!varintTable_1[e]) throw new Error("multicodec not recognized");
    o = varintTable_1[e];
  }
  return concat_1$1([o, t], o.length + t.length);
}

function rmPrefix(e) {
  return varint.decode(e), e.slice(varint.decode.bytes);
}

function getCodec$2(e) {
  const t = varint.decode(e),
        o = intTable.get(t);
  if (void 0 === o) throw new Error("Code ".concat(t, " not found"));
  return o;
}

function getName(e) {
  return intTable.get(e);
}

function getNumber(e) {
  const t = varintTable_1[e];
  if (void 0 === t) throw new Error("Codec `" + e + "` not found");
  return varint.decode(t);
}

function getCode(e) {
  return varint.decode(e);
}

function getCodeVarint(e) {
  const t = varintTable_1[e];
  if (void 0 === t) throw new Error("Codec `" + e + "` not found");
  return t;
}

function getVarint(e) {
  return varint.encode(e);
}

var src$4 = _objectSpread({
  addPrefix: addPrefix,
  rmPrefix: rmPrefix,
  getCodec: getCodec$2,
  getName: getName,
  getNumber: getNumber,
  getCode: getCode,
  getCodeVarint: getCodeVarint,
  getVarint: getVarint,
  print: print
}, constants_1$1);

const CIDUtil = {
  checkCIDComponents: function checkCIDComponents(e) {
    if (null == e) return "null values are not valid CIDs";
    if (0 !== e.version && 1 !== e.version) return "Invalid version, must be a number equal to 1 or 0";
    if ("string" != typeof e.codec) return "codec must be string";

    if (0 === e.version) {
      if ("dag-pb" !== e.codec) return "codec must be 'dag-pb' for CIDv0";
      if ("base58btc" !== e.multibaseName) return "multibaseName must be 'base58btc' for CIDv0";
    }

    if (!(e.multihash instanceof Uint8Array)) return "multihash must be a Uint8Array";

    try {
      src$3.validate(e.multihash);
    } catch (e) {
      let t = e.message;
      return t || (t = "Multihash validation failed"), t;
    }
  }
};
var cidUtil = CIDUtil;

function equals(e, t) {
  if (e === t) return !0;
  if (e.byteLength !== t.byteLength) return !1;

  for (let o = 0; o < e.byteLength; o++) if (e[o] !== t[o]) return !1;

  return !0;
}

var equals_1 = equals;
const codecs = baseTable_1.baseTable,
      codecInts = Object.keys(codecs).reduce((e, t) => (e[codecs[t]] = t, e), {}),
      symbol = Symbol.for("@ipld/js-cid/CID");

class CID {
  constructor(e, t, o, r) {
    if (this.version, this.codec, this.multihash, Object.defineProperty(this, symbol, {
      value: !0
    }), CID.isCID(e)) {
      const t = e;
      return this.version = t.version, this.codec = t.codec, this.multihash = t.multihash, void (this.multibaseName = t.multibaseName || (0 === t.version ? "base58btc" : "base32"));
    }

    if ("string" == typeof e) {
      const t = src$2.isEncoded(e);

      if (t) {
        const o = src$2.decode(e);
        this.version = parseInt(o[0].toString(), 16), this.codec = src$4.getCodec(o.slice(1)), this.multihash = src$4.rmPrefix(o.slice(1)), this.multibaseName = t;
      } else this.version = 0, this.codec = "dag-pb", this.multihash = src$3.fromB58String(e), this.multibaseName = "base58btc";

      return CID.validateCID(this), void Object.defineProperty(this, "string", {
        value: e
      });
    }

    if (e instanceof Uint8Array) {
      const t = parseInt(e[0].toString(), 16);

      if (1 === t) {
        const o = e;
        this.version = t, this.codec = src$4.getCodec(o.slice(1)), this.multihash = src$4.rmPrefix(o.slice(1)), this.multibaseName = "base32";
      } else this.version = 0, this.codec = "dag-pb", this.multihash = e, this.multibaseName = "base58btc";

      CID.validateCID(this);
    } else this.version = e, "number" == typeof t && (t = codecInts[t]), this.codec = t, this.multihash = o, this.multibaseName = r || (0 === e ? "base58btc" : "base32"), CID.validateCID(this);
  }

  get bytes() {
    let e = this._bytes;

    if (!e) {
      if (0 === this.version) e = this.multihash;else {
        if (1 !== this.version) throw new Error("unsupported version");
        {
          const t = src$4.getCodeVarint(this.codec);
          e = concat_1([[1], t, this.multihash], 1 + t.byteLength + this.multihash.byteLength);
        }
      }
      Object.defineProperty(this, "_bytes", {
        value: e
      });
    }

    return e;
  }

  get prefix() {
    const e = src$4.getCodeVarint(this.codec),
          t = src$3.prefix(this.multihash);
    return concat_1([[this.version], e, t], 1 + e.byteLength + t.byteLength);
  }

  get code() {
    return codecs[this.codec];
  }

  toV0() {
    if ("dag-pb" !== this.codec) throw new Error("Cannot convert a non dag-pb CID to CIDv0");

    const _src$3$decode = src$3.decode(this.multihash),
          e = _src$3$decode.name,
          t = _src$3$decode.length;

    if ("sha2-256" !== e) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
    if (32 !== t) throw new Error("Cannot convert non 32 byte multihash CID to CIDv0");
    return new CID(0, this.codec, this.multihash);
  }

  toV1() {
    return new CID(1, this.codec, this.multihash);
  }

  toBaseEncodedString(e = this.multibaseName) {
    if (this.string && 0 !== this.string.length && e === this.multibaseName) return this.string;
    let t;

    if (0 === this.version) {
      if ("base58btc" !== e) throw new Error("not supported with CIDv0, to support different bases, please migrate the instance do CIDv1, you can do that through cid.toV1()");
      t = src$3.toB58String(this.multihash);
    } else {
      if (1 !== this.version) throw new Error("unsupported version");
      t = toString_1(src$2.encode(e, this.bytes));
    }

    return e === this.multibaseName && Object.defineProperty(this, "string", {
      value: t
    }), t;
  }

  [Symbol.for("nodejs.util.inspect.custom")]() {
    return "CID(" + this.toString() + ")";
  }

  toString(e) {
    return this.toBaseEncodedString(e);
  }

  toJSON() {
    return {
      codec: this.codec,
      version: this.version,
      hash: this.multihash
    };
  }

  equals(e) {
    return this.codec === e.codec && this.version === e.version && equals_1(this.multihash, e.multihash);
  }

  static validateCID(e) {
    const t = cidUtil.checkCIDComponents(e);
    if (t) throw new Error(t);
  }

  static isCID(e) {
    return e instanceof CID || Boolean(e && e[symbol]);
  }

}

CID.codecs = codecs;
var src$5 = CID;

const drain = async e => {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;

  var _iteratorError;

  try {
    for (var _iterator = _asyncIterator(e), _step, _value; _step = await _iterator.next(), _iteratorNormalCompletion = _step.done, _value = await _step.value, !_iteratorNormalCompletion; _iteratorNormalCompletion = true) {
      const t = _value;
      ;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        await _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var itDrain = drain;

class EventIterator {
  constructor(e, t, o = {}) {
    this.listen = e, this.remove = t, this.options = Object.assign({
      highWaterMark: 100
    }, o), Object.freeze(this);
  }

  [Symbol.asyncIterator]() {
    let e;

    const t = [],
          o = this.listen,
          r = this.remove,
          s = o => {
      const r = {
        value: o,
        done: !1
      };
      if (e) e.resolve(r), e = void 0;else {
        t.push(Promise.resolve(r));
        const e = this.options.highWaterMark;
        void 0 !== e && t.length >= e && console && console.warn("EventIterator queue reached ".concat(t.length, " items"));
      }
    },
          n = () => {
      r && r(s, n, i);
      const o = {
        done: !0
      };
      e ? (e.resolve(o), e = void 0) : t.push(Promise.resolve(o));
    },
          i = o => {
      if (r && r(s, n, i), e) e.reject(o), e = void 0;else {
        const e = Promise.reject(o);
        e.catch(() => {}), t.push(e);
      }
    };

    return o(s, n, i), {
      next: o => t.length ? t.shift() : new Promise((t, o) => {
        e = {
          resolve: t,
          reject: o
        };
      }),
      return: () => (r && r(s, n, i), Promise.resolve({
        done: !0
      }))
    };
  }

}

var EventIterator_1 = EventIterator,
    _default$1 = EventIterator,
    eventIterator = Object.defineProperty({
  EventIterator: EventIterator_1,
  default: _default$1
}, "__esModule", {
  value: !0
}),
    EventIterator$1 = eventIterator.EventIterator;

function subscribe(e, t, o) {
  return new eventIterator.EventIterator(o => {
    this.addEventListener(e, o, t);
  }, o => {
    this.removeEventListener(e, o, t);
  }, o);
}

var subscribe_1 = subscribe,
    _default$2 = eventIterator.EventIterator,
    dom = Object.defineProperty({
  EventIterator: EventIterator$1,
  subscribe: subscribe_1,
  default: _default$2
}, "__esModule", {
  value: !0
});
const EventIterator$2 = dom.EventIterator;

class MultiResolver {
  add(e, t) {
    return Promise.resolve(e).then(e => {
      this.onResolve && this.onResolve({
        result: e,
        id: t
      });
    }).catch(e => {
      this.onReject && this.onReject({
        error: e,
        id: t
      });
    }), this;
  }

}

class UnorderedMultiResolver {
  constructor() {
    this._length = 0, this._onResolve = this._onResolve.bind(this), this._onReject = this._onReject.bind(this);
    const e = new MultiResolver();
    e.onResolve = this._onResolve, e.onReject = this._onReject, this._resolver = e;
  }

  _onResolve({
    result: e
  }) {
    this._length--, this.onResolve && this.onResolve(e), !this._length && this.onDrain && this.onDrain();
  }

  _onReject({
    error: e,
    id: t
  }) {
    this.destroy(), this.onReject && this.onReject(e);
  }

  add(e) {
    return this._length++, this._resolver.add(e), this;
  }

  get length() {
    return this._length;
  }

  error(e) {
    return this.destroy(), this.onError && this.onError(e), this;
  }

  end() {
    return this.destroy(), this.onEnd && this.onEnd(), this;
  }

  destroy() {
    this._resolver.onResolve = null, this._resolver.onReject = null, this._resolver = null, this._length = 0;
  }

}

class OrderedMultiResolver {
  constructor() {
    this._nextId = 0, this._promises = [], this._onResolve = this._onResolve.bind(this), this._onReject = this._onReject.bind(this);
    const e = new MultiResolver();
    e.onResolve = this._onResolve, e.onReject = this._onReject, this._resolver = e;
  }

  _onResolve({
    result: e,
    id: t
  }) {
    if (this._promises[0].id === t) {
      for (this._promises.shift(), this.onResolve && this.onResolve(e); this._promises.length && this._promises[0].result;) {
        const _this$_promises$shift = this._promises.shift(),
              e = _this$_promises$shift.result;

        this.onResolve && this.onResolve(e);
      }

      !this._promises.length && this.onDrain && this.onDrain();
    } else for (var o = 0; o < this._promises.length; o++) if (this._promises[o].id === t) {
      this._promises[o].result = e;
      break;
    }
  }

  _onReject({
    error: e,
    id: t
  }) {
    this.destroy(), this.onReject && this.onReject(e);
  }

  add(e) {
    return this._promises.push({
      promise: e,
      id: this._nextId
    }), this._resolver.add(e, this._nextId), this._nextId++, this;
  }

  get length() {
    return this._promises.length;
  }

  error(e) {
    return this.destroy(), this.onError && this.onError(e), this;
  }

  end() {
    return this.destroy(), this.onEnd && this.onEnd(), this;
  }

  destroy() {
    this._resolver.onResolve = null, this._resolver.onReject = null, this._resolver = null, this._promises = null;
  }

}

function paramap(e, t, o) {
  return _wrapAsyncGenerator(function* () {
    (o = o || {}).ordered = null == o.ordered || o.ordered;
    const r = o.ordered ? new OrderedMultiResolver() : new UnorderedMultiResolver();
    const s = new EventIterator$2((e, t, o) => {
      r.onResolve = e, r.onReject = o, r.onError = o, r.onEnd = t;
    }, (e, t, o) => {
      r.onResolve = null, r.onReject = null, r.onError = null, r.onEnd = null;
    });
    !async function () {
      try {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;

        var _iteratorError3;

        try {
          for (var _iterator3 = _asyncIterator(e), _step3, _value3; _step3 = await _iterator3.next(), _iteratorNormalCompletion3 = _step3.done, _value3 = await _step3.value, !_iteratorNormalCompletion3; _iteratorNormalCompletion3 = true) {
            const o = _value3;
            r.add(t(o));
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              await _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } catch (e) {
        return r.error(e);
      }

      r.length && (await new Promise(e => {
        r.onDrain = e;
      })), r.end();
    }();
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;

    var _iteratorError2;

    try {
      for (var _iterator2 = _asyncIterator(s), _step2, _value2; _step2 = yield _awaitAsyncGenerator(_iterator2.next()), _iteratorNormalCompletion2 = _step2.done, _value2 = yield _awaitAsyncGenerator(_step2.value), !_iteratorNormalCompletion2; _iteratorNormalCompletion2 = true) {
        const e = _value2;
        yield e;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          yield _awaitAsyncGenerator(_iterator2.return());
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  })();
}

var paramapIt = paramap;
const AbortError = new Error("aborted");
var PathAccessRole, ArchiveStatus;
!function (e) {
  e[e.PATH_ACCESS_ROLE_UNSPECIFIED = 0] = "PATH_ACCESS_ROLE_UNSPECIFIED", e[e.PATH_ACCESS_ROLE_READER = 1] = "PATH_ACCESS_ROLE_READER", e[e.PATH_ACCESS_ROLE_WRITER = 2] = "PATH_ACCESS_ROLE_WRITER", e[e.PATH_ACCESS_ROLE_ADMIN = 3] = "PATH_ACCESS_ROLE_ADMIN";
}(PathAccessRole || (PathAccessRole = {})), function (e) {
  e[e.Unspecified = 0] = "Unspecified", e[e.Queued = 1] = "Queued", e[e.Executing = 2] = "Executing", e[e.Failed = 3] = "Failed", e[e.Canceled = 4] = "Canceled", e[e.Success = 5] = "Success";
}(ArchiveStatus || (ArchiveStatus = {}));

for (var byteLength_1 = byteLength, toByteArray_1 = toByteArray, fromByteArray_1 = fromByteArray, lookup = [], revLookup = [], Arr = "undefined" != typeof Uint8Array ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, len = code.length; i < len; ++i) lookup[i] = code[i], revLookup[code.charCodeAt(i)] = i;

function getLens(e) {
  var t = e.length;
  if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var o = e.indexOf("=");
  return -1 === o && (o = t), [o, o === t ? 0 : 4 - o % 4];
}

function byteLength(e) {
  var t = getLens(e),
      o = t[0],
      r = t[1];
  return 3 * (o + r) / 4 - r;
}

function _byteLength(e, t, o) {
  return 3 * (t + o) / 4 - o;
}

function toByteArray(e) {
  var t,
      o,
      r = getLens(e),
      s = r[0],
      n = r[1],
      i = new Arr(_byteLength(e, s, n)),
      a = 0,
      u = n > 0 ? s - 4 : s;

  for (o = 0; o < u; o += 4) t = revLookup[e.charCodeAt(o)] << 18 | revLookup[e.charCodeAt(o + 1)] << 12 | revLookup[e.charCodeAt(o + 2)] << 6 | revLookup[e.charCodeAt(o + 3)], i[a++] = t >> 16 & 255, i[a++] = t >> 8 & 255, i[a++] = 255 & t;

  return 2 === n && (t = revLookup[e.charCodeAt(o)] << 2 | revLookup[e.charCodeAt(o + 1)] >> 4, i[a++] = 255 & t), 1 === n && (t = revLookup[e.charCodeAt(o)] << 10 | revLookup[e.charCodeAt(o + 1)] << 4 | revLookup[e.charCodeAt(o + 2)] >> 2, i[a++] = t >> 8 & 255, i[a++] = 255 & t), i;
}

function tripletToBase64(e) {
  return lookup[e >> 18 & 63] + lookup[e >> 12 & 63] + lookup[e >> 6 & 63] + lookup[63 & e];
}

function encodeChunk(e, t, o) {
  for (var r, s = [], n = t; n < o; n += 3) r = (e[n] << 16 & 16711680) + (e[n + 1] << 8 & 65280) + (255 & e[n + 2]), s.push(tripletToBase64(r));

  return s.join("");
}

function fromByteArray(e) {
  for (var t, o = e.length, r = o % 3, s = [], n = 16383, i = 0, a = o - r; i < a; i += n) s.push(encodeChunk(e, i, i + n > a ? a : i + n));

  return 1 === r ? (t = e[o - 1], s.push(lookup[t >> 2] + lookup[t << 4 & 63] + "==")) : 2 === r && (t = (e[o - 2] << 8) + e[o - 1], s.push(lookup[t >> 10] + lookup[t >> 4 & 63] + lookup[t << 2 & 63] + "=")), s.join("");
}

revLookup["-".charCodeAt(0)] = 62, revLookup["_".charCodeAt(0)] = 63;

var base64Js = {
  byteLength: byteLength_1,
  toByteArray: toByteArray_1,
  fromByteArray: fromByteArray_1
},
    read$1 = function read$1(e, t, o, r, s) {
  var n,
      i,
      a = 8 * s - r - 1,
      u = (1 << a) - 1,
      g = u >> 1,
      p = -7,
      l = o ? s - 1 : 0,
      c = o ? -1 : 1,
      d = e[t + l];

  for (l += c, n = d & (1 << -p) - 1, d >>= -p, p += a; p > 0; n = 256 * n + e[t + l], l += c, p -= 8);

  for (i = n & (1 << -p) - 1, n >>= -p, p += r; p > 0; i = 256 * i + e[t + l], l += c, p -= 8);

  if (0 === n) n = 1 - g;else {
    if (n === u) return i ? NaN : 1 / 0 * (d ? -1 : 1);
    i += Math.pow(2, r), n -= g;
  }
  return (d ? -1 : 1) * i * Math.pow(2, n - r);
},
    write = function write(e, t, o, r, s, n) {
  var i,
      a,
      u,
      g = 8 * n - s - 1,
      p = (1 << g) - 1,
      l = p >> 1,
      c = 23 === s ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
      d = r ? 0 : n - 1,
      f = r ? 1 : -1,
      b = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, i = p) : (i = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -i)) < 1 && (i--, u *= 2), (t += i + l >= 1 ? c / u : c * Math.pow(2, 1 - l)) * u >= 2 && (i++, u /= 2), i + l >= p ? (a = 0, i = p) : i + l >= 1 ? (a = (t * u - 1) * Math.pow(2, s), i += l) : (a = t * Math.pow(2, l - 1) * Math.pow(2, s), i = 0)); s >= 8; e[o + d] = 255 & a, d += f, a /= 256, s -= 8);

  for (i = i << s | a, g += s; g > 0; e[o + d] = 255 & i, d += f, i /= 256, g -= 8);

  e[o + d - f] |= 128 * b;
},
    ieee754 = {
  read: read$1,
  write: write
},
    buffer = createCommonjsModule(function (e, t) {
  var o = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = n, t.SlowBuffer = function (e) {
    +e != e && (e = 0);
    return n.alloc(+e);
  }, t.INSPECT_MAX_BYTES = 50;
  var r = 2147483647;

  function s(e) {
    if (e > r) throw new RangeError('The value "' + e + '" is invalid for option "size"');
    var t = new Uint8Array(e);
    return Object.setPrototypeOf(t, n.prototype), t;
  }

  function n(e, t, o) {
    if ("number" == typeof e) {
      if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
      return u(e);
    }

    return i(e, t, o);
  }

  function i(e, t, o) {
    if ("string" == typeof e) return function (e, t) {
      "string" == typeof t && "" !== t || (t = "utf8");
      if (!n.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
      var o = 0 | c(e, t),
          r = s(o),
          i = r.write(e, t);
      i !== o && (r = r.slice(0, i));
      return r;
    }(e, t);
    if (ArrayBuffer.isView(e)) return g(e);
    if (null == e) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
    if (L(e, ArrayBuffer) || e && L(e.buffer, ArrayBuffer)) return p(e, t, o);
    if ("undefined" != typeof SharedArrayBuffer && (L(e, SharedArrayBuffer) || e && L(e.buffer, SharedArrayBuffer))) return p(e, t, o);
    if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
    var r = e.valueOf && e.valueOf();
    if (null != r && r !== e) return n.from(r, t, o);

    var i = function (e) {
      if (n.isBuffer(e)) {
        var t = 0 | l(e.length),
            o = s(t);
        return 0 === o.length || e.copy(o, 0, 0, t), o;
      }

      if (void 0 !== e.length) return "number" != typeof e.length || W(e.length) ? s(0) : g(e);
      if ("Buffer" === e.type && Array.isArray(e.data)) return g(e.data);
    }(e);

    if (i) return i;
    if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return n.from(e[Symbol.toPrimitive]("string"), t, o);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
  }

  function a(e) {
    if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
    if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
  }

  function u(e) {
    return a(e), s(e < 0 ? 0 : 0 | l(e));
  }

  function g(e) {
    for (var t = e.length < 0 ? 0 : 0 | l(e.length), o = s(t), r = 0; r < t; r += 1) o[r] = 255 & e[r];

    return o;
  }

  function p(e, t, o) {
    if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
    if (e.byteLength < t + (o || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var r;
    return r = void 0 === t && void 0 === o ? new Uint8Array(e) : void 0 === o ? new Uint8Array(e, t) : new Uint8Array(e, t, o), Object.setPrototypeOf(r, n.prototype), r;
  }

  function l(e) {
    if (e >= r) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + r.toString(16) + " bytes");
    return 0 | e;
  }

  function c(e, t) {
    if (n.isBuffer(e)) return e.length;
    if (ArrayBuffer.isView(e) || L(e, ArrayBuffer)) return e.byteLength;
    if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
    var o = e.length,
        r = arguments.length > 2 && !0 === arguments[2];
    if (!r && 0 === o) return 0;

    for (var s = !1;;) switch (t) {
      case "ascii":
      case "latin1":
      case "binary":
        return o;

      case "utf8":
      case "utf-8":
        return N(e).length;

      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return 2 * o;

      case "hex":
        return o >>> 1;

      case "base64":
        return D(e).length;

      default:
        if (s) return r ? -1 : N(e).length;
        t = ("" + t).toLowerCase(), s = !0;
    }
  }

  function d(e, t, o) {
    var r = !1;
    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
    if ((void 0 === o || o > this.length) && (o = this.length), o <= 0) return "";
    if ((o >>>= 0) <= (t >>>= 0)) return "";

    for (e || (e = "utf8");;) switch (e) {
      case "hex":
        return w(this, t, o);

      case "utf8":
      case "utf-8":
        return k(this, t, o);

      case "ascii":
        return E(this, t, o);

      case "latin1":
      case "binary":
        return T(this, t, o);

      case "base64":
        return S(this, t, o);

      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return M(this, t, o);

      default:
        if (r) throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), r = !0;
    }
  }

  function f(e, t, o) {
    var r = e[t];
    e[t] = e[o], e[o] = r;
  }

  function b(e, t, o, r, s) {
    if (0 === e.length) return -1;

    if ("string" == typeof o ? (r = o, o = 0) : o > 2147483647 ? o = 2147483647 : o < -2147483648 && (o = -2147483648), W(o = +o) && (o = s ? 0 : e.length - 1), o < 0 && (o = e.length + o), o >= e.length) {
      if (s) return -1;
      o = e.length - 1;
    } else if (o < 0) {
      if (!s) return -1;
      o = 0;
    }

    if ("string" == typeof t && (t = n.from(t, r)), n.isBuffer(t)) return 0 === t.length ? -1 : h(e, t, o, r, s);
    if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? s ? Uint8Array.prototype.indexOf.call(e, t, o) : Uint8Array.prototype.lastIndexOf.call(e, t, o) : h(e, [t], o, r, s);
    throw new TypeError("val must be string, number or Buffer");
  }

  function h(e, t, o, r, s) {
    var n,
        i = 1,
        a = e.length,
        u = t.length;

    if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
      if (e.length < 2 || t.length < 2) return -1;
      i = 2, a /= 2, u /= 2, o /= 2;
    }

    function g(e, t) {
      return 1 === i ? e[t] : e.readUInt16BE(t * i);
    }

    if (s) {
      var p = -1;

      for (n = o; n < a; n++) if (g(e, n) === g(t, -1 === p ? 0 : n - p)) {
        if (-1 === p && (p = n), n - p + 1 === u) return p * i;
      } else -1 !== p && (n -= n - p), p = -1;
    } else for (o + u > a && (o = a - u), n = o; n >= 0; n--) {
      for (var l = !0, c = 0; c < u; c++) if (g(e, n + c) !== g(t, c)) {
        l = !1;
        break;
      }

      if (l) return n;
    }

    return -1;
  }

  function y(e, t, o, r) {
    o = Number(o) || 0;
    var s = e.length - o;
    r ? (r = Number(r)) > s && (r = s) : r = s;
    var n = t.length;
    r > n / 2 && (r = n / 2);

    for (var i = 0; i < r; ++i) {
      var a = parseInt(t.substr(2 * i, 2), 16);
      if (W(a)) return i;
      e[o + i] = a;
    }

    return i;
  }

  function m(e, t, o, r) {
    return U(N(t, e.length - o), e, o, r);
  }

  function _(e, t, o, r) {
    return U(function (e) {
      for (var t = [], o = 0; o < e.length; ++o) t.push(255 & e.charCodeAt(o));

      return t;
    }(t), e, o, r);
  }

  function v(e, t, o, r) {
    return _(e, t, o, r);
  }

  function R(e, t, o, r) {
    return U(D(t), e, o, r);
  }

  function P(e, t, o, r) {
    return U(function (e, t) {
      for (var o, r, s, n = [], i = 0; i < e.length && !((t -= 2) < 0); ++i) r = (o = e.charCodeAt(i)) >> 8, s = o % 256, n.push(s), n.push(r);

      return n;
    }(t, e.length - o), e, o, r);
  }

  function S(e, t, o) {
    return 0 === t && o === e.length ? base64Js.fromByteArray(e) : base64Js.fromByteArray(e.slice(t, o));
  }

  function k(e, t, o) {
    o = Math.min(e.length, o);

    for (var r = [], s = t; s < o;) {
      var n,
          i,
          a,
          u,
          g = e[s],
          p = null,
          l = g > 239 ? 4 : g > 223 ? 3 : g > 191 ? 2 : 1;
      if (s + l <= o) switch (l) {
        case 1:
          g < 128 && (p = g);
          break;

        case 2:
          128 == (192 & (n = e[s + 1])) && (u = (31 & g) << 6 | 63 & n) > 127 && (p = u);
          break;

        case 3:
          n = e[s + 1], i = e[s + 2], 128 == (192 & n) && 128 == (192 & i) && (u = (15 & g) << 12 | (63 & n) << 6 | 63 & i) > 2047 && (u < 55296 || u > 57343) && (p = u);
          break;

        case 4:
          n = e[s + 1], i = e[s + 2], a = e[s + 3], 128 == (192 & n) && 128 == (192 & i) && 128 == (192 & a) && (u = (15 & g) << 18 | (63 & n) << 12 | (63 & i) << 6 | 63 & a) > 65535 && u < 1114112 && (p = u);
      }
      null === p ? (p = 65533, l = 1) : p > 65535 && (p -= 65536, r.push(p >>> 10 & 1023 | 55296), p = 56320 | 1023 & p), r.push(p), s += l;
    }

    return function (e) {
      var t = e.length;
      if (t <= A) return String.fromCharCode.apply(String, e);
      var o = "",
          r = 0;

      for (; r < t;) o += String.fromCharCode.apply(String, e.slice(r, r += A));

      return o;
    }(r);
  }

  t.kMaxLength = r, n.TYPED_ARRAY_SUPPORT = function () {
    try {
      var e = new Uint8Array(1),
          t = {
        foo: function foo() {
          return 42;
        }
      };
      return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e, t), 42 === e.foo();
    } catch (e) {
      return !1;
    }
  }(), n.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(n.prototype, "parent", {
    enumerable: !0,
    get: function get() {
      if (n.isBuffer(this)) return this.buffer;
    }
  }), Object.defineProperty(n.prototype, "offset", {
    enumerable: !0,
    get: function get() {
      if (n.isBuffer(this)) return this.byteOffset;
    }
  }), n.poolSize = 8192, n.from = function (e, t, o) {
    return i(e, t, o);
  }, Object.setPrototypeOf(n.prototype, Uint8Array.prototype), Object.setPrototypeOf(n, Uint8Array), n.alloc = function (e, t, o) {
    return function (e, t, o) {
      return a(e), e <= 0 ? s(e) : void 0 !== t ? "string" == typeof o ? s(e).fill(t, o) : s(e).fill(t) : s(e);
    }(e, t, o);
  }, n.allocUnsafe = function (e) {
    return u(e);
  }, n.allocUnsafeSlow = function (e) {
    return u(e);
  }, n.isBuffer = function (e) {
    return null != e && !0 === e._isBuffer && e !== n.prototype;
  }, n.compare = function (e, t) {
    if (L(e, Uint8Array) && (e = n.from(e, e.offset, e.byteLength)), L(t, Uint8Array) && (t = n.from(t, t.offset, t.byteLength)), !n.isBuffer(e) || !n.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (e === t) return 0;

    for (var o = e.length, r = t.length, s = 0, i = Math.min(o, r); s < i; ++s) if (e[s] !== t[s]) {
      o = e[s], r = t[s];
      break;
    }

    return o < r ? -1 : r < o ? 1 : 0;
  }, n.isEncoding = function (e) {
    switch (String(e).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;

      default:
        return !1;
    }
  }, n.concat = function (e, t) {
    if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === e.length) return n.alloc(0);
    var o;
    if (void 0 === t) for (t = 0, o = 0; o < e.length; ++o) t += e[o].length;
    var r = n.allocUnsafe(t),
        s = 0;

    for (o = 0; o < e.length; ++o) {
      var i = e[o];
      if (L(i, Uint8Array) && (i = n.from(i)), !n.isBuffer(i)) throw new TypeError('"list" argument must be an Array of Buffers');
      i.copy(r, s), s += i.length;
    }

    return r;
  }, n.byteLength = c, n.prototype._isBuffer = !0, n.prototype.swap16 = function () {
    var e = this.length;
    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

    for (var t = 0; t < e; t += 2) f(this, t, t + 1);

    return this;
  }, n.prototype.swap32 = function () {
    var e = this.length;
    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

    for (var t = 0; t < e; t += 4) f(this, t, t + 3), f(this, t + 1, t + 2);

    return this;
  }, n.prototype.swap64 = function () {
    var e = this.length;
    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

    for (var t = 0; t < e; t += 8) f(this, t, t + 7), f(this, t + 1, t + 6), f(this, t + 2, t + 5), f(this, t + 3, t + 4);

    return this;
  }, n.prototype.toString = function () {
    var e = this.length;
    return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : d.apply(this, arguments);
  }, n.prototype.toLocaleString = n.prototype.toString, n.prototype.equals = function (e) {
    if (!n.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
    return this === e || 0 === n.compare(this, e);
  }, n.prototype.inspect = function () {
    var e = "",
        o = t.INSPECT_MAX_BYTES;
    return e = this.toString("hex", 0, o).replace(/(.{2})/g, "$1 ").trim(), this.length > o && (e += " ... "), "<Buffer " + e + ">";
  }, o && (n.prototype[o] = n.prototype.inspect), n.prototype.compare = function (e, t, o, r, s) {
    if (L(e, Uint8Array) && (e = n.from(e, e.offset, e.byteLength)), !n.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
    if (void 0 === t && (t = 0), void 0 === o && (o = e ? e.length : 0), void 0 === r && (r = 0), void 0 === s && (s = this.length), t < 0 || o > e.length || r < 0 || s > this.length) throw new RangeError("out of range index");
    if (r >= s && t >= o) return 0;
    if (r >= s) return -1;
    if (t >= o) return 1;
    if (this === e) return 0;

    for (var i = (s >>>= 0) - (r >>>= 0), a = (o >>>= 0) - (t >>>= 0), u = Math.min(i, a), g = this.slice(r, s), p = e.slice(t, o), l = 0; l < u; ++l) if (g[l] !== p[l]) {
      i = g[l], a = p[l];
      break;
    }

    return i < a ? -1 : a < i ? 1 : 0;
  }, n.prototype.includes = function (e, t, o) {
    return -1 !== this.indexOf(e, t, o);
  }, n.prototype.indexOf = function (e, t, o) {
    return b(this, e, t, o, !0);
  }, n.prototype.lastIndexOf = function (e, t, o) {
    return b(this, e, t, o, !1);
  }, n.prototype.write = function (e, t, o, r) {
    if (void 0 === t) r = "utf8", o = this.length, t = 0;else if (void 0 === o && "string" == typeof t) r = t, o = this.length, t = 0;else {
      if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      t >>>= 0, isFinite(o) ? (o >>>= 0, void 0 === r && (r = "utf8")) : (r = o, o = void 0);
    }
    var s = this.length - t;
    if ((void 0 === o || o > s) && (o = s), e.length > 0 && (o < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    r || (r = "utf8");

    for (var n = !1;;) switch (r) {
      case "hex":
        return y(this, e, t, o);

      case "utf8":
      case "utf-8":
        return m(this, e, t, o);

      case "ascii":
        return _(this, e, t, o);

      case "latin1":
      case "binary":
        return v(this, e, t, o);

      case "base64":
        return R(this, e, t, o);

      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return P(this, e, t, o);

      default:
        if (n) throw new TypeError("Unknown encoding: " + r);
        r = ("" + r).toLowerCase(), n = !0;
    }
  }, n.prototype.toJSON = function () {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  var A = 4096;

  function E(e, t, o) {
    var r = "";
    o = Math.min(e.length, o);

    for (var s = t; s < o; ++s) r += String.fromCharCode(127 & e[s]);

    return r;
  }

  function T(e, t, o) {
    var r = "";
    o = Math.min(e.length, o);

    for (var s = t; s < o; ++s) r += String.fromCharCode(e[s]);

    return r;
  }

  function w(e, t, o) {
    var r = e.length;
    (!t || t < 0) && (t = 0), (!o || o < 0 || o > r) && (o = r);

    for (var s = "", n = t; n < o; ++n) s += x[e[n]];

    return s;
  }

  function M(e, t, o) {
    for (var r = e.slice(t, o), s = "", n = 0; n < r.length; n += 2) s += String.fromCharCode(r[n] + 256 * r[n + 1]);

    return s;
  }

  function I(e, t, o) {
    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
    if (e + t > o) throw new RangeError("Trying to access beyond buffer length");
  }

  function C(e, t, o, r, s, i) {
    if (!n.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (t > s || t < i) throw new RangeError('"value" argument is out of bounds');
    if (o + r > e.length) throw new RangeError("Index out of range");
  }

  function O(e, t, o, r, s, n) {
    if (o + r > e.length) throw new RangeError("Index out of range");
    if (o < 0) throw new RangeError("Index out of range");
  }

  function B(e, t, o, r, s) {
    return t = +t, o >>>= 0, s || O(e, 0, o, 4), ieee754.write(e, t, o, r, 23, 4), o + 4;
  }

  function j(e, t, o, r, s) {
    return t = +t, o >>>= 0, s || O(e, 0, o, 8), ieee754.write(e, t, o, r, 52, 8), o + 8;
  }

  n.prototype.slice = function (e, t) {
    var o = this.length;
    (e = ~~e) < 0 ? (e += o) < 0 && (e = 0) : e > o && (e = o), (t = void 0 === t ? o : ~~t) < 0 ? (t += o) < 0 && (t = 0) : t > o && (t = o), t < e && (t = e);
    var r = this.subarray(e, t);
    return Object.setPrototypeOf(r, n.prototype), r;
  }, n.prototype.readUIntLE = function (e, t, o) {
    e >>>= 0, t >>>= 0, o || I(e, t, this.length);

    for (var r = this[e], s = 1, n = 0; ++n < t && (s *= 256);) r += this[e + n] * s;

    return r;
  }, n.prototype.readUIntBE = function (e, t, o) {
    e >>>= 0, t >>>= 0, o || I(e, t, this.length);

    for (var r = this[e + --t], s = 1; t > 0 && (s *= 256);) r += this[e + --t] * s;

    return r;
  }, n.prototype.readUInt8 = function (e, t) {
    return e >>>= 0, t || I(e, 1, this.length), this[e];
  }, n.prototype.readUInt16LE = function (e, t) {
    return e >>>= 0, t || I(e, 2, this.length), this[e] | this[e + 1] << 8;
  }, n.prototype.readUInt16BE = function (e, t) {
    return e >>>= 0, t || I(e, 2, this.length), this[e] << 8 | this[e + 1];
  }, n.prototype.readUInt32LE = function (e, t) {
    return e >>>= 0, t || I(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
  }, n.prototype.readUInt32BE = function (e, t) {
    return e >>>= 0, t || I(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
  }, n.prototype.readIntLE = function (e, t, o) {
    e >>>= 0, t >>>= 0, o || I(e, t, this.length);

    for (var r = this[e], s = 1, n = 0; ++n < t && (s *= 256);) r += this[e + n] * s;

    return r >= (s *= 128) && (r -= Math.pow(2, 8 * t)), r;
  }, n.prototype.readIntBE = function (e, t, o) {
    e >>>= 0, t >>>= 0, o || I(e, t, this.length);

    for (var r = t, s = 1, n = this[e + --r]; r > 0 && (s *= 256);) n += this[e + --r] * s;

    return n >= (s *= 128) && (n -= Math.pow(2, 8 * t)), n;
  }, n.prototype.readInt8 = function (e, t) {
    return e >>>= 0, t || I(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
  }, n.prototype.readInt16LE = function (e, t) {
    e >>>= 0, t || I(e, 2, this.length);
    var o = this[e] | this[e + 1] << 8;
    return 32768 & o ? 4294901760 | o : o;
  }, n.prototype.readInt16BE = function (e, t) {
    e >>>= 0, t || I(e, 2, this.length);
    var o = this[e + 1] | this[e] << 8;
    return 32768 & o ? 4294901760 | o : o;
  }, n.prototype.readInt32LE = function (e, t) {
    return e >>>= 0, t || I(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
  }, n.prototype.readInt32BE = function (e, t) {
    return e >>>= 0, t || I(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
  }, n.prototype.readFloatLE = function (e, t) {
    return e >>>= 0, t || I(e, 4, this.length), ieee754.read(this, e, !0, 23, 4);
  }, n.prototype.readFloatBE = function (e, t) {
    return e >>>= 0, t || I(e, 4, this.length), ieee754.read(this, e, !1, 23, 4);
  }, n.prototype.readDoubleLE = function (e, t) {
    return e >>>= 0, t || I(e, 8, this.length), ieee754.read(this, e, !0, 52, 8);
  }, n.prototype.readDoubleBE = function (e, t) {
    return e >>>= 0, t || I(e, 8, this.length), ieee754.read(this, e, !1, 52, 8);
  }, n.prototype.writeUIntLE = function (e, t, o, r) {
    (e = +e, t >>>= 0, o >>>= 0, r) || C(this, e, t, o, Math.pow(2, 8 * o) - 1, 0);
    var s = 1,
        n = 0;

    for (this[t] = 255 & e; ++n < o && (s *= 256);) this[t + n] = e / s & 255;

    return t + o;
  }, n.prototype.writeUIntBE = function (e, t, o, r) {
    (e = +e, t >>>= 0, o >>>= 0, r) || C(this, e, t, o, Math.pow(2, 8 * o) - 1, 0);
    var s = o - 1,
        n = 1;

    for (this[t + s] = 255 & e; --s >= 0 && (n *= 256);) this[t + s] = e / n & 255;

    return t + o;
  }, n.prototype.writeUInt8 = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
  }, n.prototype.writeUInt16LE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
  }, n.prototype.writeUInt16BE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
  }, n.prototype.writeUInt32LE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
  }, n.prototype.writeUInt32BE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
  }, n.prototype.writeIntLE = function (e, t, o, r) {
    if (e = +e, t >>>= 0, !r) {
      var s = Math.pow(2, 8 * o - 1);
      C(this, e, t, o, s - 1, -s);
    }

    var n = 0,
        i = 1,
        a = 0;

    for (this[t] = 255 & e; ++n < o && (i *= 256);) e < 0 && 0 === a && 0 !== this[t + n - 1] && (a = 1), this[t + n] = (e / i >> 0) - a & 255;

    return t + o;
  }, n.prototype.writeIntBE = function (e, t, o, r) {
    if (e = +e, t >>>= 0, !r) {
      var s = Math.pow(2, 8 * o - 1);
      C(this, e, t, o, s - 1, -s);
    }

    var n = o - 1,
        i = 1,
        a = 0;

    for (this[t + n] = 255 & e; --n >= 0 && (i *= 256);) e < 0 && 0 === a && 0 !== this[t + n + 1] && (a = 1), this[t + n] = (e / i >> 0) - a & 255;

    return t + o;
  }, n.prototype.writeInt8 = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
  }, n.prototype.writeInt16LE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
  }, n.prototype.writeInt16BE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
  }, n.prototype.writeInt32LE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
  }, n.prototype.writeInt32BE = function (e, t, o) {
    return e = +e, t >>>= 0, o || C(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
  }, n.prototype.writeFloatLE = function (e, t, o) {
    return B(this, e, t, !0, o);
  }, n.prototype.writeFloatBE = function (e, t, o) {
    return B(this, e, t, !1, o);
  }, n.prototype.writeDoubleLE = function (e, t, o) {
    return j(this, e, t, !0, o);
  }, n.prototype.writeDoubleBE = function (e, t, o) {
    return j(this, e, t, !1, o);
  }, n.prototype.copy = function (e, t, o, r) {
    if (!n.isBuffer(e)) throw new TypeError("argument should be a Buffer");
    if (o || (o = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < o && (r = o), r === o) return 0;
    if (0 === e.length || 0 === this.length) return 0;
    if (t < 0) throw new RangeError("targetStart out of bounds");
    if (o < 0 || o >= this.length) throw new RangeError("Index out of range");
    if (r < 0) throw new RangeError("sourceEnd out of bounds");
    r > this.length && (r = this.length), e.length - t < r - o && (r = e.length - t + o);
    var s = r - o;
    if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, o, r);else if (this === e && o < t && t < r) for (var i = s - 1; i >= 0; --i) e[i + t] = this[i + o];else Uint8Array.prototype.set.call(e, this.subarray(o, r), t);
    return s;
  }, n.prototype.fill = function (e, t, o, r) {
    if ("string" == typeof e) {
      if ("string" == typeof t ? (r = t, t = 0, o = this.length) : "string" == typeof o && (r = o, o = this.length), void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
      if ("string" == typeof r && !n.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);

      if (1 === e.length) {
        var s = e.charCodeAt(0);
        ("utf8" === r && s < 128 || "latin1" === r) && (e = s);
      }
    } else "number" == typeof e ? e &= 255 : "boolean" == typeof e && (e = Number(e));

    if (t < 0 || this.length < t || this.length < o) throw new RangeError("Out of range index");
    if (o <= t) return this;
    var i;
    if (t >>>= 0, o = void 0 === o ? this.length : o >>> 0, e || (e = 0), "number" == typeof e) for (i = t; i < o; ++i) this[i] = e;else {
      var a = n.isBuffer(e) ? e : n.from(e, r),
          u = a.length;
      if (0 === u) throw new TypeError('The value "' + e + '" is invalid for argument "value"');

      for (i = 0; i < o - t; ++i) this[i + t] = a[i % u];
    }
    return this;
  };
  var F = /[^+/0-9A-Za-z-_]/g;

  function N(e, t) {
    var o;
    t = t || 1 / 0;

    for (var r = e.length, s = null, n = [], i = 0; i < r; ++i) {
      if ((o = e.charCodeAt(i)) > 55295 && o < 57344) {
        if (!s) {
          if (o > 56319) {
            (t -= 3) > -1 && n.push(239, 191, 189);
            continue;
          }

          if (i + 1 === r) {
            (t -= 3) > -1 && n.push(239, 191, 189);
            continue;
          }

          s = o;
          continue;
        }

        if (o < 56320) {
          (t -= 3) > -1 && n.push(239, 191, 189), s = o;
          continue;
        }

        o = 65536 + (s - 55296 << 10 | o - 56320);
      } else s && (t -= 3) > -1 && n.push(239, 191, 189);

      if (s = null, o < 128) {
        if ((t -= 1) < 0) break;
        n.push(o);
      } else if (o < 2048) {
        if ((t -= 2) < 0) break;
        n.push(o >> 6 | 192, 63 & o | 128);
      } else if (o < 65536) {
        if ((t -= 3) < 0) break;
        n.push(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128);
      } else {
        if (!(o < 1114112)) throw new Error("Invalid code point");
        if ((t -= 4) < 0) break;
        n.push(o >> 18 | 240, o >> 12 & 63 | 128, o >> 6 & 63 | 128, 63 & o | 128);
      }
    }

    return n;
  }

  function D(e) {
    return base64Js.toByteArray(function (e) {
      if ((e = (e = e.split("=")[0]).trim().replace(F, "")).length < 2) return "";

      for (; e.length % 4 != 0;) e += "=";

      return e;
    }(e));
  }

  function U(e, t, o, r) {
    for (var s = 0; s < r && !(s + o >= t.length || s >= e.length); ++s) t[s + o] = e[s];

    return s;
  }

  function L(e, t) {
    return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
  }

  function W(e) {
    return e != e;
  }

  var x = function () {
    for (var e = "0123456789abcdef", t = new Array(256), o = 0; o < 16; ++o) for (var r = 16 * o, s = 0; s < 16; ++s) t[r + s] = e[o] + e[s];

    return t;
  }();
});

function normaliseInput(e) {
  if (null == e) throw new Error("Unexpected input: ".concat(e));
  if ("string" == typeof e || e instanceof String) return function () {
    return __asyncGenerator(this, arguments, function* () {
      yield yield __await(toFileObject(e));
    });
  }();
  if (isBytes(e) || isBloby(e)) return function () {
    return __asyncGenerator(this, arguments, function* () {
      yield yield __await(toFileObject(e));
    });
  }();
  if (e[Symbol.iterator]) return function () {
    return __asyncGenerator(this, arguments, function* () {
      const t = e[Symbol.iterator](),
            o = t.next();
      if (o.done) return yield __await(t);
      if (Number.isInteger(o.value) || isBytes(o.value)) return yield yield __await(toFileObject(function* () {
        yield o.value, yield* t;
      }())), yield __await(void 0);

      if (isFileObject(o.value) || isBloby(o.value) || "string" == typeof o.value) {
        yield yield __await(toFileObject(o.value));

        for (const e of t) yield yield __await(toFileObject(e));

        return yield __await(void 0);
      }

      throw new Error("Unexpected input: " + typeof e);
    });
  }();
  if ("function" == typeof e.getReader) return function () {
    return __asyncGenerator(this, arguments, function* () {
      var t, o;

      try {
        for (var r, s = __asyncValues(browserStreamToIt(e)); !(r = yield __await(s.next())).done;) {
          const e = r.value;
          yield yield __await(toFileObject(e));
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (o = s.return) && (yield __await(o.call(s)));
        } finally {
          if (t) throw t.error;
        }
      }
    });
  }();
  if (e[Symbol.asyncIterator]) return function () {
    return __asyncGenerator(this, arguments, function* () {
      var t, o;
      const r = e[Symbol.asyncIterator](),
            s = yield __await(r.next());
      if (s.done) return yield __await(r);
      if (isBytes(s.value)) return yield yield __await(toFileObject(function () {
        return __asyncGenerator(this, arguments, function* () {
          yield yield __await(s.value), yield __await((yield* __asyncDelegator(__asyncValues(r))));
        });
      }())), yield __await(void 0);

      if (isFileObject(s.value) || isBloby(s.value) || "string" == typeof s.value) {
        yield yield __await(toFileObject(s.value));

        try {
          for (var n, i = __asyncValues(r); !(n = yield __await(i.next())).done;) {
            const e = n.value;
            yield yield __await(toFileObject(e));
          }
        } catch (e) {
          t = {
            error: e
          };
        } finally {
          try {
            n && !n.done && (o = i.return) && (yield __await(o.call(i)));
          } finally {
            if (t) throw t.error;
          }
        }

        return yield __await(void 0);
      }

      throw new Error("Unexpected input: " + typeof e);
    });
  }();
  if (isFileObject(e)) return function () {
    return __asyncGenerator(this, arguments, function* () {
      yield yield __await(toFileObject(e));
    });
  }();
  throw new Error("Unexpected input: " + typeof e);
}

function toFileObject(e) {
  const t = {
    path: e.path || "",
    mode: e.mode,
    mtime: e.mtime
  };
  return e.content ? t.content = toAsyncIterable(e.content) : e.path || (t.content = toAsyncIterable(e)), t;
}

function toAsyncIterable(e) {
  if (isBytes(e) || "string" == typeof e) return function () {
    return __asyncGenerator(this, arguments, function* () {
      yield yield __await(toBuffer(e));
    });
  }();
  if (isBloby(e)) return blobToAsyncGenerator(e);
  if ("function" == typeof e.getReader) return browserStreamToIt(e);
  if (e[Symbol.iterator]) return function () {
    return __asyncGenerator(this, arguments, function* () {
      const t = e[Symbol.iterator](),
            o = t.next();
      if (o.done) return yield __await(t);
      if (Number.isInteger(o.value)) return yield yield __await(toBuffer(Array.from(function* () {
        yield o.value, yield* t;
      }()))), yield __await(void 0);

      if (isBytes(o.value)) {
        yield yield __await(toBuffer(o.value));

        for (const e of t) yield yield __await(toBuffer(e));

        return yield __await(void 0);
      }

      throw new Error("Unexpected input: " + typeof e);
    });
  }();
  if (e[Symbol.asyncIterator]) return function () {
    return __asyncGenerator(this, arguments, function* () {
      var t, o;

      try {
        for (var r, s = __asyncValues(e); !(r = yield __await(s.next())).done;) {
          const e = r.value;
          yield yield __await(toBuffer(e));
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (o = s.return) && (yield __await(o.call(s)));
        } finally {
          if (t) throw t.error;
        }
      }
    });
  }();
  throw new Error("Unexpected input: ".concat(e));
}

function toBuffer(e) {
  return isBytes(e) ? e : buffer.Buffer.from(e);
}

function isBytes(e) {
  return buffer.Buffer.isBuffer(e) || ArrayBuffer.isView(e) || e instanceof ArrayBuffer;
}

function isBloby(e) {
  return void 0 !== globalThis.Blob && e instanceof globalThis.Blob;
}

function isFileObject(e) {
  return "object" == typeof e && (e.path || e.content);
}

function blobToAsyncGenerator(e) {
  return "function" == typeof e.stream ? browserStreamToIt(e.stream()) : readBlob(e);
}

function browserStreamToIt(e) {
  return __asyncGenerator(this, arguments, function* () {
    const t = e.getReader();

    for (;;) {
      const e = yield __await(t.read());
      if (e.done) return yield __await(void 0);
      yield yield __await(e.value);
    }
  });
}

function readBlob(e, t) {
  return __asyncGenerator(this, arguments, function* () {
    t = t || {};
    const o = new globalThis.FileReader(),
          r = t.chunkSize || 1048576;
    let s = t.offset || 0;

    for (;;) {
      const t = yield __await(new Promise((t, n) => {
        o.onloadend = e => {
          var o;
          const r = null === (o = e.target) || void 0 === o ? void 0 : o.result;
          t(0 === r.byteLength ? null : r);
        }, o.onerror = n;
        const i = s + r,
              a = e.slice(s, i);
        o.readAsArrayBuffer(a), s = i;
      }));
      if (null == t) return yield __await(void 0);
      yield yield __await(buffer.Buffer.from(t));
    }
  });
}

const logger = loglevel.getLogger("buckets-api");

function fromPbRootObject(e) {
  return {
    key: e.getKey(),
    name: e.getName(),
    path: e.getPath(),
    createdAt: e.getCreatedAt(),
    updatedAt: e.getUpdatedAt(),
    thread: e.getThread()
  };
}

function fromPbRootObjectNullable(e) {
  if (e) return fromPbRootObject(e);
}

function fromPbMetadata(e) {
  if (!e) return;
  const t = e.getRolesMap(),
        o = new Map();
  t.forEach((e, t) => o.set(t, e));
  return {
    updatedAt: e.getUpdatedAt(),
    roles: o
  };
}

const CHUNK_SIZE = 1024;

function fromPbPathItem(e) {
  const t = e.getItemsList();
  return {
    cid: e.getCid(),
    name: e.getName(),
    path: e.getPath(),
    size: e.getSize(),
    isDir: e.getIsDir(),
    items: t ? t.map(fromPbPathItem) : [],
    count: e.getItemsCount(),
    metadata: fromPbMetadata(e.getMetadata())
  };
}

function fromPbPathItemNullable(e) {
  if (e) return fromPbPathItem(e);
}

function fromProtoArchiveRenew(e) {
  return Object.assign({}, e);
}

function fromProtoArchiveConfig(e) {
  return Object.assign(Object.assign({}, e), {
    countryCodes: e.countryCodesList,
    excludedMiners: e.excludedMinersList,
    trustedMiners: e.trustedMinersList,
    renew: e.renew ? fromProtoArchiveRenew(e.renew) : void 0
  });
}

function toProtoArchiveConfig(e) {
  const t = new bucketsd_pb.ArchiveConfig();

  if (t.setCountryCodesList(e.countryCodes), t.setDealMinDuration(e.dealMinDuration), t.setDealStartOffset(e.dealStartOffset), t.setExcludedMinersList(e.excludedMiners), t.setFastRetrieval(e.fastRetrieval), t.setMaxPrice(e.maxPrice), t.setRepFactor(e.repFactor), t.setTrustedMinersList(e.trustedMiners), t.setVerifiedDeal(e.verifiedDeal), e.renew) {
    const o = new bucketsd_pb.ArchiveRenew();
    o.setEnabled(e.renew.enabled), o.setThreshold(e.renew.threshold), t.setRenew(o);
  }

  return t;
}

function fromPbDealInfo(e) {
  return Object.assign({}, e);
}

function fromPbArchiveStatus(e) {
  switch (e) {
    case bucketsd_pb.ArchiveStatus.ARCHIVE_STATUS_CANCELED:
      return ArchiveStatus.Canceled;

    case bucketsd_pb.ArchiveStatus.ARCHIVE_STATUS_EXECUTING:
      return ArchiveStatus.Executing;

    case bucketsd_pb.ArchiveStatus.ARCHIVE_STATUS_FAILED:
      return ArchiveStatus.Failed;

    case bucketsd_pb.ArchiveStatus.ARCHIVE_STATUS_QUEUED:
      return ArchiveStatus.Queued;

    case bucketsd_pb.ArchiveStatus.ARCHIVE_STATUS_SUCCESS:
      return ArchiveStatus.Success;

    case bucketsd_pb.ArchiveStatus.ARCHIVE_STATUS_UNSPECIFIED:
      return ArchiveStatus.Unspecified;

    default:
      throw new Error("unknown status");
  }
}

function fromPbArchive(e) {
  return Object.assign(Object.assign({}, e), {
    createdAt: new Date(1e3 * e.createdAt),
    status: fromPbArchiveStatus(e.archiveStatus),
    dealInfo: e.dealInfoList.map(fromPbDealInfo)
  });
}

function ensureRootString(e, t, o, r) {
  var s;
  return __awaiter(this, void 0, void 0, function* () {
    if (o) return "string" == typeof o ? o : o.path;
    {
      const o = yield bucketsRoot(e, t, r);
      return null !== (s = null == o ? void 0 : o.path) && void 0 !== s ? s : "";
    }
  });
}

function* genChunks(e, t) {
  return yield* Array.from(Array(Math.ceil(e.byteLength / t)), (o, r) => e.slice(r * t, r * t + t));
}

function bucketsCreate(e, t, o = !1, r, s) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("create request");
    const n = new bucketsd_pb.CreateRequest();
    n.setName(t), r && n.setBootstrapCid(r), n.setPrivate(o);
    const i = yield e.unary(APIService_1.Create, n, s),
          a = i.getLinks();
    return {
      seed: i.getSeed_asU8(),
      seedCid: i.getSeedCid(),
      root: fromPbRootObjectNullable(i.getRoot()),
      links: a ? a.toObject() : void 0
    };
  });
}

function bucketsRoot(e, t, o) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("root request");
    const r = new bucketsd_pb.RootRequest();
    r.setKey(t);
    return fromPbRootObjectNullable((yield e.unary(APIService_1.Root, r, o)).getRoot());
  });
}

function bucketsLinks(e, t, o, r) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("link request");
    const s = new bucketsd_pb.LinksRequest();
    s.setKey(t), s.setPath(o);
    return (yield e.unary(APIService_1.Links, s, r)).toObject();
  });
}

function bucketsList(e, t) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("list request");
    const o = new bucketsd_pb.ListRequest(),
          r = (yield e.unary(APIService_1.List, o, t)).getRootsList();
    return r ? r.map(e => e).map(e => fromPbRootObject(e)) : [];
  });
}

function bucketsListPath(e, t, o, r) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("list path request");
    const s = new bucketsd_pb.ListPathRequest();
    s.setKey(t), s.setPath(o);
    const n = yield e.unary(APIService_1.ListPath, s, r);
    return {
      item: fromPbPathItemNullable(n.getItem()),
      root: fromPbRootObjectNullable(n.getRoot())
    };
  });
}

function bucketsListIpfsPath(e, t, o) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("list path request");
    const r = new bucketsd_pb.ListIpfsPathRequest();
    r.setPath(t);
    return fromPbPathItemNullable((yield e.unary(APIService_1.ListIpfsPath, r, o)).getItem());
  });
}

function bucketsMovePath(e, t, o, r, s) {
  return __awaiter(this, void 0, void 0, function* () {
    const n = new bucketsd_pb.MovePathRequest();
    n.setKey(t), n.setFromPath(o), n.setToPath(r), yield e.unary(APIService_1.MovePath, n, s);
  });
}

function bucketsPushPath(e, t, o, r, s, n) {
  return __awaiter(this, void 0, void 0, function* () {
    return new Promise((i, a) => __awaiter(this, void 0, void 0, function* () {
      var u, g, p;
      const l = (yield normaliseInput(r).next()).value;
      if (!l) return a(AbortError);
      const c = new APIServiceClient_1(e.serviceHost, e.rpcOptions),
            d = Object.assign(Object.assign({}, e.context.toJSON()), null == n ? void 0 : n.toJSON()),
            f = c.pushPath(d);
      void 0 !== (null == s ? void 0 : s.signal) && s.signal.addEventListener("abort", () => (f.cancel(), a(AbortError))), f.on("data", e => {
        var t, o, r, n;
        if (null === (t = null == s ? void 0 : s.signal) || void 0 === t ? void 0 : t.aborted) return f.cancel(), a(AbortError);
        if (!e.hasEvent()) return a(new Error("Invalid reply"));
        {
          const t = null === (o = e.getEvent()) || void 0 === o ? void 0 : o.toObject();

          if (null == t ? void 0 : t.path) {
            const e = t.path.startsWith("/ipfs/") ? t.path.split("/ipfs/")[1] : t.path,
                  o = new src$5(e),
                  s = {
              path: {
                path: "/ipfs/".concat(null == o ? void 0 : o.toString()),
                cid: o,
                root: o,
                remainder: ""
              },
              root: null !== (n = null === (r = t.root) || void 0 === r ? void 0 : r.path) && void 0 !== n ? n : ""
            };
            return i(s);
          }

          (null == s ? void 0 : s.progress) && s.progress(null == t ? void 0 : t.bytes);
        }
      }), f.on("end", e => e && e.code !== grpcWebClient_umd.grpc.Code.OK ? a(new Error(e.details)) : a(new Error("undefined result"))), f.on("status", e => e && e.code !== grpcWebClient_umd.grpc.Code.OK ? a(new Error(e.details)) : a(new Error("undefined result")));
      const b = new bucketsd_pb.PushPathRequest.Header();
      b.setPath(l.path || o), b.setKey(t);
      const h = yield ensureRootString(e, t, null == s ? void 0 : s.root, n);
      b.setRoot(h);
      const y = new bucketsd_pb.PushPathRequest();
      if (y.setHeader(b), f.write(y), l.content) try {
        for (var m, _ = __asyncValues(l.content); !(m = yield _.next()).done;) {
          const e = m.value;

          if (null === (p = null == s ? void 0 : s.signal) || void 0 === p ? void 0 : p.aborted) {
            try {
              f.cancel();
            } catch (e) {}

            return a(AbortError);
          }

          for (const t of genChunks(e, CHUNK_SIZE)) {
            const e = new bucketsd_pb.PushPathRequest();
            e.setChunk(t), f.write(e);
          }
        }
      } catch (e) {
        u = {
          error: e
        };
      } finally {
        try {
          m && !m.done && (g = _.return) && (yield g.call(_));
        } finally {
          if (u) throw u.error;
        }
      }
      f.end();
    }));
  });
}

function bucketsPushPaths(e, t, o, r, s) {
  return new Repeater((n, i) => __awaiter(this, void 0, void 0, function* () {
    const a = new APIServiceClient_1(e.serviceHost, e.rpcOptions),
          u = Object.assign(Object.assign({}, e.context.toJSON()), null == s ? void 0 : s.toJSON()),
          g = a.pushPaths(u);
    void 0 !== (null == r ? void 0 : r.signal) && r.signal.addEventListener("abort", () => {
      throw g.cancel(), AbortError;
    }), g.on("data", e => {
      var t;
      if (null === (t = null == r ? void 0 : r.signal) || void 0 === t ? void 0 : t.aborted) return g.cancel(), i(AbortError);
      const o = {
        path: e.getPath(),
        root: fromPbRootObjectNullable(e.getRoot()),
        cid: new src$5(e.getCid()),
        pinned: e.getPinned(),
        size: e.getSize()
      };
      n(o);
    }), g.on("end", e => e && e.code !== grpcWebClient_umd.grpc.Code.OK ? i(new Error(e.details)) : i()), g.on("status", e => e && e.code !== grpcWebClient_umd.grpc.Code.OK ? i(new Error(e.details)) : i());
    const p = new bucketsd_pb.PushPathsRequest.Header();
    p.setKey(t);
    const l = yield ensureRootString(e, t, null == r ? void 0 : r.root, s);
    p.setRoot(l);
    const c = new bucketsd_pb.PushPathsRequest();
    c.setHeader(p), g.write(c);
    yield itDrain(paramapIt(normaliseInput(o), ({
      path: e,
      content: t
    }) => {
      var o, s;
      return __awaiter(this, void 0, void 0, function* () {
        var n, a, u;
        const p = new bucketsd_pb.PushPathsRequest(),
              l = new bucketsd_pb.PushPathsRequest.Chunk();
        if (l.setPath(e), t) try {
          for (o = __asyncValues(t); !(s = yield o.next()).done;) {
            const e = s.value;

            if (null === (u = null == r ? void 0 : r.signal) || void 0 === u ? void 0 : u.aborted) {
              try {
                g.cancel();
              } catch (e) {}

              return i(AbortError);
            }

            for (const t of genChunks(e, CHUNK_SIZE)) l.setData(t), p.setChunk(l), g.write(p);
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            s && !s.done && (a = o.return) && (yield a.call(o));
          } finally {
            if (n) throw n.error;
          }
        }
        const c = new bucketsd_pb.PushPathsRequest.Chunk();
        c.setPath(e), p.setChunk(c), g.write(p);
      });
    }, {
      ordered: !1
    })), g.end();
  }));
}

function bucketsSetPath(e, t, o, r, s) {
  return __awaiter(this, void 0, void 0, function* () {
    const n = new bucketsd_pb.SetPathRequest();
    n.setKey(t), n.setPath(o), n.setCid(r), yield e.unary(APIService_1.SetPath, n, s);
  });
}

function bucketsPullPath(e, t, o, r, s) {
  return new Repeater((n, i) => {
    const a = Object.assign(Object.assign({}, e.context.toJSON()), null == s ? void 0 : s.toJSON()),
          u = new bucketsd_pb.PullPathRequest();
    u.setKey(t), u.setPath(o);
    let g = 0;
    const p = grpcWebClient_umd.grpc.invoke(APIService_1.PullPath, {
      host: e.serviceHost,
      transport: e.rpcOptions.transport,
      debug: e.rpcOptions.debug,
      request: u,
      metadata: a,
      onMessage: e => __awaiter(this, void 0, void 0, function* () {
        const t = e.getChunk_asU8();
        g += t.byteLength, (null == r ? void 0 : r.progress) && r.progress(g), n(t);
      }),
      onEnd: (e, t) => __awaiter(this, void 0, void 0, function* () {
        e !== grpcWebClient_umd.grpc.Code.OK && i(new Error(t)), i();
      })
    });
    i.then(() => p.close());
  });
}

function bucketsPullIpfsPath(e, t, o, r) {
  return new Repeater((s, n) => {
    const i = Object.assign(Object.assign({}, e.context.toJSON()), null == r ? void 0 : r.toJSON()),
          a = new bucketsd_pb.PullIpfsPathRequest();
    a.setPath(t);
    let u = 0;
    const g = grpcWebClient_umd.grpc.invoke(APIService_1.PullIpfsPath, {
      host: e.serviceHost,
      transport: e.rpcOptions.transport,
      debug: e.rpcOptions.debug,
      request: a,
      metadata: i,
      onMessage: e => __awaiter(this, void 0, void 0, function* () {
        const t = e.getChunk_asU8();
        s(t), u += t.byteLength, (null == o ? void 0 : o.progress) && o.progress(u);
      }),
      onEnd: (e, t) => __awaiter(this, void 0, void 0, function* () {
        e !== grpcWebClient_umd.grpc.Code.OK && n(new Error(t)), n();
      })
    });
    n.then(() => g.close());
  });
}

function bucketsRemove(e, t, o) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("remove request");
    const r = new bucketsd_pb.RemoveRequest();
    r.setKey(t), yield e.unary(APIService_1.Remove, r, o);
  });
}

function bucketsRemovePath(e, t, o, r, s) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("remove path request");
    const n = new bucketsd_pb.RemovePathRequest();
    n.setKey(t), n.setPath(o);
    const i = yield ensureRootString(e, t, null == r ? void 0 : r.root, s);
    n.setRoot(i);
    const a = yield e.unary(APIService_1.RemovePath, n, s);
    return {
      pinned: a.getPinned(),
      root: fromPbRootObjectNullable(a.getRoot())
    };
  });
}

function bucketsPushPathAccessRoles(e, t, o, r, s) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("remove path request");
    const n = new bucketsd_pb.PushPathAccessRolesRequest();
    n.setKey(t), n.setPath(o), r.forEach((e, t) => n.getRolesMap().set(t, e)), yield e.unary(APIService_1.PushPathAccessRoles, n, s);
  });
}

function bucketsPullPathAccessRoles(e, t, o = "/", r) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("remove path request");
    const s = new bucketsd_pb.PullPathAccessRolesRequest();
    s.setKey(t), s.setPath(o);
    const n = (yield e.unary(APIService_1.PullPathAccessRoles, s, r)).getRolesMap(),
          i = new Map();
    return n.forEach((e, t) => i.set(t, e)), i;
  });
}

function bucketsDefaultArchiveConfig(e, t, o) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("default archive config request");
    const r = new bucketsd_pb.DefaultArchiveConfigRequest();
    r.setKey(t);
    const s = (yield e.unary(APIService_1.DefaultArchiveConfig, r, o)).getArchiveConfig();
    if (!s) throw new Error("no archive config returned");
    return fromProtoArchiveConfig(s.toObject());
  });
}

function bucketsSetDefaultArchiveConfig(e, t, o, r) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("set default archive config request");
    const s = new bucketsd_pb.SetDefaultArchiveConfigRequest();
    s.setKey(t), s.setArchiveConfig(toProtoArchiveConfig(o)), yield e.unary(APIService_1.SetDefaultArchiveConfig, s, r);
  });
}

function bucketsArchive(e, t, o, r, s) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("archive request");
    const n = new bucketsd_pb.ArchiveRequest();
    n.setKey(t), void 0 !== r && n.setSkipAutomaticVerifiedDeal(r), (null == o ? void 0 : o.archiveConfig) && n.setArchiveConfig(toProtoArchiveConfig(o.archiveConfig)), yield e.unary(APIService_1.Archive, n, s);
  });
}

function bucketsArchives(e, t, o) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("archives request");
    const r = new bucketsd_pb.ArchivesRequest();
    r.setKey(t);
    const s = yield e.unary(APIService_1.Archives, r, o),
          n = s.toObject().current;
    return {
      current: n ? fromPbArchive(n) : void 0,
      history: s.toObject().historyList.map(fromPbArchive)
    };
  });
}

function bucketsArchiveWatch(e, t, o, r) {
  return __awaiter(this, void 0, void 0, function* () {
    logger.debug("archive watch request");
    const s = new bucketsd_pb.ArchiveWatchRequest();
    s.setKey(t);
    const n = Object.assign(Object.assign({}, e.context.toJSON()), null == r ? void 0 : r.toJSON()),
          i = grpcWebClient_umd.grpc.invoke(APIService_1.ArchiveWatch, {
      host: e.context.host,
      request: s,
      metadata: n,
      onMessage: e => {
        const t = {
          id: e.getJsPbMessageId(),
          msg: e.getMsg()
        };
        o(t);
      },
      onEnd: (e, t) => {
        if (e !== grpcWebClient_umd.grpc.Code.OK) return o(void 0, new Error(t));
        o();
      }
    });
    return i.close.bind(i);
  });
}

function bytesToArray(e, t = CHUNK_SIZE * CHUNK_SIZE * 3) {
  const o = [],
        r = e.length;
  let s = 0;

  for (; s < r;) o.push(e.slice(s, s += t));

  return o;
}

function listPathRecursive(e, t, o, r, s = 0) {
  return __awaiter(this, void 0, void 0, function* () {
    const n = "" === o || "." === o || "/" === o ? "" : "".concat(o, "/"),
          i = yield bucketsListPath(e, t, o);
    if (i.item && (s + 1 <= r || -1 === r)) for (let o = 0; o < i.item.items.length; o++) {
      const a = i.item.items[o];
      if (!a.isDir) continue;

      const u = "".concat(n).concat(a.name),
            _ref7 = yield listPathRecursive(e, t, u, r, s + 1),
            g = _ref7.item;

      g && (i.item.items[o] = g);
    }
    return i;
  });
}

function treeToPaths(e, t, o = !0, r = 5, s = 0) {
  return __awaiter(this, void 0, void 0, function* () {
    const n = [];

    for (const i of e) {
      const e = "" === t ? "".concat(i.name) : "".concat(t, "/").concat(i.name);

      if (!o && i.isDir || n.push(e), i.isDir && (s < r || -1 === r)) {
        const t = yield treeToPaths(i.items, e, o, r, s + 1);
        n.push(...t);
      }
    }

    return n;
  });
}

function listPathFlat(e, t, o, r, s) {
  return __awaiter(this, void 0, void 0, function* () {
    const n = yield listPathRecursive(e, t, o, s);
    return n.item ? treeToPaths(n.item.items, o, r) : [];
  });
}

const logger$1 = loglevel.getLogger("buckets");

class Buckets extends GrpcAuthentication {
  static copyAuth(e, t) {
    return new Buckets(e.context, null == t ? void 0 : t.debug);
  }

  static withUserAuth(e, t) {
    const o = super.withUserAuth(e, t);
    return this.copyAuth(o, t);
  }

  static withKeyInfo(e, t) {
    const o = Object.create(null, {
      withKeyInfo: {
        get: () => super.withKeyInfo
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const r = yield o.withKeyInfo.call(this, e, t);
      return this.copyAuth(r, t);
    });
  }

  withThread(e) {
    return super.withThread(e);
  }

  getToken(e) {
    const t = Object.create(null, {
      getToken: {
        get: () => super.getToken
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      return t.getToken.call(this, e);
    });
  }

  setToken(e) {
    return super.setToken(e);
  }

  getTokenChallenge(e, t) {
    const o = Object.create(null, {
      getTokenChallenge: {
        get: () => super.getTokenChallenge
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      return o.getTokenChallenge.call(this, e, t);
    });
  }

  open(e, t = "buckets", o = !1, r) {
    return __awaiter(this, void 0, void 0, function* () {
      const s = {
        threadName: t && "" !== t ? t : "buckets",
        encrypted: !!o,
        threadID: r
      };
      return this.getOrCreate(e, s);
    });
  }

  getOrInit(e, t = "buckets", o = !1, r) {
    return __awaiter(this, void 0, void 0, function* () {
      const s = {
        threadName: t && "" !== t ? t : "buckets",
        encrypted: !!o,
        threadID: r
      };
      return this.getOrCreate(e, s);
    });
  }

  getOrCreate(e, t, o, r, s) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!t && (o || r || s)) return console.warn("Update Buckets.getOrCreate to use GetOrCreateOptions input."), this._getOrCreate(e, "buckets", !!o, r, s);

      if (t) {
        if ("object" != typeof t) return console.warn("Update Buckets.getOrCreate to use GetOrCreateOptions input."), this._getOrCreate(e, t, !!o, r, s);
        {
          const o = t.threadName && "" !== t.threadName ? t.threadName : "buckets",
                r = !!t.encrypted;
          return this._getOrCreate(e, o, r, t.cid, t.threadID);
        }
      }

      return this._getOrCreate(e);
    });
  }

  _getOrCreate(e, t = "buckets", o = !1, r, s) {
    return __awaiter(this, void 0, void 0, function* () {
      const n = new Client(this.context);

      if (s) {
        const e = s;

        if (!(yield n.listThreads()).find(t => t.id === e)) {
          const e = ThreadID.fromString(s);
          yield n.newDB(e, t);
        }

        this.withThread(s);
      } else try {
        const e = yield n.getThread(t);
        s = "string" == typeof e.id ? e.id : ThreadID.fromBytes(e.id).toString(), this.withThread(s);
      } catch (e) {
        if ("Thread not found" !== e.message && !e.message.includes("mongo: no documents in result")) throw new Error(e.message);
        const o = ThreadID.fromRandom();
        yield n.newDB(o, t), s = o.toString(), this.withThread(s);
      }

      const i = (yield this.list()).find(t => t.name === e);
      if (i) return {
        root: i,
        threadID: s
      };
      return {
        root: (yield this.create(e, {
          encrypted: o,
          cid: r
        })).root,
        threadID: s
      };
    });
  }

  existing(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const t = new Client(this.context),
            o = [];
      if (e) o.push(e);else {
        const e = yield t.listThreads();

        for (const t of e) t.id && o.push(t.id);
      }
      const r = [];

      for (const e of o) {
        this.withThread(e);

        for (const e of yield this.list()) r.push(e);
      }

      return this.withThread(void 0), r;
    });
  }

  init(e, t = !1) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.create(e, {
        encrypted: t
      });
    });
  }

  create(e, t, o) {
    return __awaiter(this, void 0, void 0, function* () {
      if (logger$1.debug("create request"), "object" == typeof t) return bucketsCreate(this, e, !!t.encrypted, t.cid);
      void 0 === t && void 0 === o || console.warn("Update Buckets.create to use CreateOptions input.");
      return bucketsCreate(this, e, !!t, o);
    });
  }

  root(e) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("root request"), bucketsRoot(this, e);
    });
  }

  links(e, t = "/") {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("link request"), bucketsLinks(this, e, t);
    });
  }

  list() {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("list request"), bucketsList(this);
    });
  }

  listPath(e, t, o = 1) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("list path request"), yield listPathRecursive(this, e, t, o);
    });
  }

  listPathFlat(e, t, o = !0, r = 5) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("list path recursive request"), yield listPathFlat(this, e, t, o, r);
    });
  }

  listIpfsPath(e) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("list path request"), bucketsListIpfsPath(this, e);
    });
  }

  movePath(e, t, o) {
    return __awaiter(this, void 0, void 0, function* () {
      return bucketsMovePath(this, e, t, o);
    });
  }

  pushPath(e, t, o, r) {
    return __awaiter(this, void 0, void 0, function* () {
      return bucketsPushPath(this, e, t, o, r);
    });
  }

  pushPaths(e, t, o) {
    return bucketsPushPaths(this, e, t, o);
  }

  pullPath(e, t, o) {
    return bucketsPullPath(this, e, t, o);
  }

  setPath(e, t, o) {
    return __awaiter(this, void 0, void 0, function* () {
      return bucketsSetPath(this, e, t, o);
    });
  }

  pullIpfsPath(e, t) {
    return bucketsPullIpfsPath(this, e, t);
  }

  remove(e) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("remove request"), bucketsRemove(this, e);
    });
  }

  removePath(e, t, o) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("remove path request"), bucketsRemovePath(this, e, t, o);
    });
  }

  pushPathAccessRoles(e, t, o) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("push path access roles request"), bucketsPushPathAccessRoles(this, e, t, o);
    });
  }

  pullPathAccessRoles(e, t) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("pull path access roles request"), bucketsPullPathAccessRoles(this, e, t);
    });
  }

  defaultArchiveConfig(e) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("default archive config request"), bucketsDefaultArchiveConfig(this, e);
    });
  }

  setDefaultArchiveConfig(e, t) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("set default archive config request"), bucketsSetDefaultArchiveConfig(this, e, t);
    });
  }

  archive(e, t, o) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("archive request"), bucketsArchive(this, e, t, o);
    });
  }

  archives(e) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("archives request"), bucketsArchives(this, e);
    });
  }

  archiveWatch(e, t) {
    return __awaiter(this, void 0, void 0, function* () {
      return logger$1.debug("archive watch request"), bucketsArchiveWatch(this, e, t);
    });
  }

}

var AbortController$2 = src.AbortController,
    AbortSignal$1 = src.AbortSignal;
export { AbortController$2 as AbortController, AbortError, AbortSignal$1 as AbortSignal, ArchiveStatus, Buckets, PathAccessRole, bytesToArray, listPathFlat, listPathRecursive };